/* eslint-disable no-trailing-spaces */
/* eslint-disable eol-last */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/indent */

import { isNull, isUndefined } from 'lodash';

const partnerGlobalConfigLocal = JSON.parse(
  window.localStorage.getItem('partner_settings'),
);
let primaryColor =
  process.env.REACT_APP_PLATFORM_DEFAULT_PRIMARY_COLOR || '#006699';

if (
  !isNull(partnerGlobalConfigLocal) &&
  !isUndefined(partnerGlobalConfigLocal)
) {
  primaryColor = partnerGlobalConfigLocal?.color_schema?.primary;
}

export const fr = {
         login_sign_in: 'Se connecter',
         login_email_address: 'Adresse e-mail',
         login_form_password_label: 'Mot de passe',
         login_forget_password: 'Mot de passe oublié',
         login_credentials_error:
           'Veuillez vérifier votre e-mail et votre mot de passe',
         login_api_error: 'Alarme API de connexion interne',
         internal_server_error: 'Alarme Serveur Interne',
         /* Forget Password */
         forget_password_title: 'Mot de passe oublié',
         forget_password_email_address: 'Adresse e-mail',
         forget_password_button:
           'Envoyer le lien de réinitialisation du mot de passe',
         forget_password_login: 'Retour',
         forgot_password_form_success:
           "L'e-mail de réinitialisation du mot de passe a été envoyé. Veuillez vérifier votre boîte de réception. L'e-mail pourrait se trouver dans vos spams.",
         forgot_password_subject:
           'Fortes Data Management - Mot de passe oublié',
         temporary_password_subject: 'Nouveau compte créé',
         forgot_password_required_form_error:
           "L'adresse e-mail est obligatoire",
         forgot_password_valid_form_error:
           'Doit être une adresse e-mail valide',
         /* END Forget Password */
         /** Reset Password */
         reset_password_title: 'Réinitialiser le mot de passe',
         reset_password_new_password: 'Nouveau mot de passe',
         reset_password_confirm_password: 'Confirmer le mot de passe',
         reset_password_new_password_required_form_error:
           'Le nouveau mot de passe est requis',
         reset_password_confirm_password_required_form_error:
           'La confirmation du mot de passe est requise',
         reset_password_passwords_not_matching:
           'Les mots de passe ne correspondent pas',
         reset_password_new_password_form_error:
           'Le mot de passe doit contenir au moins 8 caractères, dont au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         reset_password_button: 'Réinitialiser le mot de passe',
         reset_password_form_success:
           'Votre mot de passe a été mis à jour avec succès.',
         /** End Reset Password */
         /* DASHBOARD */
         dashboard_title: 'Tableau de bord',
         dashboard_amount_of_devices: "NOMBRE D'APPAREILS",
         dashboard_amount_of_devices_week:
           "NOMBRE D'APPAREILS LA SEMAINE DERNIÈRE",
         dashboard_amount_of_devices_error:
           "NOMBRE D'APPAREILS AVEC DES ERREURS",
         dashboard_temperature: 'TEMPÉRATURE DE RETOUR EN DEGRÉS CELSIUS',
         dashboard_device_status: 'Connexions totales : ',
         dashboard_routing_temperature: 'Températures de tous les appareils',
         dashboard_routing_temperature_hr: 'Heure',
         dashboard_error_devices: 'Appareils dont le contrôle est défectueux :',
         dashboard_error: 'ERREUR',
         dashboard_online: 'EN LIGNE',
         dashboard_offline: 'HORS LIGNE',
         'dashboard organic': 'Biologique',
         'dashboard referal': 'Référence',
         dashboard_see_all: 'TOUT VOIR',
         /* END DASHBOARD */
         /* Sidebar */
         date_range: 'Plage de dates',
         sidebar_dashboard: 'Tableau de bord',
         sidebar_clients_overview: 'Gestion des clients',
         sidebar_clients: 'Clients',
         sidebar_service_clients: 'Service clients',
         sidebar_devices_overview: 'Asset management',
         sidebar_devices: 'HIU overview',
         sidebar_projects: 'Projets',
         sidebar_presets: 'Préréglages',
         sidebar_fortes_users: 'Administrateurs',
         sidebar_fortes_settings: 'Paramètres',
         sidebar_audit: 'Audit',
         sidebar_reports: 'Rapports',
         sidebar_total_devices: 'Appareils - Total',
         sidebar_online_devices: 'Appareils - En ligne',
         sidebar_offline_devices: 'Appareils - Hors ligne',
         sidebar_error_devices: 'Appareils - Alarme',
         sidebar_change_logs: 'Journaux de modifications',
         sidebar_version_title: 'Version',
         image_upload_success: "L'image a été mise à jour avec succès !",
         image_upload_file_type_error:
           'Seuls les fichiers JPEG et PNG sont autorisés.',
         image_upload_file_size_error:
           'La taille du fichier doit être inférieure à 5 Mo.',
         image_uploading_text: 'Chargement en cours...',
         /* END Sidebar */
         /* Navbar */
         navbar_search: 'Rechercher',
         navbar_notification: 'Notification',
         navbar_no_notification: "Il n'y a pas de notifications",
         navbar_profile: 'Profil',
         navbar_setting: 'Paramètres du compte',
         navbar_logout: 'Se déconnecter',
         /* END Navbar */
         active_label: 'ACTIF',
         deactive_label: 'INACTIF',
         please_fix_form_errors: 'Veuillez corriger les erreurs du formulaire',
         /* Clients */
         clients: 'Clients',
         clients_all: 'TOUS',
         clients_active: 'ACTIF',
         clients_inactive: 'INACTIF',
         clients_add_new: 'Ajouter un nouveau client',
         clients_filter_search: 'Rechercher un client',
         clients_sort_by_filter_label: 'Trier par',
         clients_sort_by_value_1: 'Date (plus récent)',
         clients_sort_by_value_2: 'Date (plus ancien)',
         clients_sort_by_value_3: 'Alphabétique',
         clients_country_filter_label: 'Pays',
         clients_filter_reset_button: 'Réinitialiser',
         clients_filter_delete_button: 'Désactiver',
         clients_table_name: 'Nom',
         clients_table_country: 'Pays',
         clients_table_devices: 'Appareils',
         clients_table_added: 'Date de création',
         clients_table_status: 'Statut',
         clients_table_row_per_page: 'Lignes par page',
         clients_bread_crumb_main_title: 'Clients',
         add_clients_bread_crumb_first_link: 'Ajouter un client',
         add_clients_form_header: 'Ajouter un client',
         edit_clients_bread_crumb_first_link: 'Modifier le client',
         edit_clients_form_header: 'Modifier le client',
         clients_form_client_name_field: 'Nom',
         clients_form_email_field: 'Adresse e-mail',
         clients_form_user_field: 'Client Contact',
         clients_form_city_field: 'Ville',
         clients_form_country_field: 'Pays',
         clients_form_client_kong_role_field: 'Rôle Kong',
         clients_form_client_kong_role_member_label: 'Membre',
         clients_form_client_kong_role_admin_label: 'Admin',
         clients_form_allow_customization_field: 'Autoriser le marquage blanc',
         clients_form_add_client_button: 'Ajouter le client',
         clients_form_edit_client_button: 'Enregistrer les modifications',
         clients_form_cancel_button: 'Annuler',
         clients_form_submitting_client_button: 'Envoi en cours...',
         clients_name_required_form_error: 'Le nom est requis',
         clients_email_required_form_error: "L'adresse e-mail est requise",
         clients_api_kong_role_required_form_error: 'Le rôle Kong est requis',
         clients_email_valid_form_error: 'Doit être une adresse e-mail valide',
         clients_city_required_form_error: 'La ville est requise',
         clients_country_required_form_error: 'Le pays est requis',
         clients_add_form_success: 'Client créé avec succès !',
         clients_edit_form_success: 'Le client a été mis à jour avec succès !',
         clients_form_api_error: 'Alarme serveur interne du client - API',
         clients_form_email_error: "L'adresse e-mail existe déjà",
         clients_no_record_found: 'Aucun client trouvé',
         client_deactivated_message: 'Le client a été désactivé avec succès',
         client_activated_message: 'Le client a été activé avec succès',
         clients_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner plusieurs enregistrements à désactiver',
         clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} clients ont été désactivés avec succès',
         client_single_stats_table_title: 'Statut',
         /* END Clients */
         client_single_first_bread_crumb: 'Clients',
         client_single_second_bread_crumb: 'Voir le client',
         client_single_country_label: 'Pays',
         client_single_devices_label: 'Appareils',
         client_single_edit_button: 'Modifier',
         client_single_users_tab: 'Utilisateurs',
         client_single_apis_tab: 'Clés API',
         client_single_customization_tab: 'Marque blanche',
         client_single_customization_tab_logo: 'Logo',
         client_single_customization_tab_primary_color: 'Couleur principale',
         client_single_customization_tab_secondary_color: 'Couleur secondaire',
         client_single_customization_tab_submit_button:
           'Enregistrer les modifications',
         client_single_customization_color_schema_success:
           'Marque blanche mise à jour avec succès.',
         client_single_filter_search: 'Rechercher',
         client_single_add_new_user_button: 'Ajouter un utilisateur',
         client_single_add_new_api_key_button: 'Ajouter une clé API',
         client_single_role_id_filter: 'Rôle',
         client_single_users_search: 'Rechercher',
         client_single_filter_reset_button: 'Réinitialiser',
         client_single_users_all: 'TOUS',
         client_single_users_active: 'ACTIF',
         client_single_users_inactive: 'INACTIF',
         client_single_filter_delete_button: 'Désactiver',
         client_single_users_table_name: 'Nom',
         client_single_users_table_address: 'Adresse',
         client_single_users_table_role_id: 'Rôle',
         client_single_users_table_status: 'Statut',
         client_single_users_table_added: 'Date de création',
         client_single_users_table_no_record_found:
           'Aucun enregistrement trouvé',
         client_single_table_row_per_page: 'Lignes par page',
         client_single_stats_online_devices_label: 'Appareils en ligne',
         client_single_stats_error_devices_label: 'Appareils en alarme',
         client_single_no_user_selected_for_de_activation_message:
           'Veuillez sélectionner un enregistrement à désactiver',
         /* END Clients Single */
         /* Service Clients */
         service_clients: 'Service Clients',
         service_clients_all: 'TOUS',
         service_clients_active: 'ACTIF',
         service_clients_inactive: 'INACTIF',
         service_clients_add_new: 'Ajouter un nouveau',
         service_clients_filter_search: 'Rechercher',
         service_clients_sort_by_filter_label: 'Trier par',
         service_clients_sort_by_value_1: 'Date (plus récent)',
         service_clients_sort_by_value_2: 'Date (plus ancien)',
         service_clients_sort_by_value_3: 'Alphabétique',
         service_clients_country_filter_label: 'Pays',
         service_clients_filter_reset_button: 'Réinitialiser',
         service_clients_filter_delete_button: 'Désactiver',
         service_clients_table_name: 'Nom',
         service_clients_table_country: 'Pays',
         service_clients_table_devices: 'Appareils',
         service_clients_table_added: 'Date de création',
         service_clients_table_status: 'Statut',
         service_clients_table_row_per_page: 'Lignes par page',
         service_clients_bread_crumb_main_title: 'Service Clients',
         add_service_clients_bread_crumb_first_link:
           'Ajouter un service client',
         add_service_clients_form_header: 'Ajouter un service client',
         edit_service_clients_bread_crumb_first_link:
           'Modifier le service client',
         edit_service_clients_form_header: 'Modifier le service client',
         service_clients_form_service_client_name_field: 'Nom',
         service_clients_form_email_field: 'Adresse e-mail',
         service_clients_form_client_field: 'Client',
         service_clients_form_user_field: 'Client Contact',
         service_clients_form_city_field: 'Ville',
         service_clients_form_country_field: 'Pays',
         service_clients_form_add_service_client_button:
           'Enregistrer les modifications',
         service_clients_form_edit_service_client_button:
           'Enregistrer les modifications',
         service_clients_form_cancel_button: 'Annuler',
         service_clients_form_submitting_service_client_button:
           'Envoi en cours...',
         service_clients_name_required_form_error: 'Le nom est requis',
         service_clients_email_required_form_error:
           "L'adresse e-mail est requise",
         service_clients_focal_user_id_required_form_error:
           "L'utilisateur focal est requis",
         service_clients_email_valid_form_error:
           'Doit être une adresse e-mail valide',
         service_clients_city_required_form_error: 'La ville est requise',
         service_clients_client_required_form_error: 'Le client est requis',
         service_clients_country_required_form_error: 'Le pays est requis',
         service_clients_add_form_success: 'Service client créé avec succès !',
         service_clients_edit_form_success:
           'Le service client a été mis à jour avec succès !',
         service_clients_form_api_error:
           'Alarme serveur interne du service client - API',
         service_clients_form_email_error: "L'adresse e-mail existe déjà",
         service_clients_no_record_found: 'Aucun service client trouvé',
         service_client_deactivated_message:
           'Le service client a été désactivé avec succès',
         service_client_activated_message:
           'Le service client a été activé avec succès',
         service_clients_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         service_clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} service(s) client(s) ont été désactivés avec succès',
         service_client_single_stats_table_title: 'Statut',
         /* END Service Clients */
         service_client_single_first_bread_crumb: 'Service Clients',
         service_client_single_second_bread_crumb: 'Voir le service client',
         service_client_single_country_label: 'Pays',
         service_client_single_devices_label: 'Appareils',
         service_client_single_edit_button: 'Modifier',
         service_client_single_users_tab: 'Utilisateurs',
         service_client_single_apis_tab: 'Clés API',
         service_client_single_filter_search: 'Rechercher',
         service_client_single_add_new_user_button: 'Ajouter un utilisateur',
         service_client_single_add_new_api_key_button: 'Ajouter une clé API',
         service_client_single_role_id_filter: 'Rôle',
         service_client_single_users_search: 'Rechercher',
         service_client_single_filter_reset_button: 'Réinitialiser',
         service_client_single_users_all: 'TOUS',
         service_client_single_users_active: 'ACTIF',
         service_client_single_users_inactive: 'INACTIF',
         service_client_single_filter_delete_button: 'Désactiver',
         service_client_single_users_table_name: 'Nom',
         service_client_single_users_table_address: 'Adresse',
         service_client_single_users_table_role_id: 'Rôle',
         service_client_single_users_table_status: 'Statut',
         service_client_single_users_table_added: 'Date de création',
         service_client_single_users_table_no_record_found:
           'Aucun enregistrement trouvé',
         service_client_single_table_row_per_page: 'Lignes par page',
         service_client_single_stats_active_devices_label: 'Appareils en ligne',
         service_client_single_stats_error_devices_label: 'Appareils en alarme',
         service_client_single_no_user_selected_for_de_activation_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         /* END Service Clients Single */
         /* Users */
         users_bread_crumb_main_title: 'Client',
         add_users_bread_crumb_first_link: 'Ajouter un utilisateur',
         add_users_form_header: 'Ajouter un utilisateur',
         edit_users_bread_crumb_first_link: "Modifier l'utilisateur",
         edit_users_form_header: "Modifier l'utilisateur",
         users_form_first_name_field: 'Prénom',
         users_form_last_name_field: 'Nom de famille',
         users_form_email_field: 'Adresse e-mail',
         users_form_official_email_field: 'Adresse e-mail officielle',
         users_form_phone_field: 'Numéro de téléphone',
         users_form_official_phone_number_field: 'Numéro de téléphone officiel',
         users_form_password_field: 'Mot de passe',
         users_form_role_id_field: 'Rôle',
         users_form_select_role_id_field: 'Sélectionner un rôle',
         users_form_street_number_field: 'Rue',
         users_form_house_number_field: 'Numéro de maison',
         users_form_neighbourhood_field: 'Quartier',
         users_form_postal_code_field: 'Code postal',
         users_form_city_field: 'Ville',
         users_form_country_field: 'Pays',
         users_form_email_verification_field:
           "Vérification de l'adresse e-mail",
         users_form_email_verification_sub_title_field:
           "La désactivation de ce bouton enverra automatiquement à l'utilisateur un e-mail de vérification",
         users_form_add_user_button: 'Enregistrer les modifications',
         users_form_edit_user_button: 'Enregistrer les modifications',
         users_form_cancel_button: 'Annuler',
         users_form_submitting_user_button: 'Envoi en cours...',
         users_first_name_required_form_error: 'Le prénom est requis',
         users_last_name_required_form_error: 'Le nom de famille est requis',
         users_email_required_form_error: "L'adresse e-mail est requise",
         users_email_valid_form_error: 'Doit être une adresse e-mail valide',
         users_password_required_form_error: 'Le mot de passe est requis',
         users_country_required_form_error: 'Le pays est requis',
         users_role_id_required_form_error: 'Le rôle est requis',
         users_password_form_error:
           'Le mot de passe doit contenir au moins 8 caractères, dont au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         users_add_form_success: 'Utilisateur créé avec succès !',
         users_edit_form_success:
           "L'utilisateur a été mis à jour avec succès !",
         users_form_api_error: 'Alarme serveur interne des utilisateurs - API',
         users_form_email_error: "L'adresse e-mail existe déjà",
         users_no_record_found: 'Aucun utilisateur trouvé',
         user_deactivated_message: "L'utilisateur a été désactivé avec succès",
         user_activated_message: "L'utilisateur a été activé avec succès",
         user_email_verified_title: 'Adresse e-mail vérifiée',
         user_email_verified_sub_title:
           "La désactivation de ce bouton enverra automatiquement à l'utilisateur un e-mail de vérification",
         users_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         users_bulk_deactivated_message:
           '{{ USERS_COUNT }} utilisateurs ont été désactivés avec succès',
         /** Projects */
         projects: 'Projets',
         projects_all: 'TOUS',
         projects_active: 'ACTIF',
         projects_inactive: 'INACTIF',
         projects_unassigned: 'NON ATTRIBUÉ',
         projects_add_new: 'Ajouter un nouveau',
         projects_filter_search: 'Rechercher un projet',
         projects_sort_by_filter_label: 'Trier par',
         projects_sort_by_value_1: 'Date (plus récent)',
         projects_sort_by_value_2: 'Date (plus ancien)',
         projects_sort_by_value_3: 'Alphabétique',
         projects_country_filter_label: 'Pays',
         projects_filter_reset_button: 'Réinitialiser',
         projects_filter_delete_button: 'Supprimer',
         projects_table_name: 'Nom',
         projects_table_batch_number: 'Numéro de lot',
         projects_table_client: 'Clients',
         projects_table_devices: 'Appareils',
         projects_table_added: 'Date de création',
         projects_table_status: 'Statut',
         projects_table_row_per_page: 'Lignes par page',
         projects_bread_crumb_main_title: 'Projets',
         add_projects_bread_crumb_first_link: 'Ajouter un projet',
         add_projects_form_header: 'Ajouter un projet',
         edit_projects_bread_crumb_first_link: 'Modifier le projet',
         edit_projects_form_header: 'Modifier le projet',
         projects_form_project_name_field: 'Nom du projet',
         projects_form_email_field: 'Adresse e-mail',
         projects_form_client_field: 'Client',
         projects_form_service_client_field: 'Service client',
         projects_form_user_field: 'Utilisateur',
         projects_form_description_field: 'Description (facultatif)',
         projects_form_add_project_button: 'Enregistrer les modifications',
         projects_form_edit_project_button: 'Enregistrer les modifications',
         projects_form_cancel_button: 'Annuler',
         projects_form_submitting_service_client_button: 'Envoi en cours...',
         projects_name_required_form_error: 'Le nom est requis',
         projects_form_unqiue_project_order_number_error:
           'Le numéro de commande du projet doit être unique',
         projects_batch_number_required_form_error:
           'Le numéro de lot est requis',
         projects_client_required_form_error: 'Le client est requis',
         projects_description_required_form_error: 'La description est requise',
         projects_add_form_success: 'Projet créé avec succès !',
         projects_edit_form_success: 'Le projet a été mis à jour avec succès !',
         projects_form_api_error: 'Alarme serveur interne des projets - API',
         projects_no_record_found: 'Aucun projet trouvé',
         projects_deactivated_message: 'Le projet a été désactivé avec succès',
         projects_activated_message: 'Le projet a été activé avec succès',
         projects_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         projects_bulk_deactivated_message:
           '{{ USERS_COUNT }} projets ont été désactivés avec succès',
         projects_single_stats_table_title: 'Statut',
         /** Devices */
         devices_form_header: 'Appareils',
         devices_all: 'Tous',
         devices_active: 'En ligne',
         devices_inactive: 'Hors ligne',
         devices_error: 'ERREUR',
         devices_register_enabled: 'Activé',
         devices_register_disabled: 'Désactivé',
         devices_add_new: 'Ajouter un nouveau',
         devices_name: 'Nom',
         devices_address: "Adresse d'installation",
         devices_client: 'Client',
         devices_project: 'Projet',
         devices_status: 'Statut',
         devices_description: "Module Thermique d'Appartement",
         device_is_online: 'L\'appareil est "en ligne"',
         device_is_offline: 'L\'appareil est "hors ligne"',
         devices_last_viewed: 'Dernière vue',
         devices_action: 'Action',
         devices_search: 'Recherche',
         devices_row_per_page: 'Lignes par page',
         device_rssi_title: 'RSSI',
         device_status_reg_105_no_error_255: "Pas d'erreur",
         devices_filter_search: 'Rechercher',
         devices_sort_by_filter_label: 'Trier par',
         devices_sort_by_value_1: 'Date (plus récent)',
         devices_sort_by_value_2: 'Date (plus ancien)',
         devices_sort_by_value_3: 'Alphabétique',
         devices_country_filter_label: 'Pays',
         devices_filter_reset_button: 'Réinitialiser',
         devices_filter_delete_button: 'Supprimer',
         devices_table_name: 'Nom',
         devices_table_firmware: 'Firmware',
         devices_table_device_type: "Type d'appareil",
         devices_table_batch_number: 'Numéro de lot',
         devices_table_client: 'Clients',
         devices_table_devices: 'Appareils',
         devices_table_added: 'Date de création',
         devices_table_status: 'Statut',
         devices_table_row_per_page: 'Lignes par page',
         devices_bread_crumb_main_title: 'Appareils',
         add_devices_bread_crumb_first_link: 'Ajouter un appareil',
         add_devices_form_header: 'Ajouter un appareil',
         edit_devices_bread_crumb_first_link: "Modifier l'appareil",
         edit_devices_form_header: "Modifier l'appareil",
         devices_form_device_information_tab: "Informations sur l'appareil",
         devices_form_name_field: "Nom de l'appareil",
         devices_form_type_field: "Type d'appareil",
         devices_form_ip_address_field: 'Adresse IP',
         devices_form_preset_field: 'Préréglage',
         devices_form_project_field: 'Projet',
         devices_form_project_offboarding_error: 'The selected project is currently being offboarded:',
         devices_form_client_field: 'Client',
         devices_form_batch_number_field: 'Numéro de lot',
         devices_form_serial_number_field: 'Numéro de série Mercurius',
         devices_form_box_serial_number_field:
           "Numéro de série Unité d'interface thermique",
         devices_form_firmware_field: 'Version du firmware',
         devices_form_description_field: "Module Thermique d'Appartement",
         devices_form_device_address_tab: "Adresse d'installation",
         devices_form_street_number_field: 'Rue',
         devices_form_house_number_field: 'Numéro de maison',
         devices_form_postal_code_field: 'Code postal',
         devices_form_neighbourhood_field: 'Informations supplémentaires',
         devices_form_city_field: 'Ville',
         devices_form_country_field: 'Pays',
         devices_form_floor_number_field: 'Étage',
         devices_form_building_number_field: 'Numéro de construction',
         devices_form_additional_information_tab:
           'Informations supplémentaires',
         devices_form_sn_heat_unit_field:
           'Numéro de série unité d’interface thermique',
         devices_form_article_number_field:
           'Numéro d’article unité d’interface thermique',
         devices_form_prod_order_nr_week_field:
           'Numéro de commande de production',
         devices_form_serial_number_mercurius_field:
           'Numéro de série Mercurius',
         devices_form_sim_card_number_field: 'Numéro de carte SIM',
         devices_form_customer_ref_field: 'Référence du client',
         devices_form_production_date_field: 'Date de production',
         devices_form_order_number_field: 'Numéro de commande',
         devices_form_product_number_field: 'Numéro d’article',
         devices_form_model_number_field: 'Numéro de modèle',
         devices_form_note_field: 'Note (facultatif)',
         devices_form_settings_tab: 'Réglages',
         devices_form_device_interval_field: 'Intervalle',
         devices_form_is_device_enabled_sensor_field:
           'Activer les données du capteur',
         devices_form_is_device_activated_field: "Désactiver l'appareil",
         devices_form_mbus_tab: 'M-Bus',
         devices_form_is_device_enabled_heat_meter_field:
           'Activer le compteur de chaleur',
         devices_form_is_device_enabled_cool_meter_field:
           'Activer le compteur de froid',
         devices_form_is_device_enabled_electric_meter_field:
           "Activer le compteur d'électricité",
         devices_form_is_device_enabled_bi_directional_meter_field:
           'Activer le compteur de chaleur/froid',
         devices_form_is_device_enabled_water_meter_field:
           "Activer le compteur d'eau",
         devices_form_is_device_enabled_mbus_search_meter_button:
           'Recherche M-Bus',
         devices_form_add_device_button: 'Ajouter un appareil',
         devices_form_edit_device_button: 'Enregistrer les modifications',
         devices_form_cancel_button: 'Annuler',
         devices_form_submitting_service_client_button:
           'En cours de soumission...',
         devices_name_required_form_error: 'Le nom est requis',
         devices_batch_number_required_form_error:
           'Le numéro de lot est requis',
         devices_serial_number_required_form_error:
           'Le numéro de série est requis',
         devices_sn_heat_number_numeric_form_error:
           "Le numéro de série de l'unité d'interface thermique doit être un nombre",
         devices_article_number_form_error: 'Le numéro d’article est requis',
         devices_prod_order_nr_week_form_error:
           'Le numéro de commande de production est requis',
         devices_serial_number_mercurius_form_error:
           'Le numéro de série Mercurius est requis',
         devices_sim_card_number_form_error:
           'Le numéro de carte SIM est requis',
         devices_device_interval_numeric_form_error:
           "L'intervalle de l'appareil doit être un nombre",
         devices_client_required_form_error: 'Le client est requis',
         devices_project_required_form_error: 'Le projet est requis',
         devices_preset_required_form_error: 'Le préréglage est requis',
         devices_description_required_form_error: 'La description est requise',
         devices_add_form_success: 'Appareil créé avec succès !',
         devices_edit_form_success: "L'appareil a été mis à jour avec succès !",
         devices_form_unique_error:
           "Le numéro de série de l'unité d'interface thermique et le numéro de série Mercurius doivent être uniques",
         devices_form_api_error: 'Alarme interne - API des appareils',
         devices_no_record_found: 'Aucun appareil trouvé',
         substations_no_record_found: 'Aucune sous-station trouvée',
         devices_deactivated_message: "L'appareil a été désactivé avec succès",
         devices_activated_message: "L'appareil a été activé avec succès",
         devices_search_mbus_registers_success:
           "Le message a été envoyé avec succès à l'appareil.",
         devices_search_mbus_registers_missing_serial_number_error:
           'Veuillez remplir le numéro de série pour continuer.',
         devices_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         devices_bulk_deactivated_message:
           '{{ USERS_COUNT }} appareils ont été désactivés avec succès',
         // Devices Single
         device_single_page_title: "Détails de l'appareil",
         devices_single_bread_crumb_main_title: "Vue d'ensemble de l'appareil",
         devices_single_bread_crumb_first_link: "Page de l'appareil",
         devices_single_basic_details_client: 'CLIENT',
         devices_single_basic_details_serial_number:
           'NUMÉRO DE SÉRIE MERCURIUS',
         devices_single_basic_details_firmware: 'FIRMWARE',
         devices_single_basic_details_type: "TYPE D'APPAREIL",
         devices_single_edit_device_button: "Modifier l'appareil",
         device_single_error_status: 'Erreur',
         device_single_online_status: 'En ligne',
         device_single_offline_status: 'Hors ligne',
         device_single_rss_device_status: "Statut de l'appareil",
         device_single_rss_signal_strength: 'Force du signal',
         device_single_temperature_tab: 'Graphique de température',
         device_single_temperature_title:
           "Historique de l'unité d'interface thermique",
         device_single_temperature_hr: 'Heure',
         device_single_registers_tab: 'Registres',
         device_single_event_tab: 'Événements',
         device_single_device_details_tab: 'Infos',
         device_single_device_api_timer_seconds_label: 'Secondes',
         device_single_device_api_timer_minute_label: 'Minute',
         device_single_device_api_timer_minutes_label: 'Minutes',
         device_single_recall_device_status_api_timer_field: 'Intervalle API',
         devices_single_last_seen: 'Dernière connexion',
         devices_single_fetch_registers: 'COLLECTE DE DONNÉES',
         device_fetch_registers_success:
           "La demande a été envoyée avec succès à l'appareil.",
         write_registers_success:
           "Le message d'écriture a été envoyé avec succès à l'appareil.",
         write_registers_error: 'Veuillez changer la valeur pour continuer.',
         fetch_registers_m_bus_meters_not_supported:
           'Les compteurs M-Bus ne sont pas pris en charge pour le moment.',
         // Operating Status
         business_situation_operating_status_TR03_title:
           "État de fonctionnement de l'unité d'interface thermique",
         device_status_nr: 'NR',
         device_status_name: 'Nom',
         device_status_value: 'Valeur',
         business_situation_operating_status_TR03_100: 'État de chauffage',
         business_situation_operating_status_TR03_100_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Demande',
             3: 'Circulation après',
             4: 'Désactivé',
             5: 'Circulation avant',
           },
         }),
         business_situation_operating_status_TR03_101: "État de l'eau chaude",
         business_situation_operating_status_TR03_101_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Demande',
             3: 'Circulation après',
             4: 'Désactivé',
           },
         }),
         business_situation_operating_status_TR03_102: 'État de préchauffage',
         business_situation_operating_status_TR03_102_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
           },
         }),
         business_situation_operating_status_TR03_103:
           'État de désinfection thermique',
         business_situation_operating_status_TR03_103_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Demande',
             3: 'Circulation après',
             4: 'Désactivé',
           },
         }),
         business_situation_operating_status_TR03_104:
           'État de refroidissement',
         business_situation_operating_status_TR03_104_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Initialisation',
             3: 'Demande',
             4: 'Circulation après',
             5: 'Circulation avant',
           },
         }),
         business_situation_operating_status_TR03_1802:
           "État de l'élément chauffant TE",
         business_situation_operating_status_TR03_1802_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         business_situation_operating_status_TR03_105: "Code d'alarme",
         business_situation_operating_status_TR03_106: 'Version du logiciel',
         business_situation_operating_status_TR03_107:
           "Vanne d'eau chaude (M1)",
         business_situation_operating_status_TR03_108:
           'Vanne de chauffage/refroidissement (M2)',
         business_situation_operating_status_TR03_109: 'Pompe',
         business_situation_operating_status_TR03_109_list: JSON.stringify({
           list: {
             0: 'Désactivée',
             1: 'Activée',
           },
         }),
         business_situation_operating_status_TR03_110: 'Vanne 6 voies',
         business_situation_operating_status_TR03_110_list: JSON.stringify({
           list: {
             0: 'Position : Chauffage',
             1: 'Position : Refroidissement',
           },
         }),
         business_situation_operating_status_TR03_112_list: JSON.stringify({
           list: {
             0: 'Chauffage ou demande',
             1: 'Refroidissement',
           },
         }),
         business_situation_operating_status_TR03_113:
           "Entrée du thermostat d'ambiance",
         business_situation_operating_status_TR03_113_list: JSON.stringify({
           list: {
             1: 'Pas de demande de chauffage',
             2: 'Demande de chauffage',
           },
         }),
         business_situation_operating_status_TR03_114: 'Indicateur OpenTherm',
         business_situation_operating_status_TR03_114_list: JSON.stringify({
           list: {
             0: 'Connexion inactive',
             1: 'Connexion active',
           },
         }),
         business_situation_operating_status_TR03_115: "Type d'appareil",
         // Business situation
         business_situation_measured_values_TR03_title: 'Mesures',
         business_situation_measured_values_TR03_200: "Débit d'eau chaude",
         business_situation_measured_values_TR03_201:
           "Température de l'eau chaude",
         business_situation_measured_values_TR03_202:
           'Approvisionnement primaire',
         business_situation_measured_values_TR03_203:
           'Retour primaire/Extérieur',
         business_situation_measured_values_TR03_205:
           'Approvisionnement secondaire',
         business_situation_measured_values_TR03_206: 'Retour secondaire',
         business_situation_measured_values_TR03_204:
           'Point de consigne de chauffage calculé',
         business_situation_measured_values_TR03_207:
           'Température ambiante (OpenTherm)',
         business_situation_measured_values_TR03_208:
           'Point de consigne de la pièce (OpenTherm)',
         business_situation_measured_values_TR03_210:
           "Pression d'eau secondaire",
         business_situation_measured_values_TR03_263: '% pump power',
         // Operating time
         business_situation_operating_time_TR03_title:
           'Temps de fonctionnement',
         business_situation_operating_time_TR03_800:
           'Temps de fonctionnement total du système',
         business_situation_operating_time_TR03_801:
           'Temps de combustion de chauffage',
         business_situation_operating_time_TR03_802:
           'Temps de combustion de refroidissement',
         business_situation_operating_time_TR03_803:
           "Temps de combustion de l'eau chaude",
         business_situation_operating_time_TR03_804: 'Nombre de puisages',
         business_situation_operating_time_TR03_805: "Volume d'eau chaude",
         business_situation_operating_time_TR03_806: 'Coupures de courant',
         // Warmtapwater
         settings_dhw_warm_tap_water_TR03_title:
           'Réglages eau chaude sanitaire',
         settings_dhw_warm_tap_water_TR03_300:
           "Point de consigne de l'eau chaude",
         settings_dhw_warm_tap_water_TR03_301: 'Mode préchauffage',
         settings_dhw_warm_tap_water_TR03_301_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Antigel',
             2: 'Économie',
             3: 'Confort',
             4: 'Dynamique (recommandé)',
           },
         }),
         settings_dhw_warm_tap_water_TR03_302: 'Point de consigne de confort',
         settings_dhw_warm_tap_water_TR03_303: 'Seuil de débit minimal',
         settings_dhw_warm_tap_water_TR03_304: "Activation de l'eau chaude",
         settings_dhw_warm_tap_water_TR03_304_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         // Thermal disinfection
         settings_thermal_disinfection_TR03_title:
           'Réglages Désinfection thermique',
         settings_thermal_disinfection_TR03_400:
           'Désinfection thermique activée',
         settings_thermal_disinfection_TR03_400_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_thermal_disinfection_TR03_401:
           'Point de consigne de désinfection thermique',
         settings_thermal_disinfection_TR03_402:
           'Durée de combustion de la désinfection thermique',
         settings_thermal_disinfection_TR03_403:
           "Temps d'attente de la désinfection thermique",
         // TE-Booster
         settings_dhw_te_booster_TR03_title: 'Réglages TE-Booster',
         settings_dhw_te_booster_TR03_1800: 'TE-Booster',
         settings_dhw_te_booster_TR03_1800_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_dhw_te_booster_TR03_1804: 'Point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1805:
           'Hystérésis du point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1812:
           'Délai du point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1813:
           'Minuteur du point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1815: 'Seuil TE-Booster',
         settings_dhw_te_booster_TR03_1816: 'Volume enregistré TE-Booster',
         // Heating
         heating_and_cooling_settings_heating_TR03_title: 'Réglages chauffage',
         heating_and_cooling_settings_heating_TR03_500:
           'Point de consigne maximal chauffage',
         heating_and_cooling_settings_heating_TR03_501:
           'Point de consigne minimal chauffage',
         heating_and_cooling_settings_heating_TR03_506:
           'Retour primaire maximal',
         heating_and_cooling_settings_heating_TR03_507:
           'Facteur de compensation de retour primaire',
         heating_and_cooling_settings_heating_TR03_508:
           'Différence de consigne primaire-secondaire',
         heating_and_cooling_settings_heating_TR03_510:
           'Température maximale de chauffage',
         heating_and_cooling_settings_heating_TR03_509:
           'Différence minimale primaire-secondaire',
         heating_and_cooling_settings_heating_TR03_514:
           'Point de consigne de chauffage',
         heating_and_cooling_settings_heating_TR03_515:
           'Activation du chauffage',
         heating_and_cooling_settings_heating_TR03_515_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         // Cooling
         heating_and_cooling_settings_cooling_TR03_title:
           'Réglages refroidissement',
         heating_and_cooling_settings_cooling_TR03_600:
           'Point de consigne de refroidissement',
         heating_and_cooling_settings_cooling_TR03_601:
           'Retour primaire minimal',
         heating_and_cooling_settings_cooling_TR03_602:
           'Facteur de compensation de retour primaire',
         heating_and_cooling_settings_cooling_TR03_605:
           'Température maximale de refroidissement',
         heating_and_cooling_settings_cooling_TR03_606:
           'Point de consigne de refroidissement minimal',
         heating_and_cooling_settings_cooling_TR03_607:
           'Point de consigne de refroidissement maximal',
         heating_and_cooling_settings_cooling_TR03_611:
           'Activation du refroidissement',
         heating_and_cooling_settings_cooling_TR03_611_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         // Secondary General
         heating_and_cooling_settings_secondary_general_TR03_title:
           'Réglages généraux',
         heating_and_cooling_settings_secondary_general_TR03_512:
           'Pression minimale',
         heating_and_cooling_settings_secondary_general_TR03_513:
           'Pression maximale',
         heating_and_cooling_settings_secondary_general_TR03_603:
           "Temps d'attente pour basculer chauffage et refroidissement",
         heating_and_cooling_settings_secondary_general_TR03_604:
           "Temps d'attente de la vanne 6 voies",
         // Changeover WKW
         heating_and_cooling_settings_changeover_wkw_TR03_title:
           'Réglages systèmes 3,5 tubes',
         heating_and_cooling_settings_changeover_wkw_TR03_1850:
           'Configuration 3,5 tubes',
         heating_and_cooling_settings_changeover_wkw_TR03_1850_list: JSON.stringify(
           {
             list: {
               0: 'Chauffage',
               1: 'Refroidissement',
             },
           },
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1851:
           'Seuil de détection du refroidissement',
         heating_and_cooling_settings_changeover_wkw_TR03_1852:
           'Seuil de détection du chauffage',
         heating_and_cooling_settings_changeover_wkw_TR03_1853:
           'Point de consigne de chauffage abaissé',
         heating_and_cooling_settings_changeover_wkw_TR03_1854:
           'Point de consigne abaissé utilisé',
         heating_and_cooling_settings_changeover_wkw_TR03_1854_list: JSON.stringify(
           {
             list: {
               0: 'Désactivé',
               1: 'Activé',
             },
           },
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1855:
           'Position de pré-détection M2',
         heating_and_cooling_settings_changeover_wkw_TR03_1856:
           'Intervalle de détection',
         heating_and_cooling_settings_changeover_wkw_TR03_1857:
           "Minuteur de l'intervalle de détection",
         heating_and_cooling_settings_changeover_wkw_TR03_1858:
           'Délai de pré-détection',
         heating_and_cooling_settings_changeover_wkw_TR03_1859:
           'Minuteur de pré-détection',
         heating_and_cooling_settings_changeover_wkw_TR03_1860:
           'Minuteur de bascule de configuration',
         heating_and_cooling_settings_changeover_wkw_TR03_1861:
           'Délai de bascule',
         heating_and_cooling_settings_changeover_wkw_TR03_1862:
           'Seuil de bascule de configuration',
         heating_and_cooling_settings_changeover_wkw_TR03_1863:
           'Mode de fonction Boost',
         heating_and_cooling_settings_changeover_wkw_TR03_1863_list: JSON.stringify(
           {
             list: {
               0: 'Désactivé',
               1: 'Activé',
             },
           },
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1864:
           'Minuteur de détection Boost',
         heating_and_cooling_settings_changeover_wkw_TR03_1865:
           'Délai de détection Boost',
         heating_and_cooling_settings_changeover_wkw_TR03_1866:
           'Position de boost maximale',
         // Manual Operation
         settings_manual_operation_TR03_title: 'Contrôle manuel',
         settings_manual_operation_TR03_700: 'Activation du contrôle manuel',
         settings_manual_operation_TR03_700_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_manual_operation_TR03_701: 'Vanve eau chaude (M1)',
         settings_manual_operation_TR03_702:
           'Vanve chauffage/refroidissement (M2)',
         settings_manual_operation_TR03_703: 'Pompe',
         settings_manual_operation_TR03_703_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_manual_operation_TR03_704: 'Vanne 6 voies',
         settings_manual_operation_TR03_704_list: JSON.stringify({
           list: {
             0: 'Chauffage',
             1: 'Refroidissement',
           },
         }),
         settings_manual_operation_TR03_706: 'État de la demande de chaleur',
         settings_manual_operation_TR03_706_list: JSON.stringify({
           list: {
             0: 'Chauffage ou demande',
             1: 'Refroidissement',
           },
         }),
         settings_manual_operation_TR03_707: 'Vanve eau chaude (M1) [%]',
         settings_manual_operation_TR03_708:
           'Vanve chauffage/refroidissement (M2) [%]',
         settings_manual_operation_TR03_1801: 'Élément électrique TE-Booster',
         settings_manual_operation_TR03_1801_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_manual_operation_TR03_709: 'Manual control timeout timer',
         // Live Tap Water
         live_tap_water_title: 'Eau Chaude en Temps Réel',
         live_tap_water_101: "État de l'eau chaude",
         live_tap_water_107: 'Vanve eau chaude (M1)',
         live_tap_water_200: 'Débit',
         live_tap_water_201: "Température de l'eau chaude",
         live_tap_water_202: 'Approvisionnement primaire',
         live_tap_water_203: 'Retour primaire',
         live_tap_water_1007: 'Débit primaire compteur M-Bus',
         live_tap_water_1008: 'Puissance',
         // Live CV
         live_cv_title: 'Chauffage en Temps Réel',
         live_cv_100: 'État de chauffage',
         live_cv_108: 'Vanve chauffage (M2)',
         live_cv_202: 'Approvisionnement primaire',
         live_cv_203: 'Retour primaire',
         live_cv_204: 'Point de consigne de chauffage calculé',
         live_cv_205: 'Approvisionnement secondaire',
         live_cv_206: 'Retour secondaire',
         live_cv_113: "Entrée thermostat d'ambiance",
         live_cv_210: "Pression d'eau secondaire",
         live_cv_1007: 'Débit primaire compteur M-Bus',
         live_cv_1008: 'Puissance',
         // Live Cooling
         live_cooling_title: 'Refroidissement en Temps Réel',
         live_cooling_104: 'État de refroidissement',
         live_cooling_109: 'Pompe',
         live_cooling_110: 'Vanne 6 voies',
         live_cooling_113: "Entrée thermostat d'ambiance",
         live_cooling_108: 'Vanne de refroidissement (M2)',
         live_cooling_202: 'Approvisionnement primaire',
         live_cooling_204: 'Point de consigne de chauffage calculé',
         live_cooling_205: 'Approvisionnement secondaire',
         live_cooling_206: 'Retour secondaire',
         // M Bus Limit DELETE ALL
         m_bus_limit_title: 'Limitation du Bus M',
         m_bus_limit_1500: 'Activation de la limitation',
         m_bus_limit_1501: 'Numéro de série du compteur limité',
         m_bus_limit_1503: 'État de limitation',
         m_bus_limit_1504: 'Configuration de limitation EC (h) et ECS (b)',
         m_bus_limit_1505: 'Limitation de puissance',
         m_bus_limit_1506: 'Limitation de débit',
         m_bus_limit_1507:
           'Limitation de température de retour (Uniquement pour ECS)',
         // Meter 1
         m_bus_meter_1_title: 'Compteur 1 (Chauffage)',
         m_bus_meter_1_0000: 'Numéro de série',
         m_bus_meter_1_0002: 'Fabricant',
         m_bus_meter_1_0003: 'Type de compteur',
         m_bus_meter_1_0004: 'État',
         m_bus_meter_1_0005: 'Débit',
         m_bus_meter_1_0006: 'Puissance',
         m_bus_meter_1_0007: "Température d'alimentation",
         m_bus_meter_1_0008: 'Température de retour',
         m_bus_meter_1_0010: 'Énergie de chauffage accumulée',
         m_bus_meter_1_0012: 'Volume accumulé',
         // Meter 2
         m_bus_meter_2_title: 'Compteur 2 (Refroidissement)',
         m_bus_meter_2_0100: 'Numéro de série',
         m_bus_meter_2_0102: 'Fabricant',
         m_bus_meter_2_0103: 'Type de compteur',
         m_bus_meter_2_0104: 'État',
         m_bus_meter_2_0105: 'Débit',
         m_bus_meter_2_0106: 'Puissance',
         m_bus_meter_2_0107: "Température d'alimentation",
         m_bus_meter_2_0108: 'Température de retour',
         m_bus_meter_2_0110: 'Énergie de refroidissement accumulée',
         m_bus_meter_2_0112: 'Volume accumulé',
         // Meter 3
         m_bus_meter_3_title: 'Compteur 3 (Électricité)',
         m_bus_meter_3_0200: 'Numéro de série',
         m_bus_meter_3_0202: 'Fabricant',
         m_bus_meter_3_0203: 'Type de compteur',
         m_bus_meter_3_0204: 'État',
         m_bus_meter_3_0206: 'Puissance',
         m_bus_meter_3_0210: 'Énergie accumulée',
         m_bus_meter_3_0214: 'Courant',
         // Meter 4
         m_bus_meter_4_title: 'Compteur 4 (Eau)',
         m_bus_meter_4_0300: 'Numéro de série',
         m_bus_meter_4_0302: 'Fabricant',
         m_bus_meter_4_0303: 'Type de compteur',
         m_bus_meter_4_0304: 'État',
         m_bus_meter_4_0305: 'Débit',
         m_bus_meter_4_0307: "Température d'alimentation (si disponible)",
         m_bus_meter_4_0312: 'Volume accumulé',
         // Meter 5
         m_bus_meter_5_title: 'Compteur 5 (Bidirectionnel)',
         m_bus_meter_5_0400: 'Numéro de série',
         m_bus_meter_5_0402: 'Fabricant',
         m_bus_meter_5_0403: 'Type de compteur',
         m_bus_meter_5_0404: 'État',
         m_bus_meter_5_0405: 'Débit',
         m_bus_meter_5_0406: 'Puissance',
         m_bus_meter_5_0407: "Température d'alimentation",
         m_bus_meter_5_0408: 'Température de retour',
         m_bus_meter_5_0410: 'Énergie de chauffage accumulée',
         m_bus_meter_5_0412: 'Volume accumulé',
         m_bus_meter_5_0414: 'Énergie de refroidissement accumulée',
         // History Block Alarms
         history_block_errors_title:
           "Erreurs de Bloc d'Historique - triées par les plus récentes",
         history_block_errors_860: 'Alarme de Bloc 1',
         history_block_errors_861: 'Alarme de Bloc 2',
         history_block_errors_862: 'Alarme de Bloc 3',
         history_block_errors_863: 'Alarme de Bloc 4',
         history_block_errors_864: 'Alarme de Bloc 5',
         history_block_errors_865: 'Alarme de Bloc 6',
         history_block_errors_866: 'Alarme de Bloc 7',
         history_block_errors_867: 'Alarme de Bloc 8',
         history_block_errors_868: 'Alarme de Bloc 9',
         history_block_errors_869: 'Alarme de Bloc 10',
         history_block_errors_870: 'Alarme de Bloc 11',
         history_block_errors_871: 'Alarme de Bloc 12',
         history_block_errors_872: 'Alarme de Bloc 13',
         history_block_errors_873: 'Alarme de Bloc 14',
         history_block_errors_874: 'Alarme de Bloc 15',
         // Events
         device_events_type_filter_label: "Type d'événement",
         device_events_type_filter_value_1: 'Audit',
         device_events_type_filter_value_2: 'Alarme',
         // Presets
         presets: 'Préréglages',
         presets_all: 'Tous',
         presets_active: 'ACTIF',
         presets_inactive: 'INACTIF',
         presets_add_new: 'Ajouter nouveau',
         presets_filter_search: 'Recherche',
         presets_filter_reset_button: 'Réinitialiser',
         presets_filter_delete_button: 'Supprimer',
         presets_table_name: 'Nom',
         presets_table_status: 'Statut',
         presets_updated_date: 'Mis à jour le',
         presets_action: 'Actions',
         presets_table_row_per_page: 'Lignes par page',
         presets_status_menu_list: JSON.stringify([
           {
             key: 'settings_hot_water',
             value: 'Réglages eau chaude',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Réglages chauffage et refroidissement',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Contrôle manuel',
             permission: 'manual-control-tab-read',
           },
         ]),
         add_presets_title: 'Ajouter préréglage',
         edit_presets_title: 'Modifier préréglage',
         presets_form_name_required: 'Le nom du préréglage est requis',
         presets_form_register_required:
           "La valeur d'enregistrement est requise",
         presets_form_add_preset_button: 'Enregistrer les modifications',
         presets_form_edit_preset_button: 'Enregistrer les modifications',
         presets_form_cancel_button: 'Annuler',
         presets_add_form_success: 'Préréglage créé avec succès !',
         presets_edit_form_success: 'Préréglage mis à jour avec succès !',
         presets_form_api_error:
           "Alarme du serveur interne de l'API - Préréglages",
         presets_no_record_found: 'Aucun préréglage trouvé',
         presets_deactivated_message: 'Le préréglage est désactivé avec succès',
         presets_activated_message: 'Le préréglage est activé avec succès',
         presets_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         presets_bulk_deactivated_message:
           '{{ USERS_COUNT }} préréglages sont désactivés avec succès',
         // Audits
         audits: 'Vérifications',
         audits_all: 'Tous',
         audits_active: 'Vérification',
         audits_inactive: 'Alarme',
         audits_filter_search: 'Recherche',
         audits_client_filter_label: 'Client',
         audits_error_code_filter_label: "Code d'alarme",
         audits_project_filter_label: 'Projet',
         audits_order_number_filter_label: 'Numéro de commande',
         audits_events_type_filter_label: "Type d'événement",
         audits_date_range_filter_label: 'Plage de dates',
         audits_events_type_filter_value_1: 'Vérification',
         audits_events_type_filter_value_2: 'Alarme',
         audits_reset_filters_button: 'Réinitialiser',
         audits_date: 'Date',
         audits_device: 'Appareil',
         audits_client: 'Client',
         audits_message: 'Message',
         audits_table_row_per_page: 'Lignes par page',
         audits_table_no_record_found: 'Aucun enregistrement trouvé',
         // Settings
         settings_update_profile_title: 'Mettre à jour le profil',
         settings_notification_title: 'Notifications',
         settings_notification_window_exceptions_title:
           "Notifier en cas d'exceptions de la fenêtre de fonctionnement",
         settings_notification_device_error_title:
           "Notifier lorsqu'un appareil est en mode d'erreur",
         settings_notification_channels_title: 'Canaux de notifications',
         settings_notification_use_email_title: "Utiliser l'email",
         /* Admins */
         admins: 'Administrateurs',
         admins_first_bread_crumb: 'Administrateurs',
         admins_filter_search: 'Recherche',
         admins_add_new: 'Ajouter un utilisateur',
         admins_filter_reset_button: 'Réinitialiser',
         admins_filter_delete_button: 'Désactiver',
         admins_search: 'Recherche',
         admins_all: 'TOUS',
         admins_active: 'ACTIF',
         admins_inactive: 'INACTIF',
         admins_table_name: 'Nom',
         admins_table_address: 'Adresse',
         admins_table_role_id: 'Rôle',
         admins_table_status: 'Statut',
         admins_table_added: 'Date de création',
         admins_table_no_record_found: 'Aucun enregistrement trouvé',
         admins_table_row_per_page: 'Lignes par page',
         admins_no_user_selected_for_de_activation_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         admins_bread_crumb_main_title: 'Administrateurs',
         add_admins_bread_crumb_first_link: 'Ajouter administrateur',
         add_admins_form_header: 'Ajouter administrateur',
         edit_admins_bread_crumb_first_link: 'Modifier administrateur',
         edit_admins_form_header: 'Modifier administrateur',
         admins_form_first_name_field: 'Prénom',
         admins_form_last_name_field: 'Nom de famille',
         admins_form_email_field: 'Adresse email',
         admins_form_official_email_field: 'Adresse email officielle',
         admins_form_phone_field: 'Numéro de téléphone',
         admins_form_official_phone_number_field:
           'Numéro de téléphone officiel',
         admins_form_password_field: 'Mot de passe',
         admins_form_role_id_field: 'Rôle',
         admins_form_select_role_id_field: 'Sélectionner un rôle',
         admins_form_street_number_field: 'Rue',
         admins_form_house_number_field: 'Numéro de maison',
         admins_form_neighbourhood_field: 'Quartier',
         admins_form_postal_code_field: 'Code postal',
         admins_form_city_field: 'Ville',
         admins_form_country_field: 'Pays',
         admins_form_email_verification_field: "Vérification de l'email",
         admins_form_email_verification_sub_title_field:
           "La désactivation de ceci enverra automatiquement un email de vérification à l'administrateur",
         admins_form_add_admin_button: 'Enregistrer les modifications',
         admins_form_edit_admin_button: 'Enregistrer les modifications',
         admins_form_cancel_button: 'Annuler',
         admins_form_submitting_admin_button: 'En cours...',
         admins_first_name_required_form_error: 'Le prénom est requis',
         admins_last_name_required_form_error: 'Le nom de famille est requis',
         admins_email_required_form_error: "L'adresse email est requise",
         admins_email_valid_form_error: 'Doit être une adresse email valide',
         admins_password_required_form_error: 'Le mot de passe est requis',
         admins_country_required_form_error: 'Le pays est requis',
         admins_role_id_required_form_error: 'Le rôle est requis',
         admins_password_form_error:
           'Le mot de passe doit contenir au moins une lettre majuscule, un chiffre et un caractère spécial',
         admins_add_form_success: "L'administrateur est créé avec succès !",
         admins_edit_form_success:
           "L'administrateur est mis à jour avec succès !",
         admins_form_api_error:
           'Erreur interne du serveur API - Administrateurs',
         admins_form_email_error: "L'adresse email existe déjà",
         admins_no_record_found: 'Aucun administrateur trouvé',
         admins_deactivated_message:
           "L'administrateur est désactivé avec succès",
         admins_activated_message: "L'administrateur est activé avec succès",
         admins_email_verified_title: "L'email est vérifié",
         admins_email_verified_sub_title:
           "La désactivation de ceci enverra automatiquement un email de vérification à l'administrateur",
         admins_bulk_no_admin_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         admins_bulk_deactivated_message:
           '{{ USERS_COUNT }} administrateurs sont désactivés avec succès',
         // Search Results
         search_result_title: 'Résultats de la recherche : ',
         search_users: 'Utilisateurs',
         search_clients: 'Clients',
         search_service_clients: 'Clients de service',
         search_devices: 'Appareils',
         search_presets: 'Préréglages',
         search_projects: 'Projets',
         // New Languages
         no_error_devices_found: 'Aucun appareil en erreur trouvé',
         project_single_first_bread_crumb: 'Projets',
         project_single_second_bread_crumb: 'Voir le projet',
         project_single_client_label: 'Client',
         project_single_service_client_label: 'Client de service',
         project_single_devices_label: 'Appareils',
         project_single_edit_button: 'Modifier',
         project_single_devices_tab: 'Appareils',
         client_single_view_more_errors_button: 'Voir plus',
         client_error_single_devices_tab: 'Appareils en alarme',
         client_error_single_device_name: 'Appareil',
         client_error_single_device_error_code: "Code d'alarme",
         client_error_single_device_error_date_time: 'Date',
         devices_bulk_edit_registers_button: 'Modifier le(s) paramètre(s)',
         devices_bulk_edit_ota_button: 'Mise à jour du(des) appareil(s)',
         client_error_single_device_errors_table_row_per_page:
           'Lignes par page',
         client_error_single_device_error_no_record_found:
           'Aucun enregistrement trouvé',
         devices_bulk_edit_registers_title:
           "Mise à jour des paramètres d'appareil en vrac",
         substations_bulk_edit_registers_title: 'Mise à jour groupée des registres de sous-stations',
         heat_pumps_bulk_edit_registers_title: 'Mise à jour groupée des registres de pompes à chaleur',
         devices_bulk_edit_registers_form_submit_button: 'Mise à jour groupée',
         devices_bulk_edit_registers_form_cancel_button: 'Annuler',
         devices_bulk_edit_registers_form_success:
           'Message transmis aux appareils sélectionnés',
         devices_bulk_edit_registers_form_error:
           'Veuillez remplir au moins une valeur de registre',
         devices_bulk_edit_registers_form_api_error:
           'Erreur interne du serveur',
         devices_bulk_edit_ota_title:
           "Mise à jour groupée du firmware d'appareil",
         devices_bulk_edit_ota_form_firmware_field: 'Firmware',
         devices_bulk_edit_ota_form_submit_button:
           'Mettre à jour les appareils',
         substations_bulk_edit_ota_form_submit_button: 'Mettre à jour les sous-stations',
         heat_pumps_bulk_edit_ota_form_submit_button: 'Mettre à jour les pompes à chaleur',
         devices_bulk_edit_ota_form_cancel_button: 'Annuler',
         devices_bulk_edit_ota_form_success:
           'Message transmis aux appareils sélectionnés',
         devices_bulk_edit_ota_form_firmware_required_error: 'Firmware requis',
         devices_bulk_edit_ota_form_api_error:
           'Erreur interne du serveur en vrac',
         devices_bulk_edit_registers_selected_devices:
           'Appareils sélectionnés pour la mise à jour groupée',
         // Device Status Table Pop Over
         custom_popover_min_value: 'Valeur min.',
         custom_popover_max_value: 'Valeur max.',
         custom_popover_list_options: 'Valeurs possibles',
         custom_popover_short_description: 'Description',
         custom_popover_close_modal_button: 'Fermer la fenêtre',
         // Warmtapwater PopOver Short Description
         custom_popover_300_short_description:
           "Température de consigne d'eau chaude",
         custom_popover_301_short_description: 'Mode de préchauffage',
         custom_popover_302_short_description:
           'Température de consigne de confort',
         custom_popover_303_short_description: 'Seuil de débit minimum',
         custom_popover_304_short_description: "Activation de l'eau chaude",
         // Thermal disinfection PopOver Short Description
         custom_popover_400_short_description: 'Désinfection thermique activée',
         custom_popover_401_short_description:
           'Point de consigne de désinfection thermique',
         custom_popover_402_short_description:
           'Temps de brûlage de la désinfection thermique',
         custom_popover_403_short_description:
           "Temps d'attente de la désinfection thermique",
         // TE-Booster PopOver Short Description
         custom_popover_1800_short_description: 'TE-Booster activé',
         custom_popover_1804_short_description: 'Point de consigne TE-Booster',
         custom_popover_1805_short_description:
           'Hystérésis du point de consigne TE-Booster',
         custom_popover_1812_short_description:
           'Délai du point de consigne TE-Booster',
         custom_popover_1813_short_description:
           'Minuteur du point de consigne TE-Booster',
         custom_popover_1815_short_description: 'Seuil TE-Booster',
         custom_popover_1816_short_description: 'Volume enregistré TE-Booster',
         // Heating PopOver Short Description
         custom_popover_500_short_description:
           'Température de consigne maximale de chauffage',
         custom_popover_501_short_description:
           'Température de consigne minimale de chauffage',
         custom_popover_506_short_description: 'Retour primaire maximal',
         custom_popover_507_short_description:
           'Facteur de compensation de retour primaire',
         custom_popover_508_short_description:
           'Écart de température entre primaire et secondaire',
         custom_popover_510_short_description:
           'Température maximale de chauffage',
         custom_popover_509_short_description:
           'Écart minimal entre primaire et secondaire',
         custom_popover_514_short_description:
           'Température de consigne de chauffage',
         custom_popover_515_short_description: 'Activation du chauffage',
         // Cooling PopOver Short Description
         custom_popover_600_short_description:
           'Température de consigne de refroidissement',
         custom_popover_601_short_description: 'Retour primaire minimal',
         custom_popover_602_short_description:
           'Facteur de compensation de retour primaire',
         custom_popover_605_short_description:
           'Température maximale de refroidissement',
         custom_popover_606_short_description:
           'Température de consigne minimale de refroidissement',
         custom_popover_607_short_description:
           'Température de consigne maximale de refroidissement',
         custom_popover_611_short_description: 'Activation du refroidissement',
         // Secondary General PopOver Short Description
         custom_popover_512_short_description: 'Pression minimale',
         custom_popover_513_short_description: 'Pression maximale',
         custom_popover_603_short_description:
           "Temps d'attente pour basculer entre chauffage et refroidissement",
         custom_popover_604_short_description:
           "Temps d'attente de la vanne 6 voies",
         // Changeover WKW PopOver Short Description
         custom_popover_1850_short_description:
           'Configuration du système 3.5 tuyaux',
         custom_popover_1851_short_description:
           'Seuil de détection du refroidissement',
         custom_popover_1852_short_description:
           'Seuil de détection du chauffage',
         custom_popover_1853_short_description:
           'Point de consigne réduit pour le chauffage',
         custom_popover_1854_short_description:
           'Point de consigne réduit utilisé',
         custom_popover_1855_short_description: 'Position de prédétection M2',
         custom_popover_1856_short_description: 'Intervalle de détection',
         custom_popover_1857_short_description:
           "Minuterie d'intervalle de détection",
         custom_popover_1858_short_description: 'Délai de prédétection',
         custom_popover_1859_short_description: 'Minuterie de prédétection',
         custom_popover_1860_short_description:
           'Minuterie de commutation de configuration',
         custom_popover_1861_short_description: 'Délai de commutation',
         custom_popover_1862_short_description:
           'Seuil de commutation de configuration',
         custom_popover_1863_short_description:
           'Mode de fonctionnement de renforcement',
         custom_popover_1864_short_description:
           'Minuterie de détection de renforcement',
         custom_popover_1865_short_description:
           'Délai de détection de renforcement',
         custom_popover_1866_short_description:
           'Position de renforcement maximale',
         // Manual Operation PopOver Short Description
         custom_popover_700_short_description: 'Activation du contrôle manuel',
         custom_popover_701_short_description: 'Van M1 eau chaude',
         custom_popover_702_short_description:
           'Van M2 chauffage/refroidissement',
         custom_popover_703_short_description: 'Pompe',
         custom_popover_704_short_description: 'Van 6 voies',
         custom_popover_706_short_description:
           "Sortie d'état de la demande de chauffage",
         custom_popover_707_short_description: 'Van M1 eau chaude [%]',
         custom_popover_708_short_description:
           'Van M2 chauffage/refroidissement [%]',
         custom_popover_1801_short_description: 'Élément électrique TE-Booster',
         custom_popover_709_short_description:
           'Minuterie de temporisation de contrôle manuel',
         // Warmtapwater PopOver Long Description
         custom_popover_300_long_description: 'Point de consigne ECS',
         custom_popover_301_long_description: 'Mode de préchauffage',
         custom_popover_302_long_description: 'Point de consigne confort',
         custom_popover_303_long_description: 'Seuil de démarrage du débit',
         custom_popover_304_long_description: "Activation de l'ECS",
         // Thermal disinfection PopOver Long Description
         custom_popover_400_long_description:
           'Activation de la désinfection thermique',
         custom_popover_401_long_description:
           'Point de consigne de désinfection thermique',
         custom_popover_402_long_description:
           'Durée de combustion de désinfection thermique',
         custom_popover_403_long_description:
           "Temps d'attente de désinfection thermique",
         // TE-Booster PopOver Long Description
         custom_popover_1800_long_description: 'Activation du TE-Booster',
         custom_popover_1804_long_description:
           'Point de consigne du TE-Booster',
         custom_popover_1805_long_description:
           'Hystérésis du point de consigne du TE-Booster',
         custom_popover_1812_long_description:
           "Délai d'expiration du point de consigne du TE-Booster",
         custom_popover_1813_long_description:
           'Minuteur du point de consigne du TE-Booster',
         custom_popover_1815_long_description: 'Seuil du TE-Booster',
         custom_popover_1816_long_description:
           'Volume enregistré du TE-Booster',
         // Heating PopOver Long Description
         custom_popover_500_long_description:
           'Température de consigne maximale du chauffage',
         custom_popover_501_long_description:
           'Température de consigne minimale du chauffage',
         custom_popover_506_long_description: 'Retour primaire maximal',
         custom_popover_507_long_description:
           'Facteur de compensation Retour primaire',
         custom_popover_508_long_description: 'Différence de consigne Prim/CH',
         custom_popover_510_long_description:
           'Température maximale de chauffage',
         custom_popover_509_long_description: 'Différence minimale Prim/CH',
         custom_popover_514_long_description:
           'Température de consigne du chauffage',
         custom_popover_515_long_description: 'Activation du chauffage',
         // Cooling PopOver Long Description
         custom_popover_600_long_description:
           'Température de consigne de refroidissement',
         custom_popover_601_long_description:
           'Retour primaire maximal du refroidissement',
         custom_popover_602_long_description:
           'Facteur de compensation % de la consigne maximale',
         custom_popover_605_long_description:
           'Température maximale de refroidissement',
         custom_popover_606_long_description:
           'Température de consigne minimale de refroidissement',
         custom_popover_607_long_description:
           'Température de consigne maximale de refroidissement',
         custom_popover_611_long_description: 'Activation du refroidissement',
         // Secondary General PopOver Long Description
         custom_popover_512_long_description: 'Pression minimale du chauffage',
         custom_popover_513_long_description: 'Pression maximale du chauffage',
         custom_popover_603_long_description:
           "Temps d'attente pour passer du chauffage au refroidissement",
         custom_popover_604_long_description:
           "Temps d'attente de la vanne à 6 voies",
         // Changeover WKW PopOver Long Description
         custom_popover_1850_long_description: 'Configuration de 3,5 tuyaux',
         custom_popover_1851_long_description:
           'Seuil de détection du refroidissement',
         custom_popover_1852_long_description:
           'Seuil de détection du chauffage',
         custom_popover_1853_long_description:
           'Point de consigne de chauffage réduit',
         custom_popover_1854_long_description:
           'Point de consigne réduit utilisé',
         custom_popover_1855_long_description: 'Position MCV2 de prédétection',
         custom_popover_1856_long_description: 'Intervalle de détection',
         custom_popover_1857_long_description:
           "Minuterie d'intervalle de détection",
         custom_popover_1858_long_description: 'Délai de prédétection',
         custom_popover_1859_long_description: 'Minuterie de prédétection',
         custom_popover_1860_long_description:
           'Minuterie de commutation de configuration',
         custom_popover_1861_long_description: 'Délai de commutation',
         custom_popover_1862_long_description:
           'Seuil de commutation de configuration',
         custom_popover_1863_long_description: 'Mode de fonction Boost',
         custom_popover_1864_long_description:
           'Minuterie de détection du Boost',
         custom_popover_1865_long_description: 'Délai de détection du Boost',
         custom_popover_1866_long_description: 'Position de Boost maximale',
         // Manual Operation PopOver Long Description
         custom_popover_700_long_description: 'Contrôle manuel activé',
         custom_popover_701_long_description: 'Contrôle manuel VMC-1',
         custom_popover_702_long_description: 'Contrôle manuel VMC-2',
         custom_popover_703_long_description: 'Contrôle manuel Pompe (P1)',
         custom_popover_704_long_description: 'Valve1',
         custom_popover_706_long_description:
           "Sortie d'état de demande de chaleur",
         custom_popover_707_long_description: 'Contrôle manuel VMC-1 [%]',
         custom_popover_708_long_description: 'Contrôle manuel VMC-2 [%]',
         custom_popover_1801_long_description: 'Élément électrique TE-Booster',
         custom_popover_709_long_description: 'Minuterie de contrôle manuel',
         // API keys
         client_single_api_key_approve_api_key_label: 'Clé API',
         client_single_api_key_app_id_label: 'Identifiant App',
         client_single_api_key_approve_api_key_button: 'Approuver le Compte',
         client_single_api_key_suspend_api_key_button:
           "Suspendre l'Application",
         client_single_api_key_unblock_application_button:
           "Débloquer l'Application",
         client_single_api_key_generate_api_key_button: 'Générer une Clé API',
         client_single_api_key_generate_api_key_success:
           'La Clé API a été générée avec succès',
         client_single_api_key_generate_api_limit_error:
           'Désolé, nous ne pouvons pas régénérer une nouvelle Clé API car la limite de régénération est atteinte.',
         client_single_api_key_generate_api_kong_error:
           "Alarme API Kong. Veuillez contacter l'administrateur.",
         client_single_api_application_suspend_success:
           "L'application Kong a été suspendue avec succès",
         client_single_api_application_unblock_success:
           "L'application Kong a été débloquée avec succès",
         client_single_api_application_suspend_error:
           "L'application est déjà suspendue",
         client_single_api_application_unblock_error:
           "L'application est déjà débloquée",
         client_single_api_key_account_pending_approval:
           "Votre compte n'a pas encore été approuvé. Veuillez contacter l'administrateur pour plus de détails.",
         client_single_api_key_account_suspended:
           "Votre compte est suspendu. Veuillez contacter l'administrateur pour plus de détails.",
         // Clients Form
         kong_temporary_password_subject: 'Compte Kong Créé',
         clients_form_password_field: 'Mot de passe',
         clients_password_required_form_error:
           'Le mot de passe doit contenir au moins une lettre majuscule, un chiffre et un caractère spécial',
         // Devices Form
         devices_form_mbus_meters_are_not_connected:
           'Les compteurs MBus ne sont pas connectés.',
         MBUS_METER_HEATING: 'Compteur de chaleur',
         MBUS_METER_COOLING: 'Compteur de froid',
         MBUS_METER_ELECTRICITY: "Compteur d'électricité",
         MBUS_METER_WATER: "Compteur d'eau",
         MBUS_METER_BI_DIRECTIONAL: 'Compteur de chaleur/froid',
         meter_enabled: 'Activé',
         meter_disabled: 'Désactivé',
         devices_mbus_registers_toggle_register_status_success:
           "Le message a été envoyé avec succès à l'appareil.",
         MBUS_METER_SERIAL_NUMBER: 'Numéro de série',
         MBUS_METER_MANUFACTURER: 'Fabricant',
         MBUS_METER_METER_TYPE: 'Type de compteur',
         MBUS_METER_STATUS: 'Statut',
         MBUS_METER_FLOW: 'Débit',
         MBUS_METER_POWER: 'Puissance',
         MBUS_METER_SUPPLY_TEMPERATURE: 'Température de fourniture',
         MBUS_METER_RETURN_TEMPERATURE: 'Température de retour',
         MBUS_METER_HEATING_ENERGY: 'Énergie de chauffage accumulée',
         MBUS_METER_ELECTRICITY_ENERGY: 'Électricité accumulée',
         MBUS_METER_VOLUME: 'Volume accumulé',
         MBUS_METER_COOLING_ENERGY: 'Énergie de refroidissement accumulée',
         MBUS_METER_CURRENT: 'Courant',
         custom_popover_MBUS_METER_SERIAL_NUMBER_short_description:
           'Numéro de série',
         custom_popover_MBUS_METER_MANUFACTURER_short_description: 'Fabricant',
         custom_popover_MBUS_METER_METER_TYPE_short_description:
           'Type de compteur',
         custom_popover_MBUS_METER_STATUS_short_description: 'Statut',
         custom_popover_MBUS_METER_FLOW_short_description: 'Débit',
         custom_popover_MBUS_METER_POWER_short_description: 'Puissance',
         custom_popover_MBUS_METER_SUPPLY_TEMPERATURE_short_description:
           'Température de fourniture',
         custom_popover_MBUS_METER_RETURN_TEMPERATURE_short_description:
           'Température de retour',
         custom_popover_MBUS_METER_HEATING_ENERGY_short_description:
           'Énergie de chauffage accumulée',
         custom_popover_MBUS_METER_ELECTRICITY_ENERGY_short_description:
           'Électricité accumulée',
         custom_popover_MBUS_METER_VOLUME_short_description: 'Volume accumulé',
         custom_popover_MBUS_METER_COOLING_ENERGY_short_description:
           'Énergie de refroidissement accumulée',
         custom_popover_MBUS_METER_CURRENT_short_description: 'Courant',
         // Device Data Logs Per Device
         device_single_device_registers_tab: 'Définir les registres',
         device_status_interval: 'Intervalle',
         device_status_interval_in_seconds: 'Secondes',
         device_single_set_registers_error:
           'Veuillez sélectionner au moins un registre pour continuer.',
         device_single_set_registers_max_limit_error:
           'You can select a maximum of ##MAX## registers. You have selected ##SELECTED##.',
         device_single_set_registers_success:
           "Le message a été transmis avec succès à l'appareil.",
         device_single_set_register_form_interval_required_error:
           "L'intervalle (en secondes) est requis",
         device_single_set_register_form_interval_numeric_error:
           "L'intervalle (en secondes) doit être numérique",
         device_single_set_register_form_send_button: 'Envoyer',
         device_single_set_register_form_cancel_button: 'Annuler',
         clients_kong_email_error: "L'adresse e-mail existe déjà dans Kong",
         page_title_appending_title: ' | Gestion des données Fortes',
         project_single_device_registers_tab: 'Définir les registres',
         audits_user: 'Utilisateur',
         audits_system_generated: 'Application',
         device_single_project_set_registers_error:
           "Le message n'est pas transmis car aucun appareil n'est lié au projet",
         audits_user_filter_label: 'Utilisateur',
         audits_event_type_field: "Type d'événement",
         audits_select_event_type_field: "Sélectionner le type d'événement",
         audits_select_event_type_incoming_option: 'Entrant',
         audits_select_event_type_outgoing_option: 'Sortant',
         audits_select_event_type_system_generated_option: 'Application',
         audits_table_loading: 'Chargement des événements',
         appliance_type_reference_table_appliance_name: 'Nom',
         appliance_type_reference_table_appliance_type: "Type d'appareil",
         appliance_type_reference_table_updated_at: 'Mis à jour le',
         sidebar_appliance_type_reference_menu: "Types d'appareils",
         appliance_types_register_form_send_button: 'Enregistrer',
         appliance_types_register_form_cancel_button: 'Annuler',
         appliance_types: "Types d'appareils",
         appliance_types_table_no_record_found: 'Aucun enregistrement trouvé',
         appliance_types_table_row_per_page: 'Lignes par page',
         add_appliance_type: "Ajouter un type d'appareil",
         add_appliance_types_form_header: "Ajouter un type d'appareil",
         edit_appliance_types_form_header: "Modifier un type d'appareil",
         appliance_types_add_new: 'Ajouter un nouveau',
         appliance_type_form_name_label: 'Nom',
         appliance_type_form_type_label: "Type d'appareil",
         appliance_type_form_select_type_label:
           "Sélectionner un type d'appareil",
         appliance_name_form_required_error: 'Le nom est requis',
         appliance_type_form_required_error: "Le type d'appareil est requis",
         add_appliance_type_form_success:
           "L'enregistrement du type d'appareil a été créé avec succès",
         add_appliance_type_form_api_error: 'Erreur du serveur interne',
         edit_appliance_type_form_success:
           "L'enregistrement du type d'appareil a été mis à jour avec succès",
         edit_appliance_type_form_api_error: 'Erreur du serveur interne',
         appliance_type_reference_table_filter_reset_button: 'Réinitialiser',
         appliance_type_reference_table_search: 'Rechercher',
         audits_filter_button: 'Filtres',
         device_single_no_registers_are_available:
           "Aucun registre n'est disponible",
         device_single_device_diagnostics_tab: 'Diagnostics',
         device_single_dp_measurement_back_button: 'Précédent',
         device_single_diagnostic_next_button: 'Suivant',
         device_single_dp_measurement_start_button: 'Démarrer',
         device_single_diagnostict_finish_button: 'Terminer',
         device_single_diagnostic_stop_button: 'Arrêter',
         device_single_dp_measurement_refresh_button: 'Actualiser',
         device_single_dp_measurement_event_logs_title: 'Sortie',
         device_single_dp_measurement_select_mbus_meter_button:
           'Sélectionner un compteur M-Bus',
         device_single_dp_measurement_step_1_title:
           'Calcul de la pression différentielle - Choisissez le débit',
         device_single_dp_measurement_pressure_difference_stepper_1_title:
           'Choisissez le débit',
         device_single_dp_measurement_step_1_flow_1_label:
           'Calcul de la pression différentielle',
         device_single_dp_measurement_step_1_flow_2_label:
           'Eau chaude sanitaire',
         device_single_dp_measurement_pressure_difference_step_2_title:
           "Calcul de la pression différentielle - Explication de l'assistant",
         device_single_dp_measurement_pressure_difference_stepper_2_title:
           "Explication de l'assistant",
         device_single_dp_measurement_pressure_difference_step_2_description:
           "La pression différentielle disponible est toujours un problème dans les réseaux collectifs. Grâce à la puissante combinaison d'AquaHeat aflversets et de la plateforme Fortes Data Management, vous pouvez facilement effectuer un calcul de pression différentielle à n'importe quel point de votre réseau collectif grâce à un module convivial. Cela donne une excellente première indication d'une cause possible. Avec ce diagnostic, nous vous permettons de calculer une indication initiale de la différence de pression disponible. <br /><br /><strong>Requis : Le compteur de chaleur doit être connecté au module de communication Mercury</strong>",
         device_single_dp_measurement_pressure_difference_step_3_title:
           'Calcul de la pression différentielle - Contrôle des bons composants',
         device_single_dp_measurement_pressure_difference_stepper_3_title:
           'Registre de commande manuelle',
         device_single_dp_measurement_step_3_pressure_difference_output_1:
           'Sortie 1 - Activation du contrôle manuel',
         device_single_dp_measurement_pressure_difference_output_2:
           'Sortie 2 - Ouverture de la vanne de contrôle',
         device_single_dp_measurement_pressure_difference_step_3_mbus_meter_title:
           "Sélectionner le compteur M-Bus (pour plusieurs compteurs, il s'agit du compteur d'énergie qui enregistre l'eau potable.)",
         device_single_dp_measurement_pressure_difference_stepper_4_title:
           'Sélectionner le bon compteur M-Bus',
         device_single_dp_measurement_pressure_difference_step_4_flow_label:
           'Débit',
         device_single_dp_measurement_pressure_difference_stepper_5_title:
           'Calcul de la pression différentielle',
         device_single_dp_measurement_pressure_difference_output_3:
           'Sortie 3 - Sélectionner le compteur',
         device_single_dp_measurement_pressure_difference_output_4:
           'Sortie 4 - Calcul de la pression différentielle',
         device_single_dp_measurement_pressure_difference_stepper_6_title:
           'Résultat',
         device_single_dp_measurement_pressure_difference_step_6_description:
           "Votre pression différentielle est OK ! Aucune action supplémentaire n'est nécessaire.",
         device_single_dp_measurement_download_button:
           'Télécharger les résultats',
         device_single_dp_measurement_pressure_difference_step_7_description:
           'Le calcul de la pression différentielle a été effectué avec succès.',
         device_single_general_title: 'Général',
         device_single_hotwater_title: 'Eau chaude sanitaire',
         device_single_dp_measurement_hot_water_flow_1_stepper_1_title:
           'Choisir le débit',
         device_single_dp_measurement_hot_water_flow_1_stepper_2_title:
           "Explication de l'assistant",
         device_single_dp_measurement_hot_water_flow_1_stepper_3_title:
           'Ouvrir le robinet',
         device_single_dp_measurement_hot_water_flow_1_stepper_4_title:
           "Vérification du robinet et de la vanne d'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_stepper_5_title:
           'Compteur M-Bus',
         device_single_dp_measurement_hot_water_flow_1_stepper_6_title:
           "Calcul du débit d'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_stepper_7_title:
           'Résultats',
         device_single_dp_measurement_hot_water_flow_1_step_2_title:
           'Mesure de la pression différentielle - Explication du débit',
         device_single_dp_measurement_hot_water_flow_1_step_2_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_3_title:
           'Ouvrir le robinet',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error:
           'Défaut du capteur de débit',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error_one_try_left:
           'Essayez une fois de plus',
         diagnostic_flows_form_open_faucet_title:
           'Le robinet est ouvert par le client',
         diagnostic_flows_form_open_faucet_off_option_description:
           "Le robinet n'est pas ouvert par le client",
         device_single_dp_measurement_hot_water_flow_1_output_1:
           "Sortie 1 - État de l'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_output_2:
           "Sortie 2 - Vanne d'eau chaude (M1)",
         device_single_dp_measurement_hot_water_flow_1_step_3_mbus_meter_title:
           'Sélectionner le compteur M-Bus',
         device_single_dp_measurement_hot_water_flow_1_step_4_flow_label:
           'Débit',
         device_single_dp_measurement_step_4_hot_water_flow_1_output_3:
           'Sortie 3 - Sélectionner le compteur',
         device_single_dp_measurement_hot_water_flow_1_output_4:
           'Sortie 4 - Débit Mbus',
         device_single_dp_measurement_hot_water_flow_1_output_5:
           "Sortie 5 - Calcul du débit d'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_step_7_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_8_description:
           "Les diagnostics du débit d'eau chaude - Flow 1 sont terminés",
         device_single_heating_title: 'Chauffage',
         device_single_dp_measurement_step_1_flow_3_label: 'Débit 1',
         device_single_cooling_title: 'Refroidissement',
         device_single_dp_measurement_step_1_flow_4_label: 'Débit 1',
         device_single_temperature_graph_loading_data:
           'Chargement du graphique',
         device_single_temperature_no_graph_data_error:
           "Le graphique n'est pas disponible",
         device_graph_week_filter: 'S',
         device_graph_weeks_filter: 'S',
         device_graph_day_filter: 'J',
         device_graph_days_filter: 'J',
         device_graph_hours_filter: 'H',
         device_single_registers_table_numeric_error:
           'Seules les valeurs numériques sont autorisées',
         device_single_registers_table_min_max_error:
           'La valeur doit être entre min_value et max_value',
         MBUS_METER_TYPE_WATER: 'Eau',
         MBUS_METER_TYPE_ELECTRICITY: 'Électricité',
         MBUS_METER_TYPE_HEATING: 'Chaleur',
         MBUS_METER_TYPE_BIDIRECTIONAL: 'Chaleur/Froid',
         MBUS_METER_TYPE_COOLING: 'Refroidissement',
         UNKNOWN_MANUFACTURER: 'Fabricant inconnu',
         commissioning_form_header: 'Mise en service',
         commissioning_form_serial_number_scan_button: 'Scanner',
         commissioning_form_heat_interface_unit_scan_button:
           "Scanner l'unité d'interface de chauffage",
         commissioning_form_search_field: 'Numéro de série Mercurius',
         sidebar_commissioning_overview: 'Aperçu de la mise en service',
         sidebar_commissioning: 'Mise en service',
         commissioning_form_success:
           "L'appareil a été mis à jour avec succès !",
         commissioning_error_message: 'Appareil non trouvé',
         commissioning_device_submit_button: "Mettre à jour l'appareil",
         swapping_form_header: "Remplacement d'appareil",
         swapping_old_device_title: 'Ancien appareil',
         swapping_new_device_title: 'Nouvel appareil',
         swapping_form_scan_button: 'Scanner',
         swapping_form_search_field: 'Numéro de série Mercurius',
         sidebar_swapping_overview: "Aperçu du remplacement d'appareil",
         sidebar_swapping: 'Remplacement',
         swapping_form_success: "L'appareil a été remplacé avec succès !",
         swapping_old_device_error_message: 'Ancien appareil non trouvé',
         swapping_new_device_error_message: 'Nouvel appareil non trouvé',
         swapping_audit_message: "L'appareil a été remplacé",
         swapping_device_submit_button: 'Remplacer les appareils',
         email_device_swapping_subject: "Remplacement d'appareil",
         email_device_swapping_recipient_name: 'Fortes Data Management',
         email_device_swapping_title: "Remplacement d'appareil",
         email_device_swapping_old_device_title: 'Ancien appareil',
         email_device_swapping_new_device_title: 'Nouvel appareil',
         email_device_swapped_by: 'Appareil remplacé par :',
         swapping_device_unique_error: "L'appareil existe déjà",
         clear_device_form_header: "Effacer l'appareil",
         clear_device_form_scan_button: 'Scanner',
         clear_device_form_search_field: 'Numéro de série Mercurius',
         sidebar_clear_device_overview: "Effacer l'appareil",
         sidebar_clear_device: "Effacer l'appareil",
         clear_device_form_success: "L'appareil a été effacé avec succès !",
         clear_device_error_message: 'Appareil non trouvé',
         clear_device_submit_button: "Effacer l'appareil",
         clear_device_audit_message: "L'appareil a été effacé",
         device_single_swapped_devices_tab: 'Appareils remplacés',
         devices_single_swapped_old_device_name: 'Swapped From (Old)',
         devices_single_swapped_device_old_firmware: 'Old Firmware',
         devices_single_swapped_device_new_firmware: 'New Firmware',
         devices_single_swapped_old_device_type: 'Old Device Type',
         devices_single_swapped_new_device_type: 'New Device Type',
         devices_single_swapped_device_old_box_serial_number:
           'Old Serial number HIU',
         devices_single_swapped_device_new_box_serial_number:
           'Serial number HIU',
         devices_single_swapped_device_old_sim_card_number: 'Old Sim Number',
         devices_single_swapped_device_new_sim_card_number: 'New Sim Number',
         devices_single_swapped_device_created_at: 'Swapped Date',
         devices_single_swapped_device_name_search: 'Recherche',
         devices_single_swapped_new_device_name: 'Swapped To (New)',
         devices_single_swapped_device_table_no_record_found:
           'Aucun enregistrement trouvé',
         devices_single_swapped_device_table_loading: 'Chargement',
         devices_single_swapped_device_table_row_per_page: 'Lignes par page',
         sidebar_swapped_devices_overview: 'Aperçu des appareils remplacés',
         sidebar_swapped_devices: 'Appareils remplacés',
         swapped_devices_form_header: 'Appareils remplacés',
         devices_bulk_edit_registers_form_no_devices_error:
           'Veuillez sélectionner des appareils pour continuer.',
         devices_bulk_edit_firmware_modal_title:
           'Êtes-vous sûr de vouloir effectuer une mise à jour groupée ?',
         devices_bulk_edit_firmware_modal_subtitle:
           'Voulez-vous effectuer une mise à jour groupée de la version du micrologiciel ##firmware_value## pour ##total_devices## appareils ?',
         devices_bulk_edit_registers_modal_title:
           'Êtes-vous sûr de vouloir effectuer une mise à jour groupée ?',
         devices_bulk_edit_registers_modal_subtitle:
           'Voulez-vous effectuer une mise à jour groupée des registres pour ##total_devices## appareils ?',
         devices_bulk_edit_registers_modal_cancel_button: 'Annuler',
         devices_bulk_edit_registers_modal_submit_button: 'Confirmer',
         devices_bulk_edit_firmware_modal_cancel_button: 'Annuler',
         devices_bulk_edit_firmware_modal_submit_button: 'Confirmer',
         devices_bulk_export_button: 'Exporter les appareils',
         projects_bulk_export_button: 'Exporter les projets',
         project_devices_bulk_export_button: 'Exporter les appareils de projet',
         devices_bulk_export_file_name: "Exportation groupée d'appareils",
         projects_bulk_export_file_name: 'Exportation groupée de projets',
         project_devices_bulk_export_file_name:
           "Exportation groupée d'appareils",
         sidebar_reporting_overview: 'Rapports',
         sidebar_bulk_edit_ota_reporting: 'Rapport OTA',
         sidebar_bulk_reporting_registers_table_title: 'Rapport des registres',
         edit_ota_reporting: 'Audit OTA',
         reporting_ota_bulk_export_button: 'Exporter',
         reporting_ota_filter_reset_button: 'Réinitialiser',
         reporting_ota_table_filter_search: 'Recherche',
         reporting_ota_table_updated_at: 'Date',
         reporting_ota_table_total_devices: 'Total des appareils',
         reporting_ota_table_user: 'Utilisateur',
         reporting_ota_table_message: 'Message',
         reporting_ota_table_no_record_found: 'Aucun enregistrement trouvé',
         reporting_ota_table_row_per_page: 'Lignes par page',
         edit_ota_reporting_details: "Détails de l'audit OTA",
         reporting_ota_details_all_tab: 'Tout',
         reporting_ota_details_pending_tab: 'En attente',
         reporting_ota_details_success_tab: 'Succès',
         reporting_ota_details_failure_tab: 'Échec',
         reporting_ota_details_bulk_export_button: 'Exporter',
         reporting_ota_details_filter_reset_button: 'Réinitialiser',
         reporting_ota_details_table_filter_search: 'Recherche',
         reporting_ota_details_message:
           'La version du micrologiciel a été mise à jour en',
         reporting_ota_details_table_created_at: 'Date',
         reporting_ota_details_table_device: 'Appareil',
         reporting_ota_details_table_user: 'Utilisateur',
         reporting_ota_details_table_old_firmware_version:
           'Ancienne version du micrologiciel',
         reporting_ota_details_table_current_firmware_version:
           'Version actuelle du micrologiciel',
         reporting_ota_details_table_current_status: 'Statut',
         reporting_ota_details_table_message: 'Message',
         reporting_ota_details_table_no_record_found:
           'Aucun enregistrement trouvé',
         reporting_ota_details_table_row_per_page: 'Lignes par page',
         reporting_ota_bulk_export_file_name: 'Rapport OTA groupé',
         reporting_ota_details_bulk_export_file_name:
           'Détails du rapport OTA groupé',
         devices_single_swapped_bulk_export_button_file_name:
           "Rapport d'appareils remplacés",
         devices_single_swapped_bulk_export_button: 'Exporter',
         reporting_registers_table_title: "Rapport d'audit des registres",
         reporting_registers_table_created_at: 'Date',
         reporting_registers_table_total_devices: 'Total des appareils',
         reporting_registers_table_user: 'Utilisateur',
         reporting_registers_table_message: 'Message',
         reporting_registers_bulk_export_button: 'Exporter',
         reporting_registers_filter_reset_button: 'Réinitialiser',
         reporting_registers_table_filter_search: 'Recherche',
         reporting_registers_table_no_record_found:
           'Aucun enregistrement trouvé',
         reporting_registers_table_row_per_page: 'Lignes par page',
         reporting_registers_table_bulk_export_file_name:
           'Rapport groupé des registres',
         registers_reporting_details_title: "Détails de l'audit des registres",
         reporting_registers_details_bulk_export_button: 'Exporter',
         reporting_registers_details_filter_reset_button: 'Réinitialiser',
         reporting_registers_details_table_filter_search: 'Recherche',
         reporting_registers_details_table_created_at: 'Date',
         reporting_registers_details_table_device: 'Appareil',
         reporting_registers_details_table_user: 'Utilisateur',
         reporting_registers_details_table_message: 'Message',
         reporting_registers_details_table_failed_message:
           "La version du micrologiciel n'a pas été mise à jour en",
         reporting_registers_details_table_pending_message:
           'Mise à jour de la version du micrologiciel en cours en',
         reporting_registers_details_table_successful_message:
           'La version du micrologiciel a été mise à jour en',
         reporting_registers_details_table_no_record_found:
           'Aucun enregistrement trouvé',
         reporting_registers_details_table_row_per_page: 'Lignes par page',
         reporting_registers_details_bulk_export_file_name:
           'Détails du rapport groupé des registres',
         devices_bulk_edit_ota_form_firmware_field_select_label:
           'Sélectionnez le micrologiciel',
         dashboard_users_overview: 'Aperçu des utilisateurs',
         dashboard_users_title: 'Utilisateurs',
         dashboard_devices_overview: 'Aperçu des appareils',
         dashboard_devices_title: 'Appareils',
         dashboard_commissioning_overview: 'Aperçu de la mise en service',
         dashboard_commissioning_title: 'Mise en service',
         devices_filters: 'Filtres :',
         devices_submit_button: 'Soumettre',
         device_single_device_documentation_tab: 'Docs',
         device_single_documentation_brochure_button: 'Brochure',
         device_single_documentation_installation_manual_button:
           "Manuel d'installation",
         device_single_documentation_dimensional_drawing_button:
           'Dessin dimensionnel',
         device_single_documentation_parts_drawing_button: 'Dessin des pièces',
         device_single_documentation_flow_direction_button: 'Direction du flux',
         device_single_documentation_principle_diagram_button:
           'Schéma de principe',
         device_single_documentation_information_end_user_button:
           "Information à l'utilisateur final",
         device_single_documentation_malfunction_key_button:
           'Clé de dysfonctionnement',
         reporting_ota_failed_message:
           "La version du micrologiciel n'a pas été mise à jour en",
         reporting_ota_pending_message:
           'Mise à jour de la version du micrologiciel en cours en',
         reporting_ota_successful_message:
           'La version du micrologiciel a été mise à jour en',
         ota_pending: 'En attente',
         ota_success: 'Succès',
         ota_failed: 'Échec',
         clear_devices_modal_title: "Effacer l'appareil",
         clear_devices_modal_subtitle:
           'Êtes-vous sûr de vouloir effacer cet appareil avec le numéro de série <strong>##serial_number##</strong> ?',
         clear_devices_modal_cancel_button: 'Annuler',
         clear_devices_modal_submit_button: "Effacer l'appareil",
         sidebar_fortes_roles: 'Rôles',
         sidebar_fortes_permissions: 'Permissions',
         roles_all: 'Tous',
         roles_active: 'Actif',
         roles_inactive: 'Inactif',
         roles_filter_delete_button: 'Supprimer',
         roles_table_identifier: 'Identifiant',
         roles_table_name_en: 'Nom (EN)',
         roles_table_name_nl: 'Nom (NL)',
         roles_table_description_en: 'Description (EN)',
         roles_table_description_nl: 'Description (NL)',
         roles_table_status: 'Statut',
         roles_table_updated_at: 'Mis à jour le',
         roles_filter_search: 'Recherche',
         roles_no_record_found: 'Aucun enregistrement trouvé',
         roles_table_row_per_page: 'Lignes par page',
         roles_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation groupée.',
         roles_deactivated_message: 'Le rôle a été désactivé avec succès',
         roles_activated_message: 'Le rôle a été activé avec succès',
         roles_bulk_deactivated_message:
           '##ROLES_COUNT## rôles ont été désactivés avec succès',
         roles_title: 'Rôles',
         roles_add_new: 'Ajouter un nouveau',
         roles_bread_crumb_main_title: 'Rôles',
         add_roles_bread_crumb_first_link: 'Ajouter un rôle',
         edit_roles_bread_crumb_first_link: 'Modifier le rôle',
         add_roles_form_header: 'Ajouter un rôle',
         edit_roles_form_header: 'Modifier le rôle',
         roles_form_role_identifier_field: 'Identifiant',
         roles_identifier_required_form_error: "L'identifiant est requis",
         roles_form_role_name_en_field: 'Nom (EN)',
         roles_form_role_name_nl_field: 'Nom (NL)',
         roles_name_en_required_form_error: 'Le nom (EN) est requis',
         roles_name_nl_required_form_error: 'Le nom (NL) est requis',
         roles_form_description_en_field: 'Description (EN)',
         roles_form_description_nl_field: 'Description (NL)',
         roles_form_api_error: 'Erreur interne du serveur',
         roles_form_unqiue_role_name_error: "L'identifiant doit être unique",
         roles_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations pour créer un rôle",
         roles_add_form_success: 'Le rôle a été créé avec succès',
         roles_edit_form_success: 'Le rôle a été mis à jour avec succès',
         roles_form_add_role_button: 'Ajouter un rôle',
         roles_form_edit_role_button: 'Modifier le rôle',
         roles_form_cancel_button: 'Annuler',
         roles_form_permissions_title: 'Permissions',
         sidebar_fortes_modules: 'Modules',
         modules_all: 'Tous',
         modules_active: 'Actif',
         modules_inactive: 'Inactif',
         modules_filter_delete_button: 'Supprimer',
         modules_table_identifier: 'Identifiant',
         modules_table_name_en: 'Nom (EN)',
         modules_table_name_nl: 'Nom (NL)',
         modules_table_description_en: 'Description (EN)',
         modules_table_description_nl: 'Description (NL)',
         modules_table_status: 'Statut',
         modules_table_updated_at: 'Mis à jour le',
         modules_filter_search: 'Recherche',
         modules_no_record_found: 'Aucun enregistrement trouvé',
         modules_table_row_per_page: 'Lignes par page',
         modules_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         modules_deactivated_message: 'Le module a été désactivé avec succès',
         modules_activated_message: 'Le module a été activé avec succès',
         modules_bulk_deactivated_message:
           '##MODULES_COUNT## modules ont été désactivés avec succès',
         modules_title: 'Modules',
         modules_add_new: 'Ajouter un nouveau',
         modules_bread_crumb_main_title: 'Modules',
         add_modules_bread_crumb_first_link: 'Ajouter un module',
         edit_modules_bread_crumb_first_link: 'Modifier le module',
         add_modules_form_header: 'Ajouter un module',
         edit_modules_form_header: 'Modifier le module',
         modules_form_module_identifier_field: 'Identifiant',
         modules_identifier_required_form_error: "L'identifiant est requis",
         modules_form_module_name_en_field: 'Nom (EN)',
         modules_form_module_name_nl_field: 'Nom (NL)',
         modules_name_en_required_form_error: 'Le nom (EN) est requis',
         modules_name_nl_required_form_error: 'Le nom (NL) est requis',
         modules_form_description_en_field: 'Description (EN)',
         modules_form_description_nl_field: 'Description (NL)',
         modules_form_api_error: 'Erreur interne du serveur',
         modules_form_unqiue_module_name_error:
           "L'identifiant doit être unique",
         modules_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations pour créer un module",
         modules_add_form_success: 'Le module a été créé avec succès',
         modules_edit_form_success: 'Le module a été mis à jour avec succès',
         modules_form_add_module_button: 'Ajouter un module',
         modules_form_edit_module_button: 'Modifier le module',
         modules_form_cancel_button: 'Annuler',
         permissions_all: 'Tous',
         permissions_active: 'Actif',
         permissions_inactive: 'Inactif',
         permissions_filter_delete_button: 'Supprimer',
         permissions_table_identifier: 'Identifiant',
         permissions_table_module_name: 'Module',
         permissions_table_name_en: 'Nom (EN)',
         permissions_table_name_nl: 'Nom (NL)',
         permissions_table_description_en: 'Description (EN)',
         permissions_table_description_nl: 'Description (NL)',
         permissions_table_status: 'Statut',
         permissions_filter_search: 'Recherche',
         permissions_no_record_found: 'Aucun enregistrement trouvé',
         permissions_table_row_per_page: 'Lignes par page',
         permissions_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         permissions_deactivated_message:
           'La permission a été désactivée avec succès',
         permissions_activated_message:
           'La permission a été activée avec succès',
         permissions_bulk_deactivated_message:
           '##PERMISSIONS_COUNT## permissions ont été désactivées avec succès',
         permissions_title: 'Permissions',
         permissions_add_new: 'Ajouter une nouvelle',
         permissions_bread_crumb_main_title: 'Permissions',
         add_permissions_bread_crumb_first_link: 'Ajouter une permission',
         edit_permissions_bread_crumb_first_link: 'Modifier la permission',
         edit_permissions_form_header: 'Modifier la permission',
         add_permissions_form_header: 'Ajouter une permission',
         permissions_form_permission_identifier_field: 'Identifiant',
         permissions_form_permission_module_field: 'Module',
         permissions_form_permission_select_module_field:
           'Sélectionner un module',
         permissions_module_required_form_error: 'Le module est requis',
         permissions_identifier_required_form_error: "L'identifiant est requis",
         permissions_form_permission_name_en_field: 'Nom (EN)',
         permissions_form_permission_name_nl_field: 'Nom (NL)',
         permissions_form_permission_sub_module_field: 'Sous-module',
         permissions_form_permission_select_sub_module_field:
           'Sélectionner un sous-module',
         permissions_sub_module_required_form_error:
           'Le sous-module est requis',
         permissions_name_required_form_error: 'Le nom est requis',
         permissions_form_description_en_field: 'Description (EN)',
         permissions_form_description_nl_field: 'Description (NL)',
         permissions_form_api_error: 'Erreur interne du serveur',
         permissions_form_unqiue_permission_name_error:
           "L'identifiant doit être unique",
         permissions_edit_form_success:
           'La permission a été mise à jour avec succès!',
         permissions_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations pour créer une permission",
         permissions_add_form_success: 'La permission a été créée avec succès',
         permissions_form_add_permission_button: 'Ajouter une permission',
         permissions_form_edit_permission_button: 'Modifier la permission',
         permissions_form_cancel_button: 'Annuler',
         permissions_read: 'Lecture',
         permissions_create: 'Créer',
         permissions_update: 'Mettre à jour',
         permissions_delete: 'Supprimer',
         permissions_status: 'Basculer le statut',
         permissions_get_all: 'Tout obtenir',
         permissions_get_by_id: 'Obtenir par ID',
         permissions_bulk_deactivate: 'Désactiver en masse',
         permissions_form_title: 'Permissions',
         duplicate_roles_form_header: 'Dupliquer un rôle',
         duplicate_roles_bread_crumb_first_link: 'Dupliquer un rôle',
         roles_duplicate_form_success: 'Le rôle a été dupliqué avec succès',
         roles_filter_duplicate_button: 'Dupliquer un rôle',
         roles_pre_identifier_required_form_error:
           'Le pré-identifiant est requis',
         roles_form_pre_identifier_field: 'Pré-identifiant',
         roles_form_pre_identifier_select: 'Sélectionner un pré-identifiant',
         duplicate_roles_identifier_message:
           '<ul style="margin: "0", padding-left: 15px"> <li>Pour un nouveau rôle client, commencez toujours l\'identifiant par client_</li> <li>Pour un nouveau rôle de sous-client, commencez toujours l\'identifiant par service_client_</li> <li>Pour un nouveau rôle Fortes, commencez toujours l\'identifiant par fortes_</li> </ul>',
         devices_single_device_counters_title: 'Compteurs du dispositif',
         devices_single_device_counters_offline_counter: 'Compteur hors ligne',
         devices_single_device_counters_online_counter: 'Compteur en ligne',
         devices_single_device_counters_ota_fail_counter:
           "Compteur d'échec OTA",
         devices_single_device_counters_ota_update_counter:
           'Compteur de mises à jour OTA',
         devices_single_device_counters_mbus_error_counter:
           "Compteur d'erreurs MBus",
         devices_single_device_counters_modbus_error_counter:
           "Compteur d'erreurs Modbus",
         devices_single_device_docs_directory: 'Répertoires',
         device_single_documentation_no_documents_found:
           'Aucun document trouvé',
         reporting_registers_details_table_registers_pending:
           'Registres en attente',
         reporting_registers_details_table_registers_updated_fail:
           'Registres mis à jour en échec',
         reporting_registers_details_table_registers_updated_successful:
           'Registres mis à jour avec succès',
         reporting_registers_details_table_status: 'Statut',
         reporting_ota_message: 'Mettre à jour la version du micrologiciel à',
         devices_bulk_edit_registers_form_fix_register_values_error:
           'Veuillez corriger les erreurs dans toutes les onglets',
         login_permission_error:
           "Veuillez obtenir les permissions appropriées auprès de l'administrateur de Fortes",
         monitoring_title: 'Surveillance',
         monitoring_vm_title: 'Machine virtuelle',
         monitoring_ram_title: 'RAM',
         monitoring_cpu_title: 'UC',
         monitoring_disk_title: 'Disque',
         monitoring_restarts_title: 'Redémarrages',
         monitoring_uptime_title: 'Temps de fonctionnement',
         monitoring_services_title: 'Services',
         monitoring_service_table_service_name: 'Nom',
         monitoring_service_table_service_status: 'Statut',
         devices_form_service_client_field: 'Client de service',
         sidebar_kong_users: 'Utilisateurs du client Kong',
         kong_users_title: 'Utilisateurs du client Kong',
         kong_users_table_name: 'Nom',
         kong_users_table_email: 'Email',
         kong_users_table_client: 'Client',
         kong_users_table_updated_at: 'Mis à jour le',
         kong_users_bread_crumb_main_title: 'Utilisateurs du client Kong',
         add_kong_users_bread_crumb_first_link:
           'Ajouter un utilisateur du client Kong',
         add_kong_users_form_header: 'Ajouter un utilisateur du client Kong',
         kong_users_form_name_field: 'Nom',
         kong_users_form_email_field: 'Adresse e-mail',
         kong_users_form_client_field: 'Client',
         kong_users_form_password_field: 'Mot de passe',
         kong_users_name_required_form_error: 'Le nom est requis',
         kong_users_email_valid_form_error:
           'Doit être une adresse e-mail valide',
         kong_users_email_required_form_error: "L'e-mail est requis",
         kong_users_client_required_form_error: 'Le client est requis',
         kong_users_password_required_form_error:
           'Le mot de passe doit contenir au moins 8 caractères avec au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         kong_users_no_record_found: 'Aucun enregistrement trouvé',
         kong_users_table_row_per_page: 'Lignes par page',
         kong_users_add_new: 'Ajouter un utilisateur du client Kong',
         kong_users_filter_search: 'Rechercher',
         kong_user_single_first_bread_crumb: 'Utilisateurs du client Kong',
         kong_user_single_second_bread_crumb:
           'Voir les utilisateurs du client Kong',
         kong_user_single_apis_tab: 'Clés API',
         kong_user_single_edit_button_label: 'Modifier',
         kong_user_single_user_label: 'Utilisateur',
         kong_user_single_email_label: 'Email',
         kong_user_single_client_label: 'Client',
         edit_kong_users_form_header: 'Modifier un utilisateur du client Kong',
         edit_kong_users_bread_crumb_first_link:
           'Modifier un utilisateur du client Kong',
         device_single_temperature_start_date: 'Date de début',
         device_single_temperature_end_date: 'Date de fin',
         device_single_temperature_start_date_error:
           'La date de début doit être inférieure ou égale à la date de fin',
         sidebar_kong_admins: 'Administrateurs Kong',
         kong_user_admins_title: 'Administrateurs Kong',
         kong_user_admins_table_name: 'Nom',
         kong_user_admins_table_email: 'Email',
         kong_user_admins_table_updated_at: 'Mis à jour le',
         kong_user_admins_bread_crumb_main_title: 'Administrateurs Kong',
         add_kong_user_admins_bread_crumb_first_link:
           'Ajouter un administrateur Kong',
         add_kong_user_admins_form_header: 'Ajouter un administrateur Kong',
         kong_user_admins_form_name_field: 'Nom',
         kong_user_admins_form_email_field: 'Adresse e-mail',
         kong_user_admins_form_client_field: 'Administrateur',
         kong_user_admins_form_password_field: 'Mot de passe',
         kong_user_admins_name_required_form_error: 'Le nom est requis',
         kong_user_admins_email_valid_form_error:
           'Doit être une adresse e-mail valide',
         kong_user_admins_email_required_form_error: "L'e-mail est requis",
         kong_user_admins_password_required_form_error:
           'Le mot de passe doit contenir au moins 8 caractères avec au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         kong_user_admins_no_record_found: 'Aucun enregistrement trouvé',
         kong_user_admins_table_row_per_page: 'Lignes par page',
         kong_user_admins_add_new: 'Ajouter un administrateur Kong',
         kong_user_admins_filter_search: 'Rechercher',
         kong_user_admin_single_first_bread_crumb: 'Administrateurs Kong',
         kong_user_admin_single_second_bread_crumb:
           'Voir les administrateurs Kong',
         kong_user_admin_single_apis_tab: 'Clés API',
         kong_user_admin_single_edit_button_label: 'Modifier',
         kong_user_admin_single_user_label: 'Utilisateur',
         kong_user_admin_single_email_label: 'E-mail',
         edit_kong_user_admins_form_header:
           "Modifier l'utilisateur administrateur Kong",
         edit_kong_user_admins_bread_crumb_first_link:
           "Modifier l'utilisateur administrateur Kong",
         projects_project_order_number_required_form_error:
           'Le numéro de commande du projet est requis',
         projects_project_order_number_prefix_form_error:
           'Project Order Number must start with a P followed by 5 numbers, e.g. P12345',
         projects_form_project_order_number_field:
           'Numéro de commande du projet',
         client_error_single_device_address: "Adresse d'installation",
         navbar_notification_mark_all_as_read: 'Tout marquer comme lu',
         navbar_notification_view_all: 'Tout afficher',
         notifications_title: 'Notifications',
         notifications_all: 'Tout',
         notifications_unread: 'Non lu',
         notifications_read: 'Lu',
         notifications_table_title: 'Titre (EN)',
         notifications_table_description: 'Description (EN)',
         notifications_table_notification_type: 'Type de notification',
         notifications_table_notification_category: 'Catégorie de notification',
         notifications_table_date: 'Date',
         notifications_filter_search: 'Recherche',
         notifications_no_record_found: 'Aucun enregistrement trouvé',
         notifications_table_row_per_page: 'Lignes par page',
         add_notifications_form_header: 'Ajouter une notification',
         notifications_title_en_required_form_error: 'Le titre (EN) est requis',
         notifications_title_nl_required_form_error: 'Le titre (NL) est requis',
         notifications_description_en_required_form_error:
           'La description (EN) est requise',
         notifications_description_nl_required_form_error:
           'La description (NL) est requise',
         notifications_form_notification_type_field: 'Type de notification',
         notifications_notification_type_required_form_error:
           'Le type de notification est requis',
         notifications_form_notification_category_field:
           'Catégorie de notification',
         notifications_notification_category_required_form_error:
           'La catégorie de notification est requise',
         notifications_form_title_en_field: 'Titre (EN)',
         notifications_form_title_nl_field: 'Titre (NL)',
         notifications_form_start_date_field: 'Date de début',
         notifications_form_end_date_field: 'Date de fin',
         notifications_form_description_en_field: 'Description (EN)',
         notifications_form_description_nl_field: 'Description (NL)',
         notifications_form_add_button: 'Ajouter une notification',
         notifications_form_edit_button: 'Modifier la notification',
         notifications_form_cancel_button: 'Annuler',
         notifications_add_form_success:
           'La notification a été ajoutée avec succès',
         notifications_form_api_error: 'Erreur interne du serveur',
         notification_type_information: 'Information',
         notification_type_warning: 'Avertissement',
         notification_category_simple: 'Simple',
         notification_category_timebased: 'Basé sur le temps',
         edit_notifications_form_header: 'Modifier la notification',
         sidebar_notification_menu: 'Notifications',
         pop_over_close_button: 'Fermer',
         docs_user_type_end_user: 'Utilisateur final',
         docs_user_type_installer: 'Installateur',
         devices_single_device_docs_no_directory_found:
           'Aucun répertoire trouvé',
         device_single_status_tab: 'Visualisations',
         device_single_status_picture_tab: 'Image',
         device_single_status_principle_tab: 'Principe',
         device_single_status_table_loading: 'Chargement en cours...',
         device_single_status_mbus_export_button: 'Exporter',
         device_single_status_mbus_date_range_filter_label: 'Plage de dates',
         device_single_status_mbus_date_export_label: 'Date',
         device_single_status_mbus_time_export_label: 'Heure',
         device_single_status_mbus_port_export_label: 'Port',
         device_single_status_mbus_meter_connected_at_export_label:
           'Compteur connecté à',
         device_single_status_mbus_meter_status_export_label:
           'Statut du compteur',
         device_single_status_mbus_meter_type_export_label: 'Type de compteur',
         device_single_status_mbus_select_meter_type_export_label:
           'Sélectionner le type de compteur',
         device_single_status_mbus_select_meter_type_error:
           'Le type de compteur est manquant',
         device_single_status_mbus_export_internal_server_error:
           "Erreur interne du serveur lors de l'exportation",
         device_single_status_mbus_export_no_data_found_error:
           'Aucun enregistrement trouvé',
         sidebar_diagnostic_formulas: 'Formules de Diagnostic',
         diagnostic_formulas_all: 'Tout',
         diagnostic_formulas_active: 'Actif',
         diagnostic_formulas_inactive: 'Inactif',
         diagnostic_formulas_filter_delete_button: 'Supprimer',
         diagnostic_formulas_table_identifier: 'Identifiant',
         diagnostic_formulas_table_name_en: 'Nom (EN)',
         diagnostic_formulas_table_name_nl: 'Nom (NL)',
         diagnostic_formulas_table_description_en: 'Description (EN)',
         diagnostic_formulas_table_description_nl: 'Description (NL)',
         diagnostic_formulas_table_formula: 'Formule',
         diagnostic_formulas_table_status: 'Statut',
         diagnostic_formulas_table_updated_at: 'Mis à jour le',
         diagnostic_formulas_filter_search: 'Recherche',
         diagnostic_formulas_no_record_found: 'Aucun enregistrement trouvé',
         diagnostic_formulas_table_row_per_page: 'Lignes par page',
         diagnostic_formulas_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         diagnostic_formulas_deactivated_message:
           'Le diagnostic est désactivé avec succès',
         diagnostic_formulas_activated_message:
           'Le diagnostic est activé avec succès',
         diagnostic_formulas_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## diagnostics sont désactivés avec succès',
         diagnostic_formulas_title: 'Formules de Diagnostics',
         diagnostic_formulas_add_new: 'Ajouter Nouveau',
         diagnostic_formulas_bread_crumb_main_title: 'Formules de Diagnostic',
         add_diagnostic_formulas_bread_crumb_first_link:
           'Ajouter des Formules de Diagnostic',
         edit_diagnostic_formulas_bread_crumb_first_link:
           'Modifier des Formules de Diagnostic',
         add_diagnostic_formulas_form_header:
           'Ajouter des Formules de Diagnostic',
         edit_diagnostic_formulas_form_header:
           'Modifier des Formules de Diagnostic',
         diagnostic_formulas_form_diagnostic_formulas_identifier_field:
           'Identifiant',
         diagnostic_formulas_identifier_required_form_error:
           "L'identifiant est requis",
         diagnostic_formulas_form_diagnostic_formulas_name_en_field: 'Nom (EN)',
         diagnostic_formulas_form_diagnostic_formulas_name_nl_field: 'Nom (NL)',
         diagnostic_formulas_name_en_required_form_error:
           'Le nom (EN) est requis',
         diagnostic_formulas_name_nl_required_form_error:
           'Le nom (NL) est requis',
         diagnostic_formulas_formula_required_form_error:
           'La formule est requise',
         diagnostic_formulas_form_description_en_field: 'Description (EN)',
         diagnostic_formulas_form_description_nl_field: 'Description (NL)',
         diagnostic_formulas_form_forumla_field: 'Formule',
         diagnostic_formulas_form_api_error: 'Erreur interne du serveur',
         diagnostic_formulas_form_unqiue_diagnostic_formulas_name_error:
           "L'identifiant doit être unique",
         diagnostic_formulas_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer des formules de diagnostic",
         diagnostic_formulas_add_form_success:
           'Le diagnostic est créé avec succès',
         diagnostic_formulas_edit_form_success:
           'Le diagnostic est mis à jour avec succès',
         diagnostic_formulas_form_add_diagnostic_formulas_button:
           'Ajouter le Diagnostic',
         diagnostic_formulas_form_edit_diagnostic_formulas_button:
           'Modifier le Diagnostic',
         diagnostic_formulas_form_cancel_button: 'Annuler',
         sidebar_diagnostic_categories: 'Catégories de Diagnostic',
         diagnostic_categories_all: 'Tout',
         diagnostic_categories_active: 'Actif',
         diagnostic_categories_inactive: 'Inactif',
         diagnostic_categories_filter_delete_button: 'Supprimer',
         diagnostic_categories_table_identifier: 'Identifiant',
         diagnostic_categories_table_name_en: 'Nom (EN)',
         diagnostic_categories_table_name_nl: 'Nom (NL)',
         diagnostic_categories_table_description_en: 'Description (EN)',
         diagnostic_categories_table_description_nl: 'Description (NL)',
         diagnostic_categories_table_status: 'Statut',
         diagnostic_categories_table_updated_at: 'Mis à jour le',
         diagnostic_categories_filter_search: 'Recherche',
         diagnostic_categories_no_record_found: 'Aucun enregistrement trouvé',
         diagnostic_categories_table_row_per_page: 'Lignes par page',
         diagnostic_categories_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         diagnostic_categories_deactivated_message:
           'La catégorie est désactivée avec succès',
         diagnostic_categories_activated_message:
           'La catégorie est activée avec succès',
         diagnostic_categories_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## catégories sont désactivées avec succès',
         diagnostic_categories_title: 'Catégories de Diagnostic',
         diagnostic_categories_add_new: 'Ajouter Nouveau',
         diagnostic_categories_bread_crumb_main_title:
           'Catégories de Diagnostic',
         add_diagnostic_categories_bread_crumb_first_link:
           'Ajouter une Catégorie de Diagnostic',
         edit_diagnostic_categories_bread_crumb_first_link:
           'Modifier une Catégorie de Diagnostic',
         add_diagnostic_categories_form_header:
           'Ajouter une Catégorie de Diagnostic',
         edit_diagnostic_categories_form_header:
           'Modifier une Catégorie de Diagnostic',
         diagnostic_categories_form_diagnostic_categories_identifier_field:
           'Identifiant',
         diagnostic_categories_identifier_required_form_error:
           "L'identifiant est requis",
         diagnostic_categories_form_diagnostic_categories_name_en_field:
           'Nom (EN)',
         diagnostic_categories_form_diagnostic_categories_name_nl_field:
           'Nom (NL)',
         diagnostic_categories_name_en_required_form_error:
           'Le nom (EN) est requis',
         diagnostic_categories_name_nl_required_form_error:
           'Le nom (NL) est requis',
         diagnostic_categories_form_description_en_field: 'Description (EN)',
         diagnostic_categories_form_description_nl_field: 'Description (NL)',
         diagnostic_categories_form_api_error: 'Erreur interne du serveur',
         diagnostic_categories_form_unqiue_diagnostic_categories_name_error:
           "L'identifiant doit être unique",
         diagnostic_categories_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer des catégories de diagnostic",
         diagnostic_categories_add_form_success:
           'La catégorie est créée avec succès',
         diagnostic_categories_edit_form_success:
           'La catégorie est mise à jour avec succès',
         diagnostic_categories_form_add_diagnostic_categories_button:
           'Ajouter une Catégorie',
         diagnostic_categories_form_edit_diagnostic_categories_button:
           'Modifier une Catégorie',
         diagnostic_categories_form_cancel_button: 'Annuler',
         sidebar_diagnostics_overview: 'Diagnostics',
         sidebar_firmware_menu: 'Firmwares',
         firmwares_all: 'Tout',
         firmwares_active: 'Actif',
         firmwares_inactive: 'Inactif',
         firmwares_table_identifier: 'Identifiant',
         firmwares_table_name_en: 'Nom (EN)',
         firmwares_table_name_nl: 'Nom (NL)',
         firmwares_table_firmware: 'Micrologiciel',
         firmwares_table_status: 'Statut',
         firmwares_table_updated_at: 'Mis à jour le',
         firmwares_filter_search: 'Recherche',
         firmwares_no_record_found: 'Aucun enregistrement trouvé',
         firmwares_table_row_per_page: 'Lignes par page',
         firmwares_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         firmwares_deactivated_message:
           'Le micrologiciel est désactivé avec succès',
         firmwares_activated_message: 'Le micrologiciel est activé avec succès',
         firmwares_title: 'Micrologiciels',
         firmwares_add_new: 'Ajouter Nouveau',
         firmwares_bread_crumb_main_title: 'Micrologiciels',
         add_firmwares_bread_crumb_first_link: 'Ajouter un Micrologiciel',
         edit_firmwares_bread_crumb_first_link: 'Modifier un Micrologiciel',
         add_firmwares_form_header: 'Ajouter un Micrologiciel',
         edit_firmwares_form_header: 'Modifier un Micrologiciel',
         firmwares_form_firmware_identifier_field: 'Identifiant',
         firmwares_identifier_required_form_error: "L'identifiant est requis",
         firmwares_form_firmware_name_en_field: 'Nom (EN)',
         firmwares_form_firmware_name_nl_field: 'Nom (NL)',
         firmwares_form_firmware_firmware_field: 'Micrologiciel',
         firmwares_name_en_required_form_error: 'Le nom (EN) est requis',
         firmwares_name_nl_required_form_error: 'Le nom (NL) est requis',
         firmwares_form_description_en_field: 'Description (EN)',
         firmwares_form_description_nl_field: 'Description (NL)',
         firmwares_form_api_error: 'Erreur interne du serveur',
         firmwares_form_unqiue_firmware_name_error:
           "L'identifiant doit être unique",
         firmwares_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer un micrologiciel",
         firmwares_add_form_success: 'Le micrologiciel est créé avec succès',
         firmwares_edit_form_success:
           'Le micrologiciel est mis à jour avec succès',
         firmwares_form_edit_firmware_button: 'Modifier le Micrologiciel',
         firmwares_form_cancel_button: 'Annuler',
         diagnostic_flows_all: 'Tout',
         diagnostic_flows_active: 'Actif',
         diagnostic_flows_inactive: 'Inactif',
         diagnostic_flows_filter_delete_button: 'Supprimer',
         diagnostic_flows_table_identifier: 'Identifiant',
         diagnostic_flows_table_category: 'Catégorie',
         diagnostic_flows_table_name_en: 'Nom (EN)',
         diagnostic_flows_table_name_nl: 'Nom (NL)',
         diagnostic_flows_table_description_en: 'Description (EN)',
         diagnostic_flows_table_description_nl: 'Description (NL)',
         diagnostic_flows_table_status: 'Statut',
         diagnostic_flows_table_updated_at: 'Mis à jour le',
         diagnostic_flows_filter_search: 'Recherche',
         diagnostic_flows_no_record_found: 'Aucun enregistrement trouvé',
         diagnostic_flows_table_row_per_page: 'Lignes par page',
         diagnostic_flows_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         diagnostic_flows_deactivated_message:
           'Le flux est désactivé avec succès',
         diagnostic_flows_activated_message: 'Le flux est activé avec succès',
         diagnostic_flows_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## flux sont désactivés avec succès',
         diagnostic_flows_title: 'Flux de Diagnostic',
         diagnostic_flows_add_new: 'Ajouter Nouveau',
         diagnostic_flows_bread_crumb_main_title: 'Flux de Diagnostic',
         add_diagnostic_flows_bread_crumb_first_link:
           'Ajouter un Flux de Diagnostic',
         edit_diagnostic_flows_bread_crumb_first_link:
           'Modifier un Flux de Diagnostic',
         add_diagnostic_flows_form_header: 'Ajouter un Flux de Diagnostic',
         edit_diagnostic_flows_form_header: 'Modifier un Flux de Diagnostic',
         diagnostic_flows_form_diagnostic_flows_identifier_field: 'Identifiant',
         diagnostic_flows_identifier_required_form_error:
           "L'identifiant est requis",
         diagnostic_flows_form_diagnostic_flows_name_en_field: 'Nom (EN)',
         diagnostic_flows_form_diagnostic_flows_name_nl_field: 'Nom (NL)',
         diagnostic_flows_name_en_required_form_error: 'Le nom (EN) est requis',
         diagnostic_flows_name_nl_required_form_error: 'Le nom (NL) est requis',
         diagnostic_flows_category_required_form_error:
           'La catégorie est requise',
         diagnostic_flows_form_description_en_field: 'Description (EN)',
         diagnostic_flows_form_description_nl_field: 'Description (NL)',
         diagnostic_flows_form_flow_condition_error_field:
           'La condition doit avoir des règles vraies et fausses',
         diagnostic_flows_form_flow_modal_title_field: 'Êtes-vous sûr ?',
         diagnostic_flows_form_flow_modal_subtitle_field:
           'Vous voulez enregistrer les modifications du flux dans le navigateur ?',
         diagnostic_flows_form_flow_modal_cancel_button_field: 'Annuler',
         diagnostic_flows_form_flow_modal_save_button_field:
           'Enregistrer dans le navigateur',
         diagnostic_flows_form_flow_modal_save_success_message:
           'Le flux est enregistré avec succès dans le navigateur',
         diagnostic_flows_form_featured_image_field: 'Image en Vedette',
         diagnostic_flows_form_upload_featured_image_label:
           "Télécharger l'Image en Vedette",
         diagnostic_flows_form_thumbnail_field: 'Miniature',
         diagnostic_flows_form_upload_thumbnail_image_label:
           "Télécharger l'Image Miniature",
         diagnostic_flows_form_api_error: 'Erreur interne du serveur',
         diagnostic_flows_form_unqiue_diagnostic_flows_name_error:
           "L'identifiant doit être unique",
         diagnostic_flows_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer des flux de diagnostic",
         diagnostic_flows_add_form_success:
           'Le Flux de Diagnostic est créé avec succès',
         diagnostic_flows_edit_form_success:
           'Le Flux de Diagnostic est mis à jour avec succès',
         diagnostic_flows_form_add_diagnostic_flows_button: 'Ajouter un Flux',
         diagnostic_flows_form_edit_diagnostic_flows_button: 'Modifier le Flux',
         diagnostic_flows_form_cancel_button: 'Annuler',
         audits_select_event_type_error_option: 'Erreur',
         diagnostic_flows_form_flow_field: 'Flux',
         diagnostic_flows_form_flow_condition_button: 'Condition',
         diagnostic_flows_form_flow_timer_button: 'Minuteur',
         diagnostic_flows_form_flow_normal_node_button: 'Noeud',
         diagnostic_flows_form_flow_download_image_button:
           "Télécharger l'Image",
         diagnostic_flows_form_flow_start_button: 'Démarrer',
         diagnostic_flows_form_flow_end_button: 'Terminer',
         devices_bulk_export_mbus_historic_data_button:
           'Télécharger les données Mbus',
         devices_bulk_export_mbus_historic_data_file_name:
           'Données Historiques Mbus',
         devices_bulk_mbus_download_title:
           'Télécharger les Données Historiques Mbus',
         devices_bulk_bulk_mbus_download_form_date_range: 'Plage de Dates :',
         devices_bulk_bulk_mbus_download_form_submit_button:
           'Télécharger les Données Mbus',
         devices_bulk_bulk_mbus_download_form_cancel_button: 'Annuler',
         devices_bulk_mbus_download_form_success:
           'Les Données Historiques Mbus sont envoyées par email à ##EMAIL## avec succès !',
         devices_bulk_mbus_download_form_api_error: 'Erreur interne du serveur',
         devices_bulk_mbus_download_no_devices_error: '',
         devices_bulk_mbus_download_form_no_devices_error:
           'Veuillez sélectionner des appareils pour continuer.',
         devices_bulk_bulk_mbus_download_modal_title: 'Êtes-vous sûr ?',
         devices_bulk_mbus_download_modal_subtitle:
           'Voulez-vous lancer un téléchargement en masse des données historiques Mbus ?',
         devices_bulk_mbus_download_modal_cancel_button: 'Annuler',
         devices_bulk_mbus_download_modal_submit_button: 'Confirmer',
         projects_bulk_export_mbus_historic_data_button:
           'Télécharger les données Mbus',
         projects_bulk_export_mbus_historic_data_file_name:
           'Données Historiques Mbus',
         projects_bulk_mbus_download_title:
           'Télécharger les Données Historiques Mbus',
         projects_bulk_bulk_mbus_download_form_date_range: 'Plage de Dates :',
         projects_bulk_bulk_mbus_download_form_data_export_type:
           "Type d'Export de Données",
         projects_bulk_bulk_mbus_download_form_data_export_type_combined:
           'Combiné',
         projects_bulk_bulk_mbus_download_form_data_export_type_daily:
           'Journalier',
         projects_bulk_bulk_mbus_download_form_data_export_type_normal:
           'Normal',
         projects_bulk_bulk_mbus_download_form_submit_button:
           'Télécharger les Données Mbus',
         projects_bulk_bulk_mbus_download_form_cancel_button: 'Annuler',
         projects_bulk_mbus_download_form_success:
           'Les Données Historiques Mbus sont envoyées par email à ##EMAIL## avec succès !',
         projects_bulk_mbus_download_form_api_error:
           'Erreur interne du serveur',
         projects_bulk_mbus_download_no_projects_error: '',
         projects_bulk_mbus_download_form_no_projects_error:
           'Veuillez sélectionner des projets pour continuer.',
         projects_bulk_bulk_mbus_download_modal_title: 'Êtes-vous sûr ?',
         projects_bulk_mbus_download_modal_subtitle:
           'Voulez-vous lancer un téléchargement en masse des données historiques Mbus ?',
         projects_bulk_mbus_download_modal_cancel_button: 'Annuler',
         projects_bulk_mbus_download_modal_submit_button: 'Confirmer',
         projects_bulk_mbus_selected_projects: 'Projets Sélectionnés',
         sidebar_diagnostic_flows: 'Flux de Diagnostic',
         diagnostic_flows_form_diagnostic_flows_category_field:
           'Catégorie de Flux de Diagnostic',
         diagnostics_send_message_modal_registers_label: 'Registres',
         diagnostics_send_message_modal_operator_label: 'Opérateur',
         diagnostics_send_message_modal_value_label: 'Valeur',
         diagnostics_send_message_modal_registers_label_default_option:
           'Sélectionner le Registre',
         diagnostics_send_message_modal_save_button: 'Enregistrer',
         diagnostics_send_message_modal_cancel_button: 'Annuler',
         diagnostics_condition_modal_sensor_type_label: 'Type de Capteur',
         diagnostics_condition_modal_modbus_label: 'Capteur Modbus',
         diagnostics_condition_modal_mbus_label: 'Capteur Mbus',
         diagnostics_condition_modal_formula_output_label:
           'Résultat de la Formule',
         diagnostics_condition_modal_meter_type_label: 'Type de Compteur',
         diagnostics_condition_modal_meter_type_label_default_option:
           'Sélectionner le Type de Compteur',
         diagnostics_condition_modal_operator_label: 'Opérateur',
         diagnostics_condition_modal_operator_option_1: 'Inférieur',
         diagnostics_condition_modal_operator_option_2: 'Inférieur ou égal à',
         diagnostics_condition_modal_operator_option_3: 'Égal à',
         diagnostics_condition_modal_operator_option_4: 'Supérieur',
         diagnostic_flows_menu_information_form_description_nl:
           'Description (NL)',
         diagnostic_flows_menu_information_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_information_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_condition_form_description_en:
           'Description (EN)',
         diagnostic_flows_menu_condition_form_description_nl:
           'Description (NL)',
         diagnostic_flows_menu_condition_form_register_label: 'Registre',
         diagnostic_flows_menu_condition_form_operator_label: 'Opérateur',
         diagnostic_flows_menu_condition_form_value_label: 'Valeur',
         diagnostic_flows_menu_condition_form_timer_label: 'Minuteur',
         diagnostic_flows_menu_condition_form_retries_label: 'Réessais',
         diagnostic_flows_menu_condition_form_delay_label: 'Délai',
         diagnostic_flows_menu_condition_form_times_label: 'fois',
         diagnostic_flows_menu_condition_form_second_label: 'sec',
         diagnostic_flows_menu_condition_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_condition_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_modbus_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_modbus_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_modbus_form_register_label: 'Registre',
         diagnostic_flows_menu_modbus_form_operator_label: 'Opérateur',
         diagnostic_flows_menu_modbus_form_value_label: 'Valeur',
         diagnostic_flows_menu_modbus_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_modbus_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_message_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_message_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_message_form_message_label: 'Message',
         diagnostic_flows_menu_message_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_message_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_timer_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_timer_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_timer_form_timer_label: 'Minuteur',
         diagnostic_flows_menu_timer_form_delay_label: 'Délai',
         diagnostic_flows_menu_timer_form_times_label: 'fois',
         diagnostic_flows_menu_timer_form_second_label: 'sec',
         diagnostic_flows_menu_timer_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_timer_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_formula_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_formula_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_formula_form_formula_label: 'Formule',
         diagnostic_flows_menu_formula_form_formula_placeholder:
           'Veuillez choisir @ pour sélectionner les Registres Modbus ou Mbus',
         diagnostic_flows_menu_formula_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_formula_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_user_interaction_form_description_en:
           'Description (EN)',
         diagnostic_flows_menu_user_interaction_form_description_nl:
           'Description (NL)',
         diagnostic_flows_menu_user_interaction_form_operation_type:
           "Type d'Opération",
         diagnostic_flows_menu_user_interaction_form_operation_type_default_option:
           "Sélectionner le Type d'Opération",
         diagnostic_flows_menu_user_interaction_form_operation_type_option_choose_mbus_meter:
           'Sélectionner le Compteur Mbus',
         diagnostic_flows_menu_user_interaction_form_operation_type_option_choose_faucet:
           'Sélectionner le Registre de Robinet',
         diagnostic_flows_menu_user_interaction_form_field_type_option_select_field:
           'Sélectionner le Type de Champ',
         diagnostic_flows_menu_user_interaction_form_field_type:
           'Type de Champ',
         diagnostic_flows_menu_user_interaction_form_field_type_default_option:
           'Sélectionner le Type de Champ',
         diagnostic_flows_menu_user_interaction_form_field_type_option_checkbox:
           'Case à cocher',
         diagnostic_flows_menu_user_interaction_form_field_type_option_radio_button:
           'Bouton Radio',
         diagnostic_flows_menu_user_interaction_form_field_type_option_text_field:
           'Champ de Texte',
         diagnostic_flows_menu_user_interaction_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_user_interaction_form_save_button: 'Enregistrer',
         extra_white_space_form_error:
           'Les espaces supplémentaires ne sont pas autorisés',
         diagnostic_flows_form_incomplete_flow_error:
           'Veuillez vérifier les arêtes et les nœuds de couleur noire avec animation rouge',
         diagnostic_flows_menu_information: 'Information',
         diagnostic_flows_menu_modbus: 'Modbus',
         diagnostic_flows_menu_message: 'Message',
         diagnostic_flows_menu_condition: 'Condition',
         diagnostic_flows_menu_user_interaction: 'Interaction Utilisateur',
         diagnostic_flows_menu_steps: 'Page',
         diagnostic_flows_menu_timer: 'Minuteur',
         diagnostic_flows_menu_formula: 'Formule',
         diagnostic_flows_form_user_interaction_operation_type:
           "Type d'Opération",
         diagnostic_flows_form_user_interaction_operation_type_default_option:
           "Sélectionner le Type d'Opération",
         diagnostic_flows_form_user_interaction_operation_type_option_choose_mbus_meter:
           'Sélectionner le Compteur Mbus',
         diagnostic_flows_form_user_interaction_operation_type_option_choose_faucet:
           'Sélectionner le Registre de Robinet',
         diagnostic_flows_form_user_interaction_field_type_option_select_field:
           'Sélectionner le Type de Champ',
         diagnostic_flows_form_user_interaction_field_type: 'Type de Champ',
         diagnostic_flows_form_user_interaction_field_type_default_option:
           'Sélectionner le Type de Champ',
         diagnostic_flows_form_user_interaction_field_type_option_checkbox:
           'Case à cocher',
         diagnostic_flows_form_user_interaction_field_type_option_radio_button:
           'Bouton Radio',
         diagnostic_flows_form_user_interaction_field_type_option_text_field:
           'Champ de Texte',
         diagnostic_flows_form_user_interaction_description_en:
           'Description (EN)',
         diagnostic_flows_form_user_interaction_description_nl:
           'Description (NL)',
         diagnostic_flows_form_steps_label_en: 'Description (EN)',
         diagnostic_flows_form_steps_label_nl: 'Description (NL)',
         diagnostic_formulas_form_diagnostic_formulas_retries_field: 'Réessais',
         diagnostic_formulas_form_diagnostic_formulas_delay_field: 'Délai',
         diagnostic_formulas_form_diagnostic_formulas_unit_field:
           'Unité de Formule',
         diagnostic_formulas_form_forumla_field_placeholder:
           'Veuillez choisir @ pour sélectionner les Registres Modbus ou Mbus',
         device_single_diagnostic_flow_missing_pages_error:
           "##SELECTED_FLOW## n'a pas de pages. Veuillez ajouter des pages dans le flux pour continuer.",
         device_single_stepper_choose_flow_title: 'Choisissez le flux',
         device_single_stepper_choose_explanation_of_flow_wizard_title:
           "Explication de l'assistant",
         device_single_stepper_result_title: 'Résultat',
         devices_bulk_download_form_data_type: 'Type de Données',
         devices_bulk_download_form_export_type: "Type d'Exportation",
         devices_bulk_download_form_data_type_daily: 'Journalier',
         devices_bulk_download_form_data_type_hourly: 'Horaire',
         devices_bulk_download_form_export_type_combined: 'Combiné',
         devices_bulk_download_form_export_type_separated: 'Séparé',
         diagnostic_flows_form_main_stopped_text:
           "Le flux a été arrêté par l'utilisateur",
         diagnostic_execution_title: 'Exécutions de Diagnostic',
         diagnostic_execution_table_created_at: 'Créé le',
         diagnostic_execution_table_device: 'Appareil',
         diagnostic_execution_table_user: 'Utilisateur',
         diagnostic_execution_table_flow: 'Flux',
         diagnostic_execution_table_status: 'Statut',
         diagnostic_execution_table_filter_search: 'Recherche',
         diagnostic_executions_tab_all: 'Tous',
         diagnostic_executions_tab_completed: 'Terminé',
         diagnostic_executions_tab_in_progress: 'En cours',
         diagnostic_executions_tab_stopped: 'Arrêté',
         diagnostic_executions_tab_error: 'Erreur',
         diagnostic_executions_table_no_record_found:
           'Aucun enregistrement trouvé',
         diagnostic_executions_table_row_per_page: 'Lignes par page',
         diagnostic_flows_menu_result: 'Résultat',
         diagnostic_flows_menu_result_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_result_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_result_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_result_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_page_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_page_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_information_form_description_en:
           'Description (EN)',
         sidebar_diagnostic_execution_title: 'Exécutions de Diagnostic',
         diagnostic_flow_execution_single_first_bread_crumb:
           'Exécutions de Diagnostic',
         diagnostic_flow_execution_single_second_bread_crumb:
           'Voir Exécution de Diagnostic',
         diagnostic_flow_execution_single_output_tab: 'Résultat',
         diagnostic_flow_execution_single_device_name: 'Appareil',
         diagnostic_flow_execution_single_flow: 'Flux',
         diagnostic_flow_execution_single_user: 'Utilisateur',
         diagnostic_flow_execution_single_status: 'Statut',
         diagnostic_flow_execution_single_created_at: 'Créé le',
         diagnostic_flow_execution_single_bulk_export_file_name:
           'Exécutions de Diagnostic en Bloc',
         diagnostic_flow_execution_single_bulk_export_date: 'Date',
         diagnostic_flow_execution_single_bulk_export_time: 'Heure',
         diagnostic_flow_execution_single_bulk_export_device_name:
           "Nom de l'Appareil",
         diagnostic_flow_execution_single_bulk_export_device_serial_number_mercurius:
           'Numéro de Série Mercurius',
         diagnostic_flow_execution_single_bulk_export_device_user_full_name:
           'Utilisateur',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_en:
           'Nom du Flux (EN)',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_nl:
           'Nom du Flux (NL)',
         diagnostic_flow_execution_single_bulk_export_device_status: 'Statut',
         diagnostic_flows_form_main_flow_already_running_error_text:
           "Un flux est déjà en cours d'exécution sur cet appareil. Les exécutions de flux multiples ne sont pas autorisées.",
         diagnostic_flows_form_open_faucet_on_option: 'Activé',
         diagnostic_flows_form_open_faucet_off_option:
           "Désactivé (Le flux passera en mode d'erreur)",
         diagnostic_flows_form_mbus_meters_error:
           "L'appareil ne possède pas les compteurs Mbus nécessaires au flux.",
         diagnostic_flows_result_title: 'Résultat',
         duplicate_diagnostic_flows_form_header:
           'Dupliquer le Flux de Diagnostic',
         duplicate_diagnostic_flows_bread_crumb_first_link:
           'Dupliquer le Flux de Diagnostic',
         diagnostic_flows_form_duplicate_diagnostic_flows_button: 'Dupliquer',
         diagnostic_flows_duplicate_form_success:
           'Le Flux de Diagnostic a été dupliqué avec succès',
         diagnostic_flows_filter_duplicate_button: 'Dupliquer le Flux',
         diagnostic_flows_menu_result_form_id: 'Id',
         audits_street_number_filter_label: 'Rue',
         audits_house_number_filter_label: 'Numéro de Maison',
         diagnostic_execution_counter_title:
           "Compteurs d'Exécution de Diagnostic",
         diagnostic_execution_counter_table_id: 'Id',
         diagnostic_execution_counter_table_counter: 'Compteurs',
         diagnostic_execution_counter_table_flow: 'Flux',
         diagnostic_execution_counter_table_result: 'Résultat',
         diagnostic_execution_counter_table_filter_search: 'Rechercher',
         diagnostic_execution_counter_table_no_record_found:
           'Aucun enregistrement trouvé',
         diagnostic_execution_counter_table_row_per_page: 'Lignes par Page',
         sidebar_diagnostic_flow_execution_counter:
           'Compteurs de Flux de Diagnostic',
         device_single_firmware_hiu_label: 'Micrologiciel MTA',
         device_single_firmware_mercurius_label: 'Micrologiciel Mercurius',
         custom_popover_105_long_description:
           "Description Longue du Registre d'Alarme",
         settings_menu_title: 'Paramètres',
         settings_menu_clients_title: 'Clients',
         settings_menu_admins_title: 'Administrateurs',
         settings_menu_kong_admins_title: 'Administrateurs Kong',
         settings_menu_kong_clients_title: 'Clients Kong',
         settings_menu_diagnostics_title: 'Diagnostics',
         settings_menu_formulas_title: 'Formules',
         settings_menu_flows_title: 'Flux',
         settings_menu_categories_title: 'Catégories',
         settings_menu_firmwares_title: 'Micrologiciels',
         settings_menu_appliance_types_title: "Types d'Appareil",
         settings_menu_notifications_title: 'Notifications',
         settings_menu_roles_title: 'Rôles',
         settings_menu_modules_title: 'Modules',
         settings_menu_permissions_title: 'Permissions',
         settings_menu_go_back_button: 'Revenir en Arrière',
         audits_device_name_filter_label: "Nom de l'Appareil",
         device_single_documentation_parts_button: 'Pièces',
         device_single_documentation_lab_vision_button: 'Labvision',
         device_single_documentation_manuals_button: 'Manuels',
         device_single_documentation_incident_button: "Clé d'Incident",
         navbar_avg_proof_switch: 'Interrupteur de Confidentialité',
         clients_filter_bulk_delete_button: 'Supprimer',
         clients_bulk_delete_no_clients_with_zero_devices_is_selected_error_message:
           'Please select at least one record with 0 devices and 0 users',

         clients_bulk_delete_clients_with_devices_count_is_selected_error_message:
           'Please select only those records which have 0 devices and 0 users',
         projects_filter_bulk_delete_button: 'Supprimer',
         projects_bulk_delete_no_projects_with_zero_devices_is_selected_error_message:
           'Veuillez sélectionner au moins un enregistrement avec 0 appareil',
         projects_bulk_delete_projects_with_devices_count_is_selected_error_message:
           'Veuillez sélectionner uniquement les enregistrements qui ont 0 appareil',
         projects_bulk_deleted_message:
           '{{ PROJECTS_COUNT }} projets sont supprimés avec succès',
         projects_delete_modal_title: 'Êtes-vous sûr?',
         projects_delete_modal_subtitle:
           'Voulez-vous supprimer les enregistrements?',
         projects_delete_modal_cancel_button: 'Annuler',
         projects_delete_modal_delete_button: 'Supprimer',
         users_delete_modal_title: 'Êtes-vous sûr?',
         users_delete_modal_subtitle:
           'Voulez-vous supprimer les enregistrements?',
         users_delete_modal_cancel_button: 'Annuler',
         users_delete_modal_delete_button: 'Supprimer',
         users_bulk_delete_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à supprimer',
         users_bulk_deleted_message:
           '{{ USERS_COUNT }} utilisateurs sont supprimés avec succès',
         service_client_single_filter_bulk_delete_button: 'Supprimer',
         service_client_single_no_user_selected_for_deleted_message:
           'Veuillez sélectionner des enregistrements à supprimer',
         admins_bulk_deleted_message:
           '{{ USERS_COUNT }} administrateurs sont supprimés avec succès',
         admins_no_user_selected_for_deleted_message:
           'Veuillez sélectionner des enregistrements à supprimer',
         admins_filter_bulk_delete_button: 'Supprimer',
         kong_admins_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Admins are deleted successfully',
         audits_message_type_label: 'Type de Message',
         audit_bulk_export_file_name: "Fichier d'Audits",
         registers_reporting_details_all_tab: 'Tous',
         registers_reporting_details_pending_tab: 'En Attente',
         registers_reporting_details_success_tab: 'Succès',
         registers_reporting_details_failure_tab: 'Échec',
         devices_form_is_service_device_field: 'Appareil de Service',
         service_portal_login_in_correct_qr_code:
           "Le Numéro de Série de l'Appareil est incorrect",
         service_portal_login_in_correct_credentials:
           "Les identifiants de l'appareil sont incorrects. Veuillez contacter l'administrateur Fortes.",
         service_portal_login_not_a_registered_service_device:
           "L'appareil avec le Numéro de Série {{ SERIAL_NUMBER }} n'est pas enregistré.",
         devices_unprovisioned: 'Non installé',
         sidebar_unprovisioned_devices: 'Appareils non installés',
         dashboard_unprovisioned: 'NON INSTALLÉ',
         device_single_documentation_warmwater_button: 'Erreur eau chaude',
         device_single_documentation_verwarming_button:
           'Erreur chauffage central',
         service_portal_login_in_serial_number_scan_button:
           'Scanner le Numéro de Série',
         service_portal_login_in_heat_interface_unit_scan_button:
           "Scanner l'Unité d'Interface Thermique",
         service_portal_login_in_serial_number_scanned_message:
           'Le Numéro de Série est scanné',
         service_portal_login_in_heat_interface_unit_scanned_message:
           "L'Unité d'Interface Thermique est scannée",
         swapping_device_missing_new_device_error:
           "Le nouvel appareil n'est pas importé dans la base de données Mercurius",
         device_single_dashboard_mbus_title: 'MBus',
         device_single_dashboard_tab: 'Tableau de Bord',
         device_single_offline_detailed_message: 'L\'appareil est "Hors Ligne"',
         device_single_online_detailed_message:
           'L\'appareil est "En Ligne", tout fonctionne correctement',
         device_single_error_detailed_message:
           'L\'appareil est en mode "Erreur"',
         device_single_status_documents_link: "Documents de l'Appareil",
         email_device_delete_subscription_title:
           "Fortes Data Management - Supprimer l'Abonnement",
         email_device_delete_subscription_api_status_title:
           "Réponse de l'API Maxitel :",
         email_device_delete_subscription_type_swapped_device_message:
           "L'abonnement de l'appareil est supprimé dans le module d'échange d'appareils",
         email_device_delete_subscription_type_clear_device_message:
           "L'abonnement de l'appareil est supprimé dans le module de réinitialisation de l'appareil",
         devices_form_subscription_id_field: "ID de l'Abonnement",
         device_single_rss_sim_status: 'Statut SIM',
         device_monitoring_error_list_table_title: 'Historic Alarm List',
         device_monitoring_error_list_table_device: 'Appareil',
         device_monitoring_error_list_table_alarm_code: "Code d'Alarme",
         device_monitoring_error_list_table_start_date: 'Date de Début',
         device_monitoring_error_list_table_end_date: 'Date de Fin',
         device_monitoring_data_consumed_list_table_title:
           'Consommation de Données',
         device_monitoring_data_consumed_list_table_device: 'Appareil',
         device_monitoring_data_consumed_list_table_data_usage:
           'Utilisation des Données',
         device_monitoring_data_consumed_list_table_date: 'Date',
         device_monitoring_ota_history_list_table_title: 'Historique OTA',
         device_monitoring_ota_history_list_table_device: 'Appareil',
         device_monitoring_ota_history_list_table_status: 'Statut',
         device_monitoring_ota_history_list_table_date: 'Date',
         device_monitoring_device_status_history_title:
           "Historique de l'État de l'Appareil",
         device_monitoring_device_status_history_hr: 'Hr',
         device_monitoring_device_status_history_no_graph_data_error:
           'Le graphique est indisponible',
         device_monitoring_device_status_history_graph_loading_data:
           'Chargement du graphique',
         device_monitoring_firmware_history_title: 'Historique des Firmware',
         device_monitoring_device_firmware_history_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_firmware_history_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         sidebar_devices_monitoring: 'Surveillance des Appareils',
         device_monitoring_projects_counter_title: 'Compteur de Projets',
         device_monitoring_device_projects_counter_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_projects_counter_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         device_monitoring_users_counter_title: "Compteur d'Utilisateurs",
         device_monitoring_device_users_counter_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_users_counter_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         device_monitoring_sim_counter_title: 'Compteur de Données SIM',
         device_monitoring_sim_counter_exceeded_data_title: 'Dépassé',
         device_monitoring_sim_counter_in_package_data_title:
           'Dans la Limite du Forfait',
         device_monitoring_device_sim_counter_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_sim_counter_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         service_portal_login_in_dont_have_hiu_qr_code_checkbox_field:
           "Je n'ai pas de Code QR MTA",
         service_portal_login_hiu_autocomplete: "Unité d'Interface Thermique",
         device_monitoring_device_error_counters_title:
           'Historic Alarm Counters',
         device_monitoring_device_error_counters_error: 'Aucune donnée trouvée',
         device_monitoring_device_error_counters_no_graph_data_error:
           'Le diagramme circulaire est indisponible',
         device_monitoring_date_range_field: 'Plage de Dates',
         reporting_ota_details_retries_tab: 'Tentatives',
         device_monitoring_single_page_title: 'Surveillance des Appareils',
         device_monitoring_ota_history_list_table_fail_counter: 'Tentatives',
         device_monitoring_ota_history_list_table_user: 'Utilisateur',
         device_monitoring_ota_history_list_table_message: 'Message',
         device_monitoring_ota_history_list_table_old_firmware_version:
           'Ancienne Version du Firmware',
         device_monitoring_project_list_table_title: 'Projets',
         device_monitoring_firmware_list_table_title: 'Firmwares',
         device_monitoring_firmware_list_table_firmware_version: 'Firmware',
         device_monitoring_firmware_list_table_device: 'Appareil',
         device_monitoring_firmware_list_table_project: 'Projet',
         device_monitoring_firmware_list_table_saved_at: 'Date',
         monitoring_users_list_table_title: 'Utilisateurs',
         monitoring_kong_users_list_table_title: 'Utilisateurs Kong',
         monitoring_kong_users_filter_kong_admin: 'Administrateur Kong',
         monitoring_kong_users_filter_kong_client: 'Client Kong',
         client_single_users_table_role: 'Rôle',
         device_monitoring_device_status_list_table_title: "État de l'Appareil",
         navbar_languages_english: 'Anglais',
         navbar_languages_dutch: 'Néerlandais',
         navbar_languages_german: 'Allemand',
         device_single_device_settings_tab: 'Paramètres v2',
         device_single_device_settings_title: "Paramètres de l'Appareil v2",
         device_single_device_settings_secondary_device_type_field:
           "Type d'Appareil Secondaire",
         device_single_device_settings_base_topic_field: 'Sujet de Base',
         device_single_device_settings_baud_rate_uart_field:
           'Taux de Baud UART',
         device_single_device_settings_select_baud_rate_uart_field:
           'Sélectionner le Taux de Baud UART',
         device_single_device_settings_modbus_error_register_address_field:
           "Adresse de Registre d'Erreur Modbus",
         device_single_device_settings_modbus_error_register_value_field:
           "Valeur Attendue de Registre d'Erreur Modbus",
         device_single_device_settings_reboot_device_v2: 'Redémarrer',
         device_single_device_settings_send_button_v2: 'Envoyer',
         device_single_device_settings_secondary_device_type_message_forwarded:
           'Device Secondary Device Type message is forwarded to device',
         device_single_device_settings_reboot_message_forwarded:
           'Device Reboot message is forwarded to device',
         device_single_device_settings_base_topic_message_forwarded:
           'Device Base Topic message is forwarded to device',
         device_single_device_settings_baud_rate_uart_message_forwarded:
           'Device Baud Rate UART message is forwarded to device',
         device_single_device_settings_modbus_error_register_address_message_forwarded:
           'Device Modbus alarm register address message is forwarded to device',
         device_single_device_settings_modbus_expected_error_register_value_message_forwarded:
           'Device Modbus expected alarm register value message is forwarded to device',
         device_single_device_settings_secondary_device_type_error:
           "Le Type d'Appareil Secondaire doit être entre 1 et 254",
         device_single_device_settings_base_topic_error:
           'La longueur du Sujet de Base doit être entre 5 et 50',
         device_single_device_settings_baud_rate_uart_error:
           'Veuillez sélectionner une option pour le Taux de Baud UART',
         device_single_device_settings_modbus_error_register_address_error:
           "L'adresse du registre d'erreur Modbus doit être entre 0 et 65535",
         device_single_device_settings_modbus_error_register_value_error:
           "La valeur attendue du registre d'erreur Modbus doit être entre 0 et 65535",
         device_monitoring_device_error_counters_loading_data:
           'Chargement du diagramme circulaire',
         diagnostic_formulas_form_diagnostic_formulas_name_de_field: 'Nom (DE)',
         diagnostic_formulas_name_de_required_form_error:
           'Le Nom (DE) est requis',
         diagnostic_formulas_form_description_de_field: 'Description (DE)',
         diagnostic_flows_form_diagnostic_flows_name_de_field: 'Nom (DE)',
         diagnostic_flows_name_de_required_form_error: 'Le Nom (DE) est requis',
         diagnostic_flows_form_description_de_field: 'Description (DE)',
         diagnostic_categories_form_diagnostic_categories_name_de_field:
           'Nom (DE)',
         diagnostic_categories_name_de_required_form_error:
           'Le Nom (DE) est requis',
         diagnostic_categories_form_description_de_field: 'Description (DE)',
         diagnostic_categories_table_name_de: 'Nom (DE)',
         diagnostic_flows_table_name_de: 'Nom (DE)',
         diagnostic_formulas_table_name_de: 'Nom (DE)',
         modules_form_module_name_de_field: 'Nom (DE)',
         modules_name_de_required_form_error: 'Le Nom (DE) est requis',
         modules_form_description_de_field: 'Description (DE)',
         modules_table_name_de: 'Nom (DE)',
         modules_table_description_de: 'Description (DE)',
         roles_form_role_name_de_field: 'Nom (DE)',
         roles_name_de_required_form_error: 'Le Nom (DE) est requis',
         roles_form_description_de_field: 'Description (DE)',
         roles_table_name_de: 'Nom (DE)',
         roles_table_description_de: 'Description (DE)',
         permissions_form_permission_name_de_field: 'Nom (DE)',
         permissions_form_description_de_field: 'Description (DE)',
         permissions_table_name_de: 'Nom (DE)',
         permissions_table_description_de: 'Description (DE)',
         notifications_form_title_de_field: 'Titre (DE)',
         notifications_form_description_de_field: 'Description (DE)',
         firmwares_name_de_required_form_error: 'Nom (DE)',
         firmwares_form_firmware_name_de_field: 'Le Nom (DE) est requis',
         navbar_languages_danish: 'Danois',
         firmwares_name_dk_required_form_error: 'Nom (DK)',
         firmwares_form_firmware_name_dk_field: 'Le Nom (DK) est requis',
         diagnostic_formulas_form_diagnostic_formulas_name_dk_field: 'Nom (DK)',
         diagnostic_formulas_name_dk_required_form_error:
           'Le Nom (DK) est requis',
         diagnostic_formulas_form_description_dk_field: 'Description (DK)',
         diagnostic_flows_form_diagnostic_flows_name_dk_field: 'Nom (DK)',
         diagnostic_flows_name_dk_required_form_error: 'Le Nom (DK) est requis',
         diagnostic_flows_form_description_dk_field: 'Description (DK)',
         diagnostic_categories_form_diagnostic_categories_name_dk_field:
           'Nom (DK)',
         diagnostic_categories_name_dk_required_form_error:
           'Le Nom (DK) est requis',
         diagnostic_categories_form_description_dk_field: 'Description (DK)',
         diagnostic_categories_table_name_dk: 'Nom (DK)',
         diagnostic_flows_table_name_dk: 'Nom (DK)',
         diagnostic_formulas_table_name_dk: 'Nom (DK)',
         modules_form_module_name_dk_field: 'Nom (DK)',
         modules_name_dk_required_form_error: 'Le Nom (DK) est requis',
         modules_form_description_dk_field: 'Description (DK)',
         modules_table_name_dk: 'Nom (DK)',
         modules_table_description_dk: 'Description (DK)',
         roles_form_role_name_dk_field: 'Nom (DK)',
         roles_name_dk_required_form_error: 'Le Nom (DK) est requis',
         roles_form_description_dk_field: 'Description (DK)',
         roles_table_name_dk: 'Nom (DK)',
         roles_table_description_dk: 'Description (DK)',
         permissions_table_name_dk: 'Nom (DK)',
         permissions_table_description_dk: 'Description (DK)',
         notifications_form_title_dk_field: 'Titre (DK)',
         notifications_form_description_dk_field: 'Description (DK)',
         device_monitoring_data_consumed_list_table_project: 'Projet',
         project_single_device_list_search_mbus_registers_by_project:
           'Recherche de Registres Mbus',
         project_single_fetch_mbus_registers_by_project_success_message:
           'Le message est transféré aux Appareils du Projet ##PROJECT_NAME## avec succès',
         project_single_fetch_mbus_registers_by_project_error_message:
           "Erreur du Serveur d'Intervalle",
         devices_list_diagnostic_filters_title: 'Filtres de Registres',
         devices_list_diagnostics_condition_modal_sensor_type_label:
           'Type de Capteur',
         devices_list_diagnostics_condition_modal_modbus_label:
           'Capteur Modbus',
         devices_list_diagnostics_condition_modal_mbus_label: 'Capteur Mbus',
         devices_list_diagnostics_condition_modal_formula_output_label:
           'Sortie de Formule',
         devices_list_diagnostics_condition_modal_meter_type_label:
           'Type de Compteur',
         devices_list_diagnostics_condition_modal_meter_type_label_default_option:
           'Sélectionner un Type de Compteur',
         devices_list_diagnostics_condition_modal_operator_label: 'Opérateur',
         devices_list_diagnostics_condition_modal_operator_option_1:
           'Inférieur',
         devices_list_diagnostics_condition_modal_operator_option_2:
           'Inférieur ou égal à',
         devices_list_diagnostics_condition_modal_operator_option_3: 'Égal à',
         devices_list_diagnostics_condition_modal_operator_option_4:
           'Supérieur',
         devices_list_diagnostics_condition_modal_operator_option_5:
           'Supérieur ou égal à',
         devices_list_diagnostics_condition_modal_operator_option_6:
           'Différent de',
         devices_list_diagnostics_condition_modal_register_label: 'Registre',
         devices_list_diagnostics_condition_modal_register_required_error:
           'Le Registre est requis',
         devices_list_diagnostics_send_message_modal_registers_label_default_option:
           'Sélectionner un Registre',
         devices_list_diagnostics_condition_modal_value_label: 'Valeur',
         devices_list_diagnostics_condition_modal_value_is_required_error:
           'La Valeur est requise',
         devices_list_diagnostics_condition_modal_operator_is_required_error:
           "L'Opérateur est requis",
         devices_list_diagnostics_condition_modal_meter_is_required_error:
           'Le Compteur est requis',
         devices_list_diagnostics_condition_modal_value_invalid_error:
           'Valeur invalide, veuillez vérifier',
         devices_list_diagnostics_condition_modal_save_button: 'Enregistrer',
         devices_list_diagnostics_condition_modal_cancel_button: 'Annuler',
         devices_list_diagnostics_condition_modal_add_button:
           'Ajouter plus de filtres',
         error_check_table_title: "Vérifications d'Erreur de l'Appareil",
         error_check_table_filter_search: 'Recherche',
         error_check_table_no_record_found: 'Aucun enregistrement trouvé',
         error_check_table_row_per_page: 'Lignes par page',
         error_check_table_created_at: 'Créé à',
         error_check_table_total_devices: 'Appareils au total',
         error_check_details_table_title:
           "Détails de la Vérification d'Erreur de l'Appareil",
         error_check_details_table_filter_search: 'Recherche',
         error_check_details_table_no_record_found:
           'Aucun enregistrement trouvé',
         error_check_details_table_row_per_page: 'Lignes par page',
         error_check_details_table_created_at: 'Créé à',
         error_check_details_table_device: 'Appareil',
         error_check_details_table_old_error: 'Ancienne Erreur',
         error_check_details_table_new_error: 'Nouvelle Erreur',
         error_check_details_table_status: 'Statut',
         error_check_details_table_status_success: 'Succès',
         error_check_details_table_status_failed: 'Échec',
         error_check_details_table_all_tab: 'Tous',
         error_check_details_table_success_tab: 'Succès',
         error_check_details_table_failure_tab: 'Échec',
         error_check_details_table_device_name: "Nom de l'Appareil",
         error_check_details_table_device_serial_number: 'Numéro de Série',
         sidebar_devices_error_check: 'Appareils avec Erreurs',
         error_check_details_table_bulk_export_file_name:
           'Liste de Détails des Appareils avec Erreurs',
         error_check_table_bulk_export_file_name:
           'Liste des Appareils avec Erreurs',
         device_single_registers_table_min_error:
           'La valeur doit être supérieure ou égale à min_value',
         device_single_registers_table_invalid_value_error:
           'Veuillez entrer un nombre valide',
         project_single_project_setting_tab: 'Project Setting',
         project_single_project_setting_mbus_registers_title: 'MBus Registers',
         project_single_project_setting_mbus_register_accumulated_heating_energy_title:
           'Accumulated heating energy Unit',
         project_single_project_setting_mbus_register_accumulated_heating_energy_success_message:
           'Accumulated heating energy unit is successfully updated',
         project_single_project_setting_mbus_register_accumulated_heating_energy_error_message:
           'Failed to update Accumulated heating energy unit',
         project_single_project_setting_select_mbus_register_accumulated_heating_energy_title:
           'Select Accumulated heating energy',
         project_single_project_setting_select_mbus_register_update_button:
           'Update',
         custom_popover_100_short_description: 'Heating state',
         custom_popover_101_short_description: 'Hot Water state',
         custom_popover_102_short_description: 'Preheat state',
         custom_popover_103_short_description: 'Thermal disinfection state',
         custom_popover_104_short_description: 'Cooling state',
         custom_popover_1802_short_description: 'TE Heating Element State',
         custom_popover_105_short_description: 'Alarm code',
         custom_popover_107_short_description: 'Hot water valve (M1)',
         custom_popover_108_short_description: 'Heating/cooling valve (M2)',
         custom_popover_109_short_description: 'Pump',
         custom_popover_110_short_description: '6-way-valve',
         custom_popover_113_short_description: 'Room thermostat input',
         custom_popover_114_short_description: 'OpenTherm Indicator',
         custom_popover_115_short_description: 'Appliance Type',
         custom_popover_200_short_description: 'Hot water flow rate',
         custom_popover_201_short_description: 'Hot water temperature',
         custom_popover_202_short_description: 'Primary supply',
         custom_popover_203_short_description: 'Primary return/Outdoor',
         custom_popover_205_short_description: 'Secondary supply',
         custom_popover_206_short_description: 'Secondary return',
         custom_popover_204_short_description: 'Calculated heating setpoint',
         custom_popover_207_short_description: 'Room Temperature (OpenTherm)',
         custom_popover_208_short_description: 'Room Setpoint (OpenTherm)',
         custom_popover_210_short_description: 'Secondary water pressure',
         custom_popover_800_short_description: 'Total system run time',
         custom_popover_801_short_description: 'Heating burn time',
         custom_popover_802_short_description: 'Cooling burn time',
         custom_popover_803_short_description: 'Hot water burn Time',
         custom_popover_804_short_description: 'Number of tappings',
         custom_popover_805_short_description: 'Hot water Volume',
         custom_popover_806_short_description: 'Power cuts',
         create_role_stepper_information_title: 'Information',
         create_role_stepper_client_title: 'Client',
         create_role_stepper_service_client_title: 'Service Client',
         create_role_stepper_project_title: 'Project',
         create_role_stepper_device_management_title: 'Device Management',
         create_role_stepper_commissioning_title: 'Commissioning',
         create_role_stepper_reporting_title: 'Reporting',
         create_role_stepper_general_title: 'General',
         roles_form_role_name_field: 'Name',
         roles_name_required_form_error: 'Name is required',
         roles_form_description_field: 'Description',
         create_role_stepper_back_button: 'Back',
         create_role_stepper_next_button: 'Next',
         create_role_stepper_finish_button: 'Finish',
         create_role_stepper_yes_label: 'Yes',
         create_role_stepper_no_label: 'No',
         create_role_stepper_step_2_client_view_all_users: 'View all users?',
         create_role_stepper_step_2_client_create_new_users:
           'Create new users?',
         create_role_stepper_step_2_client_edit_new_users:
           'Modify existing users like the role?',
         create_role_stepper_step_3_service_client_create_new:
           "Create a new 'service client'?",
         create_role_stepper_step_3_service_client_view_users:
           "View existing 'service client' users?",
         create_role_stepper_step_3_service_client_create_users:
           "Create new 'service client' users?",
         create_role_stepper_step_3_service_client_modify_users:
           "Modify 'service client' users like the role?",
         create_role_stepper_step_4_project_view: 'View projects?',
         create_role_stepper_step_4_project_create_new: 'Create new projects?',
         create_role_stepper_step_4_project_export_mbus_data:
           'Export energy meter data from projects?',
         create_role_stepper_step_5_device_view_single_page: 'Open a device?',
         create_role_stepper_step_5_device_view_single_page_setting_registers:
           'View settings?',
         create_role_stepper_step_5_device_edit_single_page_setting_registers:
           'Modify settings?',
         create_role_stepper_step_5_device_edit_single_page_manual_control:
           'Use manual control?',
         create_role_stepper_step_5_device_single_page_view_history:
           'View history?',
         create_role_stepper_step_5_device_single_page_view_meter_data:
           'View meter data?',
         create_role_stepper_step_5_device_single_page_use_diagnostics_module:
           'Use the diagnostics module?',
         create_role_stepper_step_5_device_single_page_information_and_delivery_set_data:
           'View information such as device info, address details, and delivery set data?',
         create_role_stepper_step_6_commissioning_module_put_devices_into_operation:
           'Commissioning module to put devices into operation?',
         create_role_stepper_step_6_commissioning_module_swapping:
           'Exchange devices (transfer data from old device to new device)?',
         create_role_stepper_step_7_reporting_audit:
           'The logbook that contains all messages, alarms, and actions on devices?',
         create_role_stepper_step_7_reporting_swapped_devices:
           'Logbook of exchanged devices?',
         create_role_stepper_step_7_reporting_error_devices:
           'Logbook of devices with faults?',
         create_role_stepper_step_7_reporting_bulk_registers_update:
           'Results of group changes?',
         create_role_stepper_step_8_view_dashboard:
           'Dashboard all access and sidebar device counters',
         create_role_stepper_step_8_general_create_role: 'Creating roles?',
         create_role_stepper_question_required_error:
           'One option is required to proceed',
         project_single_project_setting_device_v2_settings_title:
           'Device V2 Settings',
         project_single_device_settings_secondary_device_type_field:
           'Secondary Device Type',
         project_single_project_setting_base_topic_field: 'Base Topic',
         project_single_device_settings_baud_rate_uart_field: 'Baud Rate UART',
         project_single_device_settings_select_baud_rate_uart_field:
           'Select Baud Rate UART',
         project_single_device_settings_modbus_error_register_address_field:
           'Modbus alarm register address',
         project_single_device_settings_modbus_error_register_value_field:
           'Modbus expected alarm register value',
         project_single_project_setting_device_v2_send_button: 'Send',
         project_single_project_setting_base_topic_success_message:
           'Base Topic is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_secondary_device_type_success_message:
           'Secondary Device Type is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_reboot_message:
           'Device Reboot Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_baut_rate_uart_success_message:
           'Device Baut Rate UART Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_modbus_expected_error_register_value_success_message:
           'Device Modbus Expected Alarm Register Value Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_modbus_error_register_address_success_message:
           'Device Reboot Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         docs_third_tab_video_instruction: 'Video Instruction',
         docs_third_tab_video_instruction_title: 'Video Instruction',
         custom_popover_106_short_description: 'Software version',
         custom_popover_106_long_description: 'Software version',
         EXPORT_MBUS_METER_SERIAL_NUMBER: 'Serial number meter',
         navbar_languages_french: 'French',
         diagnostic_formulas_form_diagnostic_formulas_name_fr_field:
           'Name (FR)',
         diagnostic_formulas_name_fr_required_form_error:
           'Name (FR) is required',
         diagnostic_formulas_form_description_fr_field: 'Description (FR)',
         diagnostic_flows_form_diagnostic_flows_name_fr_field: 'Name (FR)',
         diagnostic_flows_name_fr_required_form_error: 'Name (FR) is required',
         diagnostic_flows_form_description_fr_field: 'Description (FR)',
         diagnostic_categories_form_diagnostic_categories_name_fr_field:
           'Name (FR)',
         diagnostic_categories_name_fr_required_form_error:
           'Name (FR) is required',
         diagnostic_categories_form_description_fr_field: 'Description (FR)',
         modules_form_module_name_fr_field: 'Name (FR)',
         modules_name_fr_required_form_error: 'Name (FR) is required',
         modules_form_description_fr_field: 'Description (FR)',
         roles_form_role_name_fr_field: 'Name (FR)',
         roles_name_fr_required_form_error: 'Name (FR) is required',
         roles_form_description_fr_field: 'Description (FR)',
         permissions_form_permission_name_fr_field: 'Name (FR)',
         permissions_form_description_fr_field: 'Description (FR)',
         firmwares_form_firmware_name_fr_field: 'Name (FR)',
         firmwares_name_fr_required_form_error: 'Name (FR) is required',
         notifications_form_title_fr_field: 'Name (FR)',
         notifications_form_description_fr_field: 'Description (FR)',
         notifications_title_dk_required_form_error: 'Name (DK) is required',
         notifications_title_fr_required_form_error: 'Name (FR) is required',
         notifications_title_de_required_form_error: 'Name (DE) is required',
         notifications_description_dk_required_form_error:
           'Description (DK) is required',
         notifications_description_de_required_form_error:
           'Description (DE) is required',
         notifications_description_fr_required_form_error:
           'Description (FR) is required',
         client_single_error_devices_bread_crumb: 'Alarm Devices',
         service_client_single_error_devices_bread_crumb: 'Alarm Devices',
         devices_list_diagnostics_condition_modal_fetch_and_filter_button:
           'Fetch & Filter',
         diagnostic_register_drawer_selected_devices_title: 'Selected Devices',
         diagnostic_register_drawer_fetch_and_filter_message_1:
           'Fetching devices data',
         diagnostic_register_drawer_fetch_and_filter_message_2:
           'Database refresh',
         diagnostic_register_drawer_fetch_and_filter_message_3:
           'Filtering devices',
         devices_bulk_selected_devices_title: 'Devices Selected',
         custom_popover_100_long_description: 'Heating state',
         custom_popover_101_long_description: 'Hot Water state',
         custom_popover_102_long_description: 'Preheat state',
         custom_popover_103_long_description: 'Thermal disinfection state',
         custom_popover_104_long_description: 'Cooling state',
         custom_popover_1802_long_description: 'TE Heating Element State',
         custom_popover_107_long_description: 'Hot water valve (M1)',
         custom_popover_108_long_description: 'Heating/cooling valve (M2)',
         custom_popover_109_long_description: 'Pump',
         custom_popover_110_long_description: '6-way-valve',
         custom_popover_113_long_description: 'Room thermostat input',
         custom_popover_114_long_description: 'OpenTherm Indicator',
         custom_popover_115_long_description: 'Appliance Type',
         custom_popover_200_long_description: 'Hot water flow rate',
         custom_popover_201_long_description: 'Hot water temperature',
         custom_popover_202_long_description: 'Primary supply',
         custom_popover_203_long_description: 'Primary return/Outdoor',
         custom_popover_205_long_description: 'Secondary supply',
         custom_popover_206_long_description: 'Secondary return',
         custom_popover_204_long_description: 'Calculated heating setpoint',
         custom_popover_207_long_description: 'Room Temperature (OpenTherm)',
         custom_popover_208_long_description: 'Room Setpoint (OpenTherm)',
         custom_popover_210_long_description: 'Secondary water pressure',
         custom_popover_800_long_description: 'Total system run time',
         custom_popover_801_long_description: 'Heating burn time',
         custom_popover_802_long_description: 'Cooling burn time',
         custom_popover_803_long_description: 'Hot water burn Time',
         custom_popover_804_long_description: 'Number of tappings',
         custom_popover_805_long_description: 'Hot water Volume',
         custom_popover_806_long_description: 'Power cuts',
         project_single_project_setting_mbus_hourly_logs_title:
           'Mbus Hourly Logs',
         project_single_project_setting_mbus_hourly_logs_field:
           'Fetch Mbus Hourly',
         project_single_project_setting_mbus_hourly_logs_update_button:
           'Update',
         project_single_project_setting_mbus_hourly_logs_success_set_message:
           'Mbus Hourly logs are successfully set for the project',
         project_single_project_setting_mbus_hourly_logs_error_message:
           'Failed to update Mbus Hourly logs for the project',
         sidebar_mbus_reporting: 'Mbus Reporting',
         mbus_reporting_table_device: 'Device',
         mbus_reporting_table_project: 'Project',
         mbus_reporting_table_created_at: 'Created At',
         mbus_reporting_table_viewed_by: 'Viewed By',
         mbus_reporting_table_viewed_at: 'Viewed At',
         mbus_reporting_table_firmware: 'Firmware',
         mbus_reporting_table_no_record_found: 'No Records Found',
         mbus_reporting_table_all_filter: 'All',
         mbus_reporting_table_read_filter: 'Read',
         mbus_reporting_table_unread_filter: 'Unread',
         mbus_reporting_table_row_per_page: 'Rows per page',
         mbus_reporting_table_title: 'Mbus Reporting',
         mbus_reporting_anomaly_table_title: 'Mbus Anomalies',
         mbus_reporting_anomaly_table_difference: 'Difference',
         mbus_reporting_anomaly_table_detection: 'Detection',
         mbus_reporting_anomaly_table_mbus_meter_type: 'Meter',
         mbus_reporting_anomaly_table_mbus_serial_number: 'Mbus Serial Number',
         mbus_reporting_anomaly_table_mbus_old_value: 'Old Value',
         mbus_reporting_anomaly_table_mbus_register: 'Register',
         mbus_reporting_anomaly_table_mbus_reason: 'Reason',
         mbus_reporting_anomaly_table_mbus_fail_reason: 'Greater than',
         mbus_reporting_anomaly_table_mbus_suspicious_reason: 'Lies in between',
         mbus_reporting_anomaly_table_fail: 'Fail',
         mbus_reporting_anomaly_table_suspicious: 'Suspicious',
         mbus_reporting_table_bulk_view_reports_success_message:
           'Mbus Reporting Messages are successfully viewed',
         mbus_reporting_table_bulk_view_reports_error_message:
           'Please select Mbus Reporting records to proceed',
         mbus_reporting_table_bulk_view_button: 'Bulk View',
         mbus_reporting_table_view_button: 'View',
         mbus_reporting_table_filters_project_field: 'Project',
         mbus_reporting_table_filters_device_name_field: 'Device',
         mbus_reporting_table_filters_start_date: 'Start Date',
         mbus_reporting_table_filters_end_date: 'End Date',
         mbus_reporting_table_filters_firmware: 'Firmware',
         mbus_reporting_table_filters_mbus_serial_number: 'Mbus Serial Number',
         mbus_reporting_table_filters_viewed_by: 'Viewed By',
         business_situation_measured_values_TR03_209: 'Outdoor Temperature',
         custom_popover_209_short_description: 'Outdoor Temperature',
         custom_popover_209_long_description: 'Outdoor Temperature',
         appliance_types_set_registers_table_dashboard: 'Dashboard',
         appliance_types_set_registers_table_dashboard_error_message:
           'Device dashboard registers must be either 0 or exactly 8.',
         sidebar_missing_hourly_reporting: 'Mbus Missing Data Report',
         missing_hourly_reporting_table_title:
           'Mbus Hourly Missing Data Reporting',
         mbus_hourly_missing_reporting_table_filters_project_field: 'Project',
         mbus_hourly_missing_reporting_table_filters_device_name_field:
           'Device',
         mbus_hourly_missing_reporting_table_filters_firmware_field: 'Firmware',
         mbus_hourly_missing_reporting_table_last_seen: 'Mbus Message At',
         mbus_hourly_missing_reporting_table_created_at: 'Created At',
         mbus_hourly_missing_reporting_table_device: 'Device',
         mbus_hourly_missing_reporting_table_project: 'Project',
         mbus_hourly_missing_reporting_table_firmware: 'Firmware',
         mbus_hourly_missing_reporting_table_no_record_found:
           'No Records Found',
         mbus_hourly_missing_reporting_table_row_per_page: 'Rows per page',
         diagnostic_flows_form_loading_text: 'Loading ...',
         device_monitoring_device_frequency_history_counters_title:
           'Device Anomalies Frequency',
         device_monitoring_device_frequency_history_counters_error:
           'No data found',
         device_monitoring_device_frequency_history_counters_no_graph_data_error:
           'The piechart is unavailable',
         device_monitoring_device_frequency_history_counters_loading_data:
           'Loading ...',
         device_monitoring_project_frequency_history_counters_title:
           'Project Anomalies Frequency',
         device_monitoring_project_frequency_history_counters_error:
           'No data found',
         device_monitoring_project_frequency_history_counters_no_graph_data_error:
           'The piechart is unavailable',
         device_monitoring_project_frequency_history_counters_loading_data:
           'Loading ...',
         device_monitoring_firmware_anomalies_history_title:
           'Firmware Anomalies Frequency',
         device_monitoring_device_firmware_anomalies_history_graph_loading_data:
           'The barchart is unavailable',
         device_monitoring_device_firmware_anomalies_history_no_graph_data_error:
           'Loading ...',
         devices_device_id: 'Device Id',
         device_monitoring_device_frequency_details_table_title:
           'Device Anomalies Frequency',
         device_monitoring_device_frequency_details_table_firmware: 'Firmware',
         device_monitoring_device_frequency_details_table_device: 'Device',
         device_monitoring_device_frequency_details_table_project: 'Project',
         device_monitoring_device_frequency_details_table_saved_at: 'Date',
         device_monitoring_device_frequency_details_table_startup_messages_count:
           'Start up messages count',
         device_monitoring_project_frequency_details_table_title:
           'Project Anomalies Frequency',
         device_monitoring_project_frequency_details_table_project: 'Project',
         device_monitoring_project_frequency_details_table_devices_count:
           'Devices Count',
         device_monitoring_project_frequency_details_table_startup_messages_count:
           'Start up messages count',
         device_monitoring_firmware_frequency_details_table_title:
           'Firmware Anomalies Frequency',
         device_monitoring_firmware_frequency_details_table_firmware:
           'Firmware',
         device_monitoring_firmware_frequency_details_table_startup_messages_count:
           'Start up messages count',
         client_single_users_list_reset_and_send_email_button: 'Reset Password',
         user_reset_password_form_success:
           'User password is updated successfully',
         users_reset_password_modal_title: 'Reset Password',
         users_reset_password_modal_subtitle:
           'Do you want to reset password for this user and send email?',
         users_reset_password_modal_cancel_button: 'Close',
         users_reset_password_modal_reset_password_button:
           'Reset and Send Email',
         reset_password_subject: 'Fortes Data Management - Reset Password',
         clients_form_is_2fa_enabled_field:
           'Enable Two-Factor Authentication (2FA)',
         service_clients_form_is_2fa_enabled_field:
           'Enable Two-Factor Authentication (2FA)',
         two_factor_authentication_qr_verified_title:
           'Two-Factor Authentication (2FA)',
         two_factor_authentication_qr_unverified_title:
           'Setup Two-Factor Authentication (2FA)',
         two_factor_authentication_permission_error: '',
         two_factor_authentication_description_step_1:
           'Install one of the following applications on your mobile:',
         two_factor_authentication_description_step_2:
           'Open the application and scan the QR Code:',
         two_factor_authentication_description_step_2_rescan:
           'Regenerate QR Code',
         two_factor_authentication_description_step_3:
           'Enter the one-time code provided by the application and click Submit to finish the setup.',
         two_factor_authentication_form_otp_field: 'OTP Code',
         two_factor_authentication_form_otp_characters_limit_error:
           'OTP must be 6 characters',
         two_factor_authentication_form_otp_required_error: 'OTP is required',
         two_factor_authentication_form_incorrect_otp_error:
           'Invalid OTP, please retry again with a new OTP',
         two_factor_authentication_form_success:
           'OTP is successfully authenticated',
         two_factor_authentication_submit_button: 'Submit',
         client_single_users_list_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         service_client_single_users_list_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         users_enable_2fa_qr_code_modal_title:
           'Enable Two-Factor Authentication (2FA) QR Code',
         users_enable_2fa_qr_code_modal_subtitle:
           'Are you sure you want to enable Two-Factor Authentication (2FA) QR Code for this user?',
         users_enable_2fa_qr_code_modal_cancel_button: 'Cancel',
         users_enable_2fa_qr_code_modal_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         client_single_users_list_enable_2fa_qr_code_success_message:
           'Two-Factor Authentication (2FA) QR Code is successfully enabled',
         client_single_2fa_label: 'Two-Factor Authentication (2FA)',
         enabled_2fa_label: 'Enabled',
         disabled_2fa_label: 'Disabled',
         service_client_single_2fa_label: 'Two-Factor Authentication (2FA)',
         client_single_users_table_last_access: 'Last Seen',
         service_client_single_users_table_last_access: 'Last Seen',
         projects_form_header: 'Project Information',
         projects_commissioning_form_header: 'Project Commissioning',
         projects_commissioning_form_export_button: 'Export Devices',
         projects_commissioning_form_export_file_name:
           'Project Commissioning Export',
         projects_commissioning_form_import_button: 'Import Devices',
         projects_commissioning_form_import_message:
           "<strong>Steps to Import Devices</strong> <ol> <li>Download the Project Commissioning File Template from green Export Devices Button.</li> <li>Update the file and don't change the header column names, in case they're changed. The file import will fail.</li> <li>Import the file and changes will be updated.</li> </ol>",
         projects_commissioning_form_import_success_message:
           'Devices data is successfully commissioned',
         commissioning_device_stepper_step_1_scan_qr_serial_number_title:
           'Scan QR code Mercurius',
         commissioning_device_stepper_step_3_validate_project_setting_title:
           'Validate connectivity',
         commissioning_device_stepper_step_4_update_address_information_title:
           'Update address',
         commissioning_device_stepper_step_2_hiu_commissioning_title:
           'Scan QR code HIU',
         commissioning_device_stepper_step_5_preview_and_submit_title:
           'Preview and submit',
         commissioning_device_stepper_step_mbus_labels_title:
           'Étiquettes compteurs Mbus',
         commissioning_mbus_labels_required_error:
           'Veuillez sélectionner une étiquette pour tous les compteurs Mbus avant de continuer.',
         commissioning_form_dont_have_serial_number_checkbox:
           "Don't have Serial QR Code?",
         commissioning_form_back_button: 'Previous',
         commissioning_form_next_button: 'Next',
         commissioning_form_finish_button: 'Finish',
         commissioning_form_device_serial_is_missing_error:
           'Serial Number is required',
         commissioning_form_device_offboarding_error:
           'This device is currently being offboarded and cannot be commissioned.',
         clear_device_offboarding_error:
           'This device is currently being offboarded and cannot be cleared.',
         swapping_old_device_offboarding_error:
           'This old device is currently being offboarded and cannot be swapped.',
         swapping_new_device_offboarding_error:
           'This new device is currently being offboarded and cannot be swapped.',
         commissioning_form_modbus_mbus_validation_error:
           'Validation failed, do you want to proceed anyway?',
         commissioning_form_stepper_validation_project_setting_title:
           'Project Settings',
         commissioning_form_stepper_validation_current_setting_title:
           'Device Settings',
         commissioning_form_stepper_validation_validate_to_view:
           'Validate to view details',
         commissioning_form_stepper_validation_modbus_title: 'Modbus',
         commissioning_form_stepper_validation_mbus_title: 'M-Bus',
         commissioning_form_stepper_validation_modbus_connected_title:
           'Connected',
         commissioning_form_stepper_validation_modbus_not_connected_title:
           'Not Connected',
         commissioning_form_stepper_validation_mbus_meters_title: 'meter(s)',
         project_single_project_setting_modbus_and_mbus_validation_form_title:
           'Modbus and Mbus Setting',
         commissioning_form_stepper_validation_is_modbus_connected:
           'Is Modbus Connected',
         commissioning_form_stepper_validation_mbus_meters_select_field:
           'M-Bus Meters',
         commissioning_form_stepper_validation_mbus_meters_select_option_field:
           'Select M-Bus Meters',
         commissioning_form_stepper_validation_mbus_meters_validate_button:
           'Validate',
         commissioning_form_upload_file_type_error:
           'Only XLSX files are allowed.',
         commissioning_form_upload_file_invalid_column_names_error:
           "Invalid column ##COLUMNS##, please don't change the column names",
         commissioning_form_upload_file_size_error:
           'File size should be less than 5 MB.',
         commissioning_form_uploading_text: 'Uploading...',
         project_single_project_setting_mbus_reporting_form_title:
           'Mbus Reporting Setting',
         project_single_project_setting_mbus_hourly_missing_data_reporting_value_field:
           'Mbus Hourly Missing Data Reporting',
         project_single_project_setting_mbus_anomaly_reporting_value_field:
           'Mbus Anomaly Reporting',
         project_single_project_setting_mbus_reporting_form_button: 'Update',
         project_single_project_setting_mbus_reporting_success_message:
           'Mbus Reporting data is successfully set for the project',
         project_single_project_setting_mbus_reporting_error_message:
           'Failed to update Mbus Reporting data for the project',
         commissioning_form_upload_file_incorrect_serial_number_error:
           'Incorrect Serial Number(s) found for the project commissioning',
         commissioning_form_upload_file_incorrect_devices_data_error:
           'Incorrect Device(s) data found for the project commissioning',
         commissioning_form_upload_file_empty_sheet_error:
           'Project Commissioning file is empty',
         commissioning_form_upload_success_message:
           'Project Commissioning is successfully completed',
         commissioning_validation_failed_subject:
           'Mercurius Commissioning Report',
         commissioning_form_stepper_validation_mbus_meters_loading_title:
           'Mbus meters check takes upto 30 - 60 seconds',
         commissioning_form_stepper_validation_mbus_meters_retries_label:
           'Mbus Retries',
         commissioning_form_stepper_validation_mbus_meters_retries_button:
           'Retry',
         mbus_reporting_table_bulk_snooze_button: 'Bulk Snooze',
         mbus_reporting_table_bulk_snooze_devices_success_message:
           'Mbus Reporting Devices are successfully snoozed',
         mbus_reporting_table_bulk_snooze_modal_title: 'Are you sure?',
         mbus_reporting_table_bulk_snooze_modal_sub_title:
           'You want to snooze Mbus Reporting for the selected devices?',
         mbus_reporting_table_bulk_snooze_modal_cancel_button: 'Cancel',
         mbus_reporting_table_bulk_snooze_modal_snooze_button: 'Snooze',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration:
           'Snooze Duration',
         mbus_reporting_table_bulk_snooze_modal_select_snooze_duration:
           'Select Snooze Duration',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_day: 'Day',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_week: 'Weeks',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_month: 'Months',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_year: 'Years',
         sidebar_mbus_reporting_snoozed_devices:
           'Mbus Reporting - Snoozed Devices',
         mbus_reporting_snoozed_devices_table_title: 'Snoozed Devices',
         mbus_reporting_table_bulk_un_snooze_devices_success_message:
           'Mbus Reporting Devices are successfully UnSnoozed',
         mbus_reporting_table_bulk_un_snooze_modal_title: 'Are you sure?',
         mbus_reporting_table_bulk_un_snooze_modal_sub_title:
           'You want to UnSnooze Mbus Reporting for the selected devices?',
         mbus_reporting_table_bulk_un_snooze_modal_cancel_button: 'Cancel',
         mbus_reporting_table_bulk_un_snooze_modal_snooze_button: 'UnSnooze',
         mbus_reporting_table_bulk_un_snooze_button: 'Bulk UnSnooze',
         mbus_reporting_table_snooze_request_at: 'Request At',
         mbus_reporting_table_snooze_end_at: 'End At',
         mbus_reporting_snoozed_devices_table_all_filter: 'All',
         mbus_reporting_snoozed_devices_table_snoozed_filter: 'Snoozed',
         mbus_reporting_snoozed_devices_table_unsnoozed_filter: 'UnSnoozed',
         devices_list_diagnostics_condition_modal_single_meter_label: 'Meter',
         devices_list_diagnostics_condition_modal_multiple_meters_label:
           'Meters',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_label:
           'Connected Mbus Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_connected_label:
           'Connected',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_not_connected_label:
           'Not Connected',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_select_record_label:
           'Select Connected Mbus Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_dropdown_label:
           'Mbus Meters Connection',
         devices_list_diagnostics_condition_modal_are_mbus_connected_select_field_label:
           'Select connection status',
         devices_search_mbus_registers_multiple_devices_success:
           'The message has been successfully sent to the selected device(s).',
         devices_testing_button: 'Device Testing',
         devices_testing_form_header: 'Device Testing',
         devices_testing_device_serial_field: 'Device Serial',
         devices_testing_modbus_registers_field: 'Modbus Registers',
         devices_testing_modbus_registers_button_field: 'Send Modbus Message',
         devices_testing_single_mbus_register_field: 'Single MBus Register',
         devices_testing_single_mbus_register_button_field: 'Send Message',
         devices_testing_send_fetch_mbus_message: 'Send Fetch MBus Message',
         devices_testing_send_scan_mbus_message: 'Send Scan MBus Message',
         project_single_project_setting_mbus_hourly_logs_success_unset_message:
           'Mbus Hourly logs are successfully unset for the project',
         mbus_reporting_table_export_button: 'Export',
         mbus_reporting_table_export_file: 'Mbus Reporting',
         mbus_hourly_missing_reporting_export_button: 'Export',
         mbus_hourly_missing_reporting_export_file:
           'Mbus Hourly Missing Data Reporting',
         snoozed_devices_export_button: 'Export',
         snoozed_devices_export_file: 'Snoozed Devices',
         device_single_documentation_instructie_pomp_button: 'Instructie Pomp',
         sidebar_inconsistent_mbus_devices_reporting:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_table_header:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_bulk_export_button: 'Export',
         inconsistent_mbus_devices_reporting_filter_reset_button: 'Reset',
         inconsistent_mbus_devices_reporting_table_filter_search: 'Search',
         inconsistent_mbus_devices_reporting_table_created_at: 'Created At',
         inconsistent_mbus_devices_reporting_table_total_devices:
           'Total Devices',
         inconsistent_mbus_devices_reporting_table_total_projects:
           'Total Projects',
         inconsistent_mbus_devices_reporting_table_no_record_found:
           'No Record Found',
         inconsistent_mbus_devices_reporting_table_row_per_page:
           'Rows per page',
         devices_mbus_meter_count: 'Mbus Meters',
         devices_mbus_labels: 'Mbus Meter Purpose Labels',
         devices_bulk_modbus_download_form_data_type: 'Data Type',
         devices_bulk_modbus_download_form_export_type: 'Export Type',
         devices_bulk_modbus_download_form_data_type_daily: 'Daily',
         devices_bulk_modbus_download_form_data_type_hourly: 'Hourly',
         devices_bulk_modbus_download_form_export_type_combined: 'Combined',
         devices_bulk_modbus_download_form_export_type_separated: 'Separated',
         devices_bulk_export_modbus_historic_data_button: 'Download HIU data',
         devices_bulk_export_modbus_historic_data_file_name:
           'Modbus Historic Data',
         devices_bulk_modbus_download_title: 'Download HIU Historical Data',
         devices_bulk_modbus_download_form_date_range: 'Date Range:',
         devices_bulk_modbus_download_form_submit_button: 'Download HIU data',
         devices_bulk_modbus_download_form_cancel_button: 'Cancel',
         devices_bulk_modbus_download_form_success:
           'Modbus Historical Data is emailed to ##EMAIL## successfully!',
         devices_bulk_modbus_download_form_api_error: 'Internal Server Alarm',
         devices_bulk_modbus_download_no_devices_error:
           'Please select atleast 1 device with correct TR Type (TR03/TR04)',
         devices_bulk_modbus_download_form_no_devices_error:
           'Please select devices to proceed.',
         devices_bulk_modbus_download_modal_title: 'Are you sure?',
         devices_bulk_modbus_download_modal_subtitle:
           'You want to run a bulk download historical Modbus data?',
         devices_bulk_modbus_download_modal_cancel_button: 'Cancel',
         devices_bulk_modbus_download_modal_submit_button: 'Confirm',
         projects_bulk_export_modbus_historic_data_file_name:
           'Modbus Historic Data',
         projects_bulk_modbus_download_title: 'Download HIU Historical Data',
         projects_bulk_bulk_modbus_download_form_date_range: 'Date Range:',
         projects_bulk_bulk_modbus_download_form_data_export_type:
           'Date Export Type',
         projects_bulk_bulk_modbus_download_form_data_export_type_combined:
           'Combined',
         projects_bulk_bulk_modbus_download_form_data_export_type_daily:
           'Daily',
         projects_bulk_bulk_modbus_download_form_data_export_type_normal:
           'Normal',
         projects_bulk_bulk_modbus_download_form_submit_button:
           'Download HIU data',
         projects_bulk_bulk_modbus_download_form_cancel_button: 'Cancel',
         projects_bulk_modbus_download_form_success:
           'Modbus Historical Data is emailed to ##EMAIL## successfully!',
         projects_bulk_modbus_download_form_api_error: 'Internal Server Alarm',
         projects_bulk_modbus_download_no_projects_error: '',
         projects_bulk_modbus_download_form_no_projects_error:
           'Please select projects to proceed.',
         projects_bulk_bulk_modbus_download_modal_title: 'Are you sure?',
         projects_bulk_modbus_download_modal_subtitle:
           'You want to run a bulk download historical Modbus data?',
         projects_bulk_modbus_download_modal_cancel_button: 'Cancel',
         projects_bulk_modbus_download_modal_submit_button: 'Confirm',
         projects_bulk_modbus_selected_projects: 'Projects Selected',
         device_single_status_modbus_date_export_label: 'Date',
         device_single_download_modbus_data: 'Modbus Export',
         device_monitoring_maxitel_status_heading: 'Network Status',
         device_monitoring_maxitel_status_online: 'Online',
         device_monitoring_maxitel_status_offline: 'Offline',
         device_monitoring_maxitel_operational_status: 'Operational',
         device_monitoring_maxitel_non_operational_status: 'Not Operational',
         device_monitoring_maxitel_mobile_on_cloud_network_green:
           'MaxiTEL MobileOnCloud - Network Purple',
         device_monitoring_maxitel_mobile_on_cloud_network_purple:
           'MaxiTEL MobileOnCloud - Network Green',
         device_monitoring_maxitel_mobile_data_network_purple:
           'Mobile data - Network Purple',
         device_monitoring_maxitel_mobile_m2m_blend: 'M2M Blend',
         device_monitoring_maxitel_other_api: 'API',
         device_monitoring_maxitel_other_portal: 'Portal',
         device_monitoring_maxitel_updated_at: 'Updated',
         admins_last_seen: 'Last Seen',
         device_monitoring_send_grid_email_reached: 'Email Limit Reached',
         sidebar_email_reporting: 'Email Report',
         email_reporting_title: 'Email Reporting',
         email_reporting_tab_all: 'All',
         email_reporting_tab_passed: 'Passed',
         email_reporting_tab_failed: 'Failed',
         email_reporting_table_email_forwarded_at: 'Forwarded Date',
         email_reporting_table_to: 'To',
         email_reporting_table_recipient_name: 'Recipient Name',
         email_reporting_table_subject: 'Subject',
         email_reporting_table_status: 'Status',
         email_reporting_table_no_record_found: 'No Records Found',
         email_reporting_single_output_tab: 'Email Content',
         email_reporting_single_second_bread_crumb: 'Email Detail',
         email_reporting_single_email_logs_title: 'Email Logs',
         email_reporting_table_resend_failed_email_success_message:
           'Emails are forwarded again.',
         email_reporting_table_resend_failed_email_error_message:
           'Please select atleast records to resend email',
         email_reporting_table_resend_failed_email_button: 'Resend Email',
         email_reporting_table_filter_search: 'Search',
         email_reporting_table_row_per_page: 'Rows per page',
         settings_menu_modbus_global_configuration_title:
           'Modbus Global Configuration',
         settings_menu_modbus_global_configuration_title_form_header:
           'Modbus Global Configuration',
         settings_menu_modbus_global_configuration_TR03_tab: 'TR03 Settings',
         settings_menu_modbus_global_configuration_TR04_tab: 'TR04 Settings',
         settings_menu_modbus_global_configuration_form_success:
           'Modbus Global Configurations are saved successully',
         settings_menu_modbus_global_configuration_form_error:
           'Failed to update Modbus Global Configurations',
         settings_menu_modbus_global_configuration_form_save_button:
           'Save Modbus Settings',
         device_single_unprovisioned_detailed_message:
           'Device is in "Unprovisioned" mode',
         commissioning_form_stepper_validation_modbus_loading_title:
           'Modbus check takes upto 1 - 3 minutes',
         settings_menu_modbus_global_configuration_title_form_header_add_new:
           'Add New',
         settings_menu_modbus_global_configuration_title_add_form_header:
           'Add Article Number',
         settings_menu_modbus_global_configuration_article_number_field:
           'Article Number',
         settings_menu_modbus_global_configuration_article_number_required_form_error:
           'Article Number is required',
         settings_menu_modbus_global_configuration_article_number_unique_form_error:
           'Article Number already exists. Please provide a unique Article Number',
         settings_menu_modbus_global_configuration_type_field: 'Type',
         settings_menu_modbus_global_configuration_type_required_form_error:
           'Type is required',
         settings_menu_modbus_global_configuration_type_default_option:
           'Select a Type',
         settings_menu_modbus_global_configuration_add_success_message:
           'Article Number is successfully added',
         settings_menu_modbus_global_configuration_cancel_button: 'Cancel',
         settings_menu_modbus_global_configuration_save_button: 'Save',
         missing_article_number_message:
           'The Article Number field is either empty or not registered in the Modbus Global Configurations. Please commission the device. If the issue persists, contact your administrator.',
         // General Modbus Control / Status registers(90-99) - TR04
         general_modbus_control_TR04_80: 'Firmware Image status',
         general_modbus_control_TR04_81: 'Firmware Image ID',
         general_modbus_control_TR04_82: 'Defaults Image status',
         general_modbus_control_TR04_83: 'Defaults Image Checksum',
         general_modbus_control_TR04_96: 'Modbus Version',
         general_modbus_control_TR04_97: 'Modbus Device type / table',
         general_modbus_control_TR04_98: 'Unit selection ',
         general_modbus_control_TR04_99: 'Control register ',

         // Operating Status - TR04
         business_situation_operating_status_TR04_title:
           'Operating state Heat Interface Unit',
         business_situation_operating_status_TR04_100: 'CH Control state',
         business_situation_operating_status_TR04_100_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
             6: 'Blocked',
           },
         }),
         business_situation_operating_status_TR04_101: 'DHW Control State',
         business_situation_operating_status_TR04_101_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
             6: 'Blocked',
           },
         }),
         business_situation_operating_status_TR04_102: 'Preheat Control State',
         business_situation_operating_status_TR04_102_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
             6: 'Blocked',
           },
         }),
         business_situation_operating_status_TR04_103:
           'Anti-Legionella control state',
         business_situation_operating_status_TR04_103_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
             6: 'Blocked',
           },
         }),
         business_situation_operating_status_TR04_104: 'Cooling Control state',
         business_situation_operating_status_TR04_104_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
             6: 'Blocked',
           },
         }),

         business_situation_operating_status_TR04_105: 'Alarm Code',
         business_situation_operating_status_TR04_106: 'Software version',
         business_situation_operating_status_TR04_107:
           'StepperMotor1 Actual Position',
         business_situation_operating_status_TR04_108:
           'StepperMotor2 Actual Position',
         business_situation_operating_status_TR04_109: 'Pump',
         business_situation_operating_status_TR04_109_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         business_situation_operating_status_TR04_110: 'Valve1',
         business_situation_operating_status_TR04_110_list: JSON.stringify({
           list: {
             0: 'Position: Heating',
             1: 'Position: Cooling',
           },
         }),
         business_situation_operating_status_TR04_112_list: JSON.stringify({
           list: {
             0: 'Heating or demand',
             1: 'Cooling',
           },
         }),
         business_situation_operating_status_TR04_113: 'Room thermostat input',
         business_situation_operating_status_TR04_113_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         business_situation_operating_status_TR04_114: 'OpenTherm Indicator',
         business_situation_operating_status_TR04_114_list: JSON.stringify({
           list: {
             0: 'Inactive',
             1: 'Active',
           },
         }),
         business_situation_operating_status_TR04_115: 'Appliance Type',
         business_situation_operating_status_TR03_130: 'Remotely blocked state',
         business_situation_operating_status_TR03_130_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'DHW (+Preheat)',
             2: 'CH (+FDP)',
             3: 'DHW (+Preheat) & CH (+FDP)',
             4: 'Cooling',
             5: 'DHW (+Preheat) & Cooling',
             6: 'CH (+FDP) & Cooling',
             7: 'DHW (+Preheat) & CH (+FDP) & Cooling',
           },
         }),
         business_situation_operating_status_TR04_130: 'Remotely blocked state',
         business_situation_operating_status_TR04_130_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'DHW (+Preheat)',
             2: 'CH (+FDP)',
             3: 'DHW (+Preheat) & CH (+FDP)',
             4: 'Cooling',
             5: 'DHW (+Preheat) & Cooling',
             6: 'CH (+FDP) & Cooling',
             7: 'DHW (+Preheat) & CH (+FDP) & Cooling',
           },
         }),

         // Business situation - TR04
         business_situation_measured_values_TR04_title: 'Measurements',
         business_situation_measured_values_TR04_200: 'Flow rate',
         business_situation_measured_values_TR04_201: 'DHW Out temperature',
         business_situation_measured_values_TR04_202: 'Primary supply',
         business_situation_measured_values_TR04_203: 'Primary return',
         business_situation_measured_values_TR04_205: 'Secondary CH Supply',
         business_situation_measured_values_TR04_206: 'Secondary CH Return',
         business_situation_measured_values_TR04_204: 'CH calculated setpoint',
         business_situation_measured_values_TR04_207: 'OT Room Temperature',
         business_situation_measured_values_TR04_208: 'OT CH Setpoint',
         business_situation_measured_values_TR04_209: 'Outdoor Temperature',
         business_situation_measured_values_TR04_210: 'Water pressure',
         business_situation_measured_values_TR04_263: '% pump power',
         business_situation_measured_values_TR04_213: 'Primary DHW Return',
         business_situation_measured_values_TR04_214: 'Primary CH Return',

         // Operating time - TR04
         business_situation_operating_time_TR04_title: 'Operating Time',
         business_situation_operating_time_TR04_800: 'System Run Time',
         business_situation_operating_time_TR04_801: 'CH Burn Time',
         business_situation_operating_time_TR04_802: 'Cooling Time',
         business_situation_operating_time_TR04_803: 'DHW Burn Time',
         business_situation_operating_time_TR04_804: 'Number of tappings',

         // Lockout History-TR04
         lockout_time_TR04_title: 'Lockout History',
         lockout_time_TR04_820: 'Lock-out 1',
         lockout_time_TR04_821: 'Lock-out 2',
         lockout_time_TR04_822: 'Lock-out 3',
         lockout_time_TR04_823: 'Lock-out 4',
         lockout_time_TR04_824: 'Lock-out 5',
         lockout_time_TR04_825: 'Lock-out 6',
         lockout_time_TR04_826: 'Lock-out 7',
         lockout_time_TR04_827: 'Lock-out 8',
         lockout_time_TR04_828: 'Lock-out 9',
         lockout_time_TR04_829: 'Lock-out 10',
         lockout_time_TR04_830: 'Lock-out 11',
         lockout_time_TR04_831: 'Lock-out 12',
         lockout_time_TR04_832: 'Lock-out 13',
         lockout_time_TR04_833: 'Lock-out 14',
         lockout_time_TR04_834: 'Lock-out 15',
         lockout_time_TR04_835: 'Lock-out 16',
         lockout_time_TR04_836: 'Lock-out history time 1',
         lockout_time_TR04_837: 'Lock-out history time 2',
         lockout_time_TR04_838: 'Lock-out history time 3',
         lockout_time_TR04_839: 'Lock-out history time 4 ',
         lockout_time_TR04_840: 'Lock-out history time 5 ',
         lockout_time_TR04_841: 'Lock-out history time 6 ',
         lockout_time_TR04_842: 'Lock-out history time 7',
         lockout_time_TR04_843: 'Lock-out history time 8',
         lockout_time_TR04_844: 'Lock-out history time 9',
         lockout_time_TR04_845: 'Lock-out history time 10',
         lockout_time_TR04_846: 'Lock-out history time 11',
         lockout_time_TR04_847: 'Lock-out history time 12',
         lockout_time_TR04_848: 'Lock-out history time 13',
         lockout_time_TR04_849: 'Lock-out history time 14',
         lockout_time_TR04_850: 'Lock-out history time 15',
         lockout_time_TR04_851: 'Lock-out history time 16',
         // Blocking History-TR04
         blocking_history_TR04_860: 'Blocking 1',
         blocking_history_TR04_861: 'Blocking 2',
         blocking_history_TR04_862: 'Blocking 3',
         blocking_history_TR04_863: 'Blocking 4',
         blocking_history_TR04_864: 'Blocking 5',
         blocking_history_TR04_865: 'Blocking 6',
         blocking_history_TR04_866: 'Blocking 7',
         blocking_history_TR04_867: 'Blocking 8',
         blocking_history_TR04_868: 'Blocking 9',
         blocking_history_TR04_869: 'Blocking 10',
         blocking_history_TR04_870: 'Blocking 11',
         blocking_history_TR04_871: 'Blocking 12',
         blocking_history_TR04_872: 'Blocking 13',
         blocking_history_TR04_873: 'Blocking 14',
         blocking_history_TR04_874: 'Blocking 15',
         blocking_history_TR04_875: 'Blocking 16',
         blocking_history_TR04_876: 'Blocking history time 1',
         blocking_history_TR04_877: 'Blocking history time 2',
         blocking_history_TR04_878: 'Blocking history time 3',
         blocking_history_TR04_879: 'Blocking history time 4',
         blocking_history_TR04_880: 'Blocking history time 5',
         blocking_history_TR04_881: 'Blocking history time 6',
         blocking_history_TR04_882: 'Blocking history time 7',
         blocking_history_TR04_883: 'Blocking history time 8',
         blocking_history_TR04_884: 'Blocking history time 9',
         blocking_history_TR04_885: 'Blocking history time 10',
         blocking_history_TR04_886: 'Blocking history time 11',
         blocking_history_TR04_887: 'Blocking history time 12',
         blocking_history_TR04_888: 'Blocking history time 13',
         blocking_history_TR04_889: 'Blocking history time 14',
         blocking_history_TR04_890: 'Blocking history time 15',
         blocking_history_TR04_891: 'Blocking history time 16',
         // Warmtapwater - TR04
         settings_dhw_warm_tap_water_TR04_title: 'Settings hot water',
         settings_dhw_warm_tap_water_TR04_300: 'DHW setpoint',
         settings_dhw_warm_tap_water_TR04_301: 'Preheat mode',
         settings_dhw_warm_tap_water_TR04_301_list: JSON.stringify({
           list: { 0: 'Eco', 1: 'Anti freeze', 2: 'Comfort', 3: 'Dynamic' },
         }),
         settings_dhw_warm_tap_water_TR04_302: 'Preheat Comfort setpoint',
         settings_dhw_warm_tap_water_TR04_303: 'Flow rate start threshold',
         settings_dhw_warm_tap_water_TR04_304: 'DHW Mode',
         settings_dhw_warm_tap_water_TR04_304_list: JSON.stringify({
           list: {
             0: 'Off',
             8: 'PID Controlled',
           },
         }),
         settings_dhw_warm_tap_water_TR04_305: 'DHW Primary Boost Exit Time',
         settings_dhw_warm_tap_water_TR04_306:
           'DHW Mode8 Dynamic Setpoint Active',
         settings_dhw_warm_tap_water_TR04_306_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_dhw_warm_tap_water_TR04_307: 'DHW Actual Setpoint',

         // Thermal disinfection - TR04
         settings_thermal_disinfection_TR04_title:
           'Settings Thermal disinfection',
         settings_thermal_disinfection_TR04_400: 'Aleg enabled',
         settings_thermal_disinfection_TR04_400_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_thermal_disinfection_TR04_401: 'Aleg Setpoint',
         settings_thermal_disinfection_TR04_402: 'Aleg burn time',
         settings_thermal_disinfection_TR04_403: 'Aleg wait time',

         // Heating - TR04
         heating_and_cooling_settings_heating_TR04_title: 'Settings heating',
         heating_and_cooling_settings_heating_TR04_500: 'CH Max Setpoint',
         heating_and_cooling_settings_heating_TR04_501: 'CH Min Setpoint',
         heating_and_cooling_settings_heating_TR04_502: 'OutdoorResetMin',
         heating_and_cooling_settings_heating_TR04_503: 'OutdoorResetMax',
         heating_and_cooling_settings_heating_TR04_504: 'WarmWeatherShut',
         heating_and_cooling_settings_heating_TR04_506:
           'Maximum primary return',
         heating_and_cooling_settings_heating_TR04_507:
           'Max Primary Return perc',
         heating_and_cooling_settings_heating_TR04_508:
           'Delta Prim CH Setpoint',
         heating_and_cooling_settings_heating_TR04_509: 'Delta Prim min',
         heating_and_cooling_settings_heating_TR04_510: 'Max Heating Temp',
         heating_and_cooling_settings_heating_TR04_514: 'CH Setpoint',
         heating_and_cooling_settings_heating_TR04_515: 'CH Mode',
         heating_and_cooling_settings_heating_TR04_515_list: JSON.stringify({
           list: {
             0: 'PID',
             8: 'Open/Close',
             9: 'Primary Delta-T',
             10: 'Secondary Delta-T',
           },
         }),

         // Cooling - TR04
         heating_and_cooling_settings_cooling_TR04_title: 'Settings cooling',
         heating_and_cooling_settings_cooling_TR04_600: 'CoolTempSetpoint',
         heating_and_cooling_settings_cooling_TR04_601:
           'Cool MaxPrimary Return',
         heating_and_cooling_settings_cooling_TR04_602:
           'Cool % of Max Setpoint compensation',
         heating_and_cooling_settings_cooling_TR04_605: 'Max Cooling Temp',
         heating_and_cooling_settings_cooling_TR04_606: 'Cool setpoint min',
         heating_and_cooling_settings_cooling_TR04_607: 'Cool setpoint max',
         heating_and_cooling_settings_cooling_TR04_608: 'Condens protection',
         heating_and_cooling_settings_cooling_TR04_608_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         heating_and_cooling_settings_cooling_TR04_609: 'Condens timer',
         heating_and_cooling_settings_cooling_TR04_610:
           'Condens Increased setpoint',
         heating_and_cooling_settings_cooling_TR04_611: 'Cooling enable',
         heating_and_cooling_settings_cooling_TR04_611_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         // Secondary General - TR04
         heating_and_cooling_settings_secondary_general_TR04_title:
           'Settings general',
         heating_and_cooling_settings_secondary_general_TR04_512:
           'CH Min Pressure',
         heating_and_cooling_settings_secondary_general_TR04_513:
           'CH Max Pressure',
         heating_and_cooling_settings_secondary_general_TR04_603:
           'CoolHeatWaitingTime',
         heating_and_cooling_settings_secondary_general_TR04_604:
           '6-way valve waiting time',

         // Manual Operation - TR04
         settings_manual_operation_TR04_title: 'Manual control',
         settings_manual_operation_TR04_700: 'Manual control enable',
         settings_manual_operation_TR04_700_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR04_701: 'MCV-1 Manual control',
         settings_manual_operation_TR04_702: 'MCV-2 Manual control',
         settings_manual_operation_TR04_703: 'Manual (CH) Pump setting',
         settings_manual_operation_TR04_703_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR04_704: 'Manual 6-way valve position',
         settings_manual_operation_TR04_704_list: JSON.stringify({
           list: {
             0: 'Heating',
             1: 'Cooling',
           },
         }),
         settings_manual_operation_TR04_707: 'MCV-1 Manual control[%]',
         settings_manual_operation_TR04_708: 'MCV-2 Manual control[%]',
         settings_manual_operation_TR04_709: 'Manual control timeout',
         // DeltaP Parameters(LIN-PUMP)
         deltap_parameters_TR04_1870_1871: 'Customer installation pressure',
         deltap_parameters_TR04_1872_1873: 'DeltaP KV-Value',
         deltap_parameters_TR04_1874_1875: 'DeltaP Max Pressure',
         device_status_name_TR03: 'Name (TR03)',
         device_status_name_TR04: 'Name (TR04)',
         device_single_set_register_device_tr_type_unavailable:
           'Device Type is unavailable for the whole project',
         sidebar_terms_and_conditions_title: 'Terms and Conditions',
         sidebar_support_text: 'Questions or comments? Email',
         sidebar_support_text_copied: 'Email Copied!',
         settings_menu_legal_document_title: 'Legal Documents',
         legal_documents_name_en_required_form_error:
           'Document Name (EN) is required',
         legal_documents_name_nl_required_form_error:
           'Document Name (NL) is required',
         legal_documents_name_fr_required_form_error:
           'Document Name (FR) is required',
         legal_documents_name_de_required_form_error:
           'Document Name (DE) is required',
         legal_documents_name_dk_required_form_error:
           'Document Name (DK) is required',
         legal_documents_title_en_required_form_error:
           'Document Popup Title (EN) is required',
         legal_documents_title_nl_required_form_error:
           'Document Popup Title (NL) is required',
         legal_documents_title_fr_required_form_error:
           'Document Popup Title (FR) is required',
         legal_documents_title_de_required_form_error:
           'Document Popup Title (DE) is required',
         legal_documents_title_dk_required_form_error:
           'Document Popup Title (DK) is required',
         legal_documents_checkbox_label_en_required_form_error:
           'Document Checkbox Label (EN) is required',
         legal_documents_checkbox_label_nl_required_form_error:
           'Document Checkbox Label (NL) is required',
         legal_documents_checkbox_label_fr_required_form_error:
           'Document Checkbox Label (FR) is required',
         legal_documents_checkbox_label_de_required_form_error:
           'Document Checkbox Label (DE) is required',
         legal_documents_checkbox_label_dk_required_form_error:
           'Document Checkbox Label (DK) is required',
         legal_documents_document_url_required_form_error:
           'Legal Document (EN) is required',
         legal_documents_version_required_form_error: 'Version is required',
         legal_documents_type_required_form_error: 'Document Type is required',
         legal_documents_add_form_success:
           'Legal Document is successfully created',
         legal_document_modal_download_button: 'Download',
         legal_document_modal_download_error:
           'Failed to download the document',
         legal_documents_form_api_error:
           'Failed to created Legal Document due to Internal Server Alarm',
         legal_documents_form_legal_document_name_en_field:
           'Document Name (EN)',
         legal_documents_form_legal_document_name_nl_field:
           'Document Name (NL)',
         legal_documents_form_legal_document_name_fr_field:
           'Document Name (FR)',
         legal_documents_form_legal_document_name_de_field:
           'Document Name (DE)',
         legal_documents_form_legal_document_name_dk_field:
           'Document Name (DK)',
         legal_documents_form_legal_document_title_en_field:
           'Document Popup Title (EN)',
         legal_documents_form_legal_document_title_nl_field:
           'Document Popup Title (NL)',
         legal_documents_form_legal_document_title_fr_field:
           'Document Popup Title (FR)',
         legal_documents_form_legal_document_title_de_field:
           'Document Popup Title (DE)',
         legal_documents_form_legal_document_title_dk_field:
           'Document Popup Title (DK)',
         legal_documents_form_legal_document_checkbox_label_en_field:
           'Document Checkbox Label (EN)',
         legal_documents_form_legal_document_checkbox_label_nl_field:
           'Document Checkbox Label (NL)',
         legal_documents_form_legal_document_checkbox_label_fr_field:
           'Document Checkbox Label (FR)',
         legal_documents_form_legal_document_checkbox_label_de_field:
           'Document Checkbox Label (DE)',
         legal_documents_form_legal_document_checkbox_label_dk_field:
           'Document Checkbox Label (DK)',
         legal_documents_form_legal_document_document_url_field:
           'Upload Legal Document (EN) (PDF)',
         legal_documents_form_legal_document_document_url_nl_field:
           'Upload Legal Document (NL) (PDF)',
         legal_documents_form_legal_document_document_url_de_field:
           'Upload Legal Document (DE) (PDF)',
         legal_documents_form_legal_document_document_url_dk_field:
           'Upload Legal Document (DK) (PDF)',
         legal_documents_form_legal_document_document_url_fr_field:
           'Upload Legal Document (FR) (PDF)',
         legal_documents_form_legal_document_version_field: 'Version',
         legal_documents_form_legal_document_type_field: 'Document Type',
         legal_documents_form_legal_is_mandatory_field:
           'Is Document Manadatory',
         legal_documents_form_add_legal_document_button: 'Add Document',
         legal_documents_form_cancel_button: 'Cancel',
         add_legal_documents_form_header: 'Add Legal Document',
         add_legal_documents_bread_crumb_first_link: 'Add Legal Document',
         legal_documents_bread_crumb_main_title: 'Legal Documents',
         legal_documents_edit_form_success:
           'Legal Document is successfully updated',
         legal_documents_form_edit_legal_document_button: 'Edit Document',
         edit_legal_documents_form_header: 'Edit Legal Document',
         edit_legal_documents_bread_crumb_first_link: 'Edit Legal Document',
         loginTermsOfUseInfo: 'To continue, please agree to the Terms of Use',
         legal_documents_table_document_name_en: 'Document Name (EN)',
         legal_documents_table_document_title_en: 'Document Popup Title (EN)',
         legal_documents_table_document_checkbox_label_en:
           'Document Checkbox Label (EN)',
         legal_documents_table_document_document_url: 'Legal Document',
         legal_documents_table_document_type: 'Document Type',
         legal_documents_table_version: 'Version',
         legal_documents_table_updated_at: 'Updated At',
         legal_documents_table_is_default: 'Status',
         legal_documents: 'Legal Documents',
         legal_documents_add_new: 'Add Legal Document',
         legal_documents_table_row_per_page: 'Rows per page',
         legal_documents_no_record_found: 'No Records Found',
         legal_documents_filter_delete_button: 'Delete',
         legal_documents_status_default: 'Default',
         legal_documents_status_archived: 'Archived',
         legal_documents_all: 'All',
         legal_documents_filter_search: 'Search',
         legal_documents_default_document_success_message:
           '"LEGAL_DOC_TYPE" default Legal Document is successfully updated.',
         legal_documents_bulk_delete_button: 'Delete',
         legal_documents_bulk_delete_success_message:
           'Legal Document(s) are successfully deleted',
         legal_documents_bulk_delete_error_message:
           'Please select multiple records to delete',
         legal_documents_bulk_delete_title: 'Are you sure?',
         legal_documents_bulk_delete_subtitle: 'You want to delete Records?',
         legal_documents_upload_success:
           'Document is upload successfully!, please submit the changes.',
         legal_documents_upload_file_type_error: 'Only PDF files are allowed.',
         legal_documents_upload_file_size_error:
           'File size should be less than 20 MB.',
         legal_documents_uploading_text: 'Uploading...',
         legal_documents_reset_legal_documents_status_modal_title:
           'Are you sure?',
         legal_documents_reset_legal_documents_status_modal_subtitle:
           'Users will have to accept the document again. Are you sure you want to continue?',
         legal_documents_reset_legal_documents_status_cancel_button: 'Cancel',
         legal_documents_reset_legal_documents_status_update_without_acceptance_request_button:
           'Update without Acceptance Request',
         legal_documents_reset_legal_documents_status_update_with_acceptance_request_button:
           'Update with Acceptance Request',
         legal_documents_table_already_default_document_message:
           'This document is already set as a default "LEGAL_DOC_TYPE" document',
         cookie_banner_main_title: 'Manage Consent',
         cookie_banner_main_subtitle:
           'This website uses cookies to improve your user experience. By using our website you consent to all cookies in accordance with our Cookie Policy.',
         cookie_banner_essential_cookie_title: 'Essential Cookies',
         cookie_banner_essential_cookie_status_title: 'Always Active',
         cookie_banner_essential_cookie_subtitle:
           'Essential Cookies are crucial for a website basic functions, such as keeping you logged in, remembering settings, and ensuring security. They are necessary for the site to work properly and cannot be turned off.',
         cookie_banner_tracking_cookie_title: 'Tracking Cookies',
         cookie_banner_tracking_cookie_subtitle:
           'Tracking Cookies used by Google Analytics collect data on how you interact with the website, such as pages visited and time spent. This helps us understand user behavior and improve website performance. These cookies are optional and can be turned off.',
         cookie_banner_accept_button_title: 'Accept',
         cookie_banner_decline_button_title: 'Decline',
         cookie_banner_preferences_button_title: 'Preferences',
         cookie_banner_save_preferences_button_title: 'Save',
         settings_cookie_consent_title: 'Manage Cookies Consent',
         settings_cookie_tracking_cookies_title: 'Tracking Cookies',
         settings_cookie_tracking_cookies_success_message:
           'Tracking Cookies Status is updated successfully',
         settings_menu_partner_setting_title: 'Portal Settings',
         partner_settings_form_header: 'Portal Settings',
         partner_settings_form_logo_title: 'Logo',
         partner_settings_form_primary_color_title: 'Primary Color',
         partner_settings_form_secondary_color_title: 'Secondary Color',
         partner_settings_form_submit_button: 'Save Changes',
         partner_settings_form_white_label_success_message:
           'White-label is updated successfully.',
         devices_bulk_edit_registers_tr_device_type_unavailable:
           'Selected devices don\'t have a valid controller type. Please perform commissioning to proceed.',
         commissioning_form_stepper_validation_sim_connectivity_title:
           'Connectivity',
         commissioning_form_stepper_validation_sim_connectivity_default_setting:
           'Active',
         commissioning_form_stepper_validation_sim_connectivity_success:
           'Connectivity Active',
         commissioning_form_stepper_validation_sim_connectivity_error:
           'Connectivity Alarm',
         commissioning_form_stepper_validation_sim_connectivity_loading_title:
           'Connectivity check takes around 1 minute',
         device_single_device_settings_fetch_latest_settings_button_v2:
           'Data Collect',
         kong_account_created_subject:
           'Fortes Data Management - New API Gateway Account Created',
         kong_admin_user_form_create_success_message:
           'Kong Admin User created successfully!',
         kong_client_user_form_create_success_message:
           'Kong Client User created successfully!',
         kong_admin_user_form_update_success_message:
           'Kong Admin User updated successfully!',
         kong_client_user_form_update_success_message:
           'Kong Client User updated successfully!',
         kong_admin_user_form_error_message: 'Internal Server Alarm',
         kong_client_user_form_error_message: 'Internal Server Alarm',
         kong_admin_user_form_unique_error_message:
           'Email must be unique in Kong',
         kong_client_user_form_unique_error_message:
           'Email must be unique in Kong',
         kong_user_admin_single_api_documentation_link_label:
           'OpenAPI Specification',
         kong_client_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Clients are deleted successfully',
         devices_form_project_disabled_field:
           'The Project Field is disabled because this device is a service device',
         partner_settings_white_label: 'White Label',
         partner_settings_general_settings: 'General Setting',
         partner_settings_general_settings_partner_locales:
           'Available Languages',
         partner_settings_form_general_settings_success_message:
           'General Settings are updated successfully.',
         commissioning_form_article_number_is_missing_error:
           'Article Number is missing',
         commissioning_form_stepper_validation_sim_connectivity_check_started_title:
           'Started Connectivity Check',
         commissioning_form_stepper_validation_sim_connectivity_check_success_title:
           'Connectivity Success',
         commissioning_form_stepper_validation_project_modbus_settings_check_started_title:
           'Project Modbus Setting Check Started',
         commissioning_form_stepper_validation_project_modbus_settings_success_title:
           'Project Modbus Setting is Enabled',
         commissioning_form_stepper_validation_project_modbus_settings_disabled_title:
           'No Modbus specified in Project',
         commissioning_form_stepper_validation_sim_connectivity_missing_sim_number_error_event:
           'Connectivity Alarm - SIM Number is missing in the database',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_error_event:
           'Connectivity Alarm - Network Provider API is not responding',
         commissioning_form_stepper_validation_firmware_is_less_then_2_title:
           'Device Firmware version i.e. ###DEVICE_FIRMWARE_VERSION### must be 2.x.x, Please perform an OTA operation to update the firmware version',
         commissioning_form_stepper_validation_firmware_is_missing_title:
           'Device Firmware version is missing',
         commissioning_form_stepper_validation_baud_rate_fetch_failed_error_event:
           'Modbus - Unable to Fetch Baud Rate. Expected Baud Rate was ###BAUD_RATE###',
         commissioning_form_stepper_validation_baud_rate_set_failed_error_event:
           'Modbus - Unable to Set Baud Rate ###BAUD_RATE###',
         commissioning_form_stepper_validation_modbus_connection_error_event:
           'Modbus - Not Connected',
         commissioning_form_stepper_validation_modbus_connection_success_event:
           'Modbus - Connected',
         commissioning_form_stepper_validation_mbus_meters_check_success_event:
           'Mbus - Device Mbus Meters Count i.e. ###DEVICE_MBUS_METERS_COUNT### matched with Project Settings Meters Count i.e. ###PROJECT_SETTINGS_MBUS_METERS_COUNT###',
         commissioning_form_stepper_validation_mbus_meters_check_error_event:
           "Mbus - Device Mbus Meters Count i.e. ###DEVICE_MBUS_METERS_COUNT### doesn't match with Project Settings Meters Count i.e. ###PROJECT_SETTINGS_MBUS_METERS_COUNT###",
         commissioning_form_stepper_validation_complete_success_event:
           'Validation process is successfully completed',
         device_bulk_insert_form_header: 'Device Insert',
         devices_form_order_type_field: 'Order Type',
         partner_settings_general_settings_distributor_article_number_label:
           'HIU Settings',
         partner_settings_general_settings_distributor_article_number_enable_settings_label:
           'Enable Distributor Article and Serial Number',
         partner_settings_general_settings_distributor_article_number_disable_settings_label:
           'Disable Distributor HIU Settings',
         devices_partner_serial_number:
           'Distributor Serial Number heat interface unit',
         devices_partner_article_number_field:
           'Distributor Article number heat interface unit',
         commissioning_form_stepper_validation_baud_rate_retries_label:
           'Baud Rate Retries',
         commissioning_form_stepper_validation_modbus_retries_label:
           'Modbus Connection Retries',
         commissioning_form_header_updated_information_title:
           'Updated Information',
         commissioning_form_header_report_title: 'Report',
         commissioning_form_header_report_connectivity:
           'Connectivity Step Status: ',
         commissioning_form_header_report_modbus_validation_title:
           'Modbus Validation: ',
         commissioning_form_header_report_mbus_validation_title:
           'Mbus Validation: ',
         commissioning_form_header_report_failed_status_title: 'Failed',
         commissioning_form_header_report_passed_status_title: 'Passed',
         commissioning_form_header_report_not_status_title: 'N/A',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_success_event:
           'Network Provider API is working fine',
         project_single_project_error_devices_tab: 'Project Alarm History',
         device_monitoring_project_active_device_errors_counters_title:
           'Active Alarm Devices Counters',
         device_monitoring_project_active_device_errors_list_title:
           'Active Alarm Devices List',
         device_v2_settings_tab_general: 'General',
         device_v2_settings_tab_modbus: 'Modbus',
         device_v2_settings_tab_mbus: 'Mbus',
         device_single_device_settings_hiu_reboot_device: 'HIU Reboot',
         device_single_device_settings_hiu_reboot_message_forwarded:
           'Device HIU Modbus Reboot message is forwarded to device',
         device_single_device_settings_interval_field: 'Interval',
         device_single_device_settings_interval_in_seconds_field:
           'Interval (Minutes)',
         device_single_device_settings_mbus_interval_message_forwarded:
           'Set Mbus Interval message is forwarded to device',
         device_single_device_settings_mbus_interval_error_message_forwarded:
           'Mbus Interval must be greater than or equal to 0',
         device_single_device_settings_mbus_interval: 'Mbus Interval',
         mbus_export_is_validated_field: 'Is Validated',
         device_single_device_settings_fqdn_field: 'Device FQDN',
         device_single_device_settings_fqdn_field_default_option: 'Select FQDN',
         device_single_device_settings_fqdn_error:
           'Please select a FQDN to proceed',
         device_single_device_settings_fqdn_message_forwarded:
           'FQDN message is forwarded to the device',
         projects_table_online_devices: 'Online Devices',
         add_subscriptions_form_header: 'Create Subscription Extension',
         subscriptions_bread_crumb_main_title: 'Subscriptions',
         add_subscriptions_bread_crumb_first_link:
           'Create Subscription Extension',
         subscriptionOrderNumber_required_form_error:
           'Subscription Order Number is required',
         subscriptionPeriod_required_form_error:
           'Subscription Period is required',
         projectId_required_form_error: 'Project is required',
         clientId_required_form_error: 'Client is required',
         subscriptionType_required_form_error: 'Subscription Type is required',
         subscription_form_subscriptionOrderNumber_field:
           'Subscription Order Number',
         subscription_form_subscriptionPeriod_field:
           'Subscription Period (months)',
         subscription_form_projectId_field: 'Project',
         subscription_form_clientId_field: 'Client',
         subscription_form_subscriptionType_field: 'Subscription Type',
         subscription_form_subscriptionStartDate_field:
           'Subscription Start Date',
         subscription_form_subscriptionEndDate_field:
           'Subscription Expected End Date',
         subscription_form_description_field: 'Description',
         subscription_form_notes_field: 'Notes',
         subscription_form_add_subscription_button: 'Save Changes',
         subscription_form_cancel_button: 'Cancel',
         subscription_form_project_offboarding_error: 'The selected project is currently being offboarded:',
         subscription_form_project_offboarding_cancel_hint: 'If you want to create a subscription extension, please first cancel the offboarding of the project.',
         subscription_add_form_success: 'Subscription is successfully created',
         subscription_form_api_error:
           'Failed to created Subscription due to Internal Server Alarm',
         subscriptions_form_header: 'Subscriptions',
         subscriptions_add_new: 'Create Subscription Extension',
         subscriptions_table_project: 'Project',
         subscriptions_table_client: 'Client',
         subscriptions_table_start_date: 'Start Date',
         subscriptions_table_end_date: 'End Date',
         subscriptions_table_subscriptionPeriod: 'Duration',
         offboarding_no_client_title: 'Project Has No Client Assigned',
         offboarding_no_client_line1:
           'One or more selected projects do not have a client assigned.',
         offboarding_no_client_line2:
           'Please deselect the project and continue, or assign a client to the project and refresh this page.',
         offboarding_no_client_line3:
           'To make selection easier, use the client filter to view projects from a single client only.',
         offboarding_cannot_combine_title: 'Projects Cannot Be Combined',
         offboarding_cannot_combine_line1:
           'You can only select projects that belong to the same client.',
         offboarding_cannot_combine_line2:
           'Please deselect projects from other clients to continue.',
         offboarding_cannot_combine_line3:
           'To make selection easier, use the client filter to view projects from a single client only.',
         subscriptions_table_total_device: 'Total Devices',
         subscriptions_table_total_credit: 'Total Credits',
         subscriptions_table_credit_used: 'Credits Used',
         subscriptions_table_credit_left: 'Credits Left',
         subscriptions_table_month_to_zero_credit: 'Months to Zero Credit',
         subscriptions_table_status: 'Status',
         subscriptions_table_loading: 'Loading...',
         subscriptions_no_record_found: 'No Records Found',
         subscriptions_all: 'All',
         subscriptions_active: 'Active',
         subscriptions_inactive: 'Inactive',
         subscriptions_expired: 'Expired',
         subscriptions_expiring_soon: 'Expiring Soon',
         subscriptions_table_row_per_page: 'Rows per page',
         subscriptions_filter_search: 'Search',
         subscriptions_filters: 'Filters',
         sidebar_subscriptions_overview: 'Subscriptions Overview',
         sidebar_subscriptions: 'Subscriptions',
         project_single_project_subscription_devices_tab:
           'Device Subscriptions',
         project_single_project_subscription_overview_tab:
           'Subscription Extensions',
         sidebar_subscriptions_analytics: 'Subscription Analytics',
         subscriptions_analytics_form_header: 'Subscription Analytics',
         devices_form_order_type_order_with_hiu: 'Order with HIU',
         devices_form_order_type_order_without_hiu: 'Order without HIU',
         subscription_status_overview_title: 'Device Subscription Overview',
         subscription_analytics_data_missing_message: 'Data is not available',
         subscription_analytics_data_loading_message: 'Data is loading ...',
         subscription_status_overview_subscriptions: 'Subscriptions',
         subscription_status_overview_expiring_soon: 'Expiring soon',
         subscription_status_overview_not_expiring_in_3_months:
           'Not expiring in 3 months',
         subscription_status_overview_expired: 'Expired',
         subscription_analytics_subscriptions_expiring_soon_title:
           'Project Subscriptions Expiring Soon',
         subscription_analytics_subscriptions_expiring_soon_2_weeks: '2 Weeks',
         subscription_analytics_subscriptions_expiring_soon_1_month: '1 month',
         subscription_analytics_subscriptions_expiring_soon_2_months:
           '2 months',
         subscription_analytics_subscriptions_expiring_soon_3_months:
           '3 months',
         subscription_analytics_subscriptions_expiring_soon_6_months:
           '6 months',
         subscription_analytics_subscriptions_expiring_soon_12_months:
           '12 months',
         subscription_analytics_subscriptions_expiring_soon_no_of_subscriptions:
           'No. of Subscriptions',
         subscription_analytics_projects_credits_timeline_title:
           'Projects Credits Timeline',
         subscription_analytics_projects_credits_timeline_no_of_credits:
           'No. of Credits',
         subscription_analytics_projects_credits_timeline_months: 'Months',
         subscription_analytics_projects_credits_timeline_jan: 'Jan',
         subscription_analytics_projects_credits_timeline_feb: 'Feb',
         subscription_analytics_projects_credits_timeline_mar: 'Mar',
         subscription_analytics_projects_credits_timeline_apr: 'Apr',
         subscription_analytics_projects_credits_timeline_may: 'May',
         subscription_analytics_projects_credits_timeline_jun: 'Jun',
         subscription_analytics_projects_credits_timeline_jul: 'Jul',
         subscription_analytics_projects_credits_timeline_aug: 'Aug',
         subscription_analytics_projects_credits_timeline_sep: 'Sep',
         subscription_analytics_projects_credits_timeline_oct: 'Oct',
         subscription_analytics_projects_credits_timeline_nov: 'Nov',
         subscription_analytics_projects_credits_timeline_dec: 'Dec',
         subscription_analytics_projects_credits_consumed: 'Credits Consumed',
         subscription_analytics_projects_credits_details_active_subscriptions:
           'Active Subscriptions',
         subscription_analytics_projects_credits_details_expiring_soon:
           'Expiring soon',
         subscription_analytics_projects_credits_details_expired_subscriptions:
           'Expired Subscriptions',
         subscription_analytics_projects_credits_details_expiring_in_3_months:
           'Expiring in 3 months',
         subscription_analytics_projects_credits_details_expiring_in_6_months:
           'Expiring in 6 months',
         partner_settings_general_settings_partner_timezone: 'Default Timezone',
         distributor_timezone_modal_update_distributor_and_external_api_timezone_only:
           'Update Distributor and External API timezone only',
         distributor_timezone_modal_update_distributor_and_all_users_timezone:
           'Update Distributor and all users timezone',
         distributor_timezone_modal_cancel: 'Cancel',
         distributor_timezone_modal_title: 'Are you sure?',
         distributor_timezone_modal_subtitle:
           'You want to update the timezone for the distributor module?',
         distributor_timezone_modal_success_message:
           'Timezone is successfully updated',
         distributor_timezone_modal_error_message: 'Timezone updation failed',
         commissioning_email_commissioned_at_field: 'Commissioned at',
         commissioning_email_commissioned_by_field: 'Commissioned by',
         commissioning_email_commissioned_status_field: 'Commissioned status',
         commissioning_email_commissioned_completed_hiu_details_field:
           'Completed HIU details',
         commissioning_email_mobile_connectivity_validation_field:
           'Mobile connectivity validation',
         commissioning_email_modbus_connectivity_validation_field:
           'Modbus connectivity validation',
         commissioning_email_mbus_connectivity_validation_field:
           'Mbus connectivity validation',
         commissioning_email_updated_address_details_field:
           'Updated address details',
         commissioning_email_title: 'Mercurius Commissioning Report',
         commissioning_email_commissioned_by_message:
           'has proceeded to complete the commissioning process.',
         commissioning_email_subtitle:
           'Please find below the commissioning report of the recently commissioned Mercurius in your project.',
         commissioning_email_information:
           'generates this report after completing the Mercurius commissioning process. This will allow you or your organisation to take timely action to resolve any issues with connecting the heating interface units and ensure correct commissioning.',
         commissioning_email_questions:
           'Questions? Please contact <a href="mailto:support@fortesdata.com"><span style="font-weight: 600; color: {{ primaryColor }};">support@fortesdata.com</span></a> for further support.',
         commissioning_none_added_status: 'None Added',
         commissioning_partially_updated_status: 'Partially Updated',
         commissioning_completed_status: 'Completed',
         commissioning_hiu_failed: 'Failed',
         commissioning_hiu_passed: 'Passed',
         subscription_credits_overview_title: 'Project Credits Overview',
         subscription_credits_positive_credits: 'Positive',
         subscription_credits_negative_credits: 'Negative',
         partner_settings_general_settings_partner_locale: 'Default Language',
         distributor_locale_modal_update_distributor_locale_only:
           'Update Default Language only',
         distributor_locale_modal_update_distributor_and_all_users_locale:
           'Update Distributor and all users locale',
         distributor_locale_modal_cancel: 'Cancel',
         distributor_locale_modal_title: 'Are you sure?',
         distributor_locale_modal_subtitle:
           'You want to update the locale for the distributor module?',
         distributor_locale_modal_success_message:
           'Language is successfully updated',
         distributor_locale_modal_error_message: 'Language updation failed',
         users_form_timezone_field: 'Timezone',
         users_form_locale_field: 'Language',
         error_check_details_table_new_tab: 'New',
         error_check_details_table_resolved_tab: 'Resolved',
         error_check_details_table_active_tab: 'Active',
         error_check_details_table_error_status: 'Alarm Status',
         error_check_details_table_error: 'Alarm Code',
         error_check_details_table_error_at: 'Alarm At',
         partner_settings_general_settings_distributor_serial_number_and_article_number_settings_label:
           'Distributor Serial, Article and Order Number',
         kong_user_admin_single_client_label: 'Client',
         commissioning_updated_information_title: 'Updated Information',
         subscription_form_customerReference_field: 'Customer Reference',
         subscriptionCustomerReference_required_form_error:
           'Customer Reference is required',
         subscription_previous_credits_left: 'Previous Credits Left',
         subscription_new_credits_added: 'New Credits Added',
         subscription_actual_credits_available: 'Actual Credits Available',
         subscription_start_date: 'Start Date',
         subscription_expected_expiry_date: 'Expected Expiry Date',
         subscription_created_at: 'Created At',
         subscription_created_by: 'Created By',
         subscription_notes_detail_for_users:
           '(For Fortes Internal Use Only): Sales notes, follow-ups, and other relevant information can be documented here.',
         subscription_extension_overview: 'Subscription Extension Overview',
         view_subscriptions_form_header: 'View Subscription',
         current_subscription_state: 'Current subscription state',
         subscription_analytics_projects_credits_details_expiring_in_1_month:
           'Expiring in 1 month',
         business_situation_measured_values_TR04_211:
           'Filtered Outdoor Temperature',
         business_situation_measured_values_TR04_212:
           'Secondary Incoming Cold Water',
         business_situation_measured_values_TR04_215: 'Primary DHW Supply',
         business_situation_measured_values_TR04_216: 'Primary CH Supply',
         appliance_types_applicable: 'Applicable',
         appliance_types_device_dashboard: 'Device Dashboard',
         appliance_types_register_name: 'Register Name',
         firmware_registers_TR04_80: 'Firmware Image status',
         firmware_registers_TR04_80_list: JSON.stringify({
           list: {
             0: 'Partial image (Receiving image)',
             1: 'Valid image (Ready for programming)',
             2: 'Corrupt image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_81_list: JSON.stringify({
           list: {
             0: 'Firmware/application image',
             1: 'Defaults image',
             2: 'Unknown image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_82_list: JSON.stringify({
           list: {
             0: 'Partial image (Receiving image)',
             1: 'Valid image (Ready for programming)',
             2: 'Corrupt image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_98_list: JSON.stringify({
           list: {
             0: '°C bar',
             1: '°F bar',
             2: '°C psi',
             3: '°F psi',
           },
         }),
         firmware_registers_TR04_81: 'Firmware Image ID',
         firmware_registers_TR04_82: 'Defaults Image status',
         firmware_registers_TR04_98: 'Unit selection',
         firmware_registers_TR04_title: 'Firmware Registers',
         lin_pump_delta_parameters_TR04_title: 'LIN-Pump DeltaP Parameters',
         lin_pump_delta_parameters_TR04_1870: 'DeltaP Customer Installation',
         lin_pump_delta_parameters_TR04_1871:
           'DeltaP Customer Installation (1)',
         lin_pump_delta_parameters_TR04_1872: 'DeltaP Kv Value',
         lin_pump_delta_parameters_TR04_1873: 'DeltaP Kv Value (1)',
         lin_pump_delta_parameters_TR04_1874: 'NV DeltaP Max',
         lin_pump_delta_parameters_TR04_1875: 'NV DeltaP Max (1)',
         appliance_types_form_cancel_button: 'Cancel',
         appliance_types_form_submit_button: 'Save Changes',
         custom_popover_211_short_description: 'Filtered Outdoor Temperature',
         custom_popover_212_short_description: 'Secondary Incoming Cold Water',
         custom_popover_215_short_description: 'Primary DHW Supply',
         custom_popover_216_short_description: 'Primary CH Supply',
         custom_popover_80_short_description: 'Firmware Image status',
         custom_popover_81_short_description: 'Firmware Image ID',
         custom_popover_82_short_description: 'Defaults Image status',
         custom_popover_98_short_description: 'Unit selection',
         custom_popover_1871_short_description: 'DeltaP Customer Installation',
         custom_popover_1873_short_description: 'DeltaP Kv Value',
         custom_popover_1875_short_description: 'NV DeltaP Max',
         edit_devices_device_name_unique_error: 'Device Name must be unique',
         edit_devices_serial_number_unique_error:
           'Serial Number Mercurius must be unique',
         edit_devices_description_error: 'Type Heat Interface Unit is required',
         edit_devices_box_serial_number_unique_error:
           'Serial Number Heat Interface Unit must be unique',
         edit_devices_article_number_error: 'Article Number is required',
         edit_devices_distributor_article_number_error:
           'Distributor Article Number is required',
         edit_devices_distributor_serial_number_unique_error:
           'Distributor Serial Number Heat Interface Unit must be unique',
         edit_devices_prod_order_nr_week_error:
           'Production order number is required',
         edit_devices_sim_card_number_error: 'Sim card number is required',
         edit_devices_production_date_error: 'Production Date is required',
         custom_popover_211_long_description: 'Filtered Outdoor Temperature',
         custom_popover_212_long_description: 'Secondary Incoming Cold Water',
         custom_popover_215_long_description: 'Primary DHW Supply',
         custom_popover_216_long_description: 'Primary CH Supply',
         custom_popover_80_long_description: 'Firmware Image status',
         custom_popover_81_long_description: 'Firmware Image ID',
         custom_popover_82_long_description: 'Defaults Image status',
         custom_popover_98_long_description: 'Unit selection',
         custom_popover_1871_long_description: 'DeltaP Customer Installation',
         custom_popover_1873_long_description: 'DeltaP Kv Value',
         custom_popover_1875_long_description: 'NV DeltaP Max',
         devices_form_backend_error_message:
           'There are some issues with the fields. Kindly review the form and correct the errors to proceed.',
         devices_sim_card_number_length_and_type_form_error:
           'SIM card number must be numeric and exactly 19 digits',
         devices_sim_card_number_required_form_error:
           'SIM card number is required',
         devices_name_type_form_error:
           'Device name should contain only capital alphabets and numbers.',
         devices_name_min_length_form_error:
           'Device name length should be at least 5 characters long.',
         devices_name_max_length_form_error:
           'Device name length should be at most 6 characters long.',
         devices_serial_number_type_form_error:
           'Serial Number Mercurius should contain only alphabets and numbers.',
         devices_serial_number_min_length_form_error:
           'Serial Number Mercurius should be exactly 24 characters long.',
         devices_serial_number_max_length_form_error:
           'Serial Number Mercurius should be exactly 24 characters long.',
         devices_article_number_min_length_form_error:
           'Article Number should be between 10 and 13 characters.',
         devices_article_number_max_length_form_error:
           'Article Number should be between 10 and 13 characters.',
         device_single_device_error_reporting_tab: 'Alarm Reporting',
         error_reporting_alarm_type_field: 'Alarm Type',
         error_reporting_description_field: 'Description',
         error_reporting_resolution_field: 'Resolution',
         error_reporting_error_start_date_field: 'Start Date',
         error_reporting_error_end_date_field: 'End Date',
         error_reporting_error_counters_title: 'Historic Alarm Counters',
         error_reporting_error_counters_error: 'No data found',
         error_reporting_error_counters_no_graph_data_error:
           'The piechart is unavailable',
         error_reporting_error_counters_loading_data: 'Loading ...',
         errorReporting_TR04_255_errorName: 'No alarm',
         errorReporting_TR04_255_errorDescription: 'No alarm',
         errorReporting_TR04_255_errorResolution: 'None',

         errorReporting_TR04_0_errorName: 'E2PROM_READ_ERROR',
         errorReporting_TR04_0_errorDescription: 'Internal software error',
         errorReporting_TR04_0_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_8_errorName: 'RAM_ERROR',
         errorReporting_TR04_8_errorDescription: 'Internal software error',
         errorReporting_TR04_8_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_10_errorName: 'E2PROM_ERROR',
         errorReporting_TR04_10_errorDescription:
           'Wrong safety parameters in E2prom',
         errorReporting_TR04_10_errorResolution: 'Replace controller',

         errorReporting_TR04_11_errorName: 'STATE_ERROR',
         errorReporting_TR04_11_errorDescription: 'Internal software error',
         errorReporting_TR04_11_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_12_errorName: 'ROM_ERROR',
         errorReporting_TR04_12_errorDescription: 'Internal software error',
         errorReporting_TR04_12_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_15_errorName: 'MAX_TEMP_ERROR',
         eerrorReporting_TR04_15_errorDescription:
           'The external overheat protection is enabled or the Secondary CH Supply sensor (TT-4) measures a temp higher than Maximum heating temp',
         errorReporting_TR04_15_errorResolution:
           'Resolve error and press reset button',

         errorReporting_TR04_17_errorName: 'STACK_ERROR',
         errorReporting_TR04_17_errorDescription: 'Internal software error',
         errorReporting_TR04_17_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_18_errorName: 'INSTRUCTION_ERROR',
         errorReporting_TR04_18_errorDescription: 'Internal software error',
         errorReporting_TR04_18_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_23_errorName: 'CORRUPTED_ERROR_NR',
         errorReporting_TR04_23_errorDescription:
           'Error code RAM byte was corrupted to an unknown error code',
         errorReporting_TR04_23_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_29_errorName: 'PSM_ERROR',
         errorReporting_TR04_29_errorDescription: 'Internal software error',
         errorReporting_TR04_29_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_30_errorName: 'REGISTER_ERROR',
         errorReporting_TR04_30_errorDescription: 'Internal software error',
         errorReporting_TR04_30_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_37_errorName: 'ADC_ERROR',
         errorReporting_TR04_37_errorDescription: 'Internal hardware error',
         errorReporting_TR04_37_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_39_errorName: 'E2PROM_VERSION_CHECK_ERROR',
         errorReporting_TR04_39_errorDescription: 'Internal software error',
         errorReporting_TR04_39_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_106_errorName: 'REFHI_TOO_HIGH',
         errorReporting_TR04_106_errorDescription: 'Internal hardware error',
         errorReporting_TR04_106_errorResolution: 'Replace controller',

         errorReporting_TR04_107_errorName: 'REFHI_TOO_LOW',
         errorReporting_TR04_107_errorDescription: 'Internal hardware error',
         errorReporting_TR04_107_errorResolution: 'Replace controller',

         errorReporting_TR04_108_errorName: 'REFLO_TOO_HIGH',
         errorReporting_TR04_108_errorDescription: 'Internal hardware error',
         errorReporting_TR04_108_errorResolution: 'Replace controller',

         errorReporting_TR04_109_errorName: 'REFLO_TOO_LOW',
         errorReporting_TR04_109_errorDescription: 'Internal hardware error',
         errorReporting_TR04_109_errorResolution: 'Replace controller',

         errorReporting_TR04_114_errorName: 'E2PROM_VERSION_ERROR',
         errorReporting_TR04_114_errorDescription: 'Internal software error',
         errorReporting_TR04_114_errorResolution: 'Replace controller',

         errorReporting_TR04_116_errorName: 'LOW_WATER_PRESSURE_SENSOR',
         errorReporting_TR04_116_errorDescription: 'Low water pressure',
         errorReporting_TR04_116_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR04_119_errorName: 'T_PRIMARY_CH_RETURN_OPEN',
         errorReporting_TR04_119_errorDescription:
           'Primary CH Return sensor open',
         errorReporting_TR04_119_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_120_errorName: 'T_PRIMARY_SUPPLY_OPEN',
         errorReporting_TR04_120_errorDescription: 'Primary Supply sensor open',
         errorReporting_TR04_120_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_122_errorName: 'T_DHW_OUT_OPEN',
         errorReporting_TR04_122_errorDescription: 'DHW Output sensor open',
         errorReporting_TR04_122_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_126_errorName: 'T_PRIMARY_CH_RETURN_SHORTED',
         errorReporting_TR04_126_errorDescription:
           'Primary CH Return sensor shorted',
         errorReporting_TR04_126_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_127_errorName: 'T_PRIMARY_SUPPLY_SHORTED',
         errorReporting_TR04_127_errorDescription:
           'Primary Supply sensor shorted',
         errorReporting_TR04_127_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_129_errorName: 'T_DHW_OUT_SHORTED',
         errorReporting_TR04_129_errorDescription: 'DHW Output sensor shorted',
         errorReporting_TR04_129_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_134_errorName: 'RESET_BUTTON_ERROR',
         errorReporting_TR04_134_errorDescription:
           'Too many resets in a short time period',
         errorReporting_TR04_134_errorResolution:
           'Interrupt power supply HIU for approx.. 10 seconds',

         errorReporting_TR04_158_errorName: 'T_SECONDARY_CH_SUPPLY_OPEN',
         errorReporting_TR04_158_errorDescription:
           'Secondary CH Supply sensor open',
         errorReporting_TR04_158_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_159_errorName: 'T_SECONDARY_CH_RETURN_OPEN',
         errorReporting_TR04_159_errorDescription:
           'Secondary CH Return sensor open',
         errorReporting_TR04_159_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_160_errorName: 'T_SECONDARY_CH_SUPPLY_SHORTED',
         errorReporting_TR04_160_errorDescription:
           'Secondary CH Supply sensor shorted',
         errorReporting_TR04_160_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_161_errorName: 'T_SECONDARY_CH_RETURN_SHORTED',
         errorReporting_TR04_161_errorDescription:
           'Secondary CH Return sensor shorted',
         errorReporting_TR04_161_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_171_errorName: 'ADC_UNSTABLE',
         errorReporting_TR04_171_errorDescription:
           'ADC measurement detected too many unstable measurements',
         errorReporting_TR04_171_errorResolution: 'Replace controller',

         errorReporting_TR04_174_errorName: 'T_PRIMARY_DHW_RETURN_OPEN',
         errorReporting_TR04_174_errorDescription:
           'Primary DHW Return sensor open',
         errorReporting_TR04_174_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_175_errorName: 'T_PRIMARY_DHW_RETURN_SHORTED',
         errorReporting_TR04_175_errorDescription:
           'Primary DHW Return sensor shorted',
         errorReporting_TR04_175_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_203_errorName: 'HIGH_WATER_PRESSURE_SENSOR',
         errorReporting_TR04_203_errorDescription:
           'High (CH) water pressure detected',
         errorReporting_TR04_203_errorResolution: '-',

         errorReporting_TR04_206_errorName: 'TE_BOOSTER_WARNING',
         errorReporting_TR04_206_errorDescription:
           'TE-Booster is in state SafetyLock',
         errorReporting_TR04_206_errorResolution: '-',

         errorReporting_TR04_207_errorName: 'POWERPACK_DEFECT_WARNING',
         errorReporting_TR04_207_errorDescription: 'PowerPack is defective',
         errorReporting_TR04_207_errorResolution: '-',

         errorReporting_TR04_208_errorName: 'ERRORLOG_STORAGE_FAULT',
         errorReporting_TR04_208_errorDescription: 'Internal software warning',
         errorReporting_TR04_208_errorResolution: '-',

         errorReporting_TR04_209_errorName: 'DATALOG_STORAGE_FAULT',
         errorReporting_TR04_209_errorDescription: 'Internal software warning',
         errorReporting_TR04_209_errorResolution: '-',

         errorReporting_TR04_210_errorName: 'FIRMWARE_STORAGE_FAULT',
         errorReporting_TR04_210_errorDescription: 'Internal software warning',
         errorReporting_TR04_210_errorResolution: '-',

         errorReporting_TR04_211_errorName: 'DEFAULTS_STORAGE_FAULT',
         errorReporting_TR04_211_errorDescription: 'Internal software warning',
         errorReporting_TR04_211_errorResolution: '-',

         errorReporting_TR04_212_errorName: 'NO_PRIMARY_FLOW',
         errorReporting_TR04_212_errorDescription: 'No primary flow',
         errorReporting_TR04_212_errorResolution: '-',

         errorReporting_TR04_213_errorName: 'LOW_PRIMARY_FLOW',
         errorReporting_TR04_213_errorDescription: 'Primary flow too low',
         errorReporting_TR04_213_errorResolution: '-',

         errorReporting_TR04_214_errorName: 'UNDESIRED_PRIMARY_FLOW_MCV1',
         errorReporting_TR04_214_errorDescription:
           'Undesired primary flow warning for MCV1',
         errorReporting_TR04_214_errorResolution: '-',

         errorReporting_TR04_215_errorName: 'UNDESIRED_PRIMARY_FLOW_MCV1_2',
         errorReporting_TR04_215_errorDescription:
           'Undesired primary flow warning for MCV1 and MCV2',
         errorReporting_TR04_215_errorResolution: '-',

         errorReporting_TR04_216_errorName: 'T_ALEG_TOO_LOW',
         errorReporting_TR04_216_errorDescription:
           'Return temp too low during Anti-Legionella demand',
         errorReporting_TR04_216_errorResolution: '-',

         errorReporting_TR04_217_errorName: 'T_DHW_TOO_HIGH',
         errorReporting_TR04_217_errorDescription:
           'DHW temp is too high ( > 70ºC for > 5 s.)',
         errorReporting_TR04_217_errorResolution: '-',

         errorReporting_TR04_218_errorName: 'EVALUATION_TIMER_EXPIRED',
         errorReporting_TR04_218_errorDescription:
           'Evaluation Timer has expired',
         errorReporting_TR04_218_errorResolution: '-',

         errorReporting_TR04_219_errorName: 'WATER_LEAK',
         errorReporting_TR04_219_errorDescription: 'Water leak detected',
         errorReporting_TR04_219_errorResolution: '-',

         errorReporting_TR03_255_errorName: 'No alarm',
         errorReporting_TR03_255_errorDescription: 'No alarm',
         errorReporting_TR03_255_errorResolution: 'None',

         errorReporting_TR03_0_errorName: 'E2PROM_READ_ERROR',
         errorReporting_TR03_0_errorDescription: 'Internal software error',
         errorReporting_TR03_0_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_4_errorName: 'BLOCKING_TOO_LONG',
         errorReporting_TR03_4_errorDescription:
           'Control had a blocking error for more than 20 hours',
         errorReporting_TR03_4_errorResolution:
           'Press reset button and resolve underlying blocking error',

         errorReporting_TR03_8_errorName: 'RAM_ERROR',
         errorReporting_TR03_8_errorDescription: 'Internal software error',
         errorReporting_TR03_8_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_9_errorName: 'WRONG_EEPROM_SIGNATURE',
         errorReporting_TR03_9_errorDescription:
           'Contents of E2prom is not up to date',
         errorReporting_TR03_9_errorResolution: 'Replace controller',

         errorReporting_TR03_10_errorName: 'E2PROM_ERROR',
         errorReporting_TR03_10_errorDescription:
           'Wrong safety parameters in E2prom',
         errorReporting_TR03_10_errorResolution: 'Replace controller',

         errorReporting_TR03_11_errorName: 'STATE_ERROR',
         errorReporting_TR03_11_errorDescription: 'Internal software error',
         errorReporting_TR03_11_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_12_errorName: 'ROM_ERROR',
         errorReporting_TR03_12_errorDescription: 'Internal software error',
         errorReporting_TR03_12_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_15_errorName: 'MAX_TEMP_ERROR',
         errorReporting_TR03_15_errorDescription:
           'The external overheat protection is enabled or the Secondary Supply sensor (TT-1) measures a temp higher than Maximum heating temp',
         errorReporting_TR03_15_errorResolution:
           'Resolve error and press reset button',

         errorReporting_TR03_17_errorName: 'STACK_ERROR',
         errorReporting_TR03_17_errorDescription: 'Internal software error',
         errorReporting_TR03_17_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_18_errorName: 'INSTRUCTION_ERROR',
         errorReporting_TR03_18_errorDescription: 'Internal software error',
         errorReporting_TR03_18_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_23_errorName: 'CORRUPTED_ERROR_NR',
         errorReporting_TR03_23_errorDescription:
           'Error code RAM byte was corrupted to an unknown error code',
         errorReporting_TR03_23_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_29_errorName: 'PSM_ERROR',
         errorReporting_TR03_29_errorDescription: 'Internal software error',
         errorReporting_TR03_29_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_30_errorName: 'REGISTER_ERROR',
         errorReporting_TR03_30_errorDescription: 'Internal software error',
         errorReporting_TR03_30_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_36_errorName: 'COOLING_TO_HIGH',
         errorReporting_TR03_36_errorDescription:
           'Cooling temp on secondary supply too high. Cooling temp above Max cooling temp for >3 minutes.',
         errorReporting_TR03_36_errorResolution:
           'Reduce cooling temp. Press reset button. If alarm remains or returns, increase Max cooling temp to 54C. If alarm remains, replace controller.',

         errorReporting_TR03_106_errorName: 'REFHI_TOO_HIGH',
         errorReporting_TR03_106_errorDescription: 'Internal hardware error',
         errorReporting_TR03_106_errorResolution: 'Replace controller',

         errorReporting_TR03_107_errorName: 'REFHI_TOO_LOW',
         errorReporting_TR03_107_errorDescription: 'Internal hardware error',
         errorReporting_TR03_107_errorResolution: 'Replace controller',

         errorReporting_TR03_108_errorName: 'REFLO_TOO_HIGH',
         errorReporting_TR03_108_errorDescription: 'Internal hardware error',
         errorReporting_TR03_108_errorResolution: 'Replace controller',

         errorReporting_TR03_109_errorName: 'REFLO_TOO_LOW',
         errorReporting_TR03_109_errorDescription: 'Internal hardware error',
         errorReporting_TR03_109_errorResolution: 'Replace controller',

         errorReporting_TR03_110_errorName: 'REFHI2_TOO_HIGH',
         errorReporting_TR03_110_errorDescription: 'Internal hardware error',
         errorReporting_TR03_110_errorResolution: 'Replace controller',

         errorReporting_TR03_111_errorName: 'REFHI2_TOO_LOW',
         errorReporting_TR03_111_errorDescription: 'Internal hardware error',
         errorReporting_TR03_111_errorResolution: 'Replace controller',

         errorReporting_TR03_112_errorName: 'REFLO2_TOO_HIGH',
         errorReporting_TR03_112_errorDescription: 'Internal hardware error',
         errorReporting_TR03_112_errorResolution: 'Replace controller',

         errorReporting_TR03_113_errorName: 'REFLO2_TOO_LOW',
         errorReporting_TR03_113_errorDescription: 'Internal hardware error',
         errorReporting_TR03_113_errorResolution: 'Replace controller',

         errorReporting_TR03_115_errorName: 'LOW_WATER_PRESSURE_ERROR',
         errorReporting_TR03_115_errorDescription: 'Low water pressure error',
         errorReporting_TR03_115_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR03_116_errorName: 'LOW_WATER_PRESSURE_SENSOR',
         errorReporting_TR03_116_errorDescription: 'Low water pressure',
         errorReporting_TR03_116_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR03_119_errorName: 'RETURN_OPEN',
         errorReporting_TR03_119_errorDescription: 'Return sensor open',
         errorReporting_TR03_119_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_120_errorName: 'SUPPLY_OPEN',
         errorReporting_TR03_120_errorDescription: 'Supply sensor open',
         errorReporting_TR03_120_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_121_errorName: 'SUPPLY2_OPEN',
         errorReporting_TR03_121_errorDescription: 'Supply 2 sensor open',
         errorReporting_TR03_121_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_122_errorName: 'DHW_OPEN',
         errorReporting_TR03_122_errorDescription: 'DHW sensor open',
         errorReporting_TR03_122_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR03_126_errorName: 'RETURN_SHORTED',
         errorReporting_TR03_126_errorDescription: 'Return sensor shorted',
         errorReporting_TR03_126_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_127_errorName: 'SUPPLY_SHORTED',
         errorReporting_TR03_127_errorDescription: 'Supply sensor shorted',
         errorReporting_TR03_127_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_128_errorName: 'SUPPLY2_SHORTED',
         errorReporting_TR03_128_errorDescription: 'Supply 2 sensor shorted',
         errorReporting_TR03_128_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_129_errorName: 'DHW_SHORTED',
         errorReporting_TR03_129_errorDescription: 'DHW sensor shorted',
         errorReporting_TR03_129_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR03_134_errorName: 'RESET_BUTTON_ERROR',
         errorReporting_TR03_134_errorDescription:
           'Too many resets in a short time period',
         errorReporting_TR03_134_errorResolution:
           'Interrupt power supply HIU for approx. 10 seconds',

         errorReporting_TR03_167_errorName: 'RETURN2_SHORTED',
         errorReporting_TR03_167_errorDescription:
           'Secondary circuit supply sensor shorted',
         errorReporting_TR03_167_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_168_errorName: 'RETURN2_OPEN',
         errorReporting_TR03_168_errorDescription:
           'Secondary circuit return sensor shorted',
         errorReporting_TR03_168_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_169_errorName: 'HEAT_COOL_ACTIVE',
         errorReporting_TR03_169_errorDescription:
           'Cooling demand and Heating demand',
         errorReporting_TR03_169_errorResolution:
           'Check thermostat/controller a/o cables to avoid simultaneous cooling and heating demand',

         errorReporting_TR03_170_errorName: 'HW_IDENTIFIER_ERROR',
         errorReporting_TR03_170_errorDescription:
           'Hardware ID detection mismatch',
         errorReporting_TR03_170_errorResolution: 'Replace controller',

         errorReporting_TR03_203_errorName: 'HIGH_PRESSURE',
         errorReporting_TR03_203_errorDescription:
           'High (CH) water pressure detected',
         errorReporting_TR03_203_errorResolution: 'N/A',

         errorReporting_TR03_204_errorName: 'OUTDOOR_WRONG',
         errorReporting_TR03_204_errorDescription:
           'Outdoor sensor measures open/shorted',
         errorReporting_TR03_204_errorResolution: 'N/A',

         errorReporting_TR03_206_errorName: 'TE_BOOSTER_WARNING',
         errorReporting_TR03_206_errorDescription: 'DHW Storage locked DHW',
         errorReporting_TR03_206_errorResolution: 'N/A',
         errorReporting_errorType_lockout: 'Lockout',
         errorReporting_errorType_blocking: 'Blocking',
         errorReporting_errorType_warning: 'Warning',
         device_single_dashboard_active_error_title: 'Active Alarm',
         devices_box_serial_number_start_with_F_error:
           'Serial Number Heat Interface Unit must start with F',
         devices_form_default_controller_type_field: 'Default Controller Type',
         devices_form_default_soft_version_field: 'Default Software Version',
         devices_form_old_software_version_field: 'Old Software Version',
         devices_form_default_appliance_type_field: 'Default Appliance Type',
         devices_form_default_client_name_field: 'Default Client Name',
         projects_form_total_amount_order_field: 'Amount on Production Order',
         error_check_details_table_device_status_field: 'Device Status',
         error_check_details_table_export_generated_at_field: 'Generated At',
         error_check_details_table_export_generated_for_field: 'Generated for',
         error_check_details_table_export_generated_by_user_field:
           'Generated By',
         error_check_details_table_export_report_name_field: 'Name',
         error_check_details_table_export_active_alarms_report_field:
           'Active Alarms',
         error_check_details_table_export_active_new_alarms_report_field:
           'New Active Alarms',
         error_check_details_table_export_resolved_alarms_report_field:
           'Resolved Alarms',
         error_check_details_table_export_active_alarms_sheet_report_field:
           'Active Alarms',
         error_check_details_table_export_active_new_alarms_sheet_report_field:
           'New Active Alarms',
         error_check_details_table_export_resolved_alarms_sheet_report_field:
           'Resolved Alarms',
         projects_form_main_client_contact_field: 'Main Client Contact',
         projects_form_main_service_client_contact_field:
           'Main Service Client Contact',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Alarm',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Alarm Mode',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Contact Support Department',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Alarm',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Alarm Mode',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Contact Support Department',
         error_check_details_table_error_name: 'Alarm Name',
         devices_sim_card_number_form_unique_error:
           'Sim card number must be unique',
         devices_list_diagnostics_condition_modal_filter_button: 'Filter',
         devices_list_diagnostics_condition_modal_close_button: 'Close',
         roles_overview_bread_crumb_first_link:
           'Role Permissions Overview (Active Roles)',
         roles_overview_form_header: 'Role Permissions Overview (Active Roles)',
         roles_overview_fortes_roles_tab: 'Fortes Roles',
         roles_overview_client_roles_tab: 'Client roles',
         roles_overview_service_client_roles_tab: 'Service client roles',
         roles_overview_filter_roles_button: 'Filter Roles',
         roles_form_permissions_loading:
           'Loading data... This may take between 10 to 20 seconds. Thank you for your patience.',
         roles_overview_success_message:
           'Role permissions for active roles have been successfully updated.',
         roles_overview_error_message:
           'Failed to update role permissions for active roles. Please contact the administrator.',
         roles_overview_success_no_permission_change_message:
           'No permission changes detected. Navigating back to the roles overview page.',
         roles_overview_export_button: 'Export',
         roles_overview_export_file_name: 'Roles Overview',
         roles_list_table_roles_overview_button: 'Roles Overview',
         roles_overview_update_button: 'Update Roles',
         devices_form_first_event_timestamp_field: 'First event date',
         devices_list_diagnostics_condition_modal_sensor_type_field_label:
           'Sensor Type',
         devices_list_diagnostics_condition_modal_controller_type_field_label:
           'Controller Type',
         subscription_form_unique_error_message:
           'Subscription Order Number already exist',
         email_common_questions: `Questions? Please contact <a style="color: ${primaryColor};" href="mailto:${process.env.REACT_APP_SUPPORT_EMAIL}"><span>${process.env.REACT_APP_SUPPORT_EMAIL}</span></a> for further support.`,
         email_common_footer_receiving:
           'You are receiving this email because you have an active account on the ##distributorName## portal and have chosen to receive notifications via email.',
         email_common_footer_unsubscribe: `Do not wish to receive these emails? Turn off email notifications <a style="color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}/admin/setting">here</a>.`,

         email_template_new_account_created_title: 'New Account Created',
         email_template_new_account_created_main_content:
           'Thank you for registering with ##distributorName##, the platform to remotely monitor and manage your Fortes Heating Interface Units and linked energy meters.',
         email_template_new_account_created_password_intro:
           'To get you started, we have created an account for you on the ##distributorName## portal. Please find your temporary password below.',
         email_template_new_account_created_temp_password:
           'Temporary Password:',
         email_template_new_account_created_login_instruction: `Please follow this <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> link</a>, to <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> login</a> and change your password.`,
         email_template_new_account_created_button: 'LOGIN',
         email_template_modbus_data_title: 'Modbus Data',
         email_template_modbus_data_content:
           'You have requested an export for the available (Modbus) data of the Heating Interface Unit(s). The export file is password protected to safeguard your data.<br />Please click on this link to download the zip file. Enter the password when opening the zip file.',
         email_template_modbus_data_password: 'Password:',
         email_template_modbus_data_expiry_note:
           'Note: The above link will expire after 12 hours.',
         email_template_modbus_data_button: 'DOWNLOAD ZIP FILE',
         email_template_mbus_data_title: 'Mbus Data',
         email_template_mbus_data_content:
           'You have requested an export for the available (Mbus) data of the energy meter(s).',
         email_template_mbus_data_content_1:
           'The export file is password protected to safeguard your data.',
         email_template_mbus_data_content_2:
           'Please click on this link to download the zip file. Enter the password when opening the zip file.',
         email_template_mbus_data_password: 'Password:',
         email_template_mbus_data_expiry:
           'Note: The above link will expire after 12 hours.',
         email_template_mbus_data_button: 'DOWNLOAD ZIP FILE',

         email_template_device_swapping_title: 'Device Swapping',
         email_template_device_swapping_content:
           'You have recently swapped a Mercurius Communication Module for a new unit.',
         email_template_device_swapping_content_1:
           'Please find below a summary of the swap in your project.',
         email_template_device_swapping_old_device_section: 'Old Device',
         email_template_device_swapping_old_project: 'Project',
         email_template_device_swapping_old_client: 'Client',
         email_template_device_swapping_old_device_name: 'Device name',
         email_template_device_swapping_old_swapped_at: 'Swapped at',
         email_template_device_swapping_old_swapped_by: 'Swapped by',
         email_template_device_swapping_old_serial_number_mercurius:
           'Serial number Mercurius',
         email_template_device_swapping_old_type_heat_interface_unit:
           'Type Heat Interface Unit',
         email_template_device_swapping_old_distributor_serial_number:
           'Distributor Serial # heat interface unit',
         email_template_device_swapping_old_distributor_article_number:
           'Distributor Article # heat interface unit',
         email_template_device_swapping_old_serial_number:
           'Serial number Heat Interface Unit',
         email_template_device_swapping_old_production_date: 'Production date',
         email_template_device_swapping_old_customer_reference:
           'Customer reference',
         email_template_device_swapping_old_article_number_heat_interface_unit:
           'Article number heat interface unit',
         email_template_device_swapping_old_production_order_number:
           'Production order number',
         email_template_device_swapping_old_order_number: 'Order number',
         email_template_device_swapping_new_device_section: 'New Device',

         email_template_device_swapping_new_device_name: 'Name',
         email_template_device_swapping_new_serial_number:
           'Serial number Mercurius',
         email_template_device_swapping_new_sim_card: 'Sim card number',
         email_template_device_swapping_new_firmware: 'Firmware version',
         email_template_device_swapping_new_device_type: 'Device type',

         email_template_device_swapping_completion:
           'has proceeded to complete the swapping process.',
         email_template_device_swapping_completion_info:
           '##distributorName## generates this report after completing the device swapping process. This will allow you or your organisation to take timely action to resolve any issues.',

         email_template_active_alarms_title: 'Active Alarms',
         email_template_active_alarms_intro:
           'Please find below a summary of the Active Alarms <sup>2</sup> for the connected Fortes Heating Interface Units in your project(s).',
         email_template_active_alarms_new_active_alarms:
           'New Active Alarms<sup>2</sup>',
         email_template_active_alarms_existing_active_alarms:
           'Existing Active Alarms',
         email_template_active_alarms_resolved_alarms:
           'Resolved Alarms<sup>3</sup>',
         email_template_active_alarms_download_report:
           'To download the full Excel report, please click on this link.',
         email_template_active_alarms_download_report_button:
           'DOWNLOAD FULL EXCEL REPORT',
         email_template_active_alarms_report_info:
           '##distributorName## generates this report every 6 hours. This will allow you or your organisation to take timely action to resolve the alarms in the heating interface units and ensure correct operation.',
         email_template_active_alarms_report_info_1:
           '1. An Active Alarm is an alarm that has occurred and is not resolved yet.',
         email_template_active_alarms_report_info_2:
           '2. A New Active Alarm is an alarm that has occurred since the last report.',
         email_template_active_alarms_report_info_3:
           '3. A Resolved Alarm is an alarm that has been resolved since the last report.',

         email_template_api_gateway_title: 'New API Gateway Account Created',
         email_template_api_gateway_main_content:
           'Thank you for registering with ##distributorName##, the platform to remotely monitor and manage your Fortes Heating Interface Units and linked energy meters.',
         email_template_api_gateway_info:
           'To get you started, we have created an account for you on the ##distributorName## Platform. Please find your API Key below.',
         email_template_api_gateway_api_key: 'API Key:',
         email_template_api_gateway_spec_link: `Please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, to review OpenAPI Specification.`,
         email_template_api_gateway_button: 'OpenAPI Specification',

         email_template_forgot_password_title: 'Forgot Password',
         email_template_forgot_password_content:
           'We received a request to reset the password for your account.',
         email_template_forgot_password_content_1: `Please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, to reset your password.`,
         email_template_forgot_password_reset_password_button: 'RESET PASSWORD',

         email_template_mbus_hourly_logs_missing_title:
           'Mbus hourly logs Missing report',
         email_template_mbus_hourly_logs_missing_content:
           'We have identified that certain devices have not sent mbus hourly data.',
         email_template_mbus_hourly_logs_view_report_button: 'VIEW REPORT',

         email_template_anomaly_digest_title: 'Anomaly Digest',
         email_template_anomaly_digest_content:
           'Here are the details of Anomaly Digest',
         email_template_anomaly_digest_duration:
           'Duration: <b>{{ anomalyDuration }}</b>',
         email_template_anomaly_digest_project_name:
           'Project name: {{projectName}}',
         email_template_anomaly_digest_device_serial: 'Device serial',
         email_template_anomaly_digest_anomaly_count: 'Anomaly count',
         email_template_anomaly_digest_button: 'VIEW ANOMALY REPORT',

         email_template_maxitel_m2m_blend_and_api_status_title:
           'Maxitel M2M Blend And API Status',
         email_template_maxitel_m2m_blend_and_api_status_intro:
           'Here are the details of Maxitel M2M Blend And API Status.',
         email_template_maxitel_m2m_blend_and_api_status_service_header:
           'Maxitel Service',
         email_template_maxitel_m2m_blend_and_api_status_status_header:
           'Status',
         email_template_maxitel_m2m_blend_and_api_status_api_status:
           'Non-operational',
         email_template_maxitel_m2m_blend_and_api_status_operational:
           'Operational',

         email_template_device_commissioning_report_title:
           'Mercurius Commissioning Report',
         email_template_device_commissioning_report_intro:
           'Please find below the commissioning report of the recently commissioned Mercurius in your project.',
         email_template_device_commissioning_report_project: 'Project',
         email_template_device_commissioning_report_client: 'Client',
         email_template_device_commissioning_report_device_name: 'Device name',
         email_template_device_commissioning_report_commissioned_at:
           'Commissioned at',
         email_template_device_commissioning_report_commissioned_by:
           'Commissioned by',
         email_template_device_commissioning_report_commissioning_status:
           'Commissioning status',
         email_template_device_commissioning_report_completed_hiu_details:
           '-Completed HIU details',
         email_template_device_commissioning_report_mobile_connectivity_validation:
           '-Mobile connectivity validation',
         email_template_device_commissioning_report_modbus_connectivity_validation:
           '-Modbus connectivity validation',
         email_template_device_commissioning_report_mbus_connectivity_validation:
           '-MBus connectivity validation',
         email_template_device_commissioning_report_updated_address_details:
           '-Updated address details',
         email_template_device_commissioning_report_completion:
           'User has proceeded to complete the commissioning process.',
         email_template_device_commissioning_report_footer:
           'generates this report after completing the Mercurius commissioning process. This will allow you or your organisation to take timely action to resolve any issues with connecting the heating interface units and ensure correct commissioning.',

         email_template_subscriptions_expiring_title:
           'Project Subscriptions Expiring Soon Notification',
         email_template_subscriptions_expiring_content:
           'This is to inform you that {{ numberOfProjects }} projects are expiring soon.',
         email_template_subscriptions_expiring_content_1: `Please click on the <a style="font-weight: 600; color: ${primaryColor};" href={{ subscriptionsExpiringUrl }}>link</a> to view the details.`,
         email_template_subscriptions_expiring_soon_notification:
           'Expiring soon notification',
         email_template_subscriptions_expiring_months: 'months',
         email_template_subscriptions_expiring_button:
           'VIEW EXPIRING SOON SUBSCRIPTIONS',

         email_template_delete_device_sim_subscription_title:
           'Delete device sim subscription',
         email_template_delete_device_sim_subscription_content:
           'Please find below the device information required to manually delete the SIM subscription, as the Maxitel Delete Subscription API is currently not functioning.',

         email_template_delete_device_sim_subscription_project: 'Project',
         email_template_delete_device_sim_subscription_client: 'Client',
         email_template_delete_device_sim_subscription_device_name:
           'Device name',
         email_template_delete_device_sim_subscription_device_edited_by:
           'Device edited by',
         email_template_delete_device_sim_subscription_device_edited_at:
           'Device edited at',
         email_template_delete_device_sim_subscription_old_sim_number:
           'Old SIM number',
         email_template_greeting: 'Hi',
         swapping_email_swapped_at_field: 'Swapped At',
         swapping_email_swapped_by_field: 'Swapped By',
         projects_form_created_at_field: 'Creation Date',
         add_subscription_order_number_duplicate_error:
           'Subscription order number must be unique.',
         add_subscription_project_not_found_error:
           'The specified project does not exist.',
         add_subscription_subscription_project_credits_missing_error:
           'No devices found for the selected project.',
         add_subscription_subscription_creation_failed_error:
           'Failed to create the subscription due to an internal server error.',
         add_subscription_invalid_or_null_payload_error:
           'The provided payload is either null or invalid.',
         devices_bulk_delete_button: 'Delete Devices',
         devices_bulk_delete_modal_title: 'Are you sure?',
         devices_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Device information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Device Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         devices_bulk_delete_modal_note:
           '<strong>Note:</strong> <br/> Once you proceed with the deletion, it cannot be undone unless the IT team manually restores the data from old backups. Recovering events and other related information will be highly time-consuming. Device deletion takes some time due to the data mentioned above. Please be patient and do not cancel or refresh the page.',
         devices_bulk_delete_modal_cancel_button: 'Cancel',
         devices_bulk_delete_modal_delete_button: 'Delete',
         devices_bulk_deleted_message:
           '{{ DEVICES_COUNT }} Devices are deleted successfully',
         email_template_device_deletion_title: 'Deleted Devices Report',
         email_template_device_deletion_content:
           'Please find the summary of the devices deleted from the ##distributorName## platform:',
         email_template_device_deletion_content_1: `To download the full Excel report, please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>.`,
         email_template_device_deletion_download_button:
           'Download Full Excel Report',
         email_template_device_deletion_note:
           '##distributorName## generates this report to track device deletions for auditing purposes and to retain data in case of accidental deletions.',
         email_template_device_deletion_deleted_devices_count_field:
           'Deleted Devices count ',
         email_template_device_deletion_deleted_at_field: 'Deleted at',
         email_template_device_deletion_deleted_at_by: 'Deleted By',
         inconsistent_mbus_devices_reporting_details_table_header:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_details_bulk_export_button:
           'Export',
         inconsistent_mbus_devices_reporting_details_filter_reset_button:
           'Reset',
         inconsistent_mbus_devices_reporting_details_table_filter_search:
           'Search',
         inconsistent_mbus_devices_reporting_details_table_created_at:
           'Created At',
         inconsistent_mbus_devices_reporting_details_table_device: 'Device',
         inconsistent_mbus_devices_reporting_details_table_project: 'Project',
         inconsistent_mbus_devices_reporting_details_table_client: 'Client',
         inconsistent_mbus_devices_reporting_details_table_firmware: 'Firmware',
         inconsistent_mbus_devices_reporting_details_table_actual_rmeters_count:
           'Actual Meters Count',
         inconsistent_mbus_devices_reporting_details_table_shown_meters_count:
           'Shown Meters Count',
         inconsistent_mbus_devices_reporting_details_table_no_record_found:
           'No Record Found',
         inconsistent_mbus_devices_reporting_details_table_row_per_page:
           'Rows per page',
         error_check_details_table_export_success_message:
           'An alarm email has been sent to your inbox.',
         error_check_details_table_export_error_message:
           'Alarm email forwarding failed. Please contact support for assistance.',
         errorReporting_TR03_256_errorName: 'MODBUS_WARNING_MESSAGE',
         errorReporting_TR03_256_errorDescription:
           'No Modbus communication with HIU controller',
         errorReporting_TR03_256_errorResolution:
           'Check a/o replace Modbus cable a/o connectors. If problem persists, replace controller',
         errorReporting_TR04_256_errorName: 'MODBUS_WARNING_MESSAGE',
         errorReporting_TR04_256_errorDescription:
           'No Modbus communication with HIU controller',
         errorReporting_TR04_256_errorResolution:
           'Check a/o replace Modbus cable a/o connectors. If problem persists, replace controller',
         error_check_details_table_export_start_time_field: 'Start Time',
         error_check_details_table_export_end_time_field: 'End Time',
         error_check_details_table_export_resolution_field: 'Resolution',
         error_check_details_table_export_alarm_code_field: 'Alarm Code',
         error_check_details_table_export_alarm_name_field: 'Alarm Name',
         error_check_details_table_export_alarm_resolutions_field:
           'Alarm Resolutions',
         error_check_details_table_export_alarm_description_field:
           'Description',
         subscription_form_subscriptionPeriod_years_field:
           'Subscription Period (years)',
         subscription_form_project_devices_missing_error:
           'No devices are currently assigned to the selected project. Please add devices to continue.',
         settings_notification_device_error_toast_message:
           '"Notify when a device is in error mode" is updated successfully.',
         subscription_form_client_email_status_field: 'Client Email Status',
         subscription_form_client_email_success_field:
           'The Client Contact for this client is set on the Edit Client page, and email is successfully forwarded for the subscription extension.',
         subscription_form_client_email_error_field:
           'The Client Contact for this client is not set on the Edit Client page, and email is not forwarded for the subscription extension.',
         subscription_extension_client_email_status: 'Client Email Status',
         subscription_form_keycloak_user_id_mismatch_issue_error:
           'Client email user account has issue. Please contact the administrator',
         devices_partner_order_number_field: 'Distributor Order Number',
         edit_devices_distributor_order_number_error:
           'Distributor Order Number is required',
         legal_documents_checkbox_link_information_form_error:
           '<strong>Note: </strong><i>In the document checkbox label field, use [link] to insert the document URL and it will be automatically replaced with the actual link.</i>',
         devices_form_distinct_mercurius_type_field: 'Distinct Mercurius Type',
         device_label_table_label_field: 'Label',
         device_label_table_status_field: 'Status',
         device_label_table_last_modified_field: 'Last Modified',
         device_label_table_description_field: 'Description',
         sidebar_device_label_menu: 'Device Labels',
         device_labels_form_add_button: 'Add Device Label',
         device_labels_form_edit_button: 'Edit Device Label',
         device_labels_form_cancel_button: 'Cancel',
         device_labels_header: 'Device Labels',
         device_labels_table_no_record_found: 'No record found',
         device_labels_table_row_per_page: 'Rows per page',
         add_device_label: 'Add Device Label',
         add_device_labels_form_header: 'Add Device Label',
         edit_device_labels_form_header: 'Edit Device Label',
         device_labels_add_new: 'Add new',
         device_label_form_label_field: 'Label',
         device_label_form_description_field: 'Description',
         device_label_form_color_field: 'Color',
         device_label_form_select_color_field: 'Select Color',
         device_label_form_label_required_error: 'Device Label is required',
         device_label_form_description_required_error:
           'Description is required',
         device_label_form_label_unique_error: 'Device Label must be unique',
         device_label_form_color_required_error: 'Color is required',
         add_device_label_form_success: 'Device Label is successfully created.',
         add_device_label_form_api_error: 'Internal Server Alarm',
         device_label_activated_message: 'Device Label Successfully Activated',
         device_label_deactivated_message:
           'Device Label Successfully Deactivated',
         edit_device_label_form_success:
           'Device Label is successfully updated.',
         edit_device_label_form_api_error: 'Internal Server Alarm',
         device_label_table_filter_reset_button: 'Reset',
         device_label_table_search: 'Search',
         device_labels_green_color: 'Green',
         device_labels_blue_color: 'Blue',
         device_labels_red_color: 'Red',
         device_labels_orange_color: 'Orange',
         device_labels_grey_color: 'Grey',
         devices_form_device_labels_field: 'Device Label(s)',
         devices_table_row_all_records_label: 'All',
         devices_show_all_devices_modal_title: 'Are you Sure?',
         devices_show_all_devices_modal_subtitle:
           'By selecting "All" from the records dropdown, you are requesting to load all available records i.e. ##TOTAL_DEVICES##.',
         devices_show_all_devices_modal_note:
           '<ul><li>This action may take 30 seconds or more and could slow down the page.</li><li>Loading all records (over 10MB of data) might cause performance issues, including page lag due to the large number of items being rendered.</li><li>If you\'re okay with that, click <strong>"Proceed Anyway"</strong>.</li><li>To cancel and revert to the default 25 records, click <strong>"Cancel"</strong>.</li></ul>',
         devices_show_all_devices_modal_cancel_button: 'Cancel',
         devices_show_all_devices_modal_proceed_anyway_button: 'Proceed Anyway',
         device_labels_blue_category: '',
         device_labels_green_category: 'Resolved',
         device_labels_grey_category: 'Asset Type',
         device_labels_red_category: 'Issue Type',
         device_labels_orange_category: 'Status Type',
         commissioning_form_stepper_validation_appliance_type_check_started_title:
           'Started Appliance Type Check',
         commissioning_form_stepper_validation_appliance_type_check_success_title:
           'Success: The device has provided the appliance type',
         commissioning_form_stepper_validation_appliance_type_check_warning_title:
           'Warning: The device has not provided the appliance type',
         device_table_dynamic_columns_modal_title: 'Dynamic Columns',
         device_table_dynamic_columns_modal_columns_info_message:
           'You must choose at least 14 columns, but no more than 20 columns in total.',
         device_table_dynamic_columns_modal_columns_freeze_message:
           'The "Device Name" column is permanently frozen by default in the device list and cannot be unfrozen. You can select one additional column to freeze, which will replace the default "Serial Number Heat Interface Unit" if chosen. Frozen columns will always remain as the first two columns in the table. A maximum of two columns can be frozen at any given time.',
         project_single_device_table_dynamic_columns_modal_columns_freeze_message:
           'The "Serial number Heat Interface Unit " column is permanently frozen by default in the device list and cannot be unfrozen. You can select one additional column to freeze, which will replace the default "Installation Address" if chosen. Frozen columns will always remain as the first two columns in the table. A maximum of two columns can be frozen at any given time.',
         device_table_dynamic_columns_modal_active_column_title:
           'Active Columns',
         device_table_dynamic_columns_modal_inactive_column_title:
           'Inactive Columns',
         device_table_dynamic_columns_modal_cancel_button: 'Cancel',
         device_table_dynamic_columns_modal_go_back_button: 'Back',
         device_table_dynamic_columns_modal_next_button: 'Next',
         device_table_dynamic_columns_modal_save_button: 'Save',
         device_table_dynamic_columns_modal_default_freeze_icon_title:
           'This column is permanently frozen by default and cannot be modified.',
         device_table_dynamic_columns_modal_freeze_icon_title:
           'Click the gray freeze icon to freeze this column. Once frozen, it will automatically move to the second position and remain fixed there until you choose to freeze a different column.',
         device_table_dynamic_columns_modal_stepper_step_1_button:
           'Select columns',
         device_table_dynamic_columns_modal_stepper_step_2_button:
           'Select column positions',
         device_table_dynamic_columns_modal_success_message:
           'Dynamic Columns are updated successfully.',
         device_table_dynamic_columns_modal_error_message:
           'Failed to update Dynamic Columns.',
         devices_export_download_form_success:
           'Devices Export Data is emailed to ##EMAIL## successfully!',
         devices_bulk_data_collect_button: 'Data Collect',
         devices_bulk_data_collect_success_message:
           'Your message has been forwarded to all selected devices. This page will automatically refresh in 5 seconds.',
         device_list_filters_button_label_new: 'New',
         device_list_filters_button_label_reset_advanced_filters:
           'Reset filters -  reset all applied Advanced or Register filters',
         device_list_filters_button_label_advanced_filters_description:
           'Advanced Filters - search individual columns',
         device_list_filters_button_label_customize_device_list_table_columns:
           'Dynamic columns - customize the table columns shown',
         device_list_filters_button_label_customize_project_device_list_columns:
           'Dynamic columns - customize the table columns shown',
         device_list_filters_button_label_registers_filter:
           'HIU and Meter registers filter - filter based on register conditions',

         device_list_filters_button_label_export_devices: 'EXPORT DEVICES',
         device_list_filters_button_label_export_devices_hover:
           'Export device(s) data - export HIU and column data of selected device',

         device_list_filters_button_label_download_hiu_data:
           'DOWNLOAD HIU DATA',
         device_list_filters_button_label_download_hiu_data_hover:
           'Download HIU data - download available measurement data for a selected period',

         device_list_filters_button_label_download_meter_data:
           'DOWNLOAD METER DATA',
         device_list_filters_button_label_download_meter_data_hover:
           'Download Meter data - download available meter data for a selected period',

         device_list_filters_button_label_change_settings: 'CHANGE SETTINGS',
         device_list_filters_button_label_change_settings_hover:
           'Bulk update HIU registers - change HIU settings in bulk',

         device_list_filters_button_label_update_devices: 'UPDATE DEVICES',
         device_list_filters_button_label_update_devices_hover:
           'Update device firmware - update the Mercurius device firmware',

         device_list_filters_button_label_delete_devices: 'DELETE DEVICES',
         device_list_filters_button_label_delete_devices_hover:
           'Delete device(s) and their data',

         device_list_filters_button_label_data_collect: 'DATA COLLECT',
         device_list_filters_button_label_data_collect_hover:
           'Refresh data - fetch the latest HIU data',
         device_table_dynamic_columns_modal_restore_default_button:
           'Restore to Default',
         device_table_dynamic_columns_modal_columns_are_selected_label:
           '##NUMBER_OF_COLUMNS## columns are selected',
         device_table_dynamic_columns_modal_columns_restore_to_default_success:
           'Columns have been successfully restored to the default setting',

         email_template_reset_password_main_content:
           'The administrator of the ##distributorName## platform has reset your password.',
         email_template_reset_password_info:
           'Please find your new password below. We highly recommend to change your password afterwards.',
         email_template_reset_password_login_link: `Please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, to login with your new password.`,
         email_template_reset_password_login_button: 'Login',
         email_template_reset_password_new_password_label: 'New Password:',
         devices_form_set_logs_scope_field: 'Data Logs Scope',
         devices_form_set_logs_tooltip_field:
           'Specifies whether the device has "Project Data Log" or "Device Data Log"',
         devices_list_project_set_log_label: 'Project Data Log',
         devices_list_device_set_log_label: 'Device Data log',
         devices_single_set_logs_device_level_message:
           'The logs are set at the device level by ##USER_NAME## on ##DATE##',
         devices_single_set_logs_project_level_message:
           'The logs are set at the project level by ##USER_NAME## on ##DATE##',
         devices_single_set_logs_device_level_no_user_message:
           'The logs are set at the device level on ##DATE##',
         devices_single_set_logs_project_level_no_user_message:
           'The logs are set at the project level on ##DATE##',
         devices_single_set_logs_revert_to_project_set_log_button:
           'Reset to Project Data Log',
         devices_single_set_logs_revert_success_message:
           'Device Data Logs have been successfully reverted back to Project Data Logs',
         project_single_set_logs_revert_success_message:
           'Device(s) Data Logs have been successfully reverted back to Project Data Logs',
         project_single_set_logs_revert_modal_title: 'Are you sure?',
         project_single_set_logs_revert_modal_subtitle: `Please review the statistics for the current project devices:
          <ul>
            <li><strong>Total Devices:</strong> ##TOTAL_DEVICES##</li>
            <li><strong>Total Devices with Project Data Logs:</strong> ##TOTAL_PROJECT_SET_LOG_DEVICES##</li>
            <li><strong>Total Devices with Device Data Logs:</strong> ##TOTAL_DEVICE_SET_LOG_DEVICES##</li>
          </ul>`,

         project_single_set_logs_revert_modal_total_devices_with_device_set_logs_label:
           'Currently, there are no devices with Device Data Logs',
         project_single_set_logs_revert_modal_note:
           '<strong>Note:</strong><br/> Once you proceed with the reset, this action cannot be undone. The reset will affect all devices where Device Data Logs have been configured by users.',

         project_single_set_logs_revert_modal_cancel_button: 'Cancel',
         project_single_project_setting_modbus_and_mbus_setting_success_set_message:
           'Modbus and Mbus Settings are successfully updated.',
         project_single_project_setting_modbus_and_mbus_setting_error_message:
           'Failed to update Modbus and Mbus Settings. Please contact your adminstrator.',
         device_status_menu_list_operating_state: 'État de fonctionnement',
         device_status_menu_list_settings_hot_water: 'Réglages eau chaude',
         device_status_menu_list_settings_heating_and_cooling:
           'Réglages chauffage et refroidissement',
         device_status_menu_list_manual_control: 'Contrôle manuel',
         device_status_menu_list_firmware_registers: 'Firmware Registers',
         device_status_menu_list_lin_pump_deltap_parameters:
           'LIN-Pump DeltaP Parameters',
         device_status_menu_list_energy_meters_m_bus: 'Compteurs M-Bus',
         device_status_menu_list_livelog_hot_water:
           'Journal en direct eau chaude',
         device_status_menu_list_livelog_heating: 'Journal en direct chauffage',
         device_status_menu_list_livelog_cooling:
           'Journal en direct refroidissement',
         devices_form_unit_id_field: 'Unit Id',
         sidebar_v3_settings_menu: 'Device v3 Settings',
         devices_form_v3_mbus_discovery_button: 'Mbus Discovery',
         devices_form_v3_fetch_device_information_button:
           'Fetch Device Information',
         substations_form_v3_fetch_device_information_button:
           'Fetch Substation Information',
         heat_pumps_form_v3_fetch_device_information_button:
           'Fetch Heat Pump Information',
         devices_form_v3_fetch_device_information_success_message:
           'Fetch Device Information message is forwarded to device',
         devices_form_v3_fota_file_path_field: 'FOTA File Path',
         devices_form_v3_fota_file_path_success_message:
           'FOTA File Path message is forwarded to device',
         devices_form_v3_ota_file_path_field: 'HIU Firmware',
         devices_form_v3_ota_file_path_success_message:
           'HIU Firmware message is forwarded to device',
         devices_form_v3_file_path_error_message:
           'Please enter a valid file URL or a valid file path.',
         set_registers_modbus_option: 'Modbus',
         set_registers_mbus_option: 'Mbus',
         set_registers_mbus_serial_number_title: 'Mbus Serial Numbers',
         set_registers_mbus_registers_not_found_run_mbus_discovery_error_message:
           'MBUS is not connected for this device. Please run Device Discovery from the Device Edit page.',
         device_v2_settings_tab_ftp_and_network_tab: 'FTP',
         device_v2_settings_tab_ftp_host_field: 'FOTA Server',
         device_v2_settings_tab_ftp_user_name_field: 'FTP User Name',
         device_v2_settings_tab_ftp_password_field: 'FTP Password',
         device_single_device_settings_ftp_message_forwarded:
           'FTP Credentials Message is successfully forwarded to the device.',
         device_single_device_settings_ftp_error:
           'FTP User Name and Password are required',
         devices_ota_select_same_serial_devices_to_proceed_error:
           'All selected devices must have serial numbers of the same length to proceed.',
         devices_ota_select_at_least_one_device_to_proceed_error:
           'You must select at least one device to proceed.',
         substations_ota_select_at_least_one_to_proceed_error:
           'Vous devez sélectionner au moins une sous-station pour continuer.',
         heat_pumps_ota_select_at_least_one_to_proceed_error:
           'Vous devez sélectionner au moins une pompe à chaleur pour continuer.',
         devices_ota_incompatible_firmware_selected_error:
           'The selected firmware version isn’t compatible with your device(s). Please choose a compatible version to continue.',
         devices_ota_go_back_to_devices_list_button: 'View All Devices',
         devices_bulk_edit_hiu_ota_mixed_device_type_error:
           'Your selection contains a mix of V2 and V3 devices. Please select either all V2 devices or all V3 devices to continue.',
         devices_bulk_edit_hiu_ota_all_tr03_error:
           'All selected devices are TR03 devices, which are not supported for this update. Please select TR04 devices to proceed.',
         devices_bulk_edit_hiu_ota_unknown_type_error:
           'The controller type for all selected devices is unknown. Please configure the devices properly before proceeding.',
         devices_bulk_edit_hiu_ota_update_selected_devices:
           'Devices Selected for Bulk HIU OTA Update',
         devices_bulk_edit_hiu_ota_valid_devices: 'valid',
         devices_bulk_edit_hiu_ota_partial_invalid_warning:
           'The devices highlighted in red are either TR03 devices or have an unknown controller type and will be excluded from the HIU OTA update. You can still proceed — only the valid TR04 devices will be updated.',
         sidebar_hiu_ota_reporting: 'HIU OTA Report',
         hiu_ota_reporting_filter_start_date: 'Start Date',
         hiu_ota_reporting_filter_end_date: 'End Date',
         hiu_ota_reporting_filter_apply_button: 'Apply',
         hiu_ota_reporting_filter_reset_button: 'Reset Filters',
         hiu_ota_reporting_col_created_at: 'Updated At',
         hiu_ota_reporting_col_firmware: 'HIU Firmware',
         hiu_ota_reporting_col_total_devices: 'Total Devices',
         hiu_ota_reporting_col_user: 'User',
         hiu_ota_reporting_col_message: 'Message',
         hiu_ota_reporting_no_records: 'No records found',
         hiu_ota_reporting_export_file_name: 'HIU OTA Reporting',
         hiu_ota_reporting_table_failed_message:
           'HIU Firmware is not updated to',
         hiu_ota_reporting_table_pending_message: 'HIU Firmware is updating to',
         hiu_ota_reporting_table_successful_message:
           'HIU Firmware is updated to',
         hiu_ota_reporting_details_page_title: 'HIU OTA Report Details',
         hiu_ota_reporting_details_tab_all: 'All',
         hiu_ota_reporting_details_tab_pending: 'Pending',
         hiu_ota_reporting_details_tab_successful: 'Success',
         hiu_ota_reporting_details_tab_failed: 'Failed',
         hiu_ota_reporting_details_col_updated_at: 'Updated At',
         hiu_ota_reporting_details_col_device: 'Device',
         hiu_ota_reporting_details_col_user: 'User',
         hiu_ota_reporting_details_col_old_firmware_version: 'Old Firmware',
         hiu_ota_reporting_details_col_old_firmware: 'HIU Firmware',
         hiu_ota_reporting_details_col_status: 'Status',
         hiu_ota_reporting_details_col_message: 'Message',
         hiu_ota_reporting_details_no_records: 'No records found',
         hiu_ota_reporting_details_export_file_name:
           'HIU OTA Reporting Details',
         hiu_ota_reporting_details_col_snapshot: 'Snapshot',
         hiu_ota_reporting_details_view_snapshot: 'View Snapshot',
         hiu_ota_snapshot_dialog_title: 'Device Snapshot',
         hiu_ota_snapshot_section_configuration: 'Configuration',
         hiu_ota_snapshot_section_registers: 'Device Registers',
         hiu_ota_snapshot_col_field: 'Field',
         hiu_ota_snapshot_col_nr: 'NR',
         hiu_ota_snapshot_col_register: 'Register',
         hiu_ota_snapshot_col_value: 'Value',
         hiu_ota_snapshot_no_registers: 'No register data available',
         device_single_device_settings_baud_rate_parity_field:
           'Baud Rate Parity',
         device_single_device_settings_select_baud_rate_parity_field:
           'Select Baud Rate Parity',
         device_single_device_settings_baud_rate_stop_bits_field:
           'Baud Rate Stop Bits',
         device_single_device_settings_select_baud_rate_stop_bits_field:
           'Select Baud Rate Stop Bits',
         device_single_device_settings_baud_rate_parity_none_option: 'None',
         device_single_device_settings_baud_rate_parity_odd_option: 'Odd',
         device_single_device_settings_baud_rate_parity_even_option: 'Even',
         device_single_device_settings_baud_rate_stop_bits_05_option:
           '0.5 Stop Bit',
         device_single_device_settings_baud_rate_stop_bits_1_option:
           '1 Stop Bit',
         device_single_device_settings_baud_rate_stop_bits_15_option:
           '1.5 Stop Bits',
         device_single_device_settings_baud_rate_stop_bits_2_option:
           '2 Stop Bits',
         device_single_device_settings_v3_baud_rate_required_validation_error:
           'Baud Rate is required.',
         device_single_device_settings_v3_baud_rate_uart_number_validation_error:
           'Baud Rate must be a valid number.',
         device_single_device_settings_v3_baud_rate_parity_required_validation_error:
           'Baud Rate Parity is required.',
         device_single_device_settings_v3_baud_rate_stop_bits_required_validation_error:
           'Baud Rate Stop Bits are required.',
         modbus_v3_heat_pump_title: 'Operating state',
         modbus_v3_heat_pump_reg_9163_label: 'Flow temperature',

         modbus_v3_heat_pump_reg_9162_label: 'Return temperature',

         modbus_v3_heat_pump_reg_9085_label: 'Compressor 1 active',
         modbus_v3_heat_pump_reg_9085_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_9086_label: 'Compressor 2 active',
         modbus_v3_heat_pump_reg_9086_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_10400_label: 'Outdoor temperature',
         modbus_v3_heat_pump_reg_9165_label: 'Outdoor temperature',
         modbus_v3_heat_pump_reg_9320_label:
           'Current Water Temperature Setpoint',

         modbus_v3_heat_pump_reg_9173_label: 'Suction temperature Circ1',

         modbus_v3_heat_pump_reg_9174_label: 'Suction temperature Circ2',

         modbus_v3_heat_pump_reg_9170_label: 'Suction pressure Circ1',

         modbus_v3_heat_pump_reg_9180_label: 'Suction pressure Circ2',

         modbus_v3_heat_pump_reg_9171_label: 'Discharge temperature Circ1',

         modbus_v3_heat_pump_reg_9172_label: 'Discharge temperature Circ2',

         modbus_v3_heat_pump_reg_9169_label: 'Discharge pressure Circ1',

         modbus_v3_heat_pump_reg_9179_label: 'Discharge pressure Circ2',

         modbus_v3_heat_pump_reg_9249_label: 'Fan speed Circ1',

         modbus_v3_heat_pump_reg_9253_label: 'Fan speed Circ2',

         modbus_v3_heat_pump_reg_9084_label: '4 way valve status Circ1',
         modbus_v3_heat_pump_reg_9084_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_9095_label: '4 way valve status Circ2',
         modbus_v3_heat_pump_reg_9095_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_9319_label: 'ODU mode',
         modbus_v3_heat_pump_reg_9319_label_list: JSON.stringify({
           list: {
             0: 'Cool',
             1: 'Heat',
             2: 'DHW',
           },
         }),

         modbus_v3_heat_pump_reg_9365_label: 'Locking active',
         modbus_v3_heat_pump_reg_9365_label_list: JSON.stringify({
           list: {
             0: 'No',
             1: 'Yes',
           },
         }),

         modbus_v3_heat_pump_reg_10391_label: 'Error code',

         modbus_v3_heat_pump_reg_10395_label: 'Error state',

         modbus_v3_heat_pump_reg_9005_label: 'Status Stand-by/On',
         modbus_v3_heat_pump_reg_9005_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_9006_label: 'Status Heat/Cool',
         modbus_v3_heat_pump_reg_9006_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_9079_label: 'Status General Alarm',
         modbus_v3_heat_pump_reg_9079_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_9084_status_label: 'Status Four-way-valve',
         modbus_v3_heat_pump_reg_9084_status_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         modbus_v3_heat_pump_reg_9090_label: 'Status defrost',
         modbus_v3_heat_pump_reg_9090_label_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         device_single_device_settings_modbus_write_register_address_field:
           'Modbus Write Register Address',
         device_single_device_settings_modbus_write_enabled_field:
           'Modbus Write Enabled',
         device_single_device_settings_v3_unit_id_required_validation_error:
           'Unit Id is required.',
         device_single_device_settings_v3_modbus_write_register_address_required_validation_error:
           'Modbus Write Register Address is required.',
         device_single_device_settings_v3_modbus_write_register_address_error:
           'The Modbus Write Register Address has not been saved. Please save it first before trying this function again.',
         device_single_device_settings_v3_unit_id_error:
           'The Unit ID has not been saved. Please save it first before trying this function again.',
         device_single_device_settings_v3_modbus_write_enable_success_message:
           'Modbus Write Enable Message is successfully forwarded.',
         sidebar_heat_pumps: 'Heat Pump Overview',
         heat_pumps_form_header: 'Heat Pumps',
         heat_pumps_bulk_edit_ota_title: 'Heat Pump OTA bulk update',
         heat_pumps_bulk_hiu_ota_update_title: 'Heat Pump bulk HIU OTA update',
         heat_pumps_filter_search: 'Search Heat Pump',
         heat_pumps_no_record_found: 'No Heat Pumps found',
         device_single_modbus_write_enable_button: 'Activate Modbus Write Mode',
         device_single_modbus_write_disabled_message:
           'Modbus Write is currently disabled on this device. Click the button to enable Modbus Write Mode',
         device_list_modbus_write_enable_field: 'Modbus Write Mode',
         devices_form_appliance_category_field: 'Appliance Category',
         devices_form_appliance_category_hiu_option_field:
           'Heat Interface Unit',
         devices_form_appliance_category_heat_pump_option_field: 'Heat Pump',
         devices_form_appliance_category_substation_option_field: 'Substation',
         devices_form_appliance_category_boiler_option_field: 'Boiler',
         device_list_filters_button_label_modbus_write_hover:
           'Click the button to enable Modbus Write Mode on the selected devices',
         heat_pump_single_page_title: 'Heat Pump details',
         heat_pumps_single_bread_crumb_main_title: 'Heat Pump overview',
         heat_pumps_single_bread_crumb_first_link: 'Heat Pump page',
         heat_pumps_single_edit_device_button: 'Edit Heat Pump',
         edit_heat_pumps_bread_crumb_first_link: 'Edit Heat Pump',
         edit_heat_pumps_form_header: 'Edit Heat Pump',
         edit_substations_form_header: 'Edit Substation',
         substations_form_header: 'Substations',
         substations_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Substation Information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Substation Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         substations_bulk_delete_modal_note: `<strong>Note:</strong> <br /> Once you proceed with the deletion, it cannot be undone unless the IT team manually
          restores the data from old backups. Recovering events and other related information will be highly time-consuming.
          Substation deletion takes some time due to the data mentioned above. Please be patient and do not cancel or refresh the
          page.`,
         substations_bulk_edit_ota_title: 'Substation OTA bulk update',
         substations_bulk_hiu_ota_update_title: 'Substation bulk HIU OTA update',
         substations_bulk_modbus_download_title:
           'Download Substations Historical Data',
         substations_bulk_modbus_download_form_submit_button:
           'Download Substations data',
         substations_bulk_selected_devices_title: 'Substations Selected',
         substations_bulk_modbus_download_no_substations_error:
           'Please select atleast 1 Substation to proceed',
         heat_pumps_bulk_modbus_download_no_heat_pumps_error:
           'Please select atleast 1 Heat Pump to proceed',
         modbus_v3_heat_pump_operating_state_title: 'Operating State Heat Pump',
         modbus_v3_heat_pump_measurements_title: 'Measurements',
         heat_pump_single_temperature_title: 'The history of the heat pump',
         heat_pump_single_offline_detailed_message: 'Heat Pump is "Offline"',
         heat_pump_single_online_detailed_message:
           'Heat Pump is "Online", everything is working fine',
         heat_pump_single_error_detailed_message:
           'Heat Pump is in "Alarm" mode',
         heat_pump_single_unprovisioned_detailed_message:
           'Heat Pump is in "Unprovisioned" mode',
         heat_pump_fetch_registers_success:
           'The request has been successfully sent to Heat Pump.',
         heat_pumps_form_device_labels_field: 'Heat Pump Label',
         heat_pumps_form_device_information_tab: 'Heat Pump Information',
         heat_pumps_form_name_field: 'Heat Pump Name',
         heat_pumps_list_device_set_log_label: 'Heat Pump Data log',
         heat_pumps_form_description_field: 'Heat pump type',
         heat_pumps_description: 'Heat pump type',
         heat_pump_single_firmware_hiu_label: 'Firmware heat pump',
         heat_pumps_form_box_serial_number_field: 'Heat Pump Serial Number',
         heat_pumps_form_article_number_field: 'Heat Pump Article Number',
         heat_pumps_partner_serial_number:
           'Heat Pump Distributor Serial Number',
         heat_pumps_partner_article_number_field:
           'Heat Pump Distributor Article number',
         heat_pump_list_filters_button_label_registers_filter:
           'Heat pump and Meter registers filter - filter based on register conditions',
         heat_pump_list_filters_button_label_export_devices_hover:
           'Export heat pump(s) data - export heat pump and column data of selected heat pump',
         heat_pump_list_filters_button_label_download_hiu_data_hover:
           'Download heat pump data - download available measurement data for a selected period',
         heat_pump_list_filters_button_label_download_meter_data_hover:
           'Download Meter data - download available meter data for a selected period',
         heat_pump_list_filters_button_label_change_settings_hover:
           'Bulk update heat pump registers - change heat pump settings in bulk',
         heat_pump_list_filters_button_label_update_devices_hover:
           'Update heat pump firmware - update the Mercurius heat pump firmware',
         heat_pump_list_filters_button_label_delete_devices_hover:
           'Delete heat pump(s) and their data',
         heat_pump_list_filters_button_label_data_collect_hover:
           'Refresh data - fetch the latest heat pump data',
         heat_pump_list_filters_button_label_modbus_write_hover:
           'Click the button to enable Heat Pump Write Mode on the selected heat pumps',
         heat_pump_single_download_modbus_data: 'Export heat pump data',
         project_single_heat_pumps_tab: 'Heat Pumps',
         heat_pumps_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Heat Pump Information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Heat Pump Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         heat_pumps_bulk_delete_modal_note: `<strong>Note:</strong> <br /> Once you proceed with the deletion, it cannot be undone unless the IT team manually
          restores the data from old backups. Recovering events and other related information will be highly time-consuming.
          Heat Pump deletion takes some time due to the data mentioned above. Please be patient and do not cancel or refresh the
          page.`,
         heat_pumps_bulk_modbus_download_title:
           'Download Heat Pumps Historical Data',
         heat_pumps_bulk_modbus_download_form_submit_button:
           'Download Heat Pumps data',
         heat_pumps_bulk_selected_devices_title: 'Heat Pumps Selected',
         device_single_temperature_hide_all_registers: 'Hide All Registers',
         device_single_temperature_show_all_registers: 'Show All Registers',
         heat_pumps_form_additional_information_tab: 'Heat Pump Details',
         heat_pump_single_device_settings_title: 'Heat Pump Settings',
         heat_pump_single_rss_device_status: 'Heat Pump status',
         heat_pumps_single_device_counters_title: 'Heat Pump Counters',
         mbus_set_registers_error_no_fields:
           'Please configure at least one MBus meter before proceeding with data logs.',
         mbus_set_registers_success:
           'Project MBus data logs have been updated successfully',
         devices_form_v3_reset_hiu_after_upload: 'Reset HIU After Upload',
         devices_form_v3_verify_checksum_timeout_seconds:
           'Checksum Verification Timeout (seconds)',
         heat_pump_E001_alarm_name: 'Flow switch',
         heat_pump_E002_alarm_name: 'Pump1',
         heat_pump_E003_alarm_name: 'Pump 2',
         heat_pump_E004_alarm_name: 'Alarm for phase/voltage control',
         heat_pump_E005_alarm_name: 'Alarm unit working-point out of envelope',
         heat_pump_E006_alarm_name: 'Alarm Leakage Detector Safety Chain',
         heat_pump_E020_alarm_name: 'Water inlet low temperature',
         heat_pump_E021_alarm_name: 'Water outlet low temperature',
         heat_pump_E022_alarm_name: 'Water inlet high temperature',
         heat_pump_E023_alarm_name: 'Water outlet high temperature',
         heat_pump_E040_alarm_name: 'Inlet water temperature',
         heat_pump_E041_alarm_name: 'Outlet water temperature',
         heat_pump_E044_alarm_name: 'Sanitary tank probe error',
         heat_pump_E045_alarm_name: 'Outdoor air temperature',
         heat_pump_E046_alarm_name: 'Alarm active setpoint sensor',
         heat_pump_E047_alarm_name: 'Alarm demand limit sensor',
         heat_pump_E101_alarm_name: 'High pressure switch circuit 1',
         heat_pump_E103_alarm_name: 'Fans circuit 1',
         heat_pump_E105_alarm_name:
           'Alarm compressor working-point out of envelope cir 1',
         heat_pump_E106_alarm_name: 'EEV driver circuit 1',
         heat_pump_E107_alarm_name: 'High pressure circuit 1',
         heat_pump_E108_alarm_name: 'Low pressure circuit 1',
         heat_pump_E109_alarm_name: 'Vacuum alarm cir1',
         heat_pump_E110_alarm_name: 'Low compression ratio alarm circuito 1',
         heat_pump_E111_alarm_name: 'High compression ratio alarm circuito 1',
         heat_pump_E114_alarm_name: 'Evaporator output temperature circuit 1',
         heat_pump_E115_alarm_name: 'High pressure sensor circuit 1',
         heat_pump_E117_alarm_name: 'Low pressure sensor circuit 1',
         heat_pump_E120_alarm_name: 'Motor compressor 1 circuit 1',
         heat_pump_E122_alarm_name:
           'Alarm High Discharge temperatur compr 1 cir1',
         heat_pump_E123_alarm_name:
           'Discharge temperature sensor comp. 1 circuit 1',
         heat_pump_E130_alarm_name: 'Motor compressor 2 circuit 1',
         heat_pump_E132_alarm_name:
           'Alarm High Discharge temperatur compr 2 cir1',
         heat_pump_E133_alarm_name:
           'Discharge temperature sensor comp. 2 circuit 1',
         heat_pump_E196_alarm_name: 'Compressors configuration circuit 1',
         heat_pump_E201_alarm_name: 'High pressure switch circuit 2',
         heat_pump_E203_alarm_name: 'Fans circuit 2',
         heat_pump_E205_alarm_name:
           'Alarm compressor working-point out of envelope cir 2',
         heat_pump_E206_alarm_name: 'EEV driver circuit 2',
         heat_pump_E207_alarm_name: 'High pressure circuit 2',
         heat_pump_E208_alarm_name: 'Low pressure circuit 2',
         heat_pump_E209_alarm_name: 'Vacuum alarm cir2',
         heat_pump_E210_alarm_name: 'Low compression ratio alarm circuito 2',
         heat_pump_E211_alarm_name: 'High compression ratio alarm circuito 2',
         heat_pump_E214_alarm_name: 'Evaporator output temperature circuit 2',
         heat_pump_E215_alarm_name: 'High pressure sensor circuit 2',
         heat_pump_E217_alarm_name: 'Low pressuresensor  circuit 2',
         heat_pump_E220_alarm_name: 'Motor compressor 1 circuit 2',
         heat_pump_E222_alarm_name:
           'Alarm High Discharge temperatur compr 1 cir2',
         heat_pump_E223_alarm_name:
           'Discharge temperature sensor comp. 1 circuit 2',
         heat_pump_E230_alarm_name: 'Motor compressor 2 circuit 2',
         heat_pump_E232_alarm_name:
           'Alarm High Discharge temperatur compr 2 cir2',
         heat_pump_E233_alarm_name:
           'Discharge temperature sensor comp. 2 circuit 2',
         heat_pump_E296_alarm_name: 'Compressors configuration circuit 2',
         heat_pump_E901_alarm_name: 'Hystorical alarm full',
         heat_pump_E902_alarm_name: 'Alarm that requires a PLC reboot',
         heat_pump_E903_alarm_name: 'Real Time Clock error',
         heat_pump_E904_alarm_name: 'Scheduler input variable out of range',
         heat_pump_E910_alarm_name: 'EEVD Communication',
         heat_pump_E920_alarm_name: 'EXP1 Communication',
         heat_pump_E921_alarm_name: 'EXP2 Communication',
         heat_pump_E930_alarm_name: 'RS485-1 Communication',
         heat_pump_E931_alarm_name: 'RS485-2 Communication',
         commissioning_form_step_0_status_led_check_stepper_title:
           'Status LED Check',
         commissioning_form_step_0_status_led_check_title:
           'Please turn on your device',
         commissioning_form_step_0_status_led_check_subtitle:
           'Please power the Mecurius Communication Module. It will automatically start searching for the strongest available mobile network. It may take up to 5 minutes to connect to the platform, depending on prior registration and mobile network coverage. When the Status LED turns solid green, please click on Continue to proceed with the commissioning process.',
         commissioning_form_step_0_status_led_check_note:
           'Is the green Status LED solid green?',
         commissioning_form_step_0_status_led_check_continue_button: 'Continue',
         commissioning_form_cancel_button: 'Cancel',
         events_set_log_is_missing:
           'Data Logs are missing on both device and project level',
         sidebar_knowledge_base: 'Knowledge Base',
         knowledge_base_title: 'Knowledge Base',
         knowledge_base_second_sidebar_subtitle: 'Knowledge Base',
         knowledge_base_search: 'Search',
         knowledge_base_page_contents: 'Page Contents',
         knowledge_base_root_folder: 'Root',
         knowledge_base_no_file_selected: 'NO FILE SELECTED',
         knowledge_base_select_file_hint: 'Please select a file to view',
         knowledge_base_no_results: 'No Records Found',
         knowledge_base_no_headings: 'No Headings Found',
         knowledge_base_share: 'Share',
         knowledge_base_print: 'Print',
         knowledge_base_url_copied: 'URL copied to clipboard!',
         knowledge_base_copy_failed: 'Failed to copy URL',
         notification_type_error: 'Error',
         notifications_form_display_in_top_navigation_field:
           'Display in top navigation',
         notifications_form_active_status_field: 'Active',
         notification_deactivated_message:
           'Notification is deactivated successfully!',
         notification_activated_message:
           'Notification is activated successfully!',
         notifications_edit_form_success:
           'Notification is updated successfully',
         notifications_add_new: 'Add New',
         sidebar_collapse: 'Collapse',
         sidebar_expand: 'Expand',
         sidebar_ask_a_question: 'Ask a Question',
         sidebar_support: 'Support',
         ask_question_title_label: 'Title',
         ask_question_description_label: 'Description',
         ask_question_attachments_label: 'Attachments',
         ask_question_upload_button: 'Upload',
         ask_question_drop_text: 'Or drag and drop your file in the box',
         ask_question_cancel_button: 'Cancel',
         ask_question_submit_button: 'Submit',
         ask_a_question_title: 'Ask a Question',
         attachment_file_type_error: 'Unsupported file type',
         attachment_file_size_error: `File size exceeds ##MAX_SIZE_MB## MB`,
         attachment_duplicate_error: 'File already added',
         ask_question_title_required_form_error: 'Title is required',
         ask_question_description_required_form_error:
           'Description is required',
         ask_question_api_error: 'Failed to submit question',
         ask_question_success: 'Question submitted successfully',
         devices_form_sim_status_field: 'Sim Status',
         devices_sim_status_update_success: 'SIM status updated',
         devices_sim_status_update_error: 'Failed to update SIM status',
         devices_form_sim_status_send_button: 'Send',
         devices_form_sim_status_tab: 'Sim Status',
         sidebar_knowledge_base_faq: 'FAQs',
         ask_a_question_request_type_group_operational: 'Operational',
         ask_a_question_request_type_group_informational: 'Informational',
         ask_a_question_request_type_group_commercial_admin:
           'Commercial / Admin',
         ask_a_question_request_type_group_improvement: 'Improvement',
         ask_a_question_request_type_group_other: 'Other',

         ask_a_question_request_type_operational_incident_something_is_not_working:
           'Incident / Something is not working',
         ask_a_question_request_type_operational_data_missing_incorrect:
           'Data missing / incorrect',
         ask_a_question_request_type_operational_connection_device_offline:
           'Connection / Device offline',
         ask_a_question_request_type_operational_access_or_login_problem:
           'Access or login problem',
         ask_a_question_request_type_operational_commissioning: 'Commissioning',
         ask_a_question_request_type_operational_settings_configuration:
           'Settings / Configuration',
         ask_a_question_request_type_operational_performance_issue:
           'Performance issue (slow / unstable)',
         ask_a_question_request_type_operational_hiu_or_meter_missing_in_portal:
           'HIU or meter missing in portal',
         ask_a_question_request_type_operational_hiu_or_meter_not_working:
           'HIU or meter not working',

         ask_a_question_request_type_informational_how_to_question:
           'How-to question',
         ask_a_question_request_type_informational_product_or_feature_information:
           'Product or feature information',
         ask_a_question_request_type_informational_integration_question:
           'Integration question (API / Modbus / M-Bus)',
         ask_a_question_request_type_informational_firmware_software_update:
           'Firmware / Software update',
         ask_a_question_request_type_informational_data_request: 'Data request',
         ask_a_question_request_type_informational_documentation_request:
           'Documentation request',

         ask_a_question_request_type_commercial_admin_account_management:
           'Account management',
         ask_a_question_request_type_commercial_admin_user_roles_permissions:
           'User roles & permissions',
         ask_a_question_request_type_commercial_admin_data_privacy:
           'Data privacy',

         ask_a_question_request_type_improvement_feature_request:
           'Feature request',
         ask_a_question_request_type_improvement_usability_feedback:
           'Usability feedback',
         ask_a_question_request_type_improvement_suggestion_for_improvement:
           'Suggestion for improvement',

         ask_a_question_request_type_other_general_enquiry: 'General enquiry',
         ask_a_question_request_type_other_complaint: 'Complaint',

         ask_question_request_type_required_form_error:
           'Request type is required',
         ask_question_request_type_placeholder:
           'What would you like help with?',
         ask_question_device_id_hint:
           'Are you contacting us about a specific device? If so, please include the Device ID (for example: 12345(6) or A12345).',
         ask_question_attachments_hint:
           'You may upload attachments to help us better understand your request. While attachments are not required, they are especially helpful if your question relates to a specific device, HIU, or technical issue.',
         devices_bulk_hiu_ota_update_title: 'Device bulk HIU OTA update',
         device_list_filters_button_label_update_hiu_hover:
           'Update device HIU OTA - Trigger an OTA update for the selected HIU device(s)',
         heat_pump_list_filters_button_label_update_hiu_hover:
           'Update Heat Pump HIU OTA - Trigger an OTA update for the selected HIU Heat Pump(s)',
         substation_list_filters_button_label_export_devices_hover:
           'Export substation(s) data - export substation and column data of selected substation',
         substation_list_filters_button_label_download_hiu_data_hover:
           'Download substation data - download available measurement data for a selected period',
         substation_list_filters_button_label_download_meter_data_hover:
           'Download Meter data - download available meter data for a selected period',
         substation_list_filters_button_label_change_settings_hover:
           'Bulk update substation registers - change substation settings in bulk',
         substation_list_filters_button_label_update_devices_hover:
           'Update substation firmware - update the Mercurius substation firmware',
         substation_list_filters_button_label_delete_devices_hover:
           'Delete substation(s) and their data',
         substation_list_filters_button_label_data_collect_hover:
           'Refresh data - fetch the latest substation data',
         substation_list_filters_button_label_modbus_write_hover:
           'Click the button to enable Substation Write Mode on the selected substations',
         substation_list_filters_button_label_update_hiu_hover:
           'Update Substation HIU OTA - Trigger an OTA update for the selected HIU Substation(s)',
         devices_bulk_edit_hiu_ota_modal_title:
           'Are you sure you want to run a bulk HIU OTA update?',
         devices_bulk_edit_hiu_ota_modal_subtitle:
           'You want to Bulk HIU OTA update ##firmware_value## for ##total_devices## devices?',
         devices_bulk_edit_hiu_ota_no_devices_error:
           'You must select at least one device to proceed.',
         devices_bulk_edit_hiu_ota_v2_devices_error:
           'V2 devices are not supported for HIU OTA updates and will be automatically removed from the request.',
         ask_question_device_label: 'Device Id / Device Name (Optional)',
         ask_a_question_please_see_our: 'Please see our',
         ask_a_question_faqs: 'FAQs',
         ask_a_question_and: 'and',
         ask_a_question_knowledge_base: 'Knowledge Base',
         hiu_ota_firmware_title: 'HIU Firmwares',
         settings_menu_hiu_ota_firmwares_title: 'HIU Firmwares',
         hiu_ota_table_filename: 'Filename',
         hiu_ota_table_size: 'Size',
         hiu_ota_table_ftp_path: 'FTP Path',
         hiu_ota_table_ftp_url: 'FTP URL',
         hiu_ota_table_created_by: 'Created By',
         hiu_ota_table_created_at: 'Created At',
         hiu_ota_no_record_found: 'No records found',
         hiu_ota_table_row_per_page: 'Rows per page',
         hiu_ota_internal_server_error: 'Internal server error',
         hiu_ota_filter_search: 'Search',
         hiu_ota_table_hiu_ota_firmwares_title: 'Upload HIU Firmware',
         hiu_ota_upload_modal_title: 'Upload HIU Firmware',
         hiu_ota_upload_drop_zone_text: 'Click or drag & drop a file here',
         hiu_ota_upload_drop_zone_sub_text: 'Only .bin files are supported',
         hiu_ota_upload_invalid_file_type: 'Only .bin files are allowed',
         hiu_ota_upload_filename_label: 'Filename',
         hiu_ota_upload_filename_placeholder: 'e.g. firmware_v1.0.bin',
         hiu_ota_upload_cancel: 'Cancel',
         hiu_ota_upload_submit: 'Upload',
         hiu_ota_upload_success: 'Firmware uploaded successfully',
         hiu_ota_upload_error: 'Failed to upload firmware',
         hiu_ota_upload_duplicate_file_error:
           'A file with this name already exists. Please rename the file and try again.',
         hiu_ota_upload_valid_file_error: 'Valid file size is required',
         modbus_v3_heat_pump_reg_8260_label: 'Cooling Temperature Setpoint',
         modbus_v3_heat_pump_reg_8263_label: 'Heating Temperature Setpoint',
         modbus_v3_heat_pump_reg_21761_label:
           'Inlet Water User Side Temperature',
         modbus_v3_heat_pump_reg_21762_label:
           'Outlet Water User Side Temperature 1',
         modbus_v3_heat_pump_reg_21765_label: 'Discharge Pressure Circuit 1',
         modbus_v3_heat_pump_reg_21767_label: 'Out Temperature',
         modbus_v3_heat_pump_reg_21768_label: 'Variable Setpoint',
         modbus_v3_heat_pump_reg_21781_label: 'Discharge Temperature Circuit 1',
         modbus_v3_heat_pump_reg_21253_label:
           'Protection Compressor 1 Circuit 1',
         modbus_v3_heat_pump_reg_21254_label:
           'Protection Compressor 2 Circuit 1',
         modbus_v3_heat_pump_reg_21280_label: 'Protection Heaters',
         modbus_v3_heat_pump_reg_21287_label: 'Protection Fans',
         modbus_v3_heat_pump_reg_21299_label: 'High Pressure Switch Circuit 1',
         modbus_v3_heat_pump_reg_21304_label: 'User Side Water Flow Status',
         modbus_v3_heat_pump_reg_21306_label: 'Protection User Side Pump 1',
         modbus_v3_heat_pump_reg_21309_label: 'Remote ON/OFF',
         modbus_v3_heat_pump_reg_21311_label: 'Phases/Voltage Status',
         modbus_v3_heat_pump_reg_21314_label: 'Remote Cooling/Heating',
         modbus_v3_heat_pump_reg_21319_label: 'Oil Level',
         modbus_v3_heat_pump_reg_21320_label: 'Compressor Inverter Alarm',
         modbus_v3_heat_pump_reg_21506_label: 'Compressor 1 Circuit 1',
         modbus_v3_heat_pump_reg_21507_label: 'Compressor 2 Circuit 1',
         modbus_v3_heat_pump_reg_21522_label: 'User Side Pump 1',
         modbus_v3_heat_pump_reg_21532_label: 'Sink/Source Side Reg. Enable 1',
         modbus_v3_heat_pump_reg_21534_label: 'General Alarm',
         modbus_v3_heat_pump_reg_21536_label: 'Four-Way Valve Circuit 1',
         modbus_v3_heat_pump_reg_21585_label: 'Heaters',
         modbus_v3_heat_pump_reg_22018_label: 'Sink/Source Side Reg. Value 1',
         modbus_v3_heat_pump_reg_21253_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21254_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21280_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21287_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21299_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21304_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21306_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21309_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21311_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21314_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21319_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21320_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21506_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21507_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21522_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21532_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21534_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21536_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21585_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_danfoss_operating_state_title:
           'Operating State Heat Pump',
         modbus_heat_pump_clint_operating_state: 'Operating State (Clint)',
         modbus_heat_pump_danfoss_operating_state: 'Operating State (Danfoss)',
         modbus_heat_pump_clint_measurements: 'Measurements (Clint)',
         modbus_heat_pump_danfoss_measurements: 'Measurements (Danfoss)',
         // Heat Pump - Remeha Effenca MT
         modbus_v3_heat_pump_remeha_effenca_mt_operating_state_title: 'Operating State',
         modbus_v3_heat_pump_remeha_effenca_mt_measurements_title: 'Measurements',
         modbus_v3_heat_pump_remeha_effenca_mt_analog_readings_title: 'Pressure, Flow and Energy',
         modbus_v3_heat_pump_remeha_effenca_mt_writable_registers_title: 'Commands and Parameters',
         modbus_heat_pump_remeha_effenca_mt_operating_state: 'Operating State (Remeha Effenca MT)',
         modbus_heat_pump_remeha_effenca_mt_measurements: 'Measurements (Remeha Effenca MT)',
         modbus_heat_pump_remeha_effenca_mt_analog_readings: 'Pressure, Flow and Energy (Remeha Effenca MT)',
         modbus_heat_pump_remeha_effenca_mt_writable_registers: 'Commands and Parameters (Remeha Effenca MT)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_2_label: 'Alarm reset by modbus',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_6_label: 'Save date',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_13_label: 'Suction pressure C1 value',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_18_label: 'Plate exchanger electrical heater C1 status',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_21_label: 'Crackcase heater C1 status',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_23_label: 'Final unit setpoint',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_45_label: 'Superheating',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_50_label: 'Silent Mode Selector',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_50_label_list: JSON.stringify({
           list: {
             0: 'No Silent Mode',
             1: 'Low Noise 1',
             2: 'Low Noise 2',
             3: 'Low Noise 3',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_53_label: 'EEV position percentage',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_59_label: 'Instantaneous generated Power',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_65_label: 'Minimum Off time compressor',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_66_label: 'Minimum time between starts',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_67_label: 'Countdown Compressor Minimum OFF Time',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_68_label: 'Countdown Compressor Minimum On Time',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_70_label: 'Current day',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_75_label: 'Min Return Water Temp Compressor ON - Cooling mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_76_label: 'Return Water Temp allows Compressor Startup - Cooling Mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_100_label: 'Enable minimal outdoor temperature for defrost',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_102_label: 'Enable Pump shutdown when Compresor is OFF',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_110_label: 'Instantaneous absorbed Power',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_117_label: 'Pump speed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_120_label: 'C1 Fans analog output',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_185_label: 'Status of defrost C1',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_188_label: 'Software version (1.X.X version will be 1)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_189_label: 'Software version (X.6.X version will be 6)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_190_label: 'Software version (X.X.04 version will be 04)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_200_label: 'Setpoint from modbus',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_201_label: 'Request from modbus 0%=17% --> 100%-100%',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_204_label: 'Serial number (year)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_205_label: 'Serial number (month)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_206_label: 'Serial number (factory)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_207_label: 'Serial number (number)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_209_label: 'Working hours of compressor (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_211_label: 'Maximum speed fan in silent mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_217_label: 'Working hours of pump (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_218_label: 'Working hours of pump (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_225_label: 'Working hours of Plate exchanger heater (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_226_label: 'Working hours of Plate exchanger heater (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_229_label: 'Working hours of fan (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_231_label: 'Maximum limit of kW Dynamic (NOT AVALIABLE FUNCTION)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_251_label: 'Start-up number of compressor (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_252_label: 'Start-up number of compressor (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_259_label: 'Start-up number of pump (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_260_label: 'Start-up number of pump (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_267_label: 'Start-up number of Plate exchanger heater (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_268_label: 'Start-up number of Plate exchanger heater (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_271_label: 'Start-up number of fan (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_272_label: 'Start-up number of fan (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_280_label: 'watts/h absorbed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_281_label: 'kilowatts/h absorbed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_282_label: 'Megawatts/h absorbed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_283_label: 'watts/h generated',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_284_label: 'kilowatts/h generated',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_285_label: 'Megawatts/h generated',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_302_label: 'Feedback compressor in RPS',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_304_label: 'Feedback compressor in percentage',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_315_label: 'Compressor is in start-up mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_370_label: 'Maximum Heating Setpoint limit by Outdoor Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_371_label: 'Minimum Heating Setpoint Limit By Outdoot Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_372_label: 'Maximum Cooling Setpoint limit by Outdoor Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_373_label: 'Minimum Cooling Setpoint Limit By Outdoot Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_485_label: 'Software version (1.6.04 version will be 1604)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_495_label: 'Request type',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_495_label_list: JSON.stringify({
           list: {
             0: 'PID',
             1: 'Setpoint 0-10V',
             2: 'SetPoint BMS',
             3: 'Request compressor 0-10V',
             4: 'Request compresor 0-100 BMS',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_600_label: 'Alarma and type alarm',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_610_label: 'Compressor is limited',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_611_label: 'Info Bms Need Rese tManual',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_651_label: 'It shows actual running unit status',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_651_label_list: JSON.stringify({
           list: {
             0: 'Unit ON',
             1: 'Unit ON (RESERVED)',
             2: 'Unit ON (RESERVED)',
             3: 'Unit OFF by Alarm',
             4: 'Unit OFF by Supervisor or BMS',
             5: 'Unit OFF by Time Band',
             6: 'Unit OFF by Digital Input',
             7: 'Unit OFF by PGD Keyboard',
             8: 'Unit OFF by Manufacturer',
             9: 'Unit OFF by ChangeOver (Heating <-> Cooling Modes)',
             10: 'Unit Running on Manual Mode',
             11: 'Unit OFF by Limit Ext. Temp',
             12: 'Unit OFF and CrankCase Heating ON',
             13: 'OFFx LIM.WATER T',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_652_label: 'Configured unit model',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_652_label_list: JSON.stringify({
           list: {
             41: 'PBM3-i 20 R32',
             42: 'PBM3-i 26 R32',
             43: 'PBM3-i 33 R32',
             44: 'PBM3-i 40 R32',
             46: 'MB4C 20 R290',
             47: 'MB4C 30 R290',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_653_label: 'CranKase heater time remain (Hour)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_654_label: 'CranKase heater time remain (Minute)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_655_label: 'CranKase heater time remain (Second)',
         custom_popover_remeha_effenca_mt_2_long_description: 'Alarm reset by modbus',
         custom_popover_remeha_effenca_mt_6_long_description: 'Save date',
         custom_popover_remeha_effenca_mt_13_long_description: 'Suction pressure C1 value',
         custom_popover_remeha_effenca_mt_18_long_description: 'Plate exchanger electrical heater C1 status',
         custom_popover_remeha_effenca_mt_21_long_description: 'Crackcase heater C1 status',
         custom_popover_remeha_effenca_mt_23_long_description: 'Final unit setpoint',
         custom_popover_remeha_effenca_mt_45_long_description: 'Superheating',
         custom_popover_remeha_effenca_mt_50_long_description: 'Silent Mode Selector (0= No Silent Mode, 1= Low Noise 1 , 2= Low Noise 2, 3= Low Noise 3)',
         custom_popover_remeha_effenca_mt_53_long_description: 'EEV position percentage',
         custom_popover_remeha_effenca_mt_59_long_description: 'Instantaneous generated Power',
         custom_popover_remeha_effenca_mt_65_long_description: 'Minimum Off time compressor',
         custom_popover_remeha_effenca_mt_66_long_description: 'Minimum time between starts',
         custom_popover_remeha_effenca_mt_67_long_description: 'Countdown Compressor Minimum OFF Time',
         custom_popover_remeha_effenca_mt_68_long_description: 'Countdown Compressor Minimum On Time',
         custom_popover_remeha_effenca_mt_70_long_description: 'Current day',
         custom_popover_remeha_effenca_mt_75_long_description: 'Min Return Water Temp Compressor ON - Cooling mode',
         custom_popover_remeha_effenca_mt_76_long_description: 'Return Water Temp allows Compressor Startup - Cooling Mode',
         custom_popover_remeha_effenca_mt_100_long_description: 'Enable minimal outdoor temperature for defrost',
         custom_popover_remeha_effenca_mt_102_long_description: 'Enable Pump shutdown when Compresor is OFF',
         custom_popover_remeha_effenca_mt_110_long_description: 'Instantaneous absorbed Power',
         custom_popover_remeha_effenca_mt_117_long_description: 'Pump speed',
         custom_popover_remeha_effenca_mt_120_long_description: 'C1 Fans analog output',
         custom_popover_remeha_effenca_mt_185_long_description: 'Status of defrost C1',
         custom_popover_remeha_effenca_mt_188_long_description: 'Software version (1.X.X version will be 1)',
         custom_popover_remeha_effenca_mt_189_long_description: 'Software version (X.6.X version will be 6)',
         custom_popover_remeha_effenca_mt_190_long_description: 'Software version (X.X.04 version will be 04)',
         custom_popover_remeha_effenca_mt_200_long_description: 'Setpoint from modbus',
         custom_popover_remeha_effenca_mt_201_long_description: 'Request from modbus 0%=17% --> 100%-100%',
         custom_popover_remeha_effenca_mt_204_long_description: 'Serial number (year)',
         custom_popover_remeha_effenca_mt_205_long_description: 'Serial number (month)',
         custom_popover_remeha_effenca_mt_206_long_description: 'Serial number (factory)',
         custom_popover_remeha_effenca_mt_207_long_description: 'Serial number (number)',
         custom_popover_remeha_effenca_mt_211_long_description: 'Maximum speed fan in silent mode',
         custom_popover_remeha_effenca_mt_217_long_description: 'Working hours of pump (high part)',
         custom_popover_remeha_effenca_mt_218_long_description: 'Working hours of pump (low part)',
         custom_popover_remeha_effenca_mt_225_long_description: 'Working hours of Plate exchanger heater (high part)',
         custom_popover_remeha_effenca_mt_226_long_description: 'Working hours of Plate exchanger heater (low part)',
         custom_popover_remeha_effenca_mt_229_long_description: 'Working hours of fan (high part)',
         custom_popover_remeha_effenca_mt_231_long_description: 'Maximum limit of kW Dynamic (NOT AVALIABLE FUNCTION)',
         custom_popover_remeha_effenca_mt_251_long_description: 'Start-up number of compressor (high part)',
         custom_popover_remeha_effenca_mt_252_long_description: 'Start-up number of compressor (low part)',
         custom_popover_remeha_effenca_mt_259_long_description: 'Start-up number of pump (high part)',
         custom_popover_remeha_effenca_mt_260_long_description: 'Start-up number of pump (low part)',
         custom_popover_remeha_effenca_mt_267_long_description: 'Start-up number of Plate exchanger heater (high part)',
         custom_popover_remeha_effenca_mt_268_long_description: 'Start-up number of Plate exchanger heater (low part)',
         custom_popover_remeha_effenca_mt_271_long_description: 'Start-up number of fan (high part)',
         custom_popover_remeha_effenca_mt_272_long_description: 'Start-up number of fan (low part)',
         custom_popover_remeha_effenca_mt_280_long_description: 'watts/h absorbed',
         custom_popover_remeha_effenca_mt_281_long_description: 'kilowatts/h absorbed',
         custom_popover_remeha_effenca_mt_282_long_description: 'Megawatts/h absorbed',
         custom_popover_remeha_effenca_mt_283_long_description: 'watts/h generated',
         custom_popover_remeha_effenca_mt_284_long_description: 'kilowatts/h generated',
         custom_popover_remeha_effenca_mt_285_long_description: 'Megawatts/h generated',
         custom_popover_remeha_effenca_mt_302_long_description: 'Feedback compressor in RPS',
         custom_popover_remeha_effenca_mt_304_long_description: 'Feedback compressor in percentage',
         custom_popover_remeha_effenca_mt_315_long_description: 'Compressor is in start-up mode',
         custom_popover_remeha_effenca_mt_370_long_description: 'Maximum Heating Setpoint limit by Outdoor Temp',
         custom_popover_remeha_effenca_mt_371_long_description: 'Minimum Heating Setpoint Limit By Outdoot Temp',
         custom_popover_remeha_effenca_mt_372_long_description: 'Maximum Cooling Setpoint limit by Outdoor Temp',
         custom_popover_remeha_effenca_mt_373_long_description: 'Minimum Cooling Setpoint Limit By Outdoot Temp',
         custom_popover_remeha_effenca_mt_485_long_description: 'Software version (1.6.04 version will be 1604)',
         custom_popover_remeha_effenca_mt_495_long_description: 'Request type (0 = PID, 1 = Setpoint 0-10V, 2 = SetPoint BMS, 3 = Request compressor 0-10V, 4 = Request compresor 0-100 BMS)',
         custom_popover_remeha_effenca_mt_600_long_description: 'Alarma and type alarm',
         custom_popover_remeha_effenca_mt_610_long_description: 'Compressor is limited',
         custom_popover_remeha_effenca_mt_611_long_description: 'Info Bms Need Rese tManual',
         custom_popover_remeha_effenca_mt_651_long_description: 'It shows actual running unit status: (0= Unit ON, 1 = Unit ON (RESERVED), 2= Unit ON (RESERVED), 3 = Unit OFF by Alarm, 4 = Unit OFF by Supervisor or BMS, 5 = Unit OFF by Time Band, 6 = Unit OFF by Digital Input, 7 = Unit OFF by PGD Keyboard, 8 = Unit OFF by Manufacturer, 9 = Unit OFF by ChangeOver (Heating <-> Cooling Modes), 10 = Unit Running on Manual Mode, 11 = Unit OFF by Limit Ext. Temp, 12 = Unit OFF and CrankCase Heating ON.), 13 = OFFx LIM.WATER T',
         custom_popover_remeha_effenca_mt_652_long_description: 'Configured unit model: (41 = PBM3-i 20 R32, 42 = PBM3-i 26 R32, 43 = PBM3-i 33 R32, 44 = PBM3-i 40 R32, 46 = MB4C 20 R290, 47 = MB4C 30 R290).',
         custom_popover_remeha_effenca_mt_653_long_description: 'CranKase heater time remain (Hour)',
         custom_popover_remeha_effenca_mt_654_long_description: 'CranKase heater time remain (Minute)',
         custom_popover_remeha_effenca_mt_655_long_description: 'CranKase heater time remain (Second)',
         manufacturer_controller_field: 'Manufacturer',
         manufacturer_variant_field: 'Product Variant / Model',
         devices_manufacturer_controller_required_form_error:
           'Manufacturer is required',
         devices_manufacturer_variant_required_form_error:
           'Product Variant / Model is required',
         partner_settings_general_settings_pre_payment_label:
           'Pre-payment Settings',
         partner_settings_general_settings_pre_payment_module_label:
           'Pre-payment Module',
         partner_settings_general_settings_pre_payment_module_description:
           'This setting will enable or disable the pre-payment functionality on the platform.',
         pre_payment_settings_title: 'Pre-payment Settings',
         pre_payment_enable_on_hiu: 'Enable Pre-Payment on HIU',
         pre_payment_enable_on_hiu_description:
           'Enabling this setting allows remote control of the HIU and activates API access. Once enabled, the settings below will become available.',
         pre_payment_override_on_hiu: 'Enable Pre-Payment Override on HIU',
         pre_payment_override_on_hiu_description:
           'Users without API access can perform this action directly from the portal. The manual override serves as a fallback in case the API is unavailable.',
         pre_payment_heating_settings: 'Heating Settings',
         pre_payment_heating_enable: 'Heating enable',
         pre_payment_hot_water_settings: 'Hot Water Settings',
         pre_payment_hot_water_enable: 'Hot water enable',
         pre_payment_cooling_settings: 'Cooling Settings',
         pre_payment_cooling_enable: 'Cooling enable',
         pre_payment_table_name: 'Name',
         pre_payment_table_value: 'Value',
         pre_payment_on: 'On',
         pre_payment_off: 'Off',
         pre_payment_description: 'Description: ',
         pre_payment_heating_settings_description:
           'Disables/enables the Central Heating functions of the HIU. Requires Pre-Payment Override on HIU to be enabled.',
         pre_payment_hot_water_settings_description:
           'Disables/enables the Domestic Hot Water functions of the HIU. Requires Pre-Payment Override on HIU to be enabled.',
         pre_payment_cooling_settings_description:
           'Disables/enables the Central Cooling functions of the HIU. Requires Pre-Payment Override on HIU to be enabled.',
         pre_payment_settings_update_success:
           'Pre-payment settings updated successfully.',
         pre_payment_reporting_title: 'Pre-Payment Reporting',
         pre_payment_reporting_tab_hiu_overview: 'HIUs Overview',
         pre_payment_reporting_tab_hiu_mismatches: 'HIU Mismatches',
         pre_payment_reporting_hiu_overview: 'HIUs Overview',
         pre_payment_reporting_hiu_mismatches: 'HIUs Mismatches',
         pre_payment_reporting_hiu_setting_mismatches:
           'HIUs With Setting Mismatches',
         pre_payment_enabled_on_hiu: 'Pre-Payment Enabled on HIU',
         pre_payment_disabled_on_hiu: 'Pre-Payment Disabled on HIU',
         pre_payment_hiu_with_issues: 'HIU with Issues',
         pre_payment_hiu_without_issues: 'HIU without Issues',
         pre_payment_heating_setting: 'Heating setting',
         pre_payment_hot_water_setting: 'Hot Water setting',
         pre_payment_cooling_setting: 'Cooling setting',
         pre_payment_select_setting_status: 'Select Setting Status',
         pre_payment_enabled: 'ENABLED',
         pre_payment_disabled: 'DISABLED',
         pre_payment_no_data: 'No data available',
         pre_payment_table_col_enable_pre_payment: 'Enable Pre-Payment on HIU',
         pre_payment_table_col_enable_override:
           'Enable Pre-Payment Override on HIU',
         pre_payment_table_col_water: 'Water',
         pre_payment_table_col_cooling: 'Cooling',
         pre_payment_table_col_heating: 'Heating',
         pre_payment_update_portal_message:
           'The latest Pre-payment configuration are set via "Portal" by ##USER_NAME## on ##DATE##',
         pre_payment_update_api_message:
           'The latest Pre-payment configuration are set via "API" by ##USER_NAME## on ##DATE##',
         sidebar_pre_payment_reporting: 'Pre-payment Reporting',
         pre_payment_expected_settings: 'Expected Settings',
         pre_payment_actual_settings: 'Actual Settings',
         pre_payment_match_status: 'Match Status',
         pre_payment_requested_from: 'Requested From',
         pre_payment_requested_by: 'Requested By',
         pre_payment_updated_at: 'Updated At',
         pre_payment_last_monitored: 'Last Monitored',
         prepayment_hot_water_enabled: 'Hot Water Enabled',
         prepayment_hot_water_disabled: 'Hot Water Disabled',
         prepayment_heating_enabled: 'Heating Enabled',
         prepayment_heating_disabled: 'Heating Disabled',
         prepayment_cooling_enabled: 'Cooling Enabled',
         prepayment_cooling_disabled: 'Cooling Disabled',
         pre_payment_matched: 'MATCHED',
         pre_payment_mismatched: 'MISMATCHED',
         device_single_prepayment_tab: 'Pre-payment',
         project_single_prepayment_tab: 'Pre-payment',
         pre_payment_reporting_tab_pre_payment_events: 'Pre-Payment Events',
         clients_form_prepayment_notification_email_field:
           'Prepayment Notification Email',
         device_single_mbus_graph_title: 'Mbus Historic Data',
         sidebar_api_overview: 'APIs',
         sidebar_api_device_import: "APIs d'import d'appareils",
         sidebar_api_external: 'APIs externes',
         sidebar_api_prepayment: 'APIs de prépaiement',
         sidebar_api_writer_v3: 'Writer v3',
         api_overview_no_apis_available:
           'Aucune API disponible pour cet environnement',
         device_single_mbus_registers_tab: 'Mbus Registers',
         device_single_mbus_graph_tab: 'Mbus Graph',
         projects_form_send_subscription_expiring_notification_field:
           'Send Subscription Expiring Notification',
         projects_missing_contact_modal_title:
           'Action Required: Missing Client Contact',
         projects_missing_contact_modal_subtitle:
           'The following projects are missing a main client contact. Please assign a contact for each project before continuing.',
         projects_missing_contact_contact_required:
           'Client contact is required',
         projects_missing_contact_save_success:
           'Client contacts updated successfully',
         projects_missing_contact_save_error:
           'Failed to update client contacts. Please try again.',
         projects_missing_contact_remind_later_button: 'Remind Me Later',
         projects_missing_contact_save_button: 'Save',
         devices_form_autocomplete_device_name_or_serial_number_field:
           'Device name or Serial number Mercurius',
         swapping_same_device_error:
           'The selected devices cannot be the same. Please choose two different devices',
         clients_table_users: 'Users',
         service_clients_table_users: 'Users',
         clients_bulk_delete_success_message:
           'Clients with 0 devices and 0 users were successfully deleted.',
         clients_delete_modal_title:
           'Are you sure you want to delete the following client records?',
         service_clients_delete_modal_title:
           'Are you sure you want to delete the following service client records?',
         clients_bulk_delete_subtitle:
           'You want to delete client records with 0 devices and 0 users? \n Any selected clients with more than 0 devices or users will be ignored.',
         service_clients_bulk_delete_success_message:
           'Service Clients with 0 devices and 0 users were successfully deleted.',
         service_clients_bulk_delete_subtitle:
           'You want to delete service client records with 0 devices and 0 users? \n Any selected service clients with more than 0 devices or users will be ignored.',
         clients_bulk_deactivate_title: 'Are you sure?',
         clients_bulk_deactivate_subtitle:
           'You want to deactivate the selected clients?',
         service_clients_bulk_deactivate_title: 'Are you sure?',
         service_clients_bulk_deactivate_subtitle:
           'You want to deactivate the selected service clients?',
         sidebar_offboarding_overview: 'Offboarding Overview',
         offboarding_form_header: 'Offboarding Overview',
         offboarding_initiate_button: 'Initiate Offboarding',
         offboarding_initiate_page_title: 'Offboarding - Initiate',
         offboarding_scope_page_title: 'Offboarding - Scope',
         offboarding_review_page_title: 'Offboarding - Review',
         offboarding_confirm_page_title: 'Offboarding - Confirmation',
         offboarding_initiated_page_title: 'Offboarding - Initiated',
         offboarding_breadcrumb_subscription: 'Subscription',
         offboarding_breadcrumb_offboarding: 'Offboarding',
         offboarding_start_title: 'Initiate Offboarding',
         offboarding_start_about_to_begin:
           'You are about to begin the full offboarding process for',
         offboarding_start_includes:
           'This process includes a grace period, restricted access, and eventual data removal for the affected scope.',
         offboarding_partial_scope_about_to_begin:
           'You are about to begin the partial offboarding process for',
         offboarding_immediate_scope_about_to_begin:
           'You are about to initiate the immediate offboarding process for',
         offboarding_immediate_scope_includes:
           'Once the request is approved, all data within the affected scope will be permanently deleted immediately, with access restricted throughout the process.',
         offboarding_what_to_expect: 'What to Expect',
         offboarding_what_to_expect_1:
           'Review the full list of projects belonging to this client and confirm your selection',
         offboarding_what_to_expect_2:
           'Select the projects or account scope to offboard',
         offboarding_what_to_expect_3:
           'Review timelines, including grace period and data download window',
         offboarding_what_to_expect_4:
           'Confirm and initiate the offboarding process for the client',
         offboarding_note: 'Note',
         offboarding_note_text:
           'The client will retain limited access to view and export data before permanent deletion takes place.',
         offboarding_start_button: 'Start Offboarding',
         offboarding_scope_select_title: 'Select Offboarding Scope',
         offboarding_scope_choose_description:
           'Choose whether you want to offboard the client entirely or only selected projects.',
         offboarding_type_full: 'Full Offboarding',
         offboarding_type_full_description:
           'Offboard your entire account, including all projects and associated data.',
         offboarding_type_partial: 'Partial Offboarding',
         offboarding_type_partial_description:
           'Offboard selected projects while keeping the rest of your account active.',
         offboarding_type_immediate: 'Immediate Deletion',
         offboarding_type_immediate_description:
           'Immediately delete selected project data without a grace period.',
         offboarding_selected_projects: 'Selected project(s)',
         offboarding_add_projects: 'Add Projects',
         offboarding_please_select_projects:
           'Please select projects to proceed',
         offboarding_projects_selected_count: 'selected',
         offboarding_search_projects: 'Search projects...',
         offboarding_full_info_text:
           'All projects under this client will be offboarded. No project selection is required.',
         offboarding_partial_info_text:
           'Only the selected scope will be affected. All other projects will remain active and unchanged.',
         offboarding_immediate_info_text:
           'Selected projects will be immediately queued for deletion without a grace period.',
         offboarding_continue_button: 'Continue',
         offboarding_back_button: 'Back',
         offboarding_review_title: 'Review Timeline & Impact',
         offboarding_review_description:
           'Review what will happen after the offboarding process begins, including timelines, client access changes, and data handling for the affected projects.',
         offboarding_timeline: 'Timeline',
         offboarding_contract_termination_date: 'Contract Termination Date',
         offboarding_contract_termination_text:
           'The offboarding process for the selected projects will begin from this date.',
         offboarding_grace_period: 'Grace Period (1 Month)',
         offboarding_grace_period_1:
           'Client access will be limited to view and export only',
         offboarding_grace_period_2: 'No new data will be collected or logged',
         offboarding_grace_period_3:
           'The client may request renewal during this period',
         offboarding_data_download_window:
           'Data Download Window (Additional 1 Month)',
         offboarding_data_download_1:
           'The client can continue to access and export data',
         offboarding_data_download_2:
           'No changes or new activity will be allowed',
         offboarding_impact_summary: 'Impact Summary',
         offboarding_impact_1:
           'Write actions and configuration changes will be disabled',
         offboarding_impact_2: 'Device control and data collection will stop',
         offboarding_impact_3:
           'Data will be permanently removed after the download window',
         offboarding_review_note:
           'The client may request renewal during the grace period before final deletion.',
         offboarding_confirm_description:
           'Please review the selected projects and confirm to start the offboarding process for',
         offboarding_summary: 'Summary',
         offboarding_client_name: 'Client name',
         offboarding_scope_label: 'Scope',
         offboarding_projects_affected: 'Projects Affected',
         offboarding_data_download_deadline: 'Data Download Deadline',
         offboarding_set_upon_approval: 'Set upon approval',
         offboarding_important: 'Important',
         offboarding_important_1:
           'Client access to affected projects will be restricted to read and export only',
         offboarding_important_2:
           'Device activity and data collection for affected projects will stop',
         offboarding_important_3:
           'Data for affected projects will be permanently deleted after the download window',
         offboarding_important_4:
           'This action cannot be reversed once the process begins',
         offboarding_understand_checkbox:
           'I understand the consequences of offboarding and want to proceed with this request for',
         offboarding_understand_checkbox_prefix:
           'I understand the consequences of offboarding and want to proceed with this request for',
         offboarding_understand_checkbox_suffix: '.',
         offboarding_attachment_title: 'Mandatory Acknowledgement Attachment',
         offboarding_attachment_instruction:
           'Upload proof of customer acknowledgement to offboard the project(s). Drag & drop files here, or click to browse.',
         offboarding_attachment_subtext:
           'Accepted: images, PDFs, Word documents, or any file format. One or more files required.',
         offboarding_attachment_required_error:
           'Please upload at least one attachment confirming customer acknowledgement before proceeding.',
         offboarding_attachment_remove: 'Remove',
         offboarding_confirm_button: 'Confirm',
         offboarding_initiated_started: 'Offboarding Started',
         offboarding_initiated_success_prefix: 'The offboarding process for',
         offboarding_initiated_success_suffix:
           'has been successfully initiated.',
         offboarding_initiated_bold:
           'The selected projects are now in the offboarding process. Client access and project permissions have been updated based on the current stage.',
         offboarding_what_happens_next: 'What Happens Next',
         offboarding_next_1:
           'The grace period will begin from the contract termination date',
         offboarding_next_2:
           'Client access will be limited to view and export only',
         offboarding_next_3:
           'The client may request renewal during the grace period',
         offboarding_next_4:
           'After the deadline, affected project data will be permanently deleted',
         offboarding_go_to_dashboard: 'Go to Dashboard',
         offboarding_rejection_reason_hint:
           'A minimum of 30 characters is required for the rejection reason.',
         offboarding_toast_cancelled_success:
           'Offboarding cancelled successfully.',
         offboarding_toast_cancelled_failed:
           'Failed to cancel. Please try again.',
         offboarding_toast_create_success:
           'Offboarding request submitted successfully.',
         offboarding_toast_paused_success: 'Offboarding paused successfully.',
         offboarding_toast_resumed_success: 'Offboarding resumed successfully.',
         offboarding_toast_action_failed: 'Action failed. Please try again.',
         offboarding_toast_review_request_sent:
           'You have successfully requested offboarding review from your ##COLLEGUE_FULL_NAME##',
         offboarding_email_link_already_reviewed:
           'The selected project is already reviewed.',
         offboarding_email_link_status_not_initiated:
           'This project offboarding has already been reviewed.',
         offboarding_email_link_wrong_reviewer:
           '##REVIEWER_NAME## has already been requested to review this project.',
         offboarding_bulk_all_devices_offboarded_error: 'Please select devices which are not offboarded.',
         offboarding_toast_rejected_success:
           'Offboarding request rejected successfully.',
         offboarding_toast_rejected_failed:
           'Failed to reject. Please try again.',
         offboarding_toast_approved_success:
           'Offboarding request approved successfully.',
         offboarding_toast_approved_failed:
           'Failed to approve. Please try again.',
         offboarding_dialog_close: 'Close',
         offboarding_dialog_cancel: 'Cancel',
         offboarding_dialog_reject: 'Reject',
         offboarding_dialog_approve: 'Approve',
         offboarding_dialog_no_reason_provided: 'No reason provided.',
         offboarding_dialog_deletion_reason_title: 'Immediate Deletion Reason',
         offboarding_dialog_rejection_reason_title: 'Rejection Reason',
         offboarding_dialog_rejected_by: 'Rejected By',
         offboarding_action_review: 'Review',
         offboarding_action_pause: 'Pause',
         offboarding_action_resume: 'Resume',
         offboarding_action_cancel_offboarding: 'Cancel Offboarding',
         offboarding_action_download_attachment: 'Download Attachment',
         offboarding_toast_download_attachment_success:
           'Attachments downloaded successfully.',
         offboarding_action_review_deletion_reason:
           'Review Immediate Deletion Reason',
         offboarding_action_review_rejection_reason: 'Review Rejection Reason',
         offboarding_action_request_review_colleague:
           'Request Review From Colleague',
         offboarding_request_review_dialog_title:
           'Request Review From Colleague',
         offboarding_request_review_colleague_label:
           'Select a colleague to review this request',
         offboarding_request_review_colleague_placeholder:
           'Search by name or email...',
         offboarding_request_review_send_button: 'Send Request',
         offboarding_review_dialog_title: 'Review',
         offboarding_review_instructions:
           'and make your decision accordingly. Approve with caution, as the project will be moved to the grace period and an email will also be forwarded to the customer.',
         offboarding_review_what_will_happen: 'What Will Happen',
         offboarding_review_what_happens_next: 'What Happens Next',
         offboarding_review_partial_bullet_1:
           'Once approved, the grace period will begin immediately.',
         offboarding_review_partial_bullet_2:
           'Client access will be limited to view and export only.',
         offboarding_review_partial_bullet_3:
           'After the deadline, affected project data will be permanently deleted.',
         offboarding_review_full_bullet_1:
           'Once approved, the grace period will begin immediately.',
         offboarding_review_full_bullet_2:
           'Client access will be limited to view and export only.',
         offboarding_review_full_bullet_3:
           'Device activity and data collection for affected projects will stop.',
         offboarding_review_full_bullet_4:
           'After the deadline, affected data will be permanently deleted.',
         offboarding_review_immediate_bullet_1:
           'Once approved, deletion for the affected projects will begin immediately.',
         offboarding_review_immediate_bullet_2:
           'Client access will be revoked.',
         offboarding_review_immediate_bullet_3:
           'All project data will be permanently deleted.',
         offboarding_review_note_text:
           'The client may request renewal during the grace period. A Fortes Super Admin can pause or resume the offboarding process if the client has expressed interest to the Sales department in renewing their subscription.',
         offboarding_review_summary_title: 'Summary',
         offboarding_review_note_label: 'Note',
         offboarding_review_label_requested_by: 'Requested By',
         offboarding_review_label_client_name: 'Client Name',
         offboarding_review_label_status: 'Status',
         offboarding_review_label_status_value: 'INITIATED / UNDER REVIEW',
         offboarding_review_label_scope: 'Scope',
         offboarding_review_label_projects_affected: 'Projects Affected',
         offboarding_review_label_all_projects: 'All',
         offboarding_review_label_request_date: 'Request Date',
         offboarding_review_label_grace_period_expiry:
           'Expected Grace Period Expiry',
         offboarding_review_rejection_reason_field: 'Rejection Reason',
         offboarding_error_create:
           'Failed to initiate offboarding. Please try again.',
         offboarding_select_projects_title: 'Select Project(s)',
         offboarding_col_project_name: 'Project Name',
         offboarding_col_expiry_date: 'Expiry Date',
         offboarding_col_months_to_zero: 'Months to Zero',
         offboarding_col_devices: 'Devices',
         offboarding_no_projects_found: 'No projects found.',
         offboarding_done_button: 'Done',

         /* Full Offboarding flow */
         full_offboarding_page_title: 'Offboarding - Full',
         full_offboarding_scope_info:
           'All projects will be affected in the full offboarding process.',
         full_offboarding_confirm_title: 'Confirm Full Offboarding',
         full_offboarding_confirm_description:
           'Please review the selected scope and confirm to start the offboarding process for',
         full_offboarding_projects_all: 'All',
         full_offboarding_important_5:
           'This action cannot be reversed once the process begins',
         full_offboarding_understand_prefix:
           'I understand the consequences of full offboarding and want to proceed with this request for',
         full_offboarding_initiated_title: 'Full Offboarding Started',
         full_offboarding_initiated_success_prefix:
           'The offboarding process for',
         full_offboarding_initiated_success_suffix:
           'has been successfully initiated.',
         full_offboarding_initiated_body:
           'The selected scope is now in the offboarding process. Client access and project permissions have been updated based on the current stage.',
         full_offboarding_next_1:
           'The grace period will begin from the contract termination date',
         full_offboarding_next_2:
           'Client access will be limited to view and export only',
         full_offboarding_next_3:
           'The client may request renewal during the grace period',
         full_offboarding_next_4:
           'Device activity and data collection for affected projects will stop',
         full_offboarding_next_5:
           'After the deadline, affected data will be permanently deleted or anonymized',

         /* Immediate Deletion flow */
         immediate_offboarding_page_title: 'Offboarding - Immediate Deletion',
         immediate_offboarding_scope_warning:
           'Please note that this option will permanently delete all data associated with the selected projects. Use it with caution.',
         immediate_offboarding_review_title: 'Request Immediate Deletion',
         immediate_offboarding_review_description_prefix:
           'Select the projects belonging to',
         immediate_offboarding_review_description_suffix:
           'that should be deleted immediately.',
         immediate_offboarding_select_projects_label: 'Select Project(s)',
         immediate_offboarding_reason_label: 'Reason for Deletion',
         immediate_offboarding_reason_placeholder:
           'Provide a reason for this request',
         immediate_offboarding_review_important_1:
           'This request must be approved before deletion begins',
         immediate_offboarding_review_important_2:
           'Client access to affected projects may be restricted once approved',
         immediate_offboarding_review_important_3:
           'This process may bypass the grace period and data download window',
         immediate_offboarding_review_important_4:
           'Deletion is permanent and cannot be undone',
         immediate_offboarding_confirm_title: 'Request Immediate Deletion',
         immediate_offboarding_confirm_description_prefix:
           'You are requesting immediate deletion of the selected projects belonging to',
         immediate_offboarding_confirm_description_suffix:
           'This request will be reviewed before any action is taken.',
         immediate_offboarding_status: 'Status',
         immediate_offboarding_pending_approval: 'Pending approval',
         immediate_offboarding_scope_value: 'Request Immediate Deletion',
         immediate_offboarding_request_date: 'Request Date',
         immediate_offboarding_checkbox:
           'I understand that this action may result in permanent data loss for the affected projects.',
         immediate_offboarding_submit_button: 'Submit',
         immediate_offboarding_projects_required:
           'Please select at least one project.',
         immediate_offboarding_reason_required:
           'Please provide a reason for deletion.',
         immediate_offboarding_initiated_title: 'Deletion Request Submitted',
         immediate_offboarding_initiated_success_prefix:
           'The immediate deletion request for',
         immediate_offboarding_initiated_success_suffix:
           'has been successfully submitted and is pending review.',
         immediate_offboarding_next_1:
           'The request will be reviewed by the offboarding team',
         immediate_offboarding_next_2:
           'The client and internal stakeholders may be notified once a decision is made',
         immediate_offboarding_next_3:
           'If approved, deletion for the affected projects will begin immediately',
         immediate_offboarding_error_create:
           'Failed to submit the immediate deletion request.',
         device_single_device_settings_hiu_search_device: 'HIU Search',
         device_single_device_settings_hiu_search_message_forwarded:
           'Device HIU Modbus Search message is forwarded to device',
         device_single_device_settings_hiu_reboot_device_tooltip:
           'It reboots the modbus device',
         device_single_device_settings_hiu_search_device_tooltip:
           'The Mercurius resets the Modbus UART and Search for Modbus again.',
         sidebar_offboarding_reporting: 'Offboarding Reporting',
         offboarding_reporting_page_title: 'Offboarding Report',
         offboarding_reporting_breadcrumb: 'Offboarding Report',
         offboarding_reporting_client_filter: 'Client',
         offboarding_reporting_project_filter: 'Project',
         offboarding_reporting_status_filter: 'Status',
         offboarding_reporting_all_statuses: 'All Statuses',
         offboarding_reporting_reset_filters: 'Reset Filters',
         offboarding_reporting_tab_all: 'All',
         offboarding_reporting_tab_partial: 'Partial',
         offboarding_reporting_tab_full: 'Full',
         offboarding_reporting_tab_immediate: 'Immediate',
         offboarding_reporting_requests_title: 'Offboarding Requests',
         offboarding_reporting_trend_title: 'Offboarding Trend',
         offboarding_reporting_requests_label: 'REQUESTS',
         offboarding_reporting_legend_initiated: 'Initiated / Under Review',
         offboarding_reporting_legend_grace_period: 'Grace Period',
         offboarding_reporting_legend_rejected: 'Offboarding Rejected',
         offboarding_reporting_legend_offboarded: 'Offboarded',
         offboarding_reporting_status_initiated: 'Initiated',
         offboarding_reporting_status_grace_period: 'Grace Period',
         offboarding_reporting_status_grace_period_expired:
           'Grace Period Expired',
         offboarding_reporting_status_in_progress: 'Deletion In Progress',
         offboarding_reporting_status_completed: 'Offboarded',
         offboarding_reporting_status_approved: 'Approved',
         offboarding_reporting_status_rejected: 'Rejected',
         offboarding_reporting_status_cancelled: 'Cancelled',
         offboarding_reporting_col_request_id: 'Request ID',
         offboarding_reporting_col_client: 'Client',
         offboarding_reporting_col_project: 'Project',
         offboarding_reporting_col_scope: 'Scope',
         offboarding_reporting_col_status: 'Status',
         offboarding_reporting_col_initiator: 'Initiated by',
         offboarding_reporting_col_initiated_at: 'Initiated At',
         offboarding_reporting_col_manager: 'Offboarding Manager',
         offboarding_reporting_no_data: 'No offboarding records found',
         offboarding_reporting_col_actions: 'Actions',
         sidebar_substations: 'Substation Overview',
         sidebar_boilers: 'Boiler Overview',
         boilers_bulk_edit_ota_form_submit_button: 'Update boilers',
         boilers_ota_select_at_least_one_to_proceed_error: 'You must select at least one boiler to proceed.',
         boilers_bulk_edit_ota_title: 'Boiler OTA bulk update',
         boilers_bulk_edit_registers_title: 'Boiler registers bulk update',
         boilers_bulk_hiu_ota_update_title: 'Boiler bulk HIU OTA update',
         custom_popover_boiler_luna_mp_386_short_description: 'Heating outdoor temperature upper limit',
         custom_popover_boiler_luna_mp_387_short_description: 'Cooling neutral band',
         custom_popover_boiler_luna_mp_388_short_description: 'Antifreeze activation temperature',
         custom_popover_boiler_luna_mp_389_short_description: 'Force summer mode',
         custom_popover_boiler_luna_mp_405_short_description: 'Domestic hot water internal setpoint',
         custom_popover_boiler_luna_mp_406_short_description: 'Central heating setpoint',
         custom_popover_boiler_luna_mp_408_short_description: 'Domestic hot water flow temperature setpoint',
         custom_popover_boiler_luna_mp_409_short_description: 'Water pressure',
         custom_popover_boiler_luna_mp_410_short_description: 'Flow rate',
         custom_popover_boiler_luna_mp_413_short_description: 'Actual relative power',
         custom_popover_boiler_luna_mp_414_short_description: 'Power setpoint',
         custom_popover_boiler_luna_mp_415_short_description: 'Flame current',
         custom_popover_boiler_luna_mp_416_short_description: 'Internal heat demand power',
         custom_popover_boiler_luna_mp_417_short_description: 'Internal heat demand temperature setpoint',
         custom_popover_boiler_luna_mp_418_short_description: 'Internal heat demand type',
         custom_popover_boiler_luna_mp_419_short_description: 'Burner/compressor starts',
         custom_popover_boiler_luna_mp_421_short_description: 'Burner operating hours',
         custom_popover_boiler_luna_mp_423_short_description: 'Backup 1 starts',
         custom_popover_boiler_luna_mp_425_short_description: 'Backup 1 hours',
         custom_popover_boiler_luna_mp_427_short_description: 'Backup 2 starts',
         custom_popover_boiler_luna_mp_429_short_description: 'Backup 2 hours',
         custom_popover_boiler_luna_mp_431_short_description: 'Operating hours',
         custom_popover_boiler_luna_mp_433_short_description: 'Central heating energy consumed',
         custom_popover_boiler_luna_mp_435_short_description: 'DHW energy consumed',
         custom_popover_boiler_luna_mp_439_short_description: 'Total energy consumed',
         custom_popover_boiler_luna_mp_441_short_description: 'Backup energy consumed',
         custom_popover_boiler_luna_mp_443_short_description: 'Total energy delivered',
         custom_popover_boiler_luna_mp_445_short_description: 'Central heating energy delivered',
         custom_popover_boiler_luna_mp_447_short_description: 'DHW energy delivered',
         custom_popover_boiler_luna_mp_451_short_description: 'Backup energy delivered',
         custom_popover_boiler_luna_mp_458_short_description: 'System flow setpoint',
         custom_popover_boiler_luna_mp_459_short_description: 'Pump speed',
         custom_popover_boiler_luna_mp_477_short_description: 'Minimum heating time before DHW production',
         custom_popover_boiler_luna_mp_478_short_description: 'Maximum DHW production time',
         custom_popover_boiler_luna_mp_479_short_description: 'DHW ECO/COMFORT mode',
         custom_popover_boiler_luna_mp_516_short_description: 'Burner starts since service',
         boilers_form_is_service_device_field: 'Service Boiler',
         boiler_single_device_settings_secondary_device_type_field: 'Secondary Boiler Type',
         boiler_single_device_settings_fqdn_field: 'Boiler FQDN',
         boilers_form_project_disabled_field: 'The Project Field is disabled because this boiler is a service boiler',
         boilers_form_device_address_tab: 'Installation address',
         boilers_form_project_field: 'Project',
         boilers_form_firmware_field: 'Firmware version',
         boilers_form_serial_number_field: 'Serial number Mercurius',
         boilers_form_type_field: 'Boiler type',
         boilers_form_client_field: 'Client',
         boilers_form_sim_card_number_field: 'Sim card number',
         boilers_form_first_event_timestamp_field: 'First Incoming Event Date',
         boilers_mbus_meter_count: 'Mbus Meters',
         boilers_mbus_labels: 'Mbus Meter Purpose Labels',
         boilers_last_viewed: 'Last seen',
         boilers_form_service_client_field: 'Service client',
         boilers_form_set_logs_scope_field: 'Data Logs Scope',
         boiler_list_modbus_write_enable_field: 'Modbus Write Mode',
         boilers_form_order_type_field: 'Order Type',
         boilers_form_default_controller_type_field: 'Default Controller Type',
         boilers_form_prod_order_nr_week_field: 'Production order number',
         boilers_form_order_number_field: 'Order number',
         boilers_form_default_client_name_field: 'Default Client Name',
         boilers_form_customer_ref_field: 'Customer reference',
         boilers_form_default_appliance_type_field: 'Default Appliance Type',
         boilers_form_default_soft_version_field: 'Default Software Version',
         boiler_is_claimed_field: 'Is Claimed',
         boiler_claimed_by_field: 'Claimed By',
         boiler_is_stock_product_field: 'Is Stock Product',
         boiler_commissioned_by_field: 'Commissioned By',
         boiler_commissioned_at_field: 'Commissioned At',
         boilers_form_v3_fetch_device_information_button: 'Fetch Boiler Information',
         boilers_partner_order_number_field: 'Boiler Distributor Order Number',
         boiler_single_temperature_no_graph_data_error: 'No graph data available',
         edit_boilers_form_header: 'Edit Boiler',
         edit_boilers_bread_crumb_first_link: 'Edit Boiler',
         boiler_menu_overview: 'Overview',
         boiler_menu_heating: 'Heating',
         boiler_menu_domestic_hot_water: 'Domestic Hot Water',
         boiler_menu_performance: 'Performance',
         boiler_menu_energy: 'Energy',
         boiler_menu_maintenance: 'Maintenance',
         boiler_menu_configuration: 'Configuration',
         boiler_menu_overview_water_pressure: 'Water Pressure',
         boiler_menu_overview_flow_rate: 'Flow Rate',
         boiler_menu_overview_current_power: 'Current Power',
         boiler_menu_heating_heat_demand: 'Heat Demand',
         boiler_menu_heating_setpoint: 'Setpoint',
         boiler_menu_domestic_hot_water_setpoint: 'Setpoint',
         boiler_menu_performance_power: 'Power',
         boiler_menu_performance_burner: 'Burner',
         boiler_menu_performance_burner_starts: 'Burner Starts',
         boiler_menu_performance_burner_operating_hours: 'Burner Operating Hours',
         boiler_menu_performance_pump_speed: 'Pump Speed',
         boiler_menu_energy_consumed_total: 'Total Energy Consumed',
         boiler_menu_energy_consumed_central_heating: 'Central Heating Energy Consumed',
         boiler_menu_energy_consumed_dhw: 'DHW Energy Consumed',
         boiler_menu_energy_consumed_backup: 'Backup Energy Consumed',
         boiler_menu_energy_delivered_total: 'Total Energy Delivered',
         boiler_menu_energy_delivered_central_heating: 'Central Heating Energy Delivered',
         boiler_menu_energy_delivered_dhw: 'DHW Energy Delivered',
         boiler_menu_energy_delivered_backup: 'Backup Energy Delivered',
         boiler_menu_maintenance_burner_starts: 'Burner Starts Since Service',
         boiler_menu_configuration_heating: 'Heating',
         boiler_menu_configuration_domestic_hot_water: 'Domestic Hot Water',
         boilers_bulk_delete_modal_note: `<strong>Note:</strong> <br /> Once you proceed with the deletion, it cannot be undone unless the IT team manually
          restores the data from old backups. Recovering events and other related information will be highly time-consuming.
          Boiler deletion takes some time due to the data mentioned above. Please be patient and do not cancel or refresh the
          page.`,
         boilers_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Boiler Information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Boiler Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         boiler_fetch_registers_success: 'The request has been successfully sent to Boiler.',
         boiler_form_description_field: 'Description',
         boiler_list_filters_button_label_change_settings_hover: 'Bulk update boiler registers - change boiler settings in bulk',
         boiler_list_filters_button_label_data_collect_hover: 'Refresh data - fetch the latest boiler data',
         boiler_list_filters_button_label_delete_devices_hover: 'Delete boiler(s) and their data',
         boiler_list_filters_button_label_download_hiu_data_hover: 'Download boiler data - download available measurement data for a selected period',
         boiler_list_filters_button_label_download_meter_data_hover: 'Download Meter data - download available meter data for a selected period',
         boiler_list_filters_button_label_export_devices_hover: 'Export boiler(s) data - export boiler and column data of selected boiler',
         boiler_list_filters_button_label_modbus_write_hover: 'Click the button to enable Boiler Write Mode on the selected boilers',
         boiler_list_filters_button_label_update_devices_hover: 'Update boiler firmware - update the Mercurius boiler firmware',
         boiler_list_filters_button_label_update_hiu_hover: 'Update Boiler HIU OTA - Trigger an OTA update for the selected HIU Boiler(s)',
         boiler_single_device_settings_title: 'Boiler Settings',
         boiler_single_download_modbus_data: 'Export boiler data',
         boiler_single_error_detailed_message: 'Boiler is in "Alarm" mode',
         boiler_single_firmware_hiu_label: 'Firmware boiler',
         boiler_single_offline_detailed_message: 'Boiler is "Offline"',
         boiler_single_online_detailed_message: 'Boiler is "Online", everything is working fine',
         boiler_single_page_title: 'Boiler details',
         boiler_single_rss_device_status: 'Boiler status',
         boiler_single_temperature_title: 'The history of the boiler',
         boilers_bulk_modbus_download_form_submit_button: 'Download Boilers data',
         boilers_bulk_modbus_download_title: 'Download Boilers Historical Data',
         boilers_bulk_selected_devices_title: 'Boilers Selected',
         boilers_filter_search: 'Search Boiler',
         boilers_form_additional_information_tab: 'Boiler Details',
         boilers_form_article_number_field: 'Boiler Article Number',
         boilers_form_box_serial_number_field: 'Boiler Serial Number',
         boilers_form_description_field: 'Boiler type',
         boilers_form_device_information_tab: 'Boiler Information',
         boilers_form_device_labels_field: 'Boiler Label',
         boilers_form_header: 'Boilers',
         boilers_form_name_field: 'Boiler Name',
         boilers_list_device_set_log_label: 'Boiler Data log',
         boilers_no_record_found: 'Aucune sous-station trouvée',
         boilers_partner_article_number_field: 'Boiler Distributor Article number',
         boilers_partner_serial_number: 'Boiler Distributor Serial Number',
         boilers_single_bread_crumb_first_link: 'Boiler page',
         boilers_single_bread_crumb_main_title: 'Boiler overview',
         boilers_single_device_counters_title: 'Boiler Counters',
         boilers_single_edit_device_button: 'Edit Boiler',
         modbus_v3_boiler_luna_mp_reg_386_label: 'Heating outdoor temperature upper limit',
         custom_popover_boiler_luna_mp_386_long_description: 'Heating outdoor temperature upper limit',
         modbus_v3_boiler_luna_mp_reg_387_label: 'Cooling neutral band',
         custom_popover_boiler_luna_mp_387_long_description: 'Cooling neutral band',
         modbus_v3_boiler_luna_mp_reg_388_label: 'Antifreeze activation temperature',
         custom_popover_boiler_luna_mp_388_long_description: 'Antifreeze activation temperature',
         modbus_v3_boiler_luna_mp_reg_389_label: 'Force summer mode',
         modbus_v3_boiler_luna_mp_reg_389_label_list: '{"list":{"0":"Off","1":"On"}}',
         custom_popover_boiler_luna_mp_389_long_description: 'Force summer mode',
         modbus_v3_boiler_luna_mp_reg_405_label: 'Domestic hot water internal setpoint',
         custom_popover_boiler_luna_mp_405_long_description: 'Domestic hot water internal setpoint',
         modbus_v3_boiler_luna_mp_reg_406_label: 'Central heating setpoint',
         custom_popover_boiler_luna_mp_406_long_description: 'Central heating setpoint',
         modbus_v3_boiler_luna_mp_reg_408_label: 'Domestic hot water flow temperature setpoint',
         custom_popover_boiler_luna_mp_408_long_description: 'Domestic hot water flow temperature setpoint',
         modbus_v3_boiler_luna_mp_reg_409_label: 'Water pressure',
         custom_popover_boiler_luna_mp_409_long_description: 'Water pressure',
         modbus_v3_boiler_luna_mp_reg_410_label: 'Flow rate',
         custom_popover_boiler_luna_mp_410_long_description: 'Flow rate',
         modbus_v3_boiler_luna_mp_reg_413_label: 'Actual relative power',
         custom_popover_boiler_luna_mp_413_long_description: 'Actual relative power',
         modbus_v3_boiler_luna_mp_reg_414_label: 'Power setpoint',
         custom_popover_boiler_luna_mp_414_long_description: 'Power setpoint',
         modbus_v3_boiler_luna_mp_reg_415_label: 'Flame current',
         custom_popover_boiler_luna_mp_415_long_description: 'Flame current',
         modbus_v3_boiler_luna_mp_reg_416_label: 'Internal heat demand power',
         custom_popover_boiler_luna_mp_416_long_description: 'Internal heat demand power',
         modbus_v3_boiler_luna_mp_reg_417_label: 'Internal heat demand temperature setpoint',
         custom_popover_boiler_luna_mp_417_long_description: 'Internal heat demand temperature setpoint',
         modbus_v3_boiler_luna_mp_reg_418_label: 'Internal heat demand type',
         custom_popover_boiler_luna_mp_418_long_description: 'Internal heat demand type',
         modbus_v3_boiler_luna_mp_reg_419_label: 'Burner/compressor starts',
         custom_popover_boiler_luna_mp_419_long_description: 'Burner/compressor starts',
         modbus_v3_boiler_luna_mp_reg_421_label: 'Burner operating hours',
         custom_popover_boiler_luna_mp_421_long_description: 'Burner operating hours',
         modbus_v3_boiler_luna_mp_reg_423_label: 'Backup 1 starts',
         custom_popover_boiler_luna_mp_423_long_description: 'Backup 1 starts',
         modbus_v3_boiler_luna_mp_reg_425_label: 'Backup 1 hours',
         custom_popover_boiler_luna_mp_425_long_description: 'Backup 1 hours',
         modbus_v3_boiler_luna_mp_reg_427_label: 'Backup 2 starts',
         custom_popover_boiler_luna_mp_427_long_description: 'Backup 2 starts',
         modbus_v3_boiler_luna_mp_reg_429_label: 'Backup 2 hours',
         custom_popover_boiler_luna_mp_429_long_description: 'Backup 2 hours',
         modbus_v3_boiler_luna_mp_reg_431_label: 'Operating hours',
         custom_popover_boiler_luna_mp_431_long_description: 'Operating hours',
         modbus_v3_boiler_luna_mp_reg_433_label: 'Central heating energy consumed',
         custom_popover_boiler_luna_mp_433_long_description: 'Central heating energy consumed',
         modbus_v3_boiler_luna_mp_reg_435_label: 'DHW energy consumed',
         custom_popover_boiler_luna_mp_435_long_description: 'DHW energy consumed',
         modbus_v3_boiler_luna_mp_reg_439_label: 'Total energy consumed',
         custom_popover_boiler_luna_mp_439_long_description: 'Total energy consumed',
         modbus_v3_boiler_luna_mp_reg_441_label: 'Backup energy consumed',
         custom_popover_boiler_luna_mp_441_long_description: 'Backup energy consumed',
         modbus_v3_boiler_luna_mp_reg_443_label: 'Total energy delivered',
         custom_popover_boiler_luna_mp_443_long_description: 'Total energy delivered',
         modbus_v3_boiler_luna_mp_reg_445_label: 'Central heating energy delivered',
         custom_popover_boiler_luna_mp_445_long_description: 'Central heating energy delivered',
         modbus_v3_boiler_luna_mp_reg_447_label: 'DHW energy delivered',
         custom_popover_boiler_luna_mp_447_long_description: 'DHW energy delivered',
         modbus_v3_boiler_luna_mp_reg_451_label: 'Backup energy delivered',
         custom_popover_boiler_luna_mp_451_long_description: 'Backup energy delivered',
         modbus_v3_boiler_luna_mp_reg_458_label: 'System flow setpoint',
         custom_popover_boiler_luna_mp_458_long_description: 'System flow setpoint',
         modbus_v3_boiler_luna_mp_reg_459_label: 'Pump speed',
         custom_popover_boiler_luna_mp_459_long_description: 'Pump speed',
         modbus_v3_boiler_luna_mp_reg_477_label: 'Minimum heating time before DHW production',
         custom_popover_boiler_luna_mp_477_long_description: 'Minimum heating time before DHW production',
         modbus_v3_boiler_luna_mp_reg_478_label: 'Maximum DHW production time',
         custom_popover_boiler_luna_mp_478_long_description: 'Maximum DHW production time',
         modbus_v3_boiler_luna_mp_reg_479_label: 'DHW ECO/COMFORT mode',
         modbus_v3_boiler_luna_mp_reg_479_label_list: '{"list":{"0":"Eco only - heat pump","1":"Comfort - heat pump/boiler"}}',
         custom_popover_boiler_luna_mp_479_long_description: 'DHW ECO/COMFORT mode',
         modbus_v3_boiler_luna_mp_reg_516_label: 'Burner starts since service',
         custom_popover_boiler_luna_mp_516_long_description: 'Burner starts since service',
         boiler_form_header: 'Boilers',
         substation_form_header: 'Substations',
         substation_add_form_header: 'Add substation',
         substation_add_new_button: 'Add new',
         substation_add_form_success: 'Substation imported successfully',
         substation_form_order_type_field: 'Order type',
         substation_device_name_characters_error: 'Device name should contain only capital alphabets and numbers.',
         substation_device_name_length_range_error: 'Device name length should be between 3 and 24 characters long.',
         substation_serial_number_mercurius_v3_length_error: 'Serial number mercurius length should be between 3 and 23 characters. It should contain only alphabets and numbers.',
         substation_serial_number_mercurius_identical_error: 'For V3 devices, the Serial Number Mercurius and Device Name must be identical.',
         substation_sim_card_number_v3_length_error: 'Sim card number length should be exactly 19 or 20 characters.',
         substation_production_date_format_error: 'Production date must be in format MM/DD/YYYY HH:mm:ss (e.g., 04/16/2021 13:39:00)',
         substation_default_soft_version_hex_error: 'Factory Default Software Version should be in hexadecimal.',
         substation_order_type_required_error: 'Order type is missing.',
         substation_order_type_invalid_error: 'Order type should be 1 or 2.',
         substation_form_order_type_general_option: 'General order in combination with HIU',
         substation_form_order_type_without_hiu_option: 'Order without HIU',
         substation_form_serial_number_mercurius_field: 'Serial number mercurius',
         substation_form_distinct_mercurius_type_field: 'Distinct mercurius type',
         substation_form_serial_number_field: 'Serial number',
         substation_form_production_date_field: 'Production date',
         substation_form_article_number_field: 'Article number',
         substation_form_description_field: 'Description',
         substation_form_order_number_field: 'Order number',
         substation_form_customer_ref_field: 'Customer reference',
         substation_form_prod_order_nr_field: 'Production order number',
         substation_form_sim_card_number_field: 'Sim card number',
         substation_form_default_controller_type_field: 'Default controller type',
         substation_form_default_soft_version_field: 'Default software version',
         substation_form_default_appliance_type_field: 'Default appliance type',
         substation_form_total_amount_order_field: 'Total amount order',
         substation_form_default_client_name_field: 'Default client name',
         substation_form_distributor_order_number_field: 'Distributor order number',
         substation_form_distributor_serial_number_field: 'Distributor serial number',
         substation_form_distributor_article_number_field: 'Distributor article number',
         substation_form_batch_number_field: 'Batch number',
         substation_form_is_stock_product_field: 'Is stock product',
         substation_device_name_required_error: 'Device name is missing.',
         substation_device_name_digits_error: 'Device name should only contain digits.',
         substation_device_name_length_error: 'Device name length should be exactly 5 characters.',
         substation_serial_number_mercurius_required_error: 'Serial number mercurius is missing.',
         substation_serial_number_mercurius_format_error: 'Serial number mercurius length should be exactly 24 characters. It should contain only alphabets and numbers.',
         substation_serial_number_required_error: 'Serial number is missing.',
         substation_serial_number_prefix_error: "Serial number should start with 'F' Letter.",
         substation_serial_number_alphanumeric_error: 'Serial number should contain only alphabets and numbers.',
         substation_sim_card_number_required_error: 'Sim card number is missing.',
         substation_sim_card_number_digits_error: 'Sim card number should only contain digits.',
         substation_sim_card_number_length_error: 'Sim card number length should be exactly 19 characters.',
         substation_article_number_required_error: 'Article number is missing.',
         substation_article_number_length_error: 'Article number length should be between 11 and 13 characters.',
         substation_order_number_required_error: 'Order number is missing.',
         substation_prod_order_nr_required_error: 'Production order number is missing.',
         substation_prod_order_nr_prefix_error: "Production order number should start with 'PR' Letters.",
         substation_prod_order_nr_characters_error: 'Production order number should contain only letters, numbers, dots, and dashes.',
         substation_prod_order_nr_length_error: 'Production order number length should be between 12 and 16 characters.',
         substation_production_date_required_error: 'Production date is missing.',
         substation_production_date_invalid_error: 'Invalid production date format.',
         substation_production_date_future_error: 'Production date cannot be in the future.',
         substation_import_failed_error: 'The substation could not be imported. Please review the errors below.',
         project_single_substations_tab: 'Substations',
         project_single_boilers_tab: 'Boilers',
         modbus_v3_substation_title: 'Substation',
         substation_alarms_reg_11100_label: 'Buiten acc. T',
         substation_alarms_reg_11161_label: 'Dauw punt T',
         substation_alarms_reg_11180_label: 'Gew. T comfort',
         substation_alarms_reg_11181_label: 'Gew. T bewaren',
         substation_alarms_reg_11201_label: 'S1 sensor',
         substation_alarms_reg_11215_label: 'Humidity',
         substation_alarms_reg_11501_label: 'Reference place',
         substation_alarms_reg_12180_label: 'Gew. T comfort',
         substation_alarms_reg_12181_label: 'Gew. T bewaren',
         substation_alarms_reg_12501_label: 'Reference place',
         substation_application_1_reg_11010_label: 'ECA addr.',
         substation_application_1_reg_11017_label: 'Demand offset',
         substation_application_1_reg_11022_label: 'P exercise',
         substation_application_1_reg_11023_label: 'M exercise',
         substation_application_1_reg_11040_label: 'P post-run',
         substation_application_1_reg_11077_label: 'P frost T',
         substation_application_1_reg_11078_label: 'P heat T',
         substation_application_1_reg_11093_label: 'Frost pr. T',
         substation_application_1_reg_11141_label: 'Ext. input',
         substation_application_1_reg_11142_label: 'Ext. mode',
         substation_application_1_reg_11179_label: 'Cut-out',
         substation_application_1_reg_11498_label: 'T out depend.',
         substation_application_1_reg_11500_label: 'Send desired T',
         substation_application_2_reg_12092_label: 'Standby T',
         substation_application_2_reg_12141_label: 'Ext. input',
         substation_application_2_reg_12142_label: 'Ext. mode',
         substation_application_2_reg_12144_label: 'Activation, acc. T',
         substation_application_2_reg_12156_label: 'Act. acc kamer T',
         substation_application_2_reg_12500_label: 'Send desired T',
         substation_circuit_1_heat_reg_11010_label: 'ECA adres',
         substation_circuit_1_heat_reg_11022_label: 'P exercise',
         substation_circuit_1_heat_reg_11023_label: 'M exercise',
         substation_circuit_1_heat_reg_11040_label: 'P post-run',
         substation_circuit_1_heat_reg_11077_label: 'P vorst T',
         substation_circuit_1_heat_reg_11078_label: 'P verwarming T',
         substation_circuit_1_heat_reg_11093_label: 'Vorst pr. T',
         substation_circuit_1_return_reg_11210_label: 'S10 sensor',
         substation_circuit_1_return_reg_11260_label: 'S10 Sensor reference',
         substation_circuit_1_room_reg_11031_label: 'Hoog T uit X1',
         substation_circuit_1_room_reg_11032_label: 'Grens laag Y1',
         substation_circuit_1_room_reg_11033_label: 'Laag T uit X2',
         substation_circuit_1_room_reg_11034_label: 'Grens hoog Y2',
         substation_circuit_1_room_reg_11035_label: 'Infl. - max.',
         substation_circuit_1_room_reg_11036_label: 'Infl. - min.',
         substation_circuit_1_room_reg_11037_label: 'Adapt. tijd',
         substation_circuit_1_supply_reg_11154_label: 'Filt. Acc. buiten T',
         substation_circuit_1_supply_reg_11175_label: 'Stooklijn',
         substation_circuit_1_supply_reg_11177_label: 'Temp. min.',
         substation_circuit_1_supply_reg_11178_label: 'Temp. max.',
         substation_circuit_1_supply_reg_11253_label: 'Gewenste flow T',
         substation_circuit_1_supply_reg_11400_label: 'Y1',
         substation_circuit_1_supply_reg_11401_label: 'Y2',
         substation_circuit_1_supply_reg_11402_label: 'Y3',
         substation_circuit_1_supply_reg_11403_label: 'Y4',
         substation_circuit_1_supply_reg_11404_label: 'Y5',
         substation_circuit_1_supply_reg_11405_label: 'Y6',
         substation_circuit_2_heat_reg_11038_label: 'Stop bij T uit',
         substation_circuit_2_heat_reg_11083_label: 'Add. funktie',
         substation_circuit_2_heat_reg_11089_label: 'Acc. uitg. funktie',
         substation_circuit_2_supply_reg_11141_label: 'Ext. ingang',
         substation_circuit_2_supply_reg_11142_label: 'Ext. mode',
         substation_circuit_2_supply_reg_11179_label: 'Cut-out',
         substation_circuit_2_supply_reg_11498_label: 'T out depend.',
         substation_circuit_2_supply_reg_11500_label: 'Zenden gew. T',
         substation_compensating1_2_reg_12060_label: 'Limit',
         substation_compensating1_2_reg_12061_label: 'Adapt. time',
         substation_compensating1_2_reg_12063_label: 'Infl. - min.',
         substation_compensating1_2_reg_12256_label: 'S6 Sensor reference',
         substation_control_parameter_1_reg_11024_label: 'Actuator',
         substation_control_parameter_1_reg_11174_label: 'Motor pr.',
         substation_control_parameter_1_reg_11184_label: 'Xp',
         substation_control_parameter_1_reg_11185_label: 'Tn',
         substation_control_parameter_1_reg_11186_label: 'M run',
         substation_control_parameter_1_reg_11187_label: 'Nz',
         substation_control_parameter_1_reg_11189_label: 'Min. act. time',
         substation_cooling_reg_10500_label: 'Min Outdoor Temp',
         substation_cooling_reg_10501_label: 'Min Hour Time',
         substation_cooling_reg_10502_label: 'Min Minute Time',
         substation_cooling_reg_10503_label: 'Cooling Reg 10503',
         substation_cooling_reg_10504_label: 'Cooling Reg 10504',
         substation_cooling_reg_10505_label: 'Max Outdoor Temp',
         substation_cooling_reg_10506_label: 'Max Hou Time',
         substation_cooling_reg_10507_label: 'Max Minute Time',
         substation_cooling_reg_10508_label: 'Cooling Reg 10508',
         substation_cooling_reg_10509_label: 'Cooling Reg 10509',
         substation_cooling_reg_10510_label: 'Outdoor Trend',
         substation_cooling_reg_10603_label: 'Digitaal S7',
         substation_cooling_reg_10643_label: 'Digitaal S9',
         substation_data_log_reg_10198_label: 'Autom. daglicht',
         substation_data_log_reg_10398_label: 'Scada heatoffset/setpoint',
         substation_data_log_reg_10399_label: 'Scada Timeout',
         substation_data_log_reg_10400_label: 'Scada Outdoor temperature',
         substation_data_log_reg_10401_label: 'Scada heat offset 1',
         substation_data_log_reg_10402_label: 'Scada heat offset 2',
         substation_data_log_reg_10403_label: 'Scada heat offset 3',
         substation_data_log_reg_10404_label: 'Scada heat offset 4',
         substation_data_log_reg_10409_label: 'SCADA slave request',
         substation_data_log_reg_10410_label: 'SCADA resulting reference',
         substation_data_log_reg_10420_label: 'Scada Schedule timeout',
         substation_data_log_reg_2048_label: 'ECL 485 addr.',
         substation_data_log_reg_2049_label: 'Modbus bias',
         substation_data_log_reg_2050_label: 'Taal',
         substation_data_log_reg_2150_label: 'Service pin',
         substation_data_log_reg_2151_label: 'Ext. reset',
         substation_data_log_reg_2152_label: 'Inbound accept',
         substation_data_log_reg_2153_label: 'Portal encryption',
         substation_data_log_reg_2160_label: 'ECL Portal',
         substation_data_log_reg_2161_label: 'Connectie status',
         substation_data_log_reg_2162_label: 'Poort status',
         substation_data_log_reg_2240_label: 'DNS IP1 1',
         substation_data_log_reg_2244_label: 'DNS IP2 1',
         substation_data_log_reg_258_label: 'Adres type',
         substation_data_log_reg_278_label: 'IP 1',
         substation_data_log_reg_282_label: 'Poort IP 1',
         substation_data_log_reg_286_label: 'Net Mask 1',
         substation_data_log_reg_38_label: 'Modbus adres',
         substation_data_log_reg_39_label: 'Baud',
         substation_data_log_reg_4236_label: 'AccumulatedPulse 1',
         substation_data_log_reg_4238_label: 'AccumulatedPulse 2',
         substation_data_log_reg_4240_label: 'AccumulatedPulse 3',
         substation_data_log_reg_5994_label: 'GW Command request',
         substation_data_log_reg_5995_label: 'GW State',
         substation_data_log_reg_5996_label: 'GW Telegram size',
         substation_data_log_reg_5997_label: 'Baud',
         substation_data_log_reg_5998_label: 'Commando',
         substation_data_log_reg_5999_label: 'Status',
         substation_data_log_reg_60058_label: 'Achtergrond licht',
         substation_data_log_reg_60059_label: 'Contrast',
         substation_dhw_reg_11158_label: 'Stat. luchtv. Diff',
         substation_dhw_reg_11159_label: 'St. luchtv. post T',
         substation_dhw_reg_11160_label: 'Stat. luchtv. Setp.',
         substation_dhw_settings_reg_12164_label: 'Dauw p. T offset',
         substation_dhw_settings_reg_12172_label: 'Koellijn',
         substation_dhw_settings_reg_12177_label: 'Temp. min.',
         substation_dhw_settings_reg_12178_label: 'Temp. max.',
         substation_ecl_alarm_reg_1024_label: 'Alarm field 2',
         substation_ecl_alarm_reg_1025_label: 'Alarm field 1',
         substation_ecl_alarm_reg_1032_label: 'Alarm clear 2',
         substation_ecl_alarm_reg_1033_label: 'Alarm clear 1',
         substation_ecl_alarm_reg_2052_label: 'Sensor monitor valid mask1',
         substation_ecl_alarm_reg_2054_label: 'Sensor monitor error mask1',
         substation_ecl_extension_reg_2150_label: 'Service pin',
         substation_ecl_extension_reg_2151_label: 'Ext. reset',
         substation_ecl_system_ex_reg_4236_label: 'AccumulatedPulse 1',
         substation_ecl_system_ex_reg_4238_label: 'AccumulatedPulse 2',
         substation_ecl_system_ex_reg_4240_label: 'AccumulatedPulse 3',
         substation_ecl_system_reg_10198_label: 'Aut. daylight',
         substation_ecl_system_reg_19_label: 'Code no.',
         substation_ecl_system_reg_1_label: 'System Command',
         substation_ecl_system_reg_2048_label: 'ECL 485 addr.',
         substation_ecl_system_reg_2049_label: 'Modbus bias.',
         substation_ecl_system_reg_2050_label: 'Language',
         substation_ecl_system_reg_2097_label: 'Wink',
         substation_ecl_system_reg_2099_label: 'Production week',
         substation_ecl_system_reg_34_label: 'Hardware',
         substation_ecl_system_reg_35_label: 'Software',
         substation_ecl_system_reg_36_label: 'Serial no.',
         substation_ecl_system_reg_38_label: 'Modbus addr.',
         substation_ecl_system_reg_39_label: 'Baud',
         substation_ecl_system_reg_60058_label: 'Backlight',
         substation_ecl_system_reg_60059_label: 'Contrast',
         substation_ecl_system_reg_8_label: 'Build no.',
         substation_ethernet_reg_2152_label: 'Inbound accept',
         substation_ethernet_reg_2153_label: 'Portal encryption',
         substation_ethernet_reg_2160_label: 'ECL Portal',
         substation_ethernet_reg_2161_label: 'Connection status',
         substation_ethernet_reg_2162_label: 'Portal status',
         substation_ethernet_reg_2240_label: 'DNS IP1 1',
         substation_ethernet_reg_2244_label: 'DNS IP2 1',
         substation_ethernet_reg_258_label: 'Address type',
         substation_ethernet_reg_278_label: 'IP 1',
         substation_ethernet_reg_282_label: 'Gateway IP 1',
         substation_ethernet_reg_286_label: 'Net Mask 1',
         substation_flow_temperature_1_reg_11154_label: 'Filt. acc. outdoor T',
         substation_flow_temperature_1_reg_11175_label: 'Heat curve',
         substation_flow_temperature_1_reg_11177_label: 'Temp. min.',
         substation_flow_temperature_1_reg_11178_label: 'Temp. max.',
         substation_flow_temperature_1_reg_11253_label: 'Des. flow T',
         substation_flow_temperature_1_reg_11400_label: 'Y1',
         substation_flow_temperature_1_reg_11401_label: 'Y2',
         substation_flow_temperature_1_reg_11402_label: 'Y3',
         substation_flow_temperature_1_reg_11403_label: 'Y4',
         substation_flow_temperature_1_reg_11404_label: 'Y5',
         substation_flow_temperature_1_reg_11405_label: 'Y6',
         substation_flow_temperature_2_reg_12164_label: 'Dew point T offset',
         substation_flow_temperature_2_reg_12172_label: 'Cooling curve',
         substation_flow_temperature_2_reg_12177_label: 'Temp. min.',
         substation_flow_temperature_2_reg_12178_label: 'Temp. max.',
         substation_flow_temperature_2_reg_12253_label: 'Des. flow T',
         substation_flow_temperature_2_reg_12400_label: 'Y1',
         substation_flow_temperature_2_reg_12401_label: 'Y2',
         substation_flow_temperature_2_reg_12402_label: 'Y3',
         substation_flow_temperature_2_reg_12403_label: 'Y4',
         substation_flow_temperature_2_reg_12404_label: 'Y5',
         substation_flow_temperature_2_reg_12405_label: 'Y6',
         substation_general_1_reg_10500_label: 'Min Outdoor Temp',
         substation_general_1_reg_10501_label: 'Min Hour Time',
         substation_general_1_reg_10502_label: 'Min Minute Time',
         substation_general_1_reg_10505_label: 'Max Outdoor Temp',
         substation_general_1_reg_10506_label: 'Max Hou Time',
         substation_general_1_reg_10507_label: 'Max Minute Time',
         substation_general_1_reg_10510_label: 'Outdoor Trend',
         substation_general_1_reg_10603_label: 'Digital S7',
         substation_general_1_reg_10643_label: 'Digital S9',
         substation_general_1_reg_11100_label: 'Outdoor acc. T',
         substation_general_1_reg_11161_label: 'Dew point T',
         substation_general_1_reg_11180_label: 'Des. T comfort',
         substation_general_1_reg_11181_label: 'Des. T saving',
         substation_general_1_reg_11201_label: 'S1 sensor',
         substation_general_1_reg_11330_label: 'Wake up level',
         substation_general_1_reg_11215_label: 'Humidity',
         substation_general_1_reg_11501_label: 'Reference place',
         substation_general_1_reg_4201_label: 'Mode',
         substation_general_1_reg_4211_label: 'Circuit 1 status',
         substation_general_1_reg_4220_label: 'Circuit 1 limiter flags 1',
         substation_general_1_reg_4221_label: 'Circuit 1 limiter flags 2',
         substation_general_1_reg_4222_label: 'Circuit 1 limiter flags 3',
         substation_general_1_reg_4223_label: 'Circuit 1 limiter flags 4',
         substation_general_2_reg_12180_label: 'Des. T comfort',
         substation_general_2_reg_12181_label: 'Des. T saving',
         substation_general_2_reg_12501_label: 'Reference place',
         substation_general_2_reg_4202_label: 'Mode',
         substation_general_2_reg_4212_label: 'Circuit 2 status',
         substation_general_2_reg_4224_label: 'Circuit 2 limiter flags 1',
         substation_general_5_reg_4215_label: 'Circuit 5 status',
         substation_general_5_reg_4246_label: 'Circuit 5 limiter flags 1',
         substation_general_5_reg_4247_label: 'Circuit 5 limiter flags 2',
         substation_general_5_reg_4248_label: 'Circuit 5 limiter flags 3',
         substation_general_5_reg_4249_label: 'Circuit 5 limiter flags 4',
         substation_general_6_reg_4216_label: 'Circuit 6 status',
         substation_general_6_reg_4250_label: 'Circuit 6 limiter flags 1',
         substation_general_6_reg_4251_label: 'Circuit 6 limiter flags 2',
         substation_general_6_reg_4252_label: 'Circuit 6 limiter flags 3',
         substation_general_6_reg_4253_label: 'Circuit 6 limiter flags 4',
         substation_io_test_reg_10201_label: 'S1 sensor',
         substation_io_test_reg_10202_label: 'S2 sensor',
         substation_io_test_reg_10203_label: 'S3 sensor',
         substation_io_test_reg_10204_label: 'S4 sensor',
         substation_io_test_reg_10205_label: 'S5 sensor',
         substation_io_test_reg_10206_label: 'S6 sensor',
         substation_io_test_reg_10207_label: 'S7 sensor',
         substation_io_test_reg_10208_label: 'S8 sensor',
         substation_io_test_reg_10209_label: 'S9 sensor',
         substation_io_test_reg_10210_label: 'S10 sensor',
         substation_io_test_reg_10211_label: 'S11 sensor',
         substation_io_test_reg_10212_label: 'S12 sensor',
         substation_io_test_reg_10213_label: 'Room Unit A, Sensor 1',
         substation_io_test_reg_10216_label: 'Room Unit B, Sensor 1',
         substation_m_bus_config_reg_5994_label: 'GW Command request',
         substation_m_bus_config_reg_5995_label: 'GW State',
         substation_m_bus_config_reg_5996_label: 'GW Telegram size',
         substation_m_bus_config_reg_5997_label: 'Baud',
         substation_m_bus_config_reg_5998_label: 'Command',
         substation_m_bus_config_reg_5999_label: 'State',
         substation_network_reg_12060_label: 'Grens',
         substation_network_reg_12061_label: 'Adapt. tijd',
         substation_network_reg_12063_label: 'Infl. - min.',
         substation_network_reg_12256_label: 'S6 Sensor reference',
         substation_optimization_1_reg_11011_label: 'Auto saving',
         substation_optimization_1_reg_11012_label: 'Boost',
         substation_optimization_1_reg_11014_label: 'Optimizer',
         substation_optimization_1_reg_11020_label: 'Based on',
         substation_optimization_1_reg_11021_label: 'Total stop',
         substation_optimization_1_reg_11026_label: 'Pre-stop',
         substation_outdoor_reg_11011_label: 'Autom. opslaan',
         substation_outdoor_reg_11012_label: 'Boost',
         substation_outdoor_reg_11014_label: 'Optimalisatie',
         substation_outdoor_reg_11020_label: 'Gebaseerd op',
         substation_outdoor_reg_11021_label: 'Totale stop',
         substation_outdoor_reg_11026_label: 'Pre-stop',
         substation_output_control_1_reg_11038_label: 'Stop at T out',
         substation_output_control_1_reg_11083_label: 'Add. function',
         substation_output_control_1_reg_11089_label: 'Acc. output function',
         substation_output_control_1_reg_11158_label: 'Stat. ventilation diff.',
         substation_output_control_1_reg_11159_label: 'Stat. ventilation post-run',
         substation_output_control_1_reg_11160_label: 'Stat. ventilation setp.',
         substation_output_status_reg_3995_label: 'Estimated Motor Position 1',
         substation_output_status_reg_3996_label: 'Estimated Motor Position 2',
         substation_output_status_reg_3997_label: 'Estimated Motor Position 3',
         substation_output_status_reg_4000_label: 'Triac 1',
         substation_output_status_reg_4001_label: 'Triac 2',
         substation_output_status_reg_4002_label: 'Triac 3',
         substation_output_status_reg_4003_label: 'Triac 4',
         substation_output_status_reg_4004_label: 'Triac 5',
         substation_output_status_reg_4005_label: 'Triac 6',
         substation_output_status_reg_4006_label: 'Relay 1',
         substation_output_status_reg_4007_label: 'Relay 2',
         substation_output_status_reg_4008_label: 'Relay 3',
         substation_output_status_reg_4009_label: 'Relay 4',
         substation_output_status_reg_4010_label: 'Relay 5',
         substation_output_status_reg_4011_label: 'Relay 6',
         substation_output_status_reg_4019_label: 'ECA35 PWM4',
         substation_outputs_reg_4201_label: 'Mode',
         substation_outputs_reg_4202_label: 'Mode',
         substation_outputs_reg_4211_label: 'Circuit 1 status',
         substation_outputs_reg_4212_label: 'Circuit 2 status',
         substation_outputs_reg_4220_label: 'Circuit 1 limiter flags 1',
         substation_outputs_reg_4221_label: 'Circuit 1 limiter flags 2',
         substation_outputs_reg_4222_label: 'Circuit 1 limiter flags 3',
         substation_outputs_reg_4223_label: 'Circuit 1 limiter flags 4',
         substation_outputs_reg_4224_label: 'Circuit 2 limiter flags 1',
         substation_raw_sensor_reg_10201_label: 'S1 sensor',
         substation_raw_sensor_reg_10202_label: 'S2 sensor',
         substation_raw_sensor_reg_10203_label: 'S3 sensor',
         substation_raw_sensor_reg_10204_label: 'S4 sensor',
         substation_raw_sensor_reg_10205_label: 'S5 sensor',
         substation_raw_sensor_reg_10206_label: 'S6 sensor',
         substation_raw_sensor_reg_10207_label: 'S7 sensor',
         substation_raw_sensor_reg_10208_label: 'S8 sensor',
         substation_raw_sensor_reg_10209_label: 'S9 sensor',
         substation_raw_sensor_reg_10210_label: 'S10 sensor',
         substation_raw_sensor_reg_10211_label: 'S11 sensor',
         substation_raw_sensor_reg_10212_label: 'S12 sensor',
         substation_raw_sensor_reg_10213_label: 'Room Unit A, Sensor 1',
         substation_raw_sensor_reg_10216_label: 'Room Unit B, Sensor 1',
         substation_return_limit_1_reg_11031_label: 'High T out X1',
         substation_return_limit_1_reg_11032_label: 'Low limit Y1',
         substation_return_limit_1_reg_11033_label: 'Low T out X2',
         substation_return_limit_1_reg_11034_label: 'High limit Y2',
         substation_return_limit_1_reg_11035_label: 'Infl. - max.',
         substation_return_limit_1_reg_11036_label: 'Infl. - min.',
         substation_return_limit_1_reg_11037_label: 'Adapt. time',
         substation_return_limit_1_reg_11210_label: 'S10 sensor',
         substation_return_limit_1_reg_11260_label: 'S10 Sensor reference',
         substation_return_limit_2_reg_12030_label: 'Limit',
         substation_return_limit_2_reg_12035_label: 'Infl. - max.',
         substation_return_limit_2_reg_12036_label: 'Infl. - min.',
         substation_return_limit_2_reg_12037_label: 'Adapt. time',
         substation_return_limit_2_reg_12210_label: 'S10 sensor',
         substation_return_limit_2_reg_12260_label: 'S10 Sensor reference',
         substation_scada_override_reg_10398_label: 'Scada heatoffset/setpoint',
         substation_scada_override_reg_10399_label: 'Scada Timeout',
         substation_scada_override_reg_10400_label: 'Scada Outdoor temperature',
         substation_scada_override_reg_10401_label: 'Scada heat offset 1',
         substation_scada_override_reg_10402_label: 'Scada heat offset 2',
         substation_scada_override_reg_10403_label: 'Scada heat offset 3',
         substation_scada_override_reg_10404_label: 'Scada heat offset 4',
         substation_scada_override_reg_10405_label: 'Scada boiler ctrl 1',
         substation_scada_override_reg_10406_label: 'Scada boiler ctrl 2',
         substation_scada_override_reg_10407_label: 'Scada boiler ctrl 3',
         substation_scada_override_reg_10408_label: 'Scada boiler ctrl 4',
         substation_scada_override_reg_10409_label: 'SCADA slave request',
         substation_scada_override_reg_10410_label: 'SCADA resulting reference',
         substation_scada_override_reg_10420_label: 'Scada Schedule timeout',
         substation_scada_override_reg_10421_label: 'Scada Schedule 1',
         substation_scada_override_reg_10422_label: 'Scada Schedule 2',
         substation_scada_override_reg_10423_label: 'Scada Schedule 3',
         substation_scada_override_reg_10424_label: 'Scada Schedule 4',
         substation_scada_override_reg_10425_label: 'Scada Schedule 5',
         substation_scada_override_reg_10426_label: 'Scada Schedule 6',
         substation_scada_override_reg_10427_label: 'Scada Optim value 1',
         substation_scada_override_reg_10428_label: 'Scada Optim value 2',
         substation_scada_override_reg_10429_label: 'Scada Optim value 3',
         substation_scada_override_reg_10430_label: 'Scada Optim value 4',
         substation_scada_override_reg_10431_label: 'Scada Optim value 5',
         substation_scada_override_reg_10432_label: 'Scada Optim value 6',
         substation_sensors_reg_11024_label: 'Aandrijving',
         substation_sensors_reg_11174_label: 'Motor pr.',
         substation_sensors_reg_11184_label: 'Xp',
         substation_sensors_reg_11185_label: 'Tn',
         substation_sensors_reg_11186_label: 'M run',
         substation_sensors_reg_11187_label: 'Nz',
         substation_sensors_reg_11189_label: 'Min. act. tijd',
         substation_statistics_reg_4215_label: 'Circuit 5 status',
         substation_statistics_reg_4216_label: 'Circuit 6 status',
         substation_statistics_reg_4246_label: 'Circuit 5 limiter flags 1',
         substation_statistics_reg_4247_label: 'Circuit 5 limiter flags 2',
         substation_statistics_reg_4248_label: 'Circuit 5 limiter flags 3',
         substation_statistics_reg_4249_label: 'Circuit 5 limiter flags 4',
         substation_statistics_reg_4250_label: 'Circuit 6 limiter flags 1',
         substation_statistics_reg_4251_label: 'Circuit 6 limiter flags 2',
         substation_statistics_reg_4252_label: 'Circuit 6 limiter flags 3',
         substation_statistics_reg_4253_label: 'Circuit 6 limiter flags 4',
         substation_system_info_reg_1024_label: 'Alarm field 2',
         substation_system_info_reg_1025_label: 'Alarm field 1',
         substation_system_info_reg_1032_label: 'Alarm clear 2',
         substation_system_info_reg_1033_label: 'Alarm clear 1',
         substation_system_info_reg_2052_label: 'Sensor monitor valid mask1',
         substation_system_info_reg_2054_label: 'Sensor monitor error mask1',
         substation_system_reg_12253_label: 'Gewenste flow T',
         substation_system_reg_12400_label: 'Y1',
         substation_system_reg_12401_label: 'Y2',
         substation_system_reg_12402_label: 'Y3',
         substation_system_reg_12403_label: 'Y4',
         substation_system_reg_12404_label: 'Y5',
         substation_system_reg_12405_label: 'Y6',
         substation_temp_monitoring_1_reg_12092_label: 'Standby T',
         substation_temp_monitoring_1_reg_12141_label: 'Ext. ingang',
         substation_temp_monitoring_1_reg_12142_label: 'Ext. mode',
         substation_temp_monitoring_1_reg_12144_label: 'Activation, acc. T',
         substation_temp_monitoring_1_reg_12156_label: 'Act. acc kamer T',
         substation_temp_monitoring_1_reg_12500_label: 'Zenden gew. T',
         substation_temp_monitoring_2_reg_12147_label: 'Upper difference',
         substation_temp_monitoring_2_reg_12148_label: 'Lower difference',
         substation_temp_monitoring_2_reg_12149_label: 'Delay',
         substation_temp_monitoring_2_reg_12150_label: 'Lowest temp.',
         substation_time_program_reg_3995_label: 'Estimated Motor Position 1',
         substation_time_program_reg_3996_label: 'Estimated Motor Position 2',
         substation_time_program_reg_3997_label: 'Estimated Motor Position 3',
         substation_time_program_reg_4000_label: 'Triac 1',
         substation_time_program_reg_4001_label: 'Triac 2',
         substation_time_program_reg_4002_label: 'Triac 3',
         substation_time_program_reg_4003_label: 'Triac 4',
         substation_time_program_reg_4004_label: 'Triac 5',
         substation_time_program_reg_4005_label: 'Triac 6',
         substation_time_program_reg_4006_label: 'Relay 1',
         substation_time_program_reg_4007_label: 'Relay 2',
         substation_time_program_reg_4008_label: 'Relay 3',
         substation_time_program_reg_4009_label: 'Relay 4',
         substation_time_program_reg_4010_label: 'Relay 5',
         substation_time_program_reg_4011_label: 'Relay 6',
         substation_time_program_reg_4019_label: 'ECA35 PWM4',
         substation_user_params_reg_12030_label: 'Grens',
         substation_user_params_reg_12035_label: 'Infl. - max.',
         substation_user_params_reg_12036_label: 'Infl. - min.',
         substation_user_params_reg_12037_label: 'Adapt. tijd',
         substation_user_params_reg_12210_label: 'S10 sensor',
         substation_user_params_reg_12260_label: 'S10 Sensor reference',
         substation_user_params_reg_19_label: 'Code nr.',
         substation_user_params_reg_1_label: 'System Command',
         substation_user_params_reg_2099_label: 'Productie week',
         substation_user_params_reg_34_label: 'Hardware',
         substation_user_params_reg_35_label: 'Software',
         substation_user_params_reg_36_label: 'Serie nr.',
         substation_user_params_reg_8_label: 'Prod nr.',
         substation_general_1_reg_4201_label_list: JSON.stringify({
           list: {
             0: 'Manual',
             1: 'Schedule',
             2: 'Constant comfort',
             3: 'Constant setback',
             4: 'Frost protection',
           },
         }),
         substation_general_1_reg_4211_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_2_reg_4202_label_list: JSON.stringify({
           list: {
             0: 'Manual',
             1: 'Schedule',
             2: 'Constant comfort',
             3: 'Constant setback',
             4: 'Frost protection',
           },
         }),
         substation_general_2_reg_4212_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_5_reg_4215_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_6_reg_4216_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_input_config_reg_4100_label: 'Config type S7',
         substation_input_config_reg_4100_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
             5: 'Pulse',
             6: 'Frequency',
           },
         }),
         substation_input_config_reg_4101_label: 'Config type S8',
         substation_input_config_reg_4101_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
             4: 'Flow switch',
           },
         }),
         substation_input_config_reg_4102_label: 'Config type S9',
         substation_input_config_reg_4102_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4103_label: 'Config type S10',
         substation_input_config_reg_4103_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4104_label: 'Config type S11',
         substation_input_config_reg_4104_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4105_label: 'Config type S12',
         substation_input_config_reg_4105_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4120_label: 'Config option S7',
         substation_input_config_reg_4120_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4121_label: 'Config option S8',
         substation_input_config_reg_4121_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4122_label: 'Config option S9',
         substation_input_config_reg_4122_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4123_label: 'Config option S10',
         substation_input_config_reg_4123_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4124_label: 'Config option S11',
         substation_input_config_reg_4124_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4125_label: 'Config option S12',
         substation_alarm1_1_reg_11614_label: 'Alarm high',
         substation_alarm1_1_reg_11615_label: 'Alarm low',
         substation_alarm1_1_reg_11617_label: 'Alarm time-out',
         substation_application_1_reg_11024_label: 'Actuator',
         substation_application_1_reg_11050_label: 'P demand',
         substation_application_1_reg_11052_label: 'DHW priority',
         substation_application_1_reg_11070_label: 'P cool T',
         substation_application_1_reg_11084_label: 'Ext. signal',
         substation_application_1_reg_11092_label: 'Standby T',
         substation_application_1_reg_11327_label: 'Input type',
         substation_compensating1_1_reg_11060_label: 'Limit',
         substation_compensating1_1_reg_11061_label: 'Adapt. time',
         substation_compensating1_1_reg_11062_label: 'Infl. - max.',
         substation_compensating1_1_reg_11063_label: 'Infl. - min.',
         substation_compensating2_1_reg_11064_label: 'Limit',
         substation_compensating2_1_reg_11065_label: 'Adapt. time',
         substation_compensating2_1_reg_11066_label: 'Infl. - max.',
         substation_compensating2_1_reg_11067_label: 'Infl. - min.',
         substation_control_parameter_1_reg_11017_label: 'Demand offset',
         substation_control_parameter_1_reg_11097_label: 'Supply T (idle)',
         substation_control_parameter_1_reg_11145_label: 'Mon. T select',
         substation_control_parameter_1_reg_11330_label: 'Wake up level',
         substation_control_parameter_1_reg_11364_label: 'Control, delay',
         substation_control_parameter_1_reg_11700_label: 'Await time',
         substation_control_parameter_2_reg_12165_label: 'V out max.',
         substation_control_parameter_2_reg_12167_label: 'V out min.',
         substation_control_parameter_2_reg_12184_label: 'Xp',
         substation_control_parameter_2_reg_12185_label: 'Tn',
         substation_control_parameter_2_reg_12187_label: 'Nz',
         substation_control_parameter_2_reg_12197_label: 'Td',
         substation_control_parameter_2_reg_12322_label: 'Pressure, diff.',
         substation_control_parameter_5_reg_15113_label: 'Filter constant',
         substation_control_parameter_5_reg_15352_label: 'Position',
         substation_control_parameter_5_reg_15607_label: 'Low X',
         substation_control_parameter_5_reg_15608_label: 'High X',
         substation_control_parameter_5_reg_15609_label: 'Low Y',
         substation_control_parameter_5_reg_15610_label: 'High Y',
         substation_energy_meter_1_reg_6000_label: 'M-bus address',
         substation_energy_meter_1_reg_6001_label: 'Type',
         substation_energy_meter_1_reg_6002_label: 'Scan time',
         substation_energy_meter_1_reg_6003_label: 'ID',
         substation_energy_meter_1_reg_6005_label: 'Meter Status',
         substation_energy_meter_1_reg_6006_label: 'Flow T',
         substation_energy_meter_1_reg_6007_label: 'Return T',
         substation_energy_meter_1_reg_6008_label: 'Flow',
         substation_energy_meter_1_reg_6010_label: 'Power',
         substation_energy_meter_1_reg_6012_label: 'Volume',
         substation_energy_meter_1_reg_6014_label: 'Energy',
         substation_energy_meter_1_reg_6016_label: 'Flow MAX',
         substation_energy_meter_1_reg_6018_label: 'Power MAX',
         substation_energy_meter_1_reg_6020_label: 'Flow T MAX',
         substation_energy_meter_1_reg_6021_label: 'Return T MAX',
         substation_energy_meter_1_reg_6022_label: 'Energy Storage',
         substation_ethernet_reg_2165_label: 'Server name, char 1',
         substation_ethernet_reg_2230_label: 'Password, char 1',
         substation_flow_power_limit_1_reg_11109_label: 'Input type',
         substation_flow_power_limit_1_reg_11110_label: 'Actual',
         substation_flow_power_limit_1_reg_11111_label: 'Limit',
         substation_flow_power_limit_1_reg_11112_label: 'Adapt. time',
         substation_flow_power_limit_1_reg_11113_label: 'Filter constant',
         substation_flow_power_limit_1_reg_11115_label: 'Units',
         substation_flow_power_limit_1_reg_11116_label: 'High limit Y2',
         substation_flow_power_limit_1_reg_11117_label: 'Low limit Y1',
         substation_flow_power_limit_1_reg_11118_label: 'Low T out X2',
         substation_flow_power_limit_1_reg_11119_label: 'High T out X1',
         substation_flow_temperature_1_reg_11004_label: 'Desired T',
         substation_flow_temperature_1_reg_11079_label: 'Max. flow T',
         substation_flow_temperature_1_reg_11080_label: 'Delay',
         substation_flow_temperature_1_reg_11101_label: 'Ext. desired T',
         substation_flow_temperature_1_reg_11297_label: 'Temperature reference',
         substation_flow_temperature_1_reg_11301_label: 'High T max Y2',
         substation_flow_temperature_1_reg_11303_label: 'Low T max Y1',
         substation_flow_temperature_1_reg_11609_label: 'Low Y',
         substation_flow_temperature_1_reg_11610_label: 'High Y',
         substation_general_1_reg_11018_label: 'Des. T comfort',
         substation_general_1_reg_11019_label: 'Des. T saving',
         substation_general_1_reg_11040_label: 'P post-run',
         substation_general_1_reg_11203_label: 'S3 Sensor',
         substation_general_1_reg_11204_label: 'S4 Sensor',
         substation_general_1_reg_11205_label: 'S5 Sensor',
         substation_general_1_reg_11247_label: 'Selected temperature',
         substation_general_1_reg_11331_label: 'Sleep level',
         substation_general_1_reg_11332_label: 'Sleep mode time',
         substation_general_1_reg_11333_label: 'Boost',
         substation_general_3_reg_4213_label: 'Circuit 3 status',
         substation_general_4_reg_4214_label: 'Circuit 4 status',
         substation_input_config_reg_4106_label: 'ECA 32 Config type S13',
         substation_input_config_reg_4107_label: 'ECA 32 Config type S14',
         substation_input_config_reg_4108_label: 'ECA 32 Config type S15',
         substation_input_config_reg_4109_label: 'ECA 32 Config type S16',
         substation_input_config_reg_4110_label: 'ECA 32 Config type S17',
         substation_input_config_reg_4111_label: 'ECA 32 Config type S18',
         substation_input_config_reg_4126_label: 'ECA 32 Config option S13',
         substation_input_config_reg_4127_label: 'ECA 32 Config option S14',
         substation_input_config_reg_4128_label: 'ECA 32 Config option S15',
         substation_input_config_reg_4129_label: 'ECA 32 Config option S16',
         substation_input_config_reg_4130_label: 'ECA 32 Config option S17',
         substation_input_config_reg_4131_label: 'ECA 32 Config option S18',
         substation_optimization_1_reg_11013_label: 'Ramp',
         substation_optimization_1_reg_11179_label: 'Summer, cut-out',
         substation_optimization_1_reg_11392_label: 'Sum. start, month',
         substation_optimization_1_reg_11393_label: 'Sum. start, day',
         substation_optimization_1_reg_11395_label: 'Summer, filter',
         substation_optimization_1_reg_11396_label: 'Win. start, month',
         substation_optimization_1_reg_11397_label: 'Winter start, day',
         substation_optimization_1_reg_11398_label: 'Winter, cut-out',
         substation_optimization_1_reg_11399_label: 'Winter, filter',
         substation_output_manual_status_reg_4056_label: 'ECA32 AO1 Value',
         substation_output_manual_status_reg_4057_label: 'ECA32 AO2 Value',
         substation_output_manual_status_reg_4058_label: 'ECA32 AO3 Value',
         substation_output_status_reg_4012_label: 'ECA32 Relay 1',
         substation_output_status_reg_4013_label: 'ECA32 Relay 2',
         substation_output_status_reg_4014_label: 'ECA32 Relay 3',
         substation_output_status_reg_4015_label: 'ECA32 Relay 4',
         substation_output_status_reg_4016_label: 'ECA32 AO1',
         substation_output_status_reg_4017_label: 'ECA32 AO2',
         substation_output_status_reg_4018_label: 'ECA32 AO3',
         substation_pressure1_reg_11600_label: 'Pressure',
         substation_pressure1_reg_11607_label: 'Low X',
         substation_pressure1_reg_11608_label: 'High X',
         substation_pressure1_reg_11609_label: 'Low Y',
         substation_pressure1_reg_11610_label: 'High Y',
         substation_pressure1_reg_11620_label: 'Pressure',
         substation_pressure1_reg_11629_label: 'Low Y',
         substation_pressure1_reg_11630_label: 'High Y',
         substation_pressure1_reg_17113_label: 'Filter constant',
         substation_pressure2_reg_14113_label: 'Filter constant',
         substation_pressure2_reg_14600_label: 'Pressure',
         substation_pressure2_reg_14607_label: 'Low X',
         substation_pressure2_reg_14608_label: 'High X',
         substation_pressure2_reg_14609_label: 'Low Y',
         substation_pressure2_reg_14610_label: 'High Y',
         substation_pressure3_reg_12113_label: 'Filter constant',
         substation_pressure3_reg_12600_label: 'Pressure',
         substation_pressure3_reg_12607_label: 'Low X',
         substation_pressure3_reg_12608_label: 'High X',
         substation_pressure3_reg_12609_label: 'Low Y',
         substation_pressure3_reg_12610_label: 'High Y',
         substation_pressure4_reg_13113_label: 'Filter constant',
         substation_pressure4_reg_13600_label: 'Pressure',
         substation_pressure4_reg_13607_label: 'Low X',
         substation_pressure4_reg_13608_label: 'High X',
         substation_pressure4_reg_13609_label: 'Low Y',
         substation_pressure4_reg_13610_label: 'High Y',
         substation_raw_sensor_reg_10219_label: 'ECA32 Sensor 13',
         substation_raw_sensor_reg_10220_label: 'ECA32 Sensor 14',
         substation_raw_sensor_reg_10221_label: 'ECA32 Sensor 15',
         substation_raw_sensor_reg_10222_label: 'ECA32 Sensor 16',
         substation_raw_sensor_reg_10223_label: 'ECA32 Sensor 17 PF',
         substation_raw_sensor_reg_10224_label: 'ECA32 Sensor 18 PF',
         substation_return_limit_1_reg_11028_label: 'Con. T, ret. T lim.',
         substation_return_limit_1_reg_11029_label: 'DHW, ret. T limit',
         substation_return_limit_1_reg_11030_label: 'Limit',
         substation_return_limit_1_reg_11085_label: 'Priority',
         substation_return_limit_1_reg_11255_label: 'S5 Sensor reference',
         substation_temp_monitoring_1_reg_11147_label: 'Upper difference',
         substation_temp_monitoring_1_reg_11148_label: 'Lower difference',
         substation_temp_monitoring_1_reg_11149_label: 'Delay',
         substation_temp_monitoring_1_reg_11150_label: 'Lowest temp.',
         substation_general_3_reg_4213_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_4_reg_4214_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_input_config_reg_4106_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4107_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4108_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4109_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4110_label_list: JSON.stringify({
           list: {
             5: 'Pulse',
             6: 'Frequency',
           },
         }),
         substation_input_config_reg_4111_label_list: JSON.stringify({
           list: {
             5: 'Pulse',
             6: 'Frequency',
           },
         }),
         substation_input_config_reg_4126_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4127_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4128_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4129_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4130_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4131_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4125_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),

         // Substation single-page keys
         substations_filter_search: 'Search Substation',
         substation_single_page_title: 'Substation details',
         substations_single_bread_crumb_main_title: 'Substation overview',
         substations_single_bread_crumb_first_link: 'Substation page',
         substations_single_edit_device_button: 'Edit Substation',
         substation_single_temperature_title: 'The history of the substation',
         substation_single_offline_detailed_message: 'Substation is "Offline"',
         substation_single_online_detailed_message:
           'Substation is "Online", everything is working fine',
         substation_single_error_detailed_message:
           'Substation is in "Alarm" mode',
         substation_single_unprovisioned_detailed_message:
           'Substation is in "Unprovisioned" mode',
         substation_fetch_registers_success:
           'The request has been successfully sent to Substation.',
         substation_single_firmware_hiu_label: 'Firmware substation',
         substation_single_download_modbus_data: 'Export substation data',
         substation_single_device_settings_title: 'Substation Settings',
         substation_single_rss_device_status: 'Substation status',
         substations_single_device_counters_title: 'Substation Counters',

         // Substation edit form keys
         substations_form_device_information_tab: 'Substation Information',
         substations_form_name_field: 'Substation Name',
         substations_form_device_labels_field: 'Substation Label',
         substations_form_additional_information_tab: 'Substation Details',
         substations_form_description_field: 'Substation type',
         substations_form_article_number_field: 'Substation Article Number',
         substations_partner_article_number_field:
           'Substation Distributor Article number',
         substations_form_box_serial_number_field: 'Substation Serial Number',
         substations_partner_serial_number:
           'Substation Distributor Serial Number',

         // Substation register category menu labels (grouped)
         substation_menu_general: 'General',
         substation_menu_application: 'Application',
         substation_menu_ecl: 'ECL',
         substation_menu_return_limit: 'Return Limit',
         substation_menu_output: 'Output',
         substation_menu_flow_temperature: 'Flow Temperature',
         // Individual table titles
         substation_menu_general_1: 'General 1',
         substation_menu_general_2: 'General 2',
         substation_menu_ecl_alarm: 'ECL Alarm',
         substation_menu_ecl_system: 'ECL System',
         substation_menu_raw_sensor: 'Raw Sensor',
         substation_menu_output_status: 'Output Status',
         substation_menu_input_config: 'Input Config',
         substation_menu_ecl_system_ex: 'ECL System Extended',
         substation_menu_general_5: 'General 5',
         substation_menu_general_6: 'General 6',
         substation_menu_flow_temperature_1: 'Flow Temperature 1',
         substation_menu_return_limit_1: 'Return Limit 1',
         substation_menu_optimization_1: 'Optimization 1',
         substation_menu_control_parameter_1: 'Control Parameter 1',
         substation_menu_application_1: 'Application 1',
         substation_menu_output_control_1: 'Output Control 1',
         substation_menu_flow_temperature_2: 'Flow Temperature 2',
         substation_menu_return_limit_2: 'Return Limit 2',
         substation_menu_application_2: 'Application 2',
         substation_menu_temp_monitoring_2: 'Temp Monitoring 2',
         substation_menu_compensating1_2: 'Compensating 1/2',
         substation_menu_flow_power_limit: 'Flow / Power Limit',
         substation_menu_pressure: 'Pressure',
         substation_menu_alarm1_1: 'Alarm 1',
         substation_menu_general_3: 'General 3',
         substation_menu_general_4: 'General 4',
         substation_menu_output_manual_status: 'Output Manual Status',
         substation_menu_pressure1: 'Pressure 1',
         substation_menu_pressure2: 'Pressure 2',
         substation_menu_pressure3: 'Pressure 3',
         substation_menu_pressure4: 'Pressure 4',
         substation_menu_energy_meter_1: 'Energy Meter 1',
         substation_menu_flow_power_limit_1: 'Flow / Power Limit 1',
         substation_menu_control_parameter_2: 'Control Parameter 2',
         substation_menu_control_parameter_5: 'Control Parameter 5',
         substation_menu_temp_monitoring_1: 'Temp Monitoring 1',
         substation_menu_compensating1_1: 'Compensating 1/1',
         substation_menu_compensating2_1: 'Compensating 2/1',
         substation_menu_energy_meter: 'Energy Meter',
         substation_menu_ecl_system_meas: 'ECL System (Config)',
         substation_menu_ecl_extension: 'ECL Extension',
         substation_menu_ethernet: 'Ethernet',
         substation_menu_scada_override: 'SCADA Override',
         substation_menu_m_bus_config: 'M-Bus Config',
         project_offboarding_alert_title: 'This project is currently being offboarded.',
         project_offboarding_grace_period_end: 'Grace period end date',
         project_offboarding_deletion_window_end: 'Deletion window end date',
         project_offboarding_days_left: 'days left',
         client_single_api_application_unblock_errpr:
           'Application is already unblocked',
         devices_testing: 'Device Testing',
         diagnostic_flows_form_delete_node_modal_subtitle:
           'You want to delete ##NODE_LABEL## node?',
         diagnostic_flows_form_delete_node_modal_cancel_button: 'Cancel',
         diagnostic_flows_form_delete_node_modal_delete_button: 'Delete',
         diagnostic_flows_form_main_error_text: 'Flow is stopped due to alarm',
         diagnostic_flows_form_main_success_text:
           'Flow has completed successfully',
         diagnostic_flows_form_processing_text: 'Processing',
         diagnostics_condition_modal_cancel_button: 'Cancel',
         diagnostics_condition_modal_delay_label: 'Delay',
         diagnostics_condition_modal_operator_option_5: 'Greater than equal to',
         diagnostics_condition_modal_operator_option_6: 'Not Equal to',
         diagnostics_condition_modal_register_label: 'Register',
         diagnostics_condition_modal_retries_label: 'Retries',
         diagnostics_condition_modal_save_button: 'Save',
         diagnostics_condition_modal_second_label: 'sec',
         diagnostics_condition_modal_timer_label: 'Timer',
         diagnostics_condition_modal_times_label: 'times',
         diagnostics_condition_modal_value_label: 'Value',
         mbus_reporting_anomaly_table_mbus_new_value: 'New Value',
         mbus_reporting_anomaly_table_mbus_port: 'Port',
         permissions_form_description_dk_field: 'Description (DK)',
         permissions_form_permission_name_dk_field: 'Name (DK)',
         three_scale_temporary_password_subject:
           'Fortes Energy - kong Account Created',
         diagnostic_flows_form_delete_node_modal_title: 'Are you sure?',
         custom_popover_1_short_description: 'System Command',
         custom_popover_1_long_description: 'System Command',
         custom_popover_8_short_description: 'Build no.',
         custom_popover_8_long_description: 'Build no.',
         custom_popover_19_short_description: 'Code no.',
         custom_popover_19_long_description: 'Code no.',
         custom_popover_34_short_description: 'Hardware',
         custom_popover_34_long_description: 'Hardware',
         custom_popover_35_short_description: 'Software',
         custom_popover_35_long_description: 'Software',
         custom_popover_36_short_description: 'Serial no.',
         custom_popover_36_long_description: 'Serial no.',
         custom_popover_38_short_description: 'Modbus addr.',
         custom_popover_38_long_description: 'Modbus addr.',
         custom_popover_39_short_description: 'Baud',
         custom_popover_39_long_description: 'Baud',
         custom_popover_258_short_description: 'Address type',
         custom_popover_258_long_description: 'Address type',
         custom_popover_278_short_description: 'IP 1',
         custom_popover_278_long_description: 'IP 1',
         custom_popover_282_short_description: 'Gateway IP 1',
         custom_popover_282_long_description: 'Gateway IP 1',
         custom_popover_286_short_description: 'Net Mask 1',
         custom_popover_286_long_description: 'Net Mask 1',
         custom_popover_1024_short_description: 'Alarm field 2',
         custom_popover_1024_long_description: 'Alarm field 2',
         custom_popover_1025_short_description: 'Alarm field 1',
         custom_popover_1025_long_description: 'Alarm field 1',
         custom_popover_1032_short_description: 'Alarm clear 2',
         custom_popover_1032_long_description: 'Alarm clear 2',
         custom_popover_1033_short_description: 'Alarm clear 1',
         custom_popover_1033_long_description: 'Alarm clear 1',
         custom_popover_2048_short_description: 'ECL 485 addr.',
         custom_popover_2048_long_description: 'ECL 485 addr.',
         custom_popover_2049_short_description: 'Modbus bias.',
         custom_popover_2049_long_description: 'Modbus bias.',
         custom_popover_2050_short_description: 'Language',
         custom_popover_2050_long_description: 'Language',
         custom_popover_2052_short_description: 'Sensor monitor valid mask1',
         custom_popover_2052_long_description: 'Sensor monitor valid mask1',
         custom_popover_2054_short_description: 'Sensor monitor error mask1',
         custom_popover_2054_long_description: 'Sensor monitor error mask1',
         custom_popover_2097_short_description: 'Wink',
         custom_popover_2097_long_description: 'Wink',
         custom_popover_2099_short_description: 'Production week',
         custom_popover_2099_long_description: 'Production week',
         custom_popover_2150_short_description: 'Service pin',
         custom_popover_2150_long_description: 'Service pin',
         custom_popover_2151_short_description: 'Ext. reset',
         custom_popover_2151_long_description: 'Ext. reset',
         custom_popover_2152_short_description: 'Inbound accept',
         custom_popover_2152_long_description: 'Inbound accept',
         custom_popover_2153_short_description: 'Portal encryption',
         custom_popover_2153_long_description: 'Portal encryption',
         custom_popover_2160_short_description: 'ECL Portal',
         custom_popover_2160_long_description: 'ECL Portal',
         custom_popover_2161_short_description: 'Connection status',
         custom_popover_2161_long_description: 'Connection status',
         custom_popover_2162_short_description: 'Portal status',
         custom_popover_2162_long_description: 'Portal status',
         custom_popover_2240_short_description: 'DNS IP1 1',
         custom_popover_2240_long_description: 'DNS IP1 1',
         custom_popover_2244_short_description: 'DNS IP2 1',
         custom_popover_2244_long_description: 'DNS IP2 1',
         custom_popover_3995_short_description: 'Estimated Motor Position 1',
         custom_popover_3995_long_description: 'Estimated Motor Position 1',
         custom_popover_3996_short_description: 'Estimated Motor Position 2',
         custom_popover_3996_long_description: 'Estimated Motor Position 2',
         custom_popover_3997_short_description: 'Estimated Motor Position 3',
         custom_popover_3997_long_description: 'Estimated Motor Position 3',
         custom_popover_4000_short_description: 'Triac 1',
         custom_popover_4000_long_description: 'Triac 1',
         custom_popover_4001_short_description: 'Triac 2',
         custom_popover_4001_long_description: 'Triac 2',
         custom_popover_4002_short_description: 'Triac 3',
         custom_popover_4002_long_description: 'Triac 3',
         custom_popover_4003_short_description: 'Triac 4',
         custom_popover_4003_long_description: 'Triac 4',
         custom_popover_4004_short_description: 'Triac 5',
         custom_popover_4004_long_description: 'Triac 5',
         custom_popover_4005_short_description: 'Triac 6',
         custom_popover_4005_long_description: 'Triac 6',
         custom_popover_4006_short_description: 'Relay 1',
         custom_popover_4006_long_description: 'Relay 1',
         custom_popover_4007_short_description: 'Relay 2',
         custom_popover_4007_long_description: 'Relay 2',
         custom_popover_4008_short_description: 'Relay 3',
         custom_popover_4008_long_description: 'Relay 3',
         custom_popover_4009_short_description: 'Relay 4',
         custom_popover_4009_long_description: 'Relay 4',
         custom_popover_4010_short_description: 'Relay 5',
         custom_popover_4010_long_description: 'Relay 5',
         custom_popover_4011_short_description: 'Relay 6',
         custom_popover_4011_long_description: 'Relay 6',
         custom_popover_4019_short_description: 'ECA35 PWM4',
         custom_popover_4019_long_description: 'ECA35 PWM4',
         custom_popover_4100_short_description: 'Config type S7',
         custom_popover_4100_long_description: 'Config type S7',
         custom_popover_4101_short_description: 'Config type S8',
         custom_popover_4101_long_description: 'Config type S8',
         custom_popover_4102_short_description: 'Config type S9',
         custom_popover_4102_long_description: 'Config type S9',
         custom_popover_4103_short_description: 'Config type S10',
         custom_popover_4103_long_description: 'Config type S10',
         custom_popover_4104_short_description: 'Config type S11',
         custom_popover_4104_long_description: 'Config type S11',
         custom_popover_4105_short_description: 'Config type S12',
         custom_popover_4105_long_description: 'Config type S12',
         custom_popover_4120_short_description: 'Config option S7',
         custom_popover_4120_long_description: 'Config option S7',
         custom_popover_4121_short_description: 'Config option S8',
         custom_popover_4121_long_description: 'Config option S8',
         custom_popover_4122_short_description: 'Config option S9',
         custom_popover_4122_long_description: 'Config option S9',
         custom_popover_4123_short_description: 'Config option S10',
         custom_popover_4123_long_description: 'Config option S10',
         custom_popover_4124_short_description: 'Config option S11',
         custom_popover_4124_long_description: 'Config option S11',
         custom_popover_4125_short_description: 'Config option S12',
         custom_popover_4125_long_description: 'Config option S12',
         custom_popover_4201_short_description: 'Mode',
         custom_popover_4201_long_description: 'Mode',
         custom_popover_4202_short_description: 'Mode',
         custom_popover_4202_long_description: 'Mode',
         custom_popover_4211_short_description: 'Circuit 1 status',
         custom_popover_4211_long_description: 'Circuit 1 status',
         custom_popover_4212_short_description: 'Circuit 2 status',
         custom_popover_4212_long_description: 'Circuit 2 status',
         custom_popover_4215_short_description: 'Circuit 5 status',
         custom_popover_4215_long_description: 'Circuit 5 status',
         custom_popover_4216_short_description: 'Circuit 6 status',
         custom_popover_4216_long_description: 'Circuit 6 status',
         custom_popover_4220_short_description: 'Circuit 1 limiter flags 1',
         custom_popover_4220_long_description: 'Circuit 1 limiter flags 1',
         custom_popover_4221_short_description: 'Circuit 1 limiter flags 2',
         custom_popover_4221_long_description: 'Circuit 1 limiter flags 2',
         custom_popover_4222_short_description: 'Circuit 1 limiter flags 3',
         custom_popover_4222_long_description: 'Circuit 1 limiter flags 3',
         custom_popover_4223_short_description: 'Circuit 1 limiter flags 4',
         custom_popover_4223_long_description: 'Circuit 1 limiter flags 4',
         custom_popover_4224_short_description: 'Circuit 2 limiter flags 1',
         custom_popover_4224_long_description: 'Circuit 2 limiter flags 1',
         custom_popover_4236_short_description: 'AccumulatedPulse 1',
         custom_popover_4236_long_description: 'AccumulatedPulse 1',
         custom_popover_4238_short_description: 'AccumulatedPulse 2',
         custom_popover_4238_long_description: 'AccumulatedPulse 2',
         custom_popover_4240_short_description: 'AccumulatedPulse 3',
         custom_popover_4240_long_description: 'AccumulatedPulse 3',
         custom_popover_4246_short_description: 'Circuit 5 limiter flags 1',
         custom_popover_4246_long_description: 'Circuit 5 limiter flags 1',
         custom_popover_4247_short_description: 'Circuit 5 limiter flags 2',
         custom_popover_4247_long_description: 'Circuit 5 limiter flags 2',
         custom_popover_4248_short_description: 'Circuit 5 limiter flags 3',
         custom_popover_4248_long_description: 'Circuit 5 limiter flags 3',
         custom_popover_4249_short_description: 'Circuit 5 limiter flags 4',
         custom_popover_4249_long_description: 'Circuit 5 limiter flags 4',
         custom_popover_4250_short_description: 'Circuit 6 limiter flags 1',
         custom_popover_4250_long_description: 'Circuit 6 limiter flags 1',
         custom_popover_4251_short_description: 'Circuit 6 limiter flags 2',
         custom_popover_4251_long_description: 'Circuit 6 limiter flags 2',
         custom_popover_4252_short_description: 'Circuit 6 limiter flags 3',
         custom_popover_4252_long_description: 'Circuit 6 limiter flags 3',
         custom_popover_4253_short_description: 'Circuit 6 limiter flags 4',
         custom_popover_4253_long_description: 'Circuit 6 limiter flags 4',
         custom_popover_5994_short_description: 'GW Command request',
         custom_popover_5994_long_description: 'GW Command request',
         custom_popover_5995_short_description: 'GW State',
         custom_popover_5995_long_description: 'GW State',
         custom_popover_5996_short_description: 'GW Telegram size',
         custom_popover_5996_long_description: 'GW Telegram size',
         custom_popover_5997_short_description: 'Baud',
         custom_popover_5997_long_description: 'Baud',
         custom_popover_5998_short_description: 'Command',
         custom_popover_5998_long_description: 'Command',
         custom_popover_5999_short_description: 'State',
         custom_popover_5999_long_description: 'State',
         custom_popover_10198_short_description: 'Aut. daylight',
         custom_popover_10198_long_description: 'Aut. daylight',
         custom_popover_10201_short_description: 'S1 sensor',
         custom_popover_10201_long_description: 'S1 sensor',
         custom_popover_10202_short_description: 'S2 sensor',
         custom_popover_10202_long_description: 'S2 sensor',
         custom_popover_10203_short_description: 'S3 sensor',
         custom_popover_10203_long_description: 'S3 sensor',
         custom_popover_10204_short_description: 'S4 sensor',
         custom_popover_10204_long_description: 'S4 sensor',
         custom_popover_10205_short_description: 'S5 sensor',
         custom_popover_10205_long_description: 'S5 sensor',
         custom_popover_10206_short_description: 'S6 sensor',
         custom_popover_10206_long_description: 'S6 sensor',
         custom_popover_10207_short_description: 'S7 sensor',
         custom_popover_10207_long_description: 'S7 sensor',
         custom_popover_10208_short_description: 'S8 sensor',
         custom_popover_10208_long_description: 'S8 sensor',
         custom_popover_10209_short_description: 'S9 sensor',
         custom_popover_10209_long_description: 'S9 sensor',
         custom_popover_10210_short_description: 'S10 sensor',
         custom_popover_10210_long_description: 'S10 sensor',
         custom_popover_10211_short_description: 'S11 sensor',
         custom_popover_10211_long_description: 'S11 sensor',
         custom_popover_10212_short_description: 'S12 sensor',
         custom_popover_10212_long_description: 'S12 sensor',
         custom_popover_10213_short_description: 'Room Unit A, Sensor 1',
         custom_popover_10213_long_description: 'Room Unit A, Sensor 1',
         custom_popover_10216_short_description: 'Room Unit B, Sensor 1',
         custom_popover_10216_long_description: 'Room Unit B, Sensor 1',
         custom_popover_10398_short_description: 'Scada heatoffset/setpoint',
         custom_popover_10398_long_description: 'Scada heatoffset/setpoint',
         custom_popover_10399_short_description: 'Scada Timeout',
         custom_popover_10399_long_description: 'Scada Timeout',
         custom_popover_10400_short_description: 'Scada Outdoor temperature',
         custom_popover_10400_long_description: 'Scada Outdoor temperature',
         custom_popover_10401_short_description: 'Scada heat offset 1',
         custom_popover_10401_long_description: 'Scada heat offset 1',
         custom_popover_10402_short_description: 'Scada heat offset 2',
         custom_popover_10402_long_description: 'Scada heat offset 2',
         custom_popover_10403_short_description: 'Scada heat offset 3',
         custom_popover_10403_long_description: 'Scada heat offset 3',
         custom_popover_10404_short_description: 'Scada heat offset 4',
         custom_popover_10404_long_description: 'Scada heat offset 4',
         custom_popover_10405_short_description: 'Scada boiler ctrl 1',
         custom_popover_10405_long_description: 'Scada boiler ctrl 1',
         custom_popover_10406_short_description: 'Scada boiler ctrl 2',
         custom_popover_10406_long_description: 'Scada boiler ctrl 2',
         custom_popover_10407_short_description: 'Scada boiler ctrl 3',
         custom_popover_10407_long_description: 'Scada boiler ctrl 3',
         custom_popover_10408_short_description: 'Scada boiler ctrl 4',
         custom_popover_10408_long_description: 'Scada boiler ctrl 4',
         custom_popover_10409_short_description: 'SCADA slave request',
         custom_popover_10409_long_description: 'SCADA slave request',
         custom_popover_10410_short_description: 'SCADA resulting reference',
         custom_popover_10410_long_description: 'SCADA resulting reference',
         custom_popover_10420_short_description: 'Scada Schedule timeout',
         custom_popover_10420_long_description: 'Scada Schedule timeout',
         custom_popover_10421_short_description: 'Scada Schedule 1',
         custom_popover_10421_long_description: 'Scada Schedule 1',
         custom_popover_10422_short_description: 'Scada Schedule 2',
         custom_popover_10422_long_description: 'Scada Schedule 2',
         custom_popover_10423_short_description: 'Scada Schedule 3',
         custom_popover_10423_long_description: 'Scada Schedule 3',
         custom_popover_10424_short_description: 'Scada Schedule 4',
         custom_popover_10424_long_description: 'Scada Schedule 4',
         custom_popover_10425_short_description: 'Scada Schedule 5',
         custom_popover_10425_long_description: 'Scada Schedule 5',
         custom_popover_10426_short_description: 'Scada Schedule 6',
         custom_popover_10426_long_description: 'Scada Schedule 6',
         custom_popover_10427_short_description: 'Scada Optim value 1',
         custom_popover_10427_long_description: 'Scada Optim value 1',
         custom_popover_10428_short_description: 'Scada Optim value 2',
         custom_popover_10428_long_description: 'Scada Optim value 2',
         custom_popover_10429_short_description: 'Scada Optim value 3',
         custom_popover_10429_long_description: 'Scada Optim value 3',
         custom_popover_10430_short_description: 'Scada Optim value 4',
         custom_popover_10430_long_description: 'Scada Optim value 4',
         custom_popover_10431_short_description: 'Scada Optim value 5',
         custom_popover_10431_long_description: 'Scada Optim value 5',
         custom_popover_10432_short_description: 'Scada Optim value 6',
         custom_popover_10432_long_description: 'Scada Optim value 6',
         custom_popover_10500_short_description: 'Min Outdoor Temp',
         custom_popover_10500_long_description: 'Min Outdoor Temp',
         custom_popover_10501_short_description: 'Min Hour Time',
         custom_popover_10501_long_description: 'Min Hour Time',
         custom_popover_10502_short_description: 'Min Minute Time',
         custom_popover_10502_long_description: 'Min Minute Time',
         custom_popover_10503_short_description: 'Cooling Reg 10503',
         custom_popover_10503_long_description: 'Cooling Reg 10503',
         custom_popover_10504_short_description: 'Cooling Reg 10504',
         custom_popover_10504_long_description: 'Cooling Reg 10504',
         custom_popover_10505_short_description: 'Max Outdoor Temp',
         custom_popover_10505_long_description: 'Max Outdoor Temp',
         custom_popover_10506_short_description: 'Max Hou Time',
         custom_popover_10506_long_description: 'Max Hou Time',
         custom_popover_10507_short_description: 'Max Minute Time',
         custom_popover_10507_long_description: 'Max Minute Time',
         custom_popover_10508_short_description: 'Cooling Reg 10508',
         custom_popover_10508_long_description: 'Cooling Reg 10508',
         custom_popover_10509_short_description: 'Cooling Reg 10509',
         custom_popover_10509_long_description: 'Cooling Reg 10509',
         custom_popover_10510_short_description: 'Outdoor Trend',
         custom_popover_10510_long_description: 'Outdoor Trend',
         custom_popover_10603_short_description: 'Digital S7',
         custom_popover_10603_long_description: 'Digital S7',
         custom_popover_10643_short_description: 'Digital S9',
         custom_popover_10643_long_description: 'Digital S9',
         custom_popover_11010_short_description: 'ECA addr.',
         custom_popover_11010_long_description: 'ECA addr.',
         custom_popover_11011_short_description: 'Auto saving',
         custom_popover_11011_long_description: 'Auto saving',
         custom_popover_11012_short_description: 'Boost',
         custom_popover_11012_long_description: 'Boost',
         custom_popover_11018_short_description: 'Des. T comfort',
         custom_popover_11018_long_description: 'Des. T comfort',
         custom_popover_11019_short_description: 'Des. T saving',
         custom_popover_11019_long_description: 'Des. T saving',
         custom_popover_10219_short_description: 'ECA32 Sensor 13',
         custom_popover_10219_long_description: 'ECA32 Sensor 13',
         custom_popover_10220_short_description: 'ECA32 Sensor 14',
         custom_popover_10220_long_description: 'ECA32 Sensor 14',
         custom_popover_10221_short_description: 'ECA32 Sensor 15',
         custom_popover_10221_long_description: 'ECA32 Sensor 15',
         custom_popover_10222_short_description: 'ECA32 Sensor 16',
         custom_popover_10222_long_description: 'ECA32 Sensor 16',
         custom_popover_10223_short_description: 'ECA32 Sensor 17 PF',
         custom_popover_10223_long_description: 'ECA32 Sensor 17 PF',
         custom_popover_10224_short_description: 'ECA32 Sensor 18 PF',
         custom_popover_10224_long_description: 'ECA32 Sensor 18 PF',
         custom_popover_4012_short_description: 'ECA32 Relay 1',
         custom_popover_4012_long_description: 'ECA32 Relay 1',
         custom_popover_4013_short_description: 'ECA32 Relay 2',
         custom_popover_4013_long_description: 'ECA32 Relay 2',
         custom_popover_4014_short_description: 'ECA32 Relay 3',
         custom_popover_4014_long_description: 'ECA32 Relay 3',
         custom_popover_4015_short_description: 'ECA32 Relay 4',
         custom_popover_4015_long_description: 'ECA32 Relay 4',
         custom_popover_4016_short_description: 'ECA32 AO1',
         custom_popover_4016_long_description: 'ECA32 AO1',
         custom_popover_4017_short_description: 'ECA32 AO2',
         custom_popover_4017_long_description: 'ECA32 AO2',
         custom_popover_4018_short_description: 'ECA32 AO3',
         custom_popover_4018_long_description: 'ECA32 AO3',
         custom_popover_4056_short_description: 'ECA32 AO1 Value',
         custom_popover_4056_long_description: 'ECA32 AO1 Value',
         custom_popover_4106_short_description: 'ECA 32 Config type S13',
         custom_popover_4106_long_description: 'ECA 32 Config type S13',
         custom_popover_4107_short_description: 'ECA 32 Config type S14',
         custom_popover_4107_long_description: 'ECA 32 Config type S14',
         custom_popover_4108_short_description: 'ECA 32 Config type S15',
         custom_popover_4108_long_description: 'ECA 32 Config type S15',
         custom_popover_4109_short_description: 'ECA 32 Config type S16',
         custom_popover_4109_long_description: 'ECA 32 Config type S16',
         custom_popover_4110_short_description: 'ECA 32 Config type S17',
         custom_popover_4110_long_description: 'ECA 32 Config type S17',
         custom_popover_4111_short_description: 'ECA 32 Config type S18',
         custom_popover_4111_long_description: 'ECA 32 Config type S18',
         custom_popover_4126_short_description: 'ECA 32 Config option S13',
         custom_popover_4126_long_description: 'ECA 32 Config option S13',
         custom_popover_4127_short_description: 'ECA 32 Config option S14',
         custom_popover_4127_long_description: 'ECA 32 Config option S14',
         custom_popover_4128_short_description: 'ECA 32 Config option S15',
         custom_popover_4128_long_description: 'ECA 32 Config option S15',
         custom_popover_4129_short_description: 'ECA 32 Config option S16',
         custom_popover_4129_long_description: 'ECA 32 Config option S16',
         custom_popover_4130_short_description: 'ECA 32 Config option S17',
         custom_popover_4130_long_description: 'ECA 32 Config option S17',
         custom_popover_4131_short_description: 'ECA 32 Config option S18',
         custom_popover_4131_long_description: 'ECA 32 Config option S18',
         custom_popover_11101_short_description: 'Ext. desired T',
         custom_popover_11101_long_description: 'Ext. desired T',
         custom_popover_11301_short_description: 'High T max Y2',
         custom_popover_11301_long_description: 'High T max Y2',
         custom_popover_11303_short_description: 'Low T max Y1',
         custom_popover_11303_long_description: 'Low T max Y1',
         custom_popover_11030_short_description: 'Limit',
         custom_popover_11030_long_description: 'Limit',
         custom_popover_11255_short_description: 'S5 Sensor reference',
         custom_popover_11255_long_description: 'S5 Sensor reference',
         custom_popover_11017_short_description: 'Demand offset',
         custom_popover_11017_long_description: 'Demand offset',
         custom_popover_11050_short_description: 'P demand',
         custom_popover_11050_long_description: 'P demand',
         custom_popover_11070_short_description: 'P cool T',
         custom_popover_11070_long_description: 'P cool T',
         custom_popover_11084_short_description: 'Ext. signal',
         custom_popover_11084_long_description: 'Ext. signal',
         custom_popover_11092_short_description: 'Standby T',
         custom_popover_11092_long_description: 'Standby T',
         custom_popover_11060_short_description: 'Limit',
         custom_popover_11060_long_description: 'Limit',
         custom_popover_11061_short_description: 'Adapt. time',
         custom_popover_11061_long_description: 'Adapt. time',
         custom_popover_11062_short_description: 'Infl. - max.',
         custom_popover_11062_long_description: 'Infl. - max.',
         custom_popover_11063_short_description: 'Infl. - min.',
         custom_popover_11063_long_description: 'Infl. - min.',
         custom_popover_11064_short_description: 'Limit',
         custom_popover_11064_long_description: 'Limit',
         custom_popover_11065_short_description: 'Adapt. time',
         custom_popover_11065_long_description: 'Adapt. time',
         custom_popover_11066_short_description: 'Infl. - max.',
         custom_popover_11066_long_description: 'Infl. - max.',
         custom_popover_11067_short_description: 'Infl. - min.',
         custom_popover_11067_long_description: 'Infl. - min.',
         custom_popover_6000_short_description: 'M-bus address',
         custom_popover_6000_long_description: 'M-bus address',
         custom_popover_6001_short_description: 'Type',
         custom_popover_6001_long_description: 'Type',
         custom_popover_6002_short_description: 'Scan time',
         custom_popover_6002_long_description: 'Scan time',
         custom_popover_6003_short_description: 'ID',
         custom_popover_6003_long_description: 'ID',
         custom_popover_6005_short_description: 'Meter Status',
         custom_popover_6005_long_description: 'Meter Status',
         custom_popover_6006_short_description: 'Flow T',
         custom_popover_6006_long_description: 'Flow T',
         custom_popover_6007_short_description: 'Return T',
         custom_popover_6007_long_description: 'Return T',
         custom_popover_6008_short_description: 'Flow',
         custom_popover_6008_long_description: 'Flow',
         custom_popover_6010_short_description: 'Power',
         custom_popover_6010_long_description: 'Power',
         custom_popover_6012_short_description: 'Volume',
         custom_popover_6012_long_description: 'Volume',
         custom_popover_6014_short_description: 'Energy',
         custom_popover_6014_long_description: 'Energy',
         custom_popover_6016_short_description: 'Flow MAX',
         custom_popover_6016_long_description: 'Flow MAX',
         custom_popover_6018_short_description: 'Power MAX',
         custom_popover_6018_long_description: 'Power MAX',
         custom_popover_6020_short_description: 'Flow T MAX',
         custom_popover_6020_long_description: 'Flow T MAX',
         custom_popover_6021_short_description: 'Return T MAX',
         custom_popover_6021_long_description: 'Return T MAX',
         custom_popover_6022_short_description: 'Energy Storage',
         custom_popover_6022_long_description: 'Energy Storage',
         custom_popover_2165_short_description: 'Server name, char 1',
         custom_popover_2165_long_description: 'Server name, char 1',
         custom_popover_2230_short_description: 'Password, char 1',
         custom_popover_2230_long_description: 'Password, char 1',
         custom_popover_11203_short_description: 'S3 Sensor',
         custom_popover_11203_long_description: 'S3 Sensor',
         custom_popover_11204_short_description: 'S4 Sensor',
         custom_popover_11204_long_description: 'S4 Sensor',
         custom_popover_11205_short_description: 'S5 Sensor',
         custom_popover_11205_long_description: 'S5 Sensor',
         custom_popover_11247_short_description: 'Selected temperature',
         custom_popover_11247_long_description: 'Selected temperature',
         custom_popover_4213_short_description: 'Circuit 3 status',
         custom_popover_4213_long_description: 'Circuit 3 status',
         custom_popover_4214_short_description: 'Circuit 4 status',
         custom_popover_4214_long_description: 'Circuit 4 status',
         custom_popover_11004_short_description: 'Desired T',
         custom_popover_11004_long_description: 'Desired T',
         custom_popover_11079_short_description: 'Max. flow T',
         custom_popover_11079_long_description: 'Max. flow T',
         custom_popover_11080_short_description: 'Delay',
         custom_popover_11080_long_description: 'Delay',
         custom_popover_11297_short_description: 'Temperature reference',
         custom_popover_11297_long_description: 'Temperature reference',
         custom_popover_11609_short_description: 'Low Y',
         custom_popover_11609_long_description: 'Low Y',
         custom_popover_11610_short_description: 'High Y',
         custom_popover_11610_long_description: 'High Y',
         custom_popover_11028_short_description: 'Con. T, ret. T lim.',
         custom_popover_11028_long_description: 'Con. T, ret. T lim.',
         custom_popover_11029_short_description: 'DHW, ret. T limit',
         custom_popover_11029_long_description: 'DHW, ret. T limit',
         custom_popover_11085_short_description: 'Priority',
         custom_popover_11085_long_description: 'Priority',
         custom_popover_11013_short_description: 'Ramp',
         custom_popover_11013_long_description: 'Ramp',
         custom_popover_11392_short_description: 'Sum. start, month',
         custom_popover_11392_long_description: 'Sum. start, month',
         custom_popover_11393_short_description: 'Sum. start, day',
         custom_popover_11393_long_description: 'Sum. start, day',
         custom_popover_11395_short_description: 'Summer, filter',
         custom_popover_11395_long_description: 'Summer, filter',
         custom_popover_11396_short_description: 'Win. start, month',
         custom_popover_11396_long_description: 'Win. start, month',
         custom_popover_11397_short_description: 'Winter start, day',
         custom_popover_11397_long_description: 'Winter start, day',
         custom_popover_11398_short_description: 'Winter, cut-out',
         custom_popover_11398_long_description: 'Winter, cut-out',
         custom_popover_11399_short_description: 'Winter, filter',
         custom_popover_11399_long_description: 'Winter, filter',
         custom_popover_11097_short_description: 'Supply T (idle)',
         custom_popover_11097_long_description: 'Supply T (idle)',
         custom_popover_11145_short_description: 'Mon. T select',
         custom_popover_11145_long_description: 'Mon. T select',
         custom_popover_11330_short_description: 'Wake up level',
         custom_popover_11330_long_description: 'Wake up level',
         custom_popover_11364_short_description: 'Control, delay',
         custom_popover_11364_long_description: 'Control, delay',
         custom_popover_11700_short_description: 'Await time',
         custom_popover_11700_long_description: 'Await time',
         custom_popover_11052_short_description: 'DHW priority',
         custom_popover_11052_long_description: 'DHW priority',
         custom_popover_11327_short_description: 'Input type',
         custom_popover_11327_long_description: 'Input type',
         custom_popover_11620_short_description: 'Pressure',
         custom_popover_11620_long_description: 'Pressure',
         custom_popover_11629_short_description: 'Low Y',
         custom_popover_11629_long_description: 'Low Y',
         custom_popover_11630_short_description: 'High Y',
         custom_popover_11630_long_description: 'High Y',
         custom_popover_11331_short_description: 'Sleep level',
         custom_popover_11331_long_description: 'Sleep level',
         custom_popover_11332_short_description: 'Sleep mode time',
         custom_popover_11332_long_description: 'Sleep mode time',
         custom_popover_11333_short_description: 'Boost',
         custom_popover_11333_long_description: 'Boost',
         custom_popover_4057_short_description: 'ECA32 AO2 Value',
         custom_popover_4057_long_description: 'ECA32 AO2 Value',
         custom_popover_4058_short_description: 'ECA32 AO3 Value',
         custom_popover_4058_long_description: 'ECA32 AO3 Value',
         custom_popover_11109_short_description: 'Input type',
         custom_popover_11109_long_description: 'Input type',
         custom_popover_11110_short_description: 'Actual',
         custom_popover_11110_long_description: 'Actual',
         custom_popover_11111_short_description: 'Limit',
         custom_popover_11111_long_description: 'Limit',
         custom_popover_11112_short_description: 'Adapt. time',
         custom_popover_11112_long_description: 'Adapt. time',
         custom_popover_11113_short_description: 'Filter constant',
         custom_popover_11113_long_description: 'Filter constant',
         custom_popover_11115_short_description: 'Units',
         custom_popover_11115_long_description: 'Units',
         custom_popover_11116_short_description: 'High limit Y2',
         custom_popover_11116_long_description: 'High limit Y2',
         custom_popover_11117_short_description: 'Low limit Y1',
         custom_popover_11117_long_description: 'Low limit Y1',
         custom_popover_11118_short_description: 'Low T out X2',
         custom_popover_11118_long_description: 'Low T out X2',
         custom_popover_11119_short_description: 'High T out X1',
         custom_popover_11119_long_description: 'High T out X1',
         custom_popover_12165_short_description: 'V out max.',
         custom_popover_12165_long_description: 'V out max.',
         custom_popover_12167_short_description: 'V out min.',
         custom_popover_12167_long_description: 'V out min.',
         custom_popover_12184_short_description: 'Xp',
         custom_popover_12184_long_description: 'Xp',
         custom_popover_12185_short_description: 'Tn',
         custom_popover_12185_long_description: 'Tn',
         custom_popover_12187_short_description: 'Nz',
         custom_popover_12187_long_description: 'Nz',
         custom_popover_12197_short_description: 'Td',
         custom_popover_12197_long_description: 'Td',
         custom_popover_12322_short_description: 'Pressure, diff.',
         custom_popover_12322_long_description: 'Pressure, diff.',
         custom_popover_15113_short_description: 'Filter constant',
         custom_popover_15113_long_description: 'Filter constant',
         custom_popover_15352_short_description: 'Position',
         custom_popover_15352_long_description: 'Position',
         custom_popover_15607_short_description: 'Low X',
         custom_popover_15607_long_description: 'Low X',
         custom_popover_15608_short_description: 'High X',
         custom_popover_15608_long_description: 'High X',
         custom_popover_15609_short_description: 'Low Y',
         custom_popover_15609_long_description: 'Low Y',
         custom_popover_15610_short_description: 'High Y',
         custom_popover_15610_long_description: 'High Y',
         custom_popover_11147_short_description: 'Upper difference',
         custom_popover_11147_long_description: 'Upper difference',
         custom_popover_11148_short_description: 'Lower difference',
         custom_popover_11148_long_description: 'Lower difference',
         custom_popover_11149_short_description: 'Delay',
         custom_popover_11149_long_description: 'Delay',
         custom_popover_11150_short_description: 'Lowest temp.',
         custom_popover_11150_long_description: 'Lowest temp.',
         custom_popover_11614_short_description: 'Alarm high',
         custom_popover_11614_long_description: 'Alarm high',
         custom_popover_11615_short_description: 'Alarm low',
         custom_popover_11615_long_description: 'Alarm low',
         custom_popover_11617_short_description: 'Alarm time-out',
         custom_popover_11617_long_description: 'Alarm time-out',
         custom_popover_11600_short_description: 'Pressure',
         custom_popover_11600_long_description: 'Pressure',
         custom_popover_11607_short_description: 'Low X',
         custom_popover_11607_long_description: 'Low X',
         custom_popover_11608_short_description: 'High X',
         custom_popover_11608_long_description: 'High X',
         custom_popover_17113_short_description: 'Filter constant',
         custom_popover_17113_long_description: 'Filter constant',
         custom_popover_14113_short_description: 'Filter constant',
         custom_popover_14113_long_description: 'Filter constant',
         custom_popover_14600_short_description: 'Pressure',
         custom_popover_14600_long_description: 'Pressure',
         custom_popover_14607_short_description: 'Low X',
         custom_popover_14607_long_description: 'Low X',
         custom_popover_14608_short_description: 'High X',
         custom_popover_14608_long_description: 'High X',
         custom_popover_14609_short_description: 'Low Y',
         custom_popover_14609_long_description: 'Low Y',
         custom_popover_14610_short_description: 'High Y',
         custom_popover_14610_long_description: 'High Y',
         custom_popover_12113_short_description: 'Filter constant',
         custom_popover_12113_long_description: 'Filter constant',
         custom_popover_12600_short_description: 'Pressure',
         custom_popover_12600_long_description: 'Pressure',
         custom_popover_12607_short_description: 'Low X',
         custom_popover_12607_long_description: 'Low X',
         custom_popover_12608_short_description: 'High X',
         custom_popover_12608_long_description: 'High X',
         custom_popover_12609_short_description: 'Low Y',
         custom_popover_12609_long_description: 'Low Y',
         custom_popover_12610_short_description: 'High Y',
         custom_popover_12610_long_description: 'High Y',
         custom_popover_13113_short_description: 'Filter constant',
         custom_popover_13113_long_description: 'Filter constant',
         custom_popover_13600_short_description: 'Pressure',
         custom_popover_13600_long_description: 'Pressure',
         custom_popover_13607_short_description: 'Low X',
         custom_popover_13607_long_description: 'Low X',
         custom_popover_13608_short_description: 'High X',
         custom_popover_13608_long_description: 'High X',
         custom_popover_13609_short_description: 'Low Y',
         custom_popover_13609_long_description: 'Low Y',
         custom_popover_13610_short_description: 'High Y',
         custom_popover_13610_long_description: 'High Y',
         custom_popover_11014_short_description: 'Optimizer',
         custom_popover_11014_long_description: 'Optimizer',
         custom_popover_11020_short_description: 'Based on',
         custom_popover_11020_long_description: 'Based on',
         custom_popover_11021_short_description: 'Total stop',
         custom_popover_11021_long_description: 'Total stop',
         custom_popover_11022_short_description: 'P exercise',
         custom_popover_11022_long_description: 'P exercise',
         custom_popover_11023_short_description: 'M exercise',
         custom_popover_11023_long_description: 'M exercise',
         custom_popover_11024_short_description: 'Actuator',
         custom_popover_11024_long_description: 'Actuator',
         custom_popover_11026_short_description: 'Pre-stop',
         custom_popover_11026_long_description: 'Pre-stop',
         custom_popover_11031_short_description: 'High T out X1',
         custom_popover_11031_long_description: 'High T out X1',
         custom_popover_11032_short_description: 'Low limit Y1',
         custom_popover_11032_long_description: 'Low limit Y1',
         custom_popover_11033_short_description: 'Low T out X2',
         custom_popover_11033_long_description: 'Low T out X2',
         custom_popover_11034_short_description: 'High limit Y2',
         custom_popover_11034_long_description: 'High limit Y2',
         custom_popover_11035_short_description: 'Infl. - max.',
         custom_popover_11035_long_description: 'Infl. - max.',
         custom_popover_11036_short_description: 'Infl. - min.',
         custom_popover_11036_long_description: 'Infl. - min.',
         custom_popover_11037_short_description: 'Adapt. time',
         custom_popover_11037_long_description: 'Adapt. time',
         custom_popover_11038_short_description: 'Stop at T out',
         custom_popover_11038_long_description: 'Stop at T out',
         custom_popover_11040_short_description: 'P post-run',
         custom_popover_11040_long_description: 'P post-run',
         custom_popover_11077_short_description: 'P frost T',
         custom_popover_11077_long_description: 'P frost T',
         custom_popover_11078_short_description: 'P heat T',
         custom_popover_11078_long_description: 'P heat T',
         custom_popover_11083_short_description: 'Add. function',
         custom_popover_11083_long_description: 'Add. function',
         custom_popover_11089_short_description: 'Acc. output function',
         custom_popover_11089_long_description: 'Acc. output function',
         custom_popover_11093_short_description: 'Frost pr. T',
         custom_popover_11093_long_description: 'Frost pr. T',
         custom_popover_11100_short_description: 'Outdoor acc. T',
         custom_popover_11100_long_description: 'Outdoor acc. T',
         custom_popover_11141_short_description: 'Ext. input',
         custom_popover_11141_long_description: 'Ext. input',
         custom_popover_11142_short_description: 'Ext. mode',
         custom_popover_11142_long_description: 'Ext. mode',
         custom_popover_11154_short_description: 'Filt. acc. outdoor T',
         custom_popover_11154_long_description: 'Filt. acc. outdoor T',
         custom_popover_11158_short_description: 'Stat. ventilation diff.',
         custom_popover_11158_long_description: 'Stat. ventilation diff.',
         custom_popover_11159_short_description: 'Stat. ventilation post-run',
         custom_popover_11159_long_description: 'Stat. ventilation post-run',
         custom_popover_11160_short_description: 'Stat. ventilation setp.',
         custom_popover_11160_long_description: 'Stat. ventilation setp.',
         custom_popover_11161_short_description: 'Dew point T',
         custom_popover_11161_long_description: 'Dew point T',
         custom_popover_11174_short_description: 'Motor pr.',
         custom_popover_11174_long_description: 'Motor pr.',
         custom_popover_11175_short_description: 'Heat curve',
         custom_popover_11175_long_description: 'Heat curve',
         custom_popover_11177_short_description: 'Temp. min.',
         custom_popover_11177_long_description: 'Temp. min.',
         custom_popover_11178_short_description: 'Temp. max.',
         custom_popover_11178_long_description: 'Temp. max.',
         custom_popover_11179_short_description: 'Summer, cut-out',
         custom_popover_11179_long_description: 'Summer, cut-out',
         custom_popover_11180_short_description: 'Des. T comfort',
         custom_popover_11180_long_description: 'Des. T comfort',
         custom_popover_11181_short_description: 'Des. T saving',
         custom_popover_11181_long_description: 'Des. T saving',
         custom_popover_11184_short_description: 'Xp',
         custom_popover_11184_long_description: 'Xp',
         custom_popover_11185_short_description: 'Tn',
         custom_popover_11185_long_description: 'Tn',
         custom_popover_11186_short_description: 'M run',
         custom_popover_11186_long_description: 'M run',
         custom_popover_11187_short_description: 'Nz',
         custom_popover_11187_long_description: 'Nz',
         custom_popover_11189_short_description: 'Min. act. time',
         custom_popover_11189_long_description: 'Min. act. time',
         custom_popover_11201_short_description: 'S1 sensor',
         custom_popover_11201_long_description: 'S1 sensor',
         custom_popover_11210_short_description: 'S10 sensor',
         custom_popover_11210_long_description: 'S10 sensor',
         custom_popover_11215_short_description: 'Humidity',
         custom_popover_11215_long_description: 'Humidity',
         custom_popover_11253_short_description: 'Des. flow T',
         custom_popover_11253_long_description: 'Des. flow T',
         custom_popover_11260_short_description: 'S10 Sensor reference',
         custom_popover_11260_long_description: 'S10 Sensor reference',
         custom_popover_11400_short_description: 'Y1',
         custom_popover_11400_long_description: 'Y1',
         custom_popover_11401_short_description: 'Y2',
         custom_popover_11401_long_description: 'Y2',
         custom_popover_11402_short_description: 'Y3',
         custom_popover_11402_long_description: 'Y3',
         custom_popover_11403_short_description: 'Y4',
         custom_popover_11403_long_description: 'Y4',
         custom_popover_11404_short_description: 'Y5',
         custom_popover_11404_long_description: 'Y5',
         custom_popover_11405_short_description: 'Y6',
         custom_popover_11405_long_description: 'Y6',
         custom_popover_11498_short_description: 'T out depend.',
         custom_popover_11498_long_description: 'T out depend.',
         custom_popover_11500_short_description: 'Send desired T',
         custom_popover_11500_long_description: 'Send desired T',
         custom_popover_11501_short_description: 'Reference place',
         custom_popover_11501_long_description: 'Reference place',
         custom_popover_12030_short_description: 'Limit',
         custom_popover_12030_long_description: 'Limit',
         custom_popover_12035_short_description: 'Infl. - max.',
         custom_popover_12035_long_description: 'Infl. - max.',
         custom_popover_12036_short_description: 'Infl. - min.',
         custom_popover_12036_long_description: 'Infl. - min.',
         custom_popover_12037_short_description: 'Adapt. time',
         custom_popover_12037_long_description: 'Adapt. time',
         custom_popover_12060_short_description: 'Limit',
         custom_popover_12060_long_description: 'Limit',
         custom_popover_12061_short_description: 'Adapt. time',
         custom_popover_12061_long_description: 'Adapt. time',
         custom_popover_12063_short_description: 'Infl. - min.',
         custom_popover_12063_long_description: 'Infl. - min.',
         custom_popover_12092_short_description: 'Standby T',
         custom_popover_12092_long_description: 'Standby T',
         custom_popover_12141_short_description: 'Ext. input',
         custom_popover_12141_long_description: 'Ext. input',
         custom_popover_12142_short_description: 'Ext. mode',
         custom_popover_12142_long_description: 'Ext. mode',
         custom_popover_12144_short_description: 'Activation, acc. T',
         custom_popover_12144_long_description: 'Activation, acc. T',
         custom_popover_12147_short_description: 'Upper difference',
         custom_popover_12147_long_description: 'Upper difference',
         custom_popover_12148_short_description: 'Lower difference',
         custom_popover_12148_long_description: 'Lower difference',
         custom_popover_12149_short_description: 'Delay',
         custom_popover_12149_long_description: 'Delay',
         custom_popover_12150_short_description: 'Lowest temp.',
         custom_popover_12150_long_description: 'Lowest temp.',
         custom_popover_12156_short_description: 'Act. acc kamer T',
         custom_popover_12156_long_description: 'Act. acc kamer T',
         custom_popover_12164_short_description: 'Dew point T offset',
         custom_popover_12164_long_description: 'Dew point T offset',
         custom_popover_12172_short_description: 'Cooling curve',
         custom_popover_12172_long_description: 'Cooling curve',
         custom_popover_12177_short_description: 'Temp. min.',
         custom_popover_12177_long_description: 'Temp. min.',
         custom_popover_12178_short_description: 'Temp. max.',
         custom_popover_12178_long_description: 'Temp. max.',
         custom_popover_12180_short_description: 'Des. T comfort',
         custom_popover_12180_long_description: 'Des. T comfort',
         custom_popover_12181_short_description: 'Des. T saving',
         custom_popover_12181_long_description: 'Des. T saving',
         custom_popover_12210_short_description: 'S10 sensor',
         custom_popover_12210_long_description: 'S10 sensor',
         custom_popover_12253_short_description: 'Des. flow T',
         custom_popover_12253_long_description: 'Des. flow T',
         custom_popover_12256_short_description: 'S6 Sensor reference',
         custom_popover_12256_long_description: 'S6 Sensor reference',
         custom_popover_12260_short_description: 'S10 Sensor reference',
         custom_popover_12260_long_description: 'S10 Sensor reference',
         custom_popover_12400_short_description: 'Y1',
         custom_popover_12400_long_description: 'Y1',
         custom_popover_12401_short_description: 'Y2',
         custom_popover_12401_long_description: 'Y2',
         custom_popover_12402_short_description: 'Y3',
         custom_popover_12402_long_description: 'Y3',
         custom_popover_12403_short_description: 'Y4',
         custom_popover_12403_long_description: 'Y4',
         custom_popover_12404_short_description: 'Y5',
         custom_popover_12404_long_description: 'Y5',
         custom_popover_12405_short_description: 'Y6',
         custom_popover_12405_long_description: 'Y6',
         custom_popover_12500_short_description: 'Send desired T',
         custom_popover_12500_long_description: 'Send desired T',
         custom_popover_12501_short_description: 'Reference place',
         custom_popover_12501_long_description: 'Reference place',
         custom_popover_60058_short_description: 'Backlight',
         custom_popover_60058_long_description: 'Backlight',
         custom_popover_60059_short_description: 'Contrast',
         custom_popover_60059_long_description: 'Contrast',
         device_offboarding_write_disabled_error: 'Write operation is disabled for devices currently being offboarded.',
         bulk_all_devices_offboarded_error: 'All selected devices are offboarded. Please select other devices to proceed.',
         bulk_all_heat_pumps_offboarded_error: 'All selected heat pumps are offboarded. Please select other heat pumps to proceed.',
         bulk_all_substations_offboarded_error: 'All selected substations are offboarded. Please select other substations to proceed.',
         bulk_some_devices_offboarded_warning: 'Some selected devices are being offboarded and will be skipped in this operation.',
         partner_settings_general_settings_unclaimed_devices_label:
           'Unclaimed Devices Settings',
         partner_settings_general_settings_unclaimed_devices_module_label:
           'Unclaimed devices module',
         partner_settings_general_settings_unclaimed_devices_module_description:
           'This setting will enable or disable the unclaimed devices functionality on the platform.',
         commissioning_device_stepper_step_claim_device_title: 'Claim Device',
         commissioning_form_success_claimed: 'Device is updated and claimed successfully!',
         device_is_claimed_field: 'Is Claimed',
         device_claimed_by_field: 'Claimed By',
         device_is_stock_product_field: 'Is Stock Product',
         device_commissioned_by_field: 'Commissioned By',
         device_commissioned_at_field: 'Commissioned At',
         general_yes: 'Yes',
         general_no: 'No',
         commissioning_claim_project_hint: "Unable to find the project you'd like to move the device to? Please navigate to the <a href=\"/admin/project\" target=\"_blank\" rel=\"noopener noreferrer\">project list</a> and verify the project name. If the project doesn't exist yet, use the <a href=\"/admin/project/create\" target=\"_blank\" rel=\"noopener noreferrer\">Add New button</a> in the project list to create it, then try commissioning again.",
         commissioning_form_project_is_missing_error: 'Project is required',
         commissioning_form_serial_number_search_hint: "Can't scan the QR code? You can search for the device by typing its serial number, e.g. 001122366455667788991234 or A00001.",
         commissioning_form_serial_number_claiming_hint: 'When claiming a device, enter the full serial number exactly as it appears, e.g. 001122366455667788991234 or A00001.',
         sidebar_mbus_purpose_label_menu: 'Mbus Meter Purpose Labels',
         mbus_meter_labels_header: 'Mbus Meter Purpose Labels',
         add_mbus_meter_labels_form_header: 'Add Mbus Meter Purpose Label',
         edit_mbus_meter_labels_form_header: 'Edit Mbus Meter Purpose Label',
         mbus_meter_labels_form_add_button: 'Add Mbus Meter Purpose Label',
         mbus_meter_labels_form_edit_button: 'Edit Mbus Meter Purpose Label',
         mbus_meter_label_activated_message: 'Mbus Meter Purpose Label Successfully Activated',
         mbus_meter_label_deactivated_message: 'Mbus Meter Purpose Label Successfully Deactivated',
         mbus_meter_label_form_label_required_error: 'Mbus Meter Purpose Label is required',
         mbus_meter_label_form_label_unique_error: 'Mbus Meter Purpose Label must be unique',
         add_mbus_meter_label_form_success: 'Mbus Meter Purpose Label is successfully created.',
         edit_mbus_meter_label_form_success: 'Mbus Meter Purpose Label is successfully updated.',
         mbus_meter_label_form_select_label_field: 'Select Mbus Meter Purpose Label',
         mbus_meter_label_field: 'Mbus Meter Purpose Label',

         device_events_data_logs_unavailable: 'Both device-level and project-level Data Logs are unavailable, therefore, no Data Logs were applied.',
         device_events_fetch_device_base_topic: 'Fetch Device base topic',
         device_events_device_is_offline: 'Device is Offline',
         device_events_fetch_device_information: 'Fetch Device Information',
         device_events_device_shutdown_lwt: 'Device shutdown (LWT message)',
         device_events_discovering_mbus_meter: 'Discovering MBus meter on devices',
         device_events_device_mbus_discovery_no_meter: 'Device MBus Discovery [No MBus meter available]',
         device_events_fetch_mbus_sample_configuration: 'Fetch MBus Sample Configuration',
         device_events_fetch_modbus_baudrate_config: 'Fetch Modbus Baudrate Config',
         device_events_fetch_modbus_enable_configuration: 'Fetch Modbus enable configuration',
         device_events_fetch_modbus_error_configuration: 'Fetch Modbus error configuration',
         device_events_fetch_modbus_write_enable_configuration: 'Fetch Modbus write enable configuration',
         device_events_fetch_remote_network_endpoint_config: 'Fetch Remote Network Endpoint configuration',
         device_events_fetch_remote_ftp_credentials: 'Fetch Remote FTP Credentials',
         device_events_commissioning_connectivity_error_sim_missing: 'Commissioning - Connectivity Error - SIM Number is missing in the database',
         device_events_rebooting_device: 'Rebooting Device',
         device_events_get_all_mbus_values: 'Get all Mbus values',
         device_events_request_base_topic_from_device: 'Request base topic from device',
         device_events_request_device_type_from_device: 'Request Device Type from device',
         device_events_get_modbus_baud_rate: 'Get modbus baud rate',
         device_events_get_modbus_error_register_address: 'Get modbus error register address',
         device_events_get_modbus_error_register_value: 'Get modbus error register value',
         device_events_search_mbus_registers_on_device: 'Search Mbus registers on device',
         device_events_search_mbus_registers_on_project_devices: 'Search Mbus registers on Project devices',
         device_events_rebooting_modbus_hiu_reset: 'Rebooting Modbus / HIU Reset',
         device_events_request_mbus_interval_from_device: 'Request Mbus Interval from device/ Fetch Mbus Interval',
         device_events_hiu_no_error: 'No Error',
         device_events_base_topic_is: 'Base topic is {{value}}',
         device_events_baudrate_is: 'Baudrate is {{value}}',
         device_events_set_device_base_topic: 'Set Device base topic={{value}}',
         device_events_fqdn_is_set_to: 'FQDN is set to {{value}}',
         device_events_update_fota_gateway_on_device: 'Update FOTA gateway on device file path={{value}}',
         device_events_ftp_credentials: 'FTP Credentials: Username={{username}}, Password={{password}}',
         device_events_hiu_firmware_update: 'HIU firmware update: Stage - {{stage}}. Error: {{error}}',
         device_events_update_hiu_ota: 'Update HIU OTA on unitID={{unitId}}, file path={{filePath}}, resetHiuAfterUpload={{resetHiu}}, verifyChecksumTimeoutSeconds={{timeout}}',
         device_events_reset_hiu_with_unit_id: 'Reset HIU with unitID={{value}}',
         device_events_fetching_mbus_data_records: 'Fetching MBus data records for MBUS_SERIAL_NUMBER={{serialNumber}} with data addresses {{addresses}}',
         device_events_apply_mbus_data_logs_project_level: 'Apply MBUS data logs at project level with config {{config}}',
         device_events_set_mbus_sample_configuration: 'Set MBus sample configuration with config {{config}}',
         device_events_device_send_meter_new_readings: 'Device send meter new readings: {{readings}}',
         device_events_set_modbus_error_register: 'Set Modbus error register {{value}}',
         device_events_modbus_error_report: 'Modbus Error Report: NewValue={{newValue}}, PreviousValue={{previousValue}}',
         device_events_get_values_of: 'Get Values of {{value}}',
         device_events_get_value_of: 'Get value of {{value}}',
         device_events_modbus_baudrate_config: 'Modbus Baudrate Config: baudrate={{baudrate}}, parity={{parity}}, stopbits={{stopbits}}',
         device_events_set_modbus_baudrate_config: 'Set Modbus Baudrate Config: [baudrate={{baudrate}}, parity={{parity}}, stopbits={{stopbits}}]',
         device_events_set_modbus_registers_interval: 'Set Modbus registers interval {{value}}',
         device_events_set_modbus_write_enable_configuration: 'Set Modbus write enable configuration for register={{register}}, unitId={{unitId}}, enable={{enable}}, disable={{disable}}',
         device_events_set_modbus_register_values: 'Set Modbus register values {{value}}',
         device_events_resending_ota_firmware: 'Re-sending OTA Firmware version({{version}}) update for {{nth}} time',
         device_events_set_remote_ftp_credentials: 'Set Remote FTP with credentials: username={{username}}, password={{password}}',
         device_events_set_remote_network_endpoint_config: 'Set Remote Network Endpoint configuration on fqdn={{value}}',
         device_events_reset_device_within_seconds: 'Reset device within {{value}} seconds',
         device_events_fetch_reg_for_modbus_connection: 'Fetch reg_{{value}} for Modbus Connection',
         device_events_set_base_topic_to: 'Set Base topic to {{value}}',
         device_events_set_fqdn_to: 'Set FQDN to {{value}}',
         device_events_set_modbus_baud_rate_to: 'Set modbus baud rate to {{value}}',
         device_events_set_modbus_error_register_value_to: 'set modbus error register value to {{value}}',
         device_events_set_modbus_error_register_address_to: 'set modbus error register address to {{value}}',
         device_events_set_secondary_device_type_to: 'Set secondary device type to {{value}}',
       };